'use strict';
import * as $j_java$002eio$002e$002dI$002dO$002dException from "./java.io.-I-O-Exception.js";
import * as $j_java$002elang$002e$002dEnum from "./java.lang.-Enum.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_java$002etext$002e$002dParse$002dPosition from "./java.text.-Parse-Position.js";
import * as $j_java$002etime$002e$002dDate$002dTime$002dException from "./java.time.-Date-Time-Exception.js";
import * as $j_java$002etime$002e$002dPeriod from "./java.time.-Period.js";
import * as $j_java$002etime$002e$002dYear$0024 from "./java.time.-Year$.js";
import * as $j_java$002etime$002e$002dZone$002dRegion from "./java.time.-Zone-Region.js";
import * as $j_java$002etime$002echrono$002e$002dChronology from "./java.time.chrono.-Chronology.js";
import * as $j_java$002etime$002eformat$002e$002dDate$002dTime$002dParse$002dException from "./java.time.format.-Date-Time-Parse-Exception.js";
import * as $j_java$002etime$002eformat$002e$002dDecimal$002dStyle$0024 from "./java.time.format.-Decimal-Style$.js";
import * as $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024 from "./java.time.format.-Resolver-Style$.js";
import * as $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024 from "./java.time.format.-Sign-Style$.js";
import * as $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dChar$002dLiteral$002dPrinter$002dParser from "./java.time.format.internal.-T-T-B-P-Date-Time-Formatter-Builder$-Char-Literal-Printer-Parser.js";
import * as $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dComposite$002dPrinter$002dParser from "./java.time.format.internal.-T-T-B-P-Date-Time-Formatter-Builder$-Composite-Printer-Parser.js";
import * as $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dFraction$002dPrinter$002dParser from "./java.time.format.internal.-T-T-B-P-Date-Time-Formatter-Builder$-Fraction-Printer-Parser.js";
import * as $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dInstant$002dPrinter$002dParser$0024 from "./java.time.format.internal.-T-T-B-P-Date-Time-Formatter-Builder$-Instant-Printer-Parser$.js";
import * as $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dNumber$002dPrinter$002dParser from "./java.time.format.internal.-T-T-B-P-Date-Time-Formatter-Builder$-Number-Printer-Parser.js";
import * as $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dPad$002dPrinter$002dParser$002dDecorator from "./java.time.format.internal.-T-T-B-P-Date-Time-Formatter-Builder$-Pad-Printer-Parser-Decorator.js";
import * as $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dSettings$002dParser$0024 from "./java.time.format.internal.-T-T-B-P-Date-Time-Formatter-Builder$-Settings-Parser$.js";
import * as $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dParse$002dContext$0024 from "./java.time.format.internal.-T-T-B-P-Date-Time-Parse-Context$.js";
import * as $j_java$002etime$002etemporal$002e$002dChrono$002dField from "./java.time.temporal.-Chrono-Field.js";
import * as $j_java$002etime$002etemporal$002e$002dChrono$002dUnit from "./java.time.temporal.-Chrono-Unit.js";
import * as $j_java$002etime$002etemporal$002e$002dTemporal$002dAdjusters$0024$002dRelative$002dDay$002dOf$002dWeek from "./java.time.temporal.-Temporal-Adjusters$-Relative-Day-Of-Week.js";
import * as $j_java$002etime$002etemporal$002e$002dTemporal$002dQueries$0024$0024anon$00241 from "./java.time.temporal.-Temporal-Queries$$anon$1.js";
import * as $j_java$002etime$002etemporal$002e$002dTemporal$002dQueries$0024$0024anon$00242 from "./java.time.temporal.-Temporal-Queries$$anon$2.js";
import * as $j_java$002etime$002etemporal$002e$002dTemporal$002dQueries$0024$0024anon$00243 from "./java.time.temporal.-Temporal-Queries$$anon$3.js";
import * as $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException from "./java.time.temporal.-Unsupported-Temporal-Type-Exception.js";
import * as $j_java$002etime$002etemporal$002e$002dValue$002dRange$0024 from "./java.time.temporal.-Value-Range$.js";
import * as $j_java$002etime$002ezone$002e$002dStandard$002dZone$002dRules from "./java.time.zone.-Standard-Zone-Rules.js";
import * as $j_java$002etime$002ezone$002e$002dZone$002dRules from "./java.time.zone.-Zone-Rules.js";
import * as $j_java$002etime$002ezone$002e$002dZone$002dRules$002dException from "./java.time.zone.-Zone-Rules-Exception.js";
import * as $j_java$002eutil$002e$002dAbstract$002dMap from "./java.util.-Abstract-Map.js";
import * as $j_java$002eutil$002e$002dArray$002dList from "./java.util.-Array-List.js";
import * as $j_java$002eutil$002e$002dCollections$0024 from "./java.util.-Collections$.js";
import * as $j_java$002eutil$002e$002dHash$002dMap$0024$002dEntry$002dSet from "./java.util.-Hash-Map$-Entry-Set.js";
import * as $j_java$002eutil$002e$002dHash$002dMap$0024$002dKey$002dSet from "./java.util.-Hash-Map$-Key-Set.js";
import * as $j_java$002eutil$002e$002dLocale from "./java.util.-Locale.js";
import * as $j_scala$002eruntime$002e$002dEnum$002dValue from "./scala.runtime.-Enum-Value.js";
var $p;
/** @constructor */
function $c_Ljava_time_Instant$() {
  this.J5 = null;
  this.J6 = false;
}
export { $c_Ljava_time_Instant$ as $c_Ljava_time_Instant$ };
$p = $c_Ljava_time_Instant$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_Instant$;
/** @constructor */
function $h_Ljava_time_Instant$() {
}
export { $h_Ljava_time_Instant$ as $h_Ljava_time_Instant$ };
$h_Ljava_time_Instant$.prototype = $p;
$p.AY = (function() {
  if ((!this.J6)) {
    this.J5 = new $c_Ljava_time_Instant(0, 0, 0);
    this.J6 = true;
  }
  return this.J5;
});
$p.Cd = (function(epochSecond_$_lo, epochSecond_$_hi, nanoAdjustment_$_lo, nanoAdjustment_$_hi) {
  var sign = (nanoAdjustment_$_hi >> 31);
  var xlo = (nanoAdjustment_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((nanoAdjustment_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.0000000000000017E-9 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var rHat = ((rlo - Math.imul(1000000000, lo)) | 0);
  if ((rHat < 0)) {
    var lo$1 = ((lo - 1) | 0);
    var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$1;
    var absR_$_hi = hi$1;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((nanoAdjustment_$_hi < 0)) {
    var lo$2 = ((-absR_$_lo) | 0);
    var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
    var quot_$_lo = lo$2;
    var quot_$_hi = hi$2;
  } else {
    var quot_$_lo = absR_$_lo;
    var quot_$_hi = absR_$_hi;
  }
  if ((nanoAdjustment_$_hi >= 0)) {
    var $x_1 = true;
  } else {
    var b0 = (65535 & quot_$_lo);
    var b1 = ((quot_$_lo >>> 16) | 0);
    var a0b0 = Math.imul(51712, b0);
    var a1b0 = Math.imul(15258, b0);
    var a0b1 = Math.imul(51712, b1);
    var lo$4 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var $x_1 = (((lo$4 ^ nanoAdjustment_$_lo) | (((((((Math.imul(1000000000, quot_$_hi) + Math.imul(15258, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0) ^ nanoAdjustment_$_hi)) === 0);
  }
  if ($x_1) {
    var b_$_lo = quot_$_lo;
    var b_$_hi = quot_$_hi;
  } else {
    var lo$5 = ((quot_$_lo - 1) | 0);
    var hi$4 = ((((quot_$_hi - 1) | 0) + ((lo$5 !== (-1)) | 0)) | 0);
    var b_$_lo = lo$5;
    var b_$_hi = hi$4;
  }
  var this$19 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
  var lo$6 = ((epochSecond_$_lo + b_$_lo) | 0);
  var hi$5 = ((((epochSecond_$_hi + b_$_hi) | 0) + (((lo$6 >>> 0) < (epochSecond_$_lo >>> 0)) | 0)) | 0);
  if ((((hi$5 ^ epochSecond_$_hi) & (hi$5 ^ b_$_hi)) < 0)) {
    this$19.au();
  }
  var sign$1 = (nanoAdjustment_$_hi >> 31);
  var xlo$1 = (nanoAdjustment_$_lo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((nanoAdjustment_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  var aHat$1 = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
  var x$2 = (1.0000000000000017E-9 * aHat$1);
  var lo$10 = (x$2 | 0.0);
  ((2.3283064365386963E-10 * x$2) | 0.0);
  var rHat$1 = ((rlo$1 - Math.imul(1000000000, lo$10)) | 0);
  if ((rHat$1 < 0)) {
    var lo$11 = ((1000000000 + rHat$1) | 0);
    var absR$1_$_lo = lo$11;
    var absR$1_$_hi = 0;
  } else {
    var absR$1_$_lo = rHat$1;
    var absR$1_$_hi = 0;
  }
  if ((nanoAdjustment_$_hi < 0)) {
    var lo$12 = ((-absR$1_$_lo) | 0);
    var hi$10 = ((((-absR$1_$_hi) | 0) - ((lo$12 !== 0) | 0)) | 0);
    var rem_$_lo = lo$12;
    var rem_$_hi = hi$10;
  } else {
    var rem_$_lo = absR$1_$_lo;
    var rem_$_hi = absR$1_$_hi;
  }
  if (((nanoAdjustment_$_hi >= 0) || ((rem_$_lo | rem_$_hi) === 0))) {
    var x$4_$_lo = rem_$_lo;
    var x$4_$_hi = rem_$_hi;
  } else {
    var lo$14 = ((1000000000 + rem_$_lo) | 0);
    var hi$11 = ((rem_$_hi + (((lo$14 >>> 0) < 1000000000) | 0)) | 0);
    var x$4_$_lo = lo$14;
    var x$4_$_hi = hi$11;
  }
  return this.r7(lo$6, hi$5, x$4_$_lo);
});
$p.U9 = (function(temporal) {
  try {
    var $x_1 = temporal.ai($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
    var instantSecs_$_lo = $x_1.l;
    var instantSecs_$_hi = $x_1.h;
    var nanoOfSecond = temporal.cC($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
    var $x_2 = $m_Ljava_time_Instant$();
    var hi = (nanoOfSecond >> 31);
    return $x_2.Cd(instantSecs_$_lo, instantSecs_$_hi, nanoOfSecond, hi);
  } catch (e) {
    if ((e instanceof $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException)) {
      var ex = e;
      throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__jl_Throwable__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ((("Unable to obtain Instant from TemporalAccessor: " + temporal) + ", type ") + $j_java$002elang$002e$002dObject.$objectClassName(temporal)), ex);
    } else {
      throw e;
    }
  }
});
$p.r7 = (function(seconds_$_lo, seconds_$_hi, nanoOfSecond) {
  var hi = (nanoOfSecond >> 31);
  if ((((seconds_$_lo | nanoOfSecond) | (seconds_$_hi | hi)) === 0)) {
    return this.AY();
  } else if ((((seconds_$_hi === (-7347440)) ? ((seconds_$_lo >>> 0) < 342103040) : (seconds_$_hi < (-7347440))) || ((seconds_$_hi === 7347410) ? ((seconds_$_lo >>> 0) > 4204099839) : (seconds_$_hi > 7347410)))) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), "Instant exceeds minimum or maximum instant");
  } else {
    return new $c_Ljava_time_Instant(seconds_$_lo, seconds_$_hi, nanoOfSecond);
  }
});
var $d_Ljava_time_Instant$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Instant$, "java.time.Instant$", ({
  kQ: 1
}));
export { $d_Ljava_time_Instant$ as $d_Ljava_time_Instant$ };
var $n_Ljava_time_Instant$;
function $m_Ljava_time_Instant$() {
  if ((!$n_Ljava_time_Instant$)) {
    $n_Ljava_time_Instant$ = new $c_Ljava_time_Instant$();
  }
  return $n_Ljava_time_Instant$;
}
export { $m_Ljava_time_Instant$ as $m_Ljava_time_Instant$ };
function $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate($thiz, year, month, dayOfMonth) {
  if ((dayOfMonth > 28)) {
    var $x_2 = $m_Ljava_time_chrono_IsoChronology$().bz();
    var hi = (year >> 31);
    var $x_1 = (dayOfMonth > month.BZ($x_2.jp(year, hi)));
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    if ((dayOfMonth === 29)) {
      throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), (("Invalid date 'February 29' as '" + year) + "' is not a leap year"));
    } else {
      throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), (((("Invalid date '" + month.q) + " ") + dayOfMonth) + "'"));
    }
  } else {
    return new $c_Ljava_time_LocalDate(year, month.gx(), dayOfMonth);
  }
}
export { $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate as $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate };
/** @constructor */
function $c_Ljava_time_LocalDate$() {
  this.rY = 0;
  this.AW = 0;
  this.AX = 0;
  $n_Ljava_time_LocalDate$ = this;
  this.rY = 146097;
  var value = this.rY;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(5, b0);
  var a0b1 = Math.imul(5, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(5, hi) + ((c1part >>> 16) | 0)) | 0);
  var lo$1 = ((lo - 10957) | 0);
  var hi$2 = ((((hi$1 - 1) | 0) + (((lo$1 >>> 0) < 4294956339) | 0)) | 0);
  this.AW = lo$1;
  this.AX = hi$2;
}
export { $c_Ljava_time_LocalDate$ as $c_Ljava_time_LocalDate$ };
$p = $c_Ljava_time_LocalDate$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_LocalDate$;
/** @constructor */
function $h_Ljava_time_LocalDate$() {
}
export { $h_Ljava_time_LocalDate$ as $h_Ljava_time_LocalDate$ };
$h_Ljava_time_LocalDate$.prototype = $p;
$p.eA = (function(year, month, dayOfMonth) {
  var this$2 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  var hi = (year >> 31);
  this$2.G.ak(year, hi, this$2);
  var this$4 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
  var hi$1 = (month >> 31);
  this$4.G.ak(month, hi$1, this$4);
  var this$6 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
  var hi$2 = (dayOfMonth >> 31);
  this$6.G.ak(dayOfMonth, hi$2, this$6);
  return $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate(this, year, $m_Ljava_time_Month$().xK(month), dayOfMonth);
});
$p.Cf = (function(year, dayOfYear) {
  var this$2 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  var hi = (year >> 31);
  this$2.G.ak(year, hi, this$2);
  var this$4 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
  var hi$1 = (dayOfYear >> 31);
  this$4.G.ak(dayOfYear, hi$1, this$4);
  var $x_1 = $m_Ljava_time_chrono_IsoChronology$().bz();
  var hi$2 = (year >> 31);
  var leap = $x_1.jp(year, hi$2);
  if (((dayOfYear === 366) && (!leap))) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), (("Invalid date 'DayOfYear 366' as '" + year) + "' is not a leap year"));
  }
  var moy = $m_Ljava_time_Month$().xK(((1 + ((((dayOfYear - 1) | 0) / 31) | 0)) | 0));
  if ((dayOfYear > ((((moy.Bs(leap) + moy.BZ(leap)) | 0) - 1) | 0))) {
    moy = moy.WD(1, 0);
  }
  return $p_Ljava_time_LocalDate$__create__I__Ljava_time_Month__I__Ljava_time_LocalDate(this, year, moy, ((1 + ((dayOfYear - moy.Bs(leap)) | 0)) | 0));
});
$p.gE = (function(epochDay_$_lo, epochDay_$_hi) {
  var this$1 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
  this$1.G.ak(epochDay_$_lo, epochDay_$_hi, this$1);
  var x_$_lo = this.AW;
  var x_$_hi = this.AX;
  var lo = ((epochDay_$_lo + x_$_lo) | 0);
  var hi = ((((epochDay_$_hi + x_$_hi) | 0) + (((lo >>> 0) < (epochDay_$_lo >>> 0)) | 0)) | 0);
  var zeroDay_$_lo = lo;
  var zeroDay_$_hi = hi;
  var x$1_$_lo = zeroDay_$_lo;
  var x$1_$_hi = zeroDay_$_hi;
  var lo$1 = ((x$1_$_lo - 60) | 0);
  var hi$1 = ((((x$1_$_hi - 1) | 0) + (((lo$1 >>> 0) < 4294967236) | 0)) | 0);
  zeroDay_$_lo = lo$1;
  zeroDay_$_hi = hi$1;
  var adjust_$_lo = 0;
  var adjust_$_hi = 0;
  var x$2_$_lo = zeroDay_$_lo;
  var x$2_$_hi = zeroDay_$_hi;
  if ((x$2_$_hi < 0)) {
    var x$3_$_lo = zeroDay_$_lo;
    var x$3_$_hi = zeroDay_$_hi;
    var lo$2 = ((1 + x$3_$_lo) | 0);
    var hi$2 = ((x$3_$_hi + ((lo$2 === 0) | 0)) | 0);
    var value = this.rY;
    var $x_1 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo$2, hi$2, value, (value >> 31));
    var x$4_$_lo = $x_1.l;
    var x$4_$_hi = $x_1.h;
    var lo$3 = ((x$4_$_lo - 1) | 0);
    var hi$4 = ((((x$4_$_hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
    var b0 = (65535 & lo$3);
    var b1 = ((lo$3 >>> 16) | 0);
    var a0b0 = Math.imul(400, b0);
    var a0b1 = Math.imul(400, b1);
    var lo$4 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$5 = ((Math.imul(400, hi$4) + ((c1part >>> 16) | 0)) | 0);
    adjust_$_lo = lo$4;
    adjust_$_hi = hi$5;
    var x$5_$_lo = zeroDay_$_lo;
    var x$5_$_hi = zeroDay_$_hi;
    var lo$5 = ((-lo$3) | 0);
    var hi$6 = ((((-hi$4) | 0) - ((lo$5 !== 0) | 0)) | 0);
    var value$1 = this.rY;
    var hi$7 = (value$1 >> 31);
    var a0 = (65535 & lo$5);
    var a1 = ((lo$5 >>> 16) | 0);
    var b0$1 = (65535 & value$1);
    var b1$1 = ((value$1 >>> 16) | 0);
    var a0b0$1 = Math.imul(a0, b0$1);
    var a1b0 = Math.imul(a1, b0$1);
    var a0b1$1 = Math.imul(a0, b1$1);
    var lo$6 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$8 = ((((((((Math.imul(lo$5, hi$7) + Math.imul(hi$6, value$1)) | 0) + Math.imul(a1, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
    var lo$7 = ((x$5_$_lo + lo$6) | 0);
    var hi$9 = ((((x$5_$_hi + hi$8) | 0) + (((lo$7 >>> 0) < (x$5_$_lo >>> 0)) | 0)) | 0);
    zeroDay_$_lo = lo$7;
    zeroDay_$_hi = hi$9;
  }
  var x$6_$_lo = zeroDay_$_lo;
  var x$6_$_hi = zeroDay_$_hi;
  var b0$2 = (65535 & x$6_$_lo);
  var b1$2 = ((x$6_$_lo >>> 16) | 0);
  var a0b0$2 = Math.imul(400, b0$2);
  var a0b1$2 = Math.imul(400, b1$2);
  var lo$8 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$10 = ((Math.imul(400, x$6_$_hi) + ((c1part$2 >>> 16) | 0)) | 0);
  var lo$9 = ((591 + lo$8) | 0);
  var hi$11 = ((hi$10 + (((lo$9 >>> 0) < 591) | 0)) | 0);
  var value$2 = this.rY;
  var $x_2 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo$9, hi$11, value$2, (value$2 >> 31));
  var yearEst_$_lo = $x_2.l;
  var yearEst_$_hi = $x_2.h;
  var x$12_$_lo = zeroDay_$_lo;
  var x$12_$_hi = zeroDay_$_hi;
  var x$7_$_lo = yearEst_$_lo;
  var x$7_$_hi = yearEst_$_hi;
  var b0$3 = (65535 & x$7_$_lo);
  var b1$3 = ((x$7_$_lo >>> 16) | 0);
  var a0b0$3 = Math.imul(365, b0$3);
  var a0b1$3 = Math.imul(365, b1$3);
  var lo$10 = ((a0b0$3 + (a0b1$3 << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$13 = ((Math.imul(365, x$7_$_hi) + ((c1part$3 >>> 16) | 0)) | 0);
  var num_$_lo = yearEst_$_lo;
  var num_$_hi = yearEst_$_hi;
  var hi$14 = (num_$_hi >> 1);
  var lo$12 = ((hi$14 >>> 30) | 0);
  var lo$13 = ((num_$_lo + lo$12) | 0);
  var hi$15 = ((num_$_hi + (((lo$13 >>> 0) < (num_$_lo >>> 0)) | 0)) | 0);
  var lo$14 = (((lo$13 >>> 2) | 0) | (hi$15 << 30));
  var hi$16 = (hi$15 >> 2);
  var lo$15 = ((lo$10 + lo$14) | 0);
  var hi$17 = ((((hi$13 + hi$16) | 0) + (((lo$15 >>> 0) < (lo$10 >>> 0)) | 0)) | 0);
  var num$1_$_lo = yearEst_$_lo;
  var num$1_$_hi = yearEst_$_hi;
  var sign = (num$1_$_hi >> 31);
  var xlo = (num$1_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((num$1_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 100) | 0);
  var k = ((rhi - Math.imul(100, quotHi)) | 0);
  var quotLo = ((0.010000000000000004 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((num$1_$_hi < 0)) {
    var lo$16 = ((-quotLo) | 0);
    var hi$18 = ((((-quotHi) | 0) - ((lo$16 !== 0) | 0)) | 0);
    var x$9_$_lo = lo$16;
    var x$9_$_hi = hi$18;
  } else {
    var x$9_$_lo = quotLo;
    var x$9_$_hi = quotHi;
  }
  var lo$17 = ((lo$15 - x$9_$_lo) | 0);
  var hi$19 = ((((hi$17 - x$9_$_hi) | 0) - (((lo$17 >>> 0) > (lo$15 >>> 0)) | 0)) | 0);
  var num$2_$_lo = yearEst_$_lo;
  var num$2_$_hi = yearEst_$_hi;
  var sign$1 = (num$2_$_hi >> 31);
  var xlo$1 = (num$2_$_lo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((num$2_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  var quotHi$1 = (((rhi$1 >>> 0) / 400) | 0);
  var k$1 = ((rhi$1 - Math.imul(400, quotHi$1)) | 0);
  var quotLo$1 = ((0.002500000000000001 * ((4.294967296E9 * k$1) + (rlo$1 >>> 0.0))) | 0.0);
  if ((num$2_$_hi < 0)) {
    var lo$18 = ((-quotLo$1) | 0);
    var hi$20 = ((((-quotHi$1) | 0) - ((lo$18 !== 0) | 0)) | 0);
    var x$11_$_lo = lo$18;
    var x$11_$_hi = hi$20;
  } else {
    var x$11_$_lo = quotLo$1;
    var x$11_$_hi = quotHi$1;
  }
  var lo$19 = ((lo$17 + x$11_$_lo) | 0);
  var hi$21 = ((((hi$19 + x$11_$_hi) | 0) + (((lo$19 >>> 0) < (lo$17 >>> 0)) | 0)) | 0);
  var lo$20 = ((x$12_$_lo - lo$19) | 0);
  var hi$22 = ((((x$12_$_hi - hi$21) | 0) - (((lo$20 >>> 0) > (x$12_$_lo >>> 0)) | 0)) | 0);
  var doyEst_$_lo = lo$20;
  var doyEst_$_hi = hi$22;
  var x$13_$_lo = doyEst_$_lo;
  var x$13_$_hi = doyEst_$_hi;
  if ((x$13_$_hi < 0)) {
    var x$14_$_lo = yearEst_$_lo;
    var x$14_$_hi = yearEst_$_hi;
    var lo$21 = ((x$14_$_lo - 1) | 0);
    var hi$23 = ((((x$14_$_hi - 1) | 0) + ((lo$21 !== (-1)) | 0)) | 0);
    yearEst_$_lo = lo$21;
    yearEst_$_hi = hi$23;
    var x$20_$_lo = zeroDay_$_lo;
    var x$20_$_hi = zeroDay_$_hi;
    var x$15_$_lo = yearEst_$_lo;
    var x$15_$_hi = yearEst_$_hi;
    var b0$4 = (65535 & x$15_$_lo);
    var b1$4 = ((x$15_$_lo >>> 16) | 0);
    var a0b0$4 = Math.imul(365, b0$4);
    var a0b1$4 = Math.imul(365, b1$4);
    var lo$22 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
    var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
    var hi$24 = ((Math.imul(365, x$15_$_hi) + ((c1part$4 >>> 16) | 0)) | 0);
    var num$3_$_lo = yearEst_$_lo;
    var num$3_$_hi = yearEst_$_hi;
    var hi$25 = (num$3_$_hi >> 1);
    var lo$24 = ((hi$25 >>> 30) | 0);
    var lo$25 = ((num$3_$_lo + lo$24) | 0);
    var hi$26 = ((num$3_$_hi + (((lo$25 >>> 0) < (num$3_$_lo >>> 0)) | 0)) | 0);
    var lo$26 = (((lo$25 >>> 2) | 0) | (hi$26 << 30));
    var hi$27 = (hi$26 >> 2);
    var lo$27 = ((lo$22 + lo$26) | 0);
    var hi$28 = ((((hi$24 + hi$27) | 0) + (((lo$27 >>> 0) < (lo$22 >>> 0)) | 0)) | 0);
    var num$4_$_lo = yearEst_$_lo;
    var num$4_$_hi = yearEst_$_hi;
    var sign$2 = (num$4_$_hi >> 31);
    var xlo$2 = (num$4_$_lo ^ sign$2);
    var rlo$2 = ((xlo$2 - sign$2) | 0);
    var rhi$2 = (((num$4_$_hi ^ sign$2) + (((rlo$2 >>> 0) < (xlo$2 >>> 0)) | 0)) | 0);
    var quotHi$2 = (((rhi$2 >>> 0) / 100) | 0);
    var k$2 = ((rhi$2 - Math.imul(100, quotHi$2)) | 0);
    var quotLo$2 = ((0.010000000000000004 * ((4.294967296E9 * k$2) + (rlo$2 >>> 0.0))) | 0.0);
    if ((num$4_$_hi < 0)) {
      var lo$28 = ((-quotLo$2) | 0);
      var hi$29 = ((((-quotHi$2) | 0) - ((lo$28 !== 0) | 0)) | 0);
      var x$17_$_lo = lo$28;
      var x$17_$_hi = hi$29;
    } else {
      var x$17_$_lo = quotLo$2;
      var x$17_$_hi = quotHi$2;
    }
    var lo$29 = ((lo$27 - x$17_$_lo) | 0);
    var hi$30 = ((((hi$28 - x$17_$_hi) | 0) - (((lo$29 >>> 0) > (lo$27 >>> 0)) | 0)) | 0);
    var num$5_$_lo = yearEst_$_lo;
    var num$5_$_hi = yearEst_$_hi;
    var sign$3 = (num$5_$_hi >> 31);
    var xlo$3 = (num$5_$_lo ^ sign$3);
    var rlo$3 = ((xlo$3 - sign$3) | 0);
    var rhi$3 = (((num$5_$_hi ^ sign$3) + (((rlo$3 >>> 0) < (xlo$3 >>> 0)) | 0)) | 0);
    var quotHi$3 = (((rhi$3 >>> 0) / 400) | 0);
    var k$3 = ((rhi$3 - Math.imul(400, quotHi$3)) | 0);
    var quotLo$3 = ((0.002500000000000001 * ((4.294967296E9 * k$3) + (rlo$3 >>> 0.0))) | 0.0);
    if ((num$5_$_hi < 0)) {
      var lo$30 = ((-quotLo$3) | 0);
      var hi$31 = ((((-quotHi$3) | 0) - ((lo$30 !== 0) | 0)) | 0);
      var x$19_$_lo = lo$30;
      var x$19_$_hi = hi$31;
    } else {
      var x$19_$_lo = quotLo$3;
      var x$19_$_hi = quotHi$3;
    }
    var lo$31 = ((lo$29 + x$19_$_lo) | 0);
    var hi$32 = ((((hi$30 + x$19_$_hi) | 0) + (((lo$31 >>> 0) < (lo$29 >>> 0)) | 0)) | 0);
    var lo$32 = ((x$20_$_lo - lo$31) | 0);
    var hi$33 = ((((x$20_$_hi - hi$32) | 0) - (((lo$32 >>> 0) > (x$20_$_lo >>> 0)) | 0)) | 0);
    doyEst_$_lo = lo$32;
    doyEst_$_hi = hi$33;
  }
  var x$21_$_lo = yearEst_$_lo;
  var x$21_$_hi = yearEst_$_hi;
  var x$22_$_lo = adjust_$_lo;
  var x$22_$_hi = adjust_$_hi;
  var lo$33 = ((x$21_$_lo + x$22_$_lo) | 0);
  var hi$34 = ((((x$21_$_hi + x$22_$_hi) | 0) + (((lo$33 >>> 0) < (x$21_$_lo >>> 0)) | 0)) | 0);
  yearEst_$_lo = lo$33;
  yearEst_$_hi = hi$34;
  var x$23_$_lo = doyEst_$_lo;
  var x$23_$_hi = doyEst_$_hi;
  var marchMonth0 = ((((2 + Math.imul(5, x$23_$_lo)) | 0) / 153) | 0);
  var month = ((1 + ((((2 + marchMonth0) | 0) % 12) | 0)) | 0);
  var dom = ((1 + ((x$23_$_lo - ((((5 + Math.imul(306, marchMonth0)) | 0) / 10) | 0)) | 0)) | 0);
  var x$24_$_lo = yearEst_$_lo;
  var x$24_$_hi = yearEst_$_hi;
  var value$3 = ((marchMonth0 / 10) | 0);
  var hi$35 = (value$3 >> 31);
  var lo$34 = ((x$24_$_lo + value$3) | 0);
  var hi$36 = ((((x$24_$_hi + hi$35) | 0) + (((lo$34 >>> 0) < (x$24_$_lo >>> 0)) | 0)) | 0);
  yearEst_$_lo = lo$34;
  yearEst_$_hi = hi$36;
  var this$80 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  var value$4_$_lo = yearEst_$_lo;
  var value$4_$_hi = yearEst_$_hi;
  return new $c_Ljava_time_LocalDate(this$80.G.b0(value$4_$_lo, value$4_$_hi, this$80), month, dom);
});
$p.Bw = (function(temporal) {
  var date = temporal.cg($m_Ljava_time_temporal_TemporalQueries$().fl());
  if ((date === null)) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ((("Unable to obtain LocalDate from TemporalAccessor: " + temporal) + ", type ") + $j_java$002elang$002e$002dObject.$objectClassName(temporal)));
  }
  return date;
});
$p.Wy = (function(text, formatter) {
  return formatter.Wz(text, new $c_Ljava_time_LocalDate$$anon$1());
});
$p.xx = (function(year, month, day) {
  var _day;
  switch (month) {
    case 2: {
      var $x_1 = $m_Ljava_time_chrono_IsoChronology$().bz();
      var hi = (year >> 31);
      if ($x_1.jp(year, hi)) {
        var b = 29;
      } else {
        var b = 28;
      }
      var _day = ((day < b) ? day : b);
      break;
    }
    case 4:
    case 6:
    case 9:
    case 11: {
      var _day = ((day < 30) ? day : 30);
      break;
    }
    default: {
      var _day = day;
    }
  }
  return $m_Ljava_time_LocalDate$().eA(year, month, _day);
});
var $d_Ljava_time_LocalDate$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_LocalDate$, "java.time.LocalDate$", ({
  kR: 1
}));
export { $d_Ljava_time_LocalDate$ as $d_Ljava_time_LocalDate$ };
var $n_Ljava_time_LocalDate$;
function $m_Ljava_time_LocalDate$() {
  if ((!$n_Ljava_time_LocalDate$)) {
    $n_Ljava_time_LocalDate$ = new $c_Ljava_time_LocalDate$();
  }
  return $n_Ljava_time_LocalDate$;
}
export { $m_Ljava_time_LocalDate$ as $m_Ljava_time_LocalDate$ };
/** @constructor */
function $c_Ljava_time_LocalDateTime$() {
}
export { $c_Ljava_time_LocalDateTime$ as $c_Ljava_time_LocalDateTime$ };
$p = $c_Ljava_time_LocalDateTime$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_LocalDateTime$;
/** @constructor */
function $h_Ljava_time_LocalDateTime$() {
}
export { $h_Ljava_time_LocalDateTime$ as $h_Ljava_time_LocalDateTime$ };
$h_Ljava_time_LocalDateTime$.prototype = $p;
$p.Wn = (function(year, month, dayOfMonth, hour, minute, second, nanoOfSecond) {
  return new $c_Ljava_time_LocalDateTime($m_Ljava_time_LocalDate$().eA(year, month, dayOfMonth), $m_Ljava_time_LocalTime$().PK(hour, minute, second, nanoOfSecond));
});
$p.Cb = (function(date, time) {
  return new $c_Ljava_time_LocalDateTime(date, time);
});
$p.Cc = (function(epochSecond_$_lo, epochSecond_$_hi, nanoOfSecond, offset) {
  var value = offset.dj;
  var hi = (value >> 31);
  var lo = ((epochSecond_$_lo + value) | 0);
  var hi$1 = ((((epochSecond_$_hi + hi) | 0) + (((lo >>> 0) < (epochSecond_$_lo >>> 0)) | 0)) | 0);
  var sign = (hi$1 >> 31);
  var xlo = (lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((hi$1 ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 86400) | 0);
  var k = ((rhi - Math.imul(86400, quotHi)) | 0);
  var quotLo = ((1.1574074074074079E-5 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((hi$1 < 0)) {
    var lo$1 = ((-quotLo) | 0);
    var hi$2 = ((((-quotHi) | 0) - ((lo$1 !== 0) | 0)) | 0);
    var quot_$_lo = lo$1;
    var quot_$_hi = hi$2;
  } else {
    var quot_$_lo = quotLo;
    var quot_$_hi = quotHi;
  }
  if ((hi$1 >= 0)) {
    var $x_1 = true;
  } else {
    var b0 = (65535 & quot_$_lo);
    var b1 = ((quot_$_lo >>> 16) | 0);
    var a0b0 = Math.imul(20864, b0);
    var a0b1 = Math.imul(20864, b1);
    var lo$3 = ((a0b0 + (((b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var $x_1 = (((lo$3 ^ lo) | (((((((Math.imul(86400, quot_$_hi) + b1) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + b0) | 0) >>> 16) | 0)) | 0) ^ hi$1)) === 0);
  }
  if ($x_1) {
    var localEpochDay_$_lo = quot_$_lo;
    var localEpochDay_$_hi = quot_$_hi;
  } else {
    var lo$4 = ((quot_$_lo - 1) | 0);
    var hi$4 = ((((quot_$_hi - 1) | 0) + ((lo$4 !== (-1)) | 0)) | 0);
    var localEpochDay_$_lo = lo$4;
    var localEpochDay_$_hi = hi$4;
  }
  var sign$1 = (hi$1 >> 31);
  var xlo$1 = (lo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((hi$1 ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  var k$2 = (((rhi$1 >>> 0) % 86400) | 0);
  var quotLo$2 = ((1.1574074074074079E-5 * ((4.294967296E9 * k$2) + (rlo$1 >>> 0.0))) | 0.0);
  var remLo = ((rlo$1 - Math.imul(86400, quotLo$2)) | 0);
  if ((hi$1 < 0)) {
    var lo$5 = ((-remLo) | 0);
    var hi$5 = ((-((lo$5 !== 0) | 0)) | 0);
    var rem_$_lo = lo$5;
    var rem_$_hi = hi$5;
  } else {
    var rem_$_lo = remLo;
    var rem_$_hi = 0;
  }
  if (((hi$1 >= 0) || ((rem_$_lo | rem_$_hi) === 0))) {
    var x$2_$_lo = rem_$_lo;
    var x$2_$_hi = rem_$_hi;
  } else {
    var lo$7 = ((86400 + rem_$_lo) | 0);
    var hi$6 = ((rem_$_hi + (((lo$7 >>> 0) < 86400) | 0)) | 0);
    var x$2_$_lo = lo$7;
    var x$2_$_hi = hi$6;
  }
  var $x_3 = $m_Ljava_time_LocalDate$().gE(localEpochDay_$_lo, localEpochDay_$_hi);
  var $x_2 = $m_Ljava_time_LocalTime$();
  var hi$7 = (x$2_$_lo >> 31);
  return new $c_Ljava_time_LocalDateTime($x_3, $x_2.Wq(x$2_$_lo, hi$7, nanoOfSecond));
});
var $d_Ljava_time_LocalDateTime$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_LocalDateTime$, "java.time.LocalDateTime$", ({
  kT: 1
}));
export { $d_Ljava_time_LocalDateTime$ as $d_Ljava_time_LocalDateTime$ };
var $n_Ljava_time_LocalDateTime$;
function $m_Ljava_time_LocalDateTime$() {
  if ((!$n_Ljava_time_LocalDateTime$)) {
    $n_Ljava_time_LocalDateTime$ = new $c_Ljava_time_LocalDateTime$();
  }
  return $n_Ljava_time_LocalDateTime$;
}
export { $m_Ljava_time_LocalDateTime$ as $m_Ljava_time_LocalDateTime$ };
function $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime($thiz) {
  if ((!$thiz.J8)) {
    var hours = new ($d_Ljava_time_LocalTime.r().C)(24);
    var i = 0;
    while ((i < hours.a.length)) {
      hours.a[i] = new $c_Ljava_time_LocalTime(i, 0, 0, 0);
      i = ((1 + i) | 0);
    }
    $thiz.J7 = hours;
    $thiz.J8 = true;
  }
  return $thiz.J7;
}
export { $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime as $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime };
/** @constructor */
function $c_Ljava_time_LocalTime$() {
  this.J7 = null;
  this.J8 = false;
}
export { $c_Ljava_time_LocalTime$ as $c_Ljava_time_LocalTime$ };
$p = $c_Ljava_time_LocalTime$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_LocalTime$;
/** @constructor */
function $h_Ljava_time_LocalTime$() {
}
export { $h_Ljava_time_LocalTime$ as $h_Ljava_time_LocalTime$ };
$h_Ljava_time_LocalTime$.prototype = $p;
$p.C9 = (function(hour, minute) {
  var this$2 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  var hi = (hour >> 31);
  this$2.G.ak(hour, hi, this$2);
  if ((minute === 0)) {
    return $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime(this).a[hour];
  } else {
    var this$4 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    var hi$1 = (minute >> 31);
    this$4.G.ak(minute, hi$1, this$4);
    return new $c_Ljava_time_LocalTime(hour, minute, 0, 0);
  }
});
$p.Wo = (function(hour, minute, second) {
  var this$2 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  var hi = (hour >> 31);
  this$2.G.ak(hour, hi, this$2);
  if (((minute | second) === 0)) {
    return $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime(this).a[hour];
  }
  var this$4 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
  var hi$1 = (minute >> 31);
  this$4.G.ak(minute, hi$1, this$4);
  var this$6 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
  var hi$2 = (second >> 31);
  this$6.G.ak(second, hi$2, this$6);
  return new $c_Ljava_time_LocalTime(hour, minute, second, 0);
});
$p.PK = (function(hour, minute, second, nanoOfSecond) {
  var this$2 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  var hi = (hour >> 31);
  this$2.G.ak(hour, hi, this$2);
  var this$4 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
  var hi$1 = (minute >> 31);
  this$4.G.ak(minute, hi$1, this$4);
  var this$6 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
  var hi$2 = (second >> 31);
  this$6.G.ak(second, hi$2, this$6);
  var this$8 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var hi$3 = (nanoOfSecond >> 31);
  this$8.G.ak(nanoOfSecond, hi$3, this$8);
  return this.fT(hour, minute, second, nanoOfSecond);
});
$p.Wr = (function(secondOfDay_$_lo, secondOfDay_$_hi) {
  var _secondOfDay_$_lo = secondOfDay_$_lo;
  var _secondOfDay_$_hi = secondOfDay_$_hi;
  var this$1 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
  var value_$_lo = _secondOfDay_$_lo;
  var value_$_hi = _secondOfDay_$_hi;
  this$1.G.ak(value_$_lo, value_$_hi, this$1);
  var num_$_lo = _secondOfDay_$_lo;
  var num_$_hi = _secondOfDay_$_hi;
  var sign = (num_$_hi >> 31);
  var xlo = (num_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((num_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 3600) | 0);
  var k = ((rhi - Math.imul(3600, quotHi)) | 0);
  var quotLo = ((2.777777777777779E-4 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((num_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    var x$1_$_lo = lo;
    var x$1_$_hi = hi;
  } else {
    var x$1_$_lo = quotLo;
    var x$1_$_hi = quotHi;
  }
  var x$2_$_lo = _secondOfDay_$_lo;
  var x$2_$_hi = _secondOfDay_$_hi;
  var value$1 = Math.imul(3600, x$1_$_lo);
  var hi$1 = (value$1 >> 31);
  var lo$1 = ((x$2_$_lo - value$1) | 0);
  var hi$2 = ((((x$2_$_hi - hi$1) | 0) - (((lo$1 >>> 0) > (x$2_$_lo >>> 0)) | 0)) | 0);
  _secondOfDay_$_lo = lo$1;
  _secondOfDay_$_hi = hi$2;
  var num$1_$_lo = _secondOfDay_$_lo;
  var num$1_$_hi = _secondOfDay_$_hi;
  var sign$1 = (num$1_$_hi >> 31);
  var xlo$1 = (num$1_$_lo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((num$1_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  var quotHi$1 = (((rhi$1 >>> 0) / 60) | 0);
  var k$1 = ((rhi$1 - Math.imul(60, quotHi$1)) | 0);
  var quotLo$1 = ((0.016666666666666673 * ((4.294967296E9 * k$1) + (rlo$1 >>> 0.0))) | 0.0);
  if ((num$1_$_hi < 0)) {
    var lo$2 = ((-quotLo$1) | 0);
    var hi$3 = ((((-quotHi$1) | 0) - ((lo$2 !== 0) | 0)) | 0);
    var x$4_$_lo = lo$2;
    var x$4_$_hi = hi$3;
  } else {
    var x$4_$_lo = quotLo$1;
    var x$4_$_hi = quotHi$1;
  }
  var x$5_$_lo = _secondOfDay_$_lo;
  var x$5_$_hi = _secondOfDay_$_hi;
  var value$2 = Math.imul(60, x$4_$_lo);
  var hi$4 = (value$2 >> 31);
  var lo$3 = ((x$5_$_lo - value$2) | 0);
  var hi$5 = ((((x$5_$_hi - hi$4) | 0) - (((lo$3 >>> 0) > (x$5_$_lo >>> 0)) | 0)) | 0);
  _secondOfDay_$_lo = lo$3;
  _secondOfDay_$_hi = hi$5;
  return this.fT(x$1_$_lo, x$4_$_lo, _secondOfDay_$_lo, 0);
});
$p.Wq = (function(secondOfDay_$_lo, secondOfDay_$_hi, nanoOfSecond) {
  var _secondOfDay_$_lo = secondOfDay_$_lo;
  var _secondOfDay_$_hi = secondOfDay_$_hi;
  var this$1 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
  var value_$_lo = _secondOfDay_$_lo;
  var value_$_hi = _secondOfDay_$_hi;
  this$1.G.ak(value_$_lo, value_$_hi, this$1);
  var this$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var hi = (nanoOfSecond >> 31);
  this$3.G.ak(nanoOfSecond, hi, this$3);
  var num_$_lo = _secondOfDay_$_lo;
  var num_$_hi = _secondOfDay_$_hi;
  var sign = (num_$_hi >> 31);
  var xlo = (num_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((num_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 3600) | 0);
  var k = ((rhi - Math.imul(3600, quotHi)) | 0);
  var quotLo = ((2.777777777777779E-4 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((num_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi$1 = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    var x$1_$_lo = lo;
    var x$1_$_hi = hi$1;
  } else {
    var x$1_$_lo = quotLo;
    var x$1_$_hi = quotHi;
  }
  var x$2_$_lo = _secondOfDay_$_lo;
  var x$2_$_hi = _secondOfDay_$_hi;
  var value$1 = Math.imul(3600, x$1_$_lo);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((x$2_$_lo - value$1) | 0);
  var hi$3 = ((((x$2_$_hi - hi$2) | 0) - (((lo$1 >>> 0) > (x$2_$_lo >>> 0)) | 0)) | 0);
  _secondOfDay_$_lo = lo$1;
  _secondOfDay_$_hi = hi$3;
  var num$1_$_lo = _secondOfDay_$_lo;
  var num$1_$_hi = _secondOfDay_$_hi;
  var sign$1 = (num$1_$_hi >> 31);
  var xlo$1 = (num$1_$_lo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((num$1_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  var quotHi$1 = (((rhi$1 >>> 0) / 60) | 0);
  var k$1 = ((rhi$1 - Math.imul(60, quotHi$1)) | 0);
  var quotLo$1 = ((0.016666666666666673 * ((4.294967296E9 * k$1) + (rlo$1 >>> 0.0))) | 0.0);
  if ((num$1_$_hi < 0)) {
    var lo$2 = ((-quotLo$1) | 0);
    var hi$4 = ((((-quotHi$1) | 0) - ((lo$2 !== 0) | 0)) | 0);
    var x$4_$_lo = lo$2;
    var x$4_$_hi = hi$4;
  } else {
    var x$4_$_lo = quotLo$1;
    var x$4_$_hi = quotHi$1;
  }
  var x$5_$_lo = _secondOfDay_$_lo;
  var x$5_$_hi = _secondOfDay_$_hi;
  var value$2 = Math.imul(60, x$4_$_lo);
  var hi$5 = (value$2 >> 31);
  var lo$3 = ((x$5_$_lo - value$2) | 0);
  var hi$6 = ((((x$5_$_hi - hi$5) | 0) - (((lo$3 >>> 0) > (x$5_$_lo >>> 0)) | 0)) | 0);
  _secondOfDay_$_lo = lo$3;
  _secondOfDay_$_hi = hi$6;
  return this.fT(x$1_$_lo, x$4_$_lo, _secondOfDay_$_lo, nanoOfSecond);
});
$p.l5 = (function(nanoOfDay_$_lo, nanoOfDay_$_hi) {
  var _nanoOfDay_$_lo = nanoOfDay_$_lo;
  var _nanoOfDay_$_hi = nanoOfDay_$_hi;
  var this$1 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
  var value_$_lo = _nanoOfDay_$_lo;
  var value_$_hi = _nanoOfDay_$_hi;
  this$1.G.ak(value_$_lo, value_$_hi, this$1);
  var num_$_lo = _nanoOfDay_$_lo;
  var num_$_hi = _nanoOfDay_$_hi;
  var sign = (num_$_hi >> 31);
  var xlo = (num_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((num_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (2.777777777777782E-13 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a0b0 = Math.imul(40960, b0);
  var a1b0 = Math.imul(12472, b0);
  var a0b1 = Math.imul(40960, b1);
  var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((Math.imul(817405952, hi) + Math.imul(838, lo)) | 0) + Math.imul(12472, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((rlo - lo$1) | 0);
  var hi$2 = ((((rhi - hi$1) | 0) - (((lo$2 >>> 0) > (rlo >>> 0)) | 0)) | 0);
  if ((hi$2 < 0)) {
    var lo$3 = ((lo - 1) | 0);
    var hi$3 = ((((hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$3;
    var absR_$_hi = hi$3;
  } else {
    var absR_$_lo = lo;
    var absR_$_hi = hi;
  }
  if ((num_$_hi < 0)) {
    var lo$4 = ((-absR_$_lo) | 0);
    var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
    var x$2_$_lo = lo$4;
    var x$2_$_hi = hi$4;
  } else {
    var x$2_$_lo = absR_$_lo;
    var x$2_$_hi = absR_$_hi;
  }
  var x$3_$_lo = _nanoOfDay_$_lo;
  var x$3_$_hi = _nanoOfDay_$_hi;
  var hi$5 = (x$2_$_lo >> 31);
  var b0$1 = (65535 & x$2_$_lo);
  var b1$1 = ((x$2_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(40960, b0$1);
  var a1b0$1 = Math.imul(12472, b0$1);
  var a0b1$1 = Math.imul(40960, b1$1);
  var lo$5 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$6 = ((((((((Math.imul(817405952, hi$5) + Math.imul(838, x$2_$_lo)) | 0) + Math.imul(12472, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$6 = ((x$3_$_lo - lo$5) | 0);
  var hi$7 = ((((x$3_$_hi - hi$6) | 0) - (((lo$6 >>> 0) > (x$3_$_lo >>> 0)) | 0)) | 0);
  _nanoOfDay_$_lo = lo$6;
  _nanoOfDay_$_hi = hi$7;
  var num$1_$_lo = _nanoOfDay_$_lo;
  var num$1_$_hi = _nanoOfDay_$_hi;
  var sign$1 = (num$1_$_hi >> 31);
  var xlo$1 = (num$1_$_lo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((num$1_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  var aHat$1 = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
  var x$4 = (1.6666666666666693E-11 * aHat$1);
  var lo$7 = (x$4 | 0.0);
  var hi$8 = ((2.3283064365386963E-10 * x$4) | 0.0);
  var b0$2 = (65535 & lo$7);
  var b1$2 = ((lo$7 >>> 16) | 0);
  var a0b0$2 = Math.imul(22528, b0$2);
  var a1b0$2 = Math.imul(63559, b0$2);
  var a0b1$2 = Math.imul(22528, b1$2);
  var lo$8 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$9 = ((((((((Math.imul((-129542144), hi$8) + Math.imul(13, lo$7)) | 0) + Math.imul(63559, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var lo$9 = ((rlo$1 - lo$8) | 0);
  var hi$10 = ((((rhi$1 - hi$9) | 0) - (((lo$9 >>> 0) > (rlo$1 >>> 0)) | 0)) | 0);
  if ((hi$10 < 0)) {
    var lo$10 = ((lo$7 - 1) | 0);
    var hi$11 = ((((hi$8 - 1) | 0) + ((lo$10 !== (-1)) | 0)) | 0);
    var absR$1_$_lo = lo$10;
    var absR$1_$_hi = hi$11;
  } else {
    var absR$1_$_lo = lo$7;
    var absR$1_$_hi = hi$8;
  }
  if ((num$1_$_hi < 0)) {
    var lo$11 = ((-absR$1_$_lo) | 0);
    var hi$12 = ((((-absR$1_$_hi) | 0) - ((lo$11 !== 0) | 0)) | 0);
    var x$6_$_lo = lo$11;
    var x$6_$_hi = hi$12;
  } else {
    var x$6_$_lo = absR$1_$_lo;
    var x$6_$_hi = absR$1_$_hi;
  }
  var x$7_$_lo = _nanoOfDay_$_lo;
  var x$7_$_hi = _nanoOfDay_$_hi;
  var hi$13 = (x$6_$_lo >> 31);
  var b0$3 = (65535 & x$6_$_lo);
  var b1$3 = ((x$6_$_lo >>> 16) | 0);
  var a0b0$3 = Math.imul(22528, b0$3);
  var a1b0$3 = Math.imul(63559, b0$3);
  var a0b1$3 = Math.imul(22528, b1$3);
  var lo$12 = ((a0b0$3 + (((a1b0$3 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$14 = ((((((((Math.imul((-129542144), hi$13) + Math.imul(13, x$6_$_lo)) | 0) + Math.imul(63559, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$13 = ((x$7_$_lo - lo$12) | 0);
  var hi$15 = ((((x$7_$_hi - hi$14) | 0) - (((lo$13 >>> 0) > (x$7_$_lo >>> 0)) | 0)) | 0);
  _nanoOfDay_$_lo = lo$13;
  _nanoOfDay_$_hi = hi$15;
  var num$2_$_lo = _nanoOfDay_$_lo;
  var num$2_$_hi = _nanoOfDay_$_hi;
  var sign$2 = (num$2_$_hi >> 31);
  var xlo$2 = (num$2_$_lo ^ sign$2);
  var rlo$2 = ((xlo$2 - sign$2) | 0);
  var rhi$2 = (((num$2_$_hi ^ sign$2) + (((rlo$2 >>> 0) < (xlo$2 >>> 0)) | 0)) | 0);
  var aHat$2 = ((4.294967296E9 * (rhi$2 >>> 0.0)) + (rlo$2 >>> 0.0));
  var x$8 = (1.0000000000000017E-9 * aHat$2);
  var lo$14 = (x$8 | 0.0);
  var hi$16 = ((2.3283064365386963E-10 * x$8) | 0.0);
  var rHat = ((rlo$2 - Math.imul(1000000000, lo$14)) | 0);
  if ((rHat < 0)) {
    var lo$15 = ((lo$14 - 1) | 0);
    var hi$17 = ((((hi$16 - 1) | 0) + ((lo$15 !== (-1)) | 0)) | 0);
    var absR$2_$_lo = lo$15;
    var absR$2_$_hi = hi$17;
  } else {
    var absR$2_$_lo = lo$14;
    var absR$2_$_hi = hi$16;
  }
  if ((num$2_$_hi < 0)) {
    var lo$16 = ((-absR$2_$_lo) | 0);
    var hi$18 = ((((-absR$2_$_hi) | 0) - ((lo$16 !== 0) | 0)) | 0);
    var x$10_$_lo = lo$16;
    var x$10_$_hi = hi$18;
  } else {
    var x$10_$_lo = absR$2_$_lo;
    var x$10_$_hi = absR$2_$_hi;
  }
  var x$11_$_lo = _nanoOfDay_$_lo;
  var x$11_$_hi = _nanoOfDay_$_hi;
  var hi$19 = (x$10_$_lo >> 31);
  var b0$4 = (65535 & x$10_$_lo);
  var b1$4 = ((x$10_$_lo >>> 16) | 0);
  var a0b0$4 = Math.imul(51712, b0$4);
  var a1b0$4 = Math.imul(15258, b0$4);
  var a0b1$4 = Math.imul(51712, b1$4);
  var lo$17 = ((a0b0$4 + (((a1b0$4 + a0b1$4) | 0) << 16)) | 0);
  var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
  var hi$20 = ((((((Math.imul(1000000000, hi$19) + Math.imul(15258, b1$4)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$4) | 0) >>> 16) | 0)) | 0);
  var lo$18 = ((x$11_$_lo - lo$17) | 0);
  var hi$21 = ((((x$11_$_hi - hi$20) | 0) - (((lo$18 >>> 0) > (x$11_$_lo >>> 0)) | 0)) | 0);
  _nanoOfDay_$_lo = lo$18;
  _nanoOfDay_$_hi = hi$21;
  return this.fT(x$2_$_lo, x$6_$_lo, x$10_$_lo, _nanoOfDay_$_lo);
});
$p.fT = (function(hour, minute, second, nanoOfSecond) {
  return ((((minute | second) | nanoOfSecond) === 0) ? $p_Ljava_time_LocalTime$__HOURS__ALjava_time_LocalTime(this).a[hour] : new $c_Ljava_time_LocalTime(hour, minute, second, nanoOfSecond));
});
var $d_Ljava_time_LocalTime$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_LocalTime$, "java.time.LocalTime$", ({
  kU: 1
}));
export { $d_Ljava_time_LocalTime$ as $d_Ljava_time_LocalTime$ };
var $n_Ljava_time_LocalTime$;
function $m_Ljava_time_LocalTime$() {
  if ((!$n_Ljava_time_LocalTime$)) {
    $n_Ljava_time_LocalTime$ = new $c_Ljava_time_LocalTime$();
  }
  return $n_Ljava_time_LocalTime$;
}
export { $m_Ljava_time_LocalTime$ as $m_Ljava_time_LocalTime$ };
function $p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map($thiz) {
  if ((!$thiz.Jn)) {
    $thiz.Jm = $j_java$002eutil$002e$002dAbstract$002dMap.$ct_ju_HashMap__(new $j_java$002eutil$002e$002dAbstract$002dMap.$c_ju_HashMap());
    $thiz.Jn = true;
  }
  return $thiz.Jm;
}
export { $p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map as $p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map };
function $p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map($thiz) {
  if ((!$thiz.Jj)) {
    $thiz.Ji = $j_java$002eutil$002e$002dAbstract$002dMap.$ct_ju_HashMap__(new $j_java$002eutil$002e$002dAbstract$002dMap.$c_ju_HashMap());
    $thiz.Jj = true;
  }
  return $thiz.Ji;
}
export { $p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map as $p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map };
/** @constructor */
function $c_Ljava_time_ZoneOffset$() {
  this.Jm = null;
  this.Jn = false;
  this.Ji = null;
  this.Jj = false;
  this.zK = 0;
  this.vj = 0;
  this.Jl = 0;
  this.Jk = 0;
  this.Jo = null;
  this.Jp = false;
  $n_Ljava_time_ZoneOffset$ = this;
  this.zK = 3600;
  this.vj = 60;
  this.Jl = 60;
  this.Jk = Math.imul(18, this.zK);
}
export { $c_Ljava_time_ZoneOffset$ as $c_Ljava_time_ZoneOffset$ };
$p = $c_Ljava_time_ZoneOffset$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_ZoneOffset$;
/** @constructor */
function $h_Ljava_time_ZoneOffset$() {
}
export { $h_Ljava_time_ZoneOffset$ as $h_Ljava_time_ZoneOffset$ };
$h_Ljava_time_ZoneOffset$.prototype = $p;
$p.B0 = (function() {
  if ((!this.Jp)) {
    this.Jo = $m_Ljava_time_ZoneOffset$().ul(0);
    this.Jp = true;
  }
  return this.Jo;
});
$p.ul = (function(totalSeconds) {
  var sign = (totalSeconds >> 31);
  if (((((totalSeconds ^ sign) - sign) | 0) > this.Jk)) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), "Zone offset not in valid range: -18:00 to +18:00");
  } else if ((((totalSeconds % $j_java$002elang$002e$002dObject.$checkIntDivisor(Math.imul(15, this.vj))) | 0) === 0)) {
    var result = $j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map(this), totalSeconds, null);
    if ((result === null)) {
      result = new $c_Ljava_time_ZoneOffset(totalSeconds);
      $p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map(this).dO(totalSeconds, result, (totalSeconds ^ ((totalSeconds >>> 16) | 0)), false);
      result = $j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($p_Ljava_time_ZoneOffset$__SECONDS_CACHE__ju_Map(this), totalSeconds, null);
      var this$7 = $p_Ljava_time_ZoneOffset$__ID_CACHE__ju_Map(this);
      var key = result.lS;
      var $x_2 = result;
      if ((key === null)) {
        var $x_1 = 0;
      } else {
        var originalHash = $j_java$002elang$002e$002dObject.$f_T__hashCode__I(key);
        var $x_1 = (originalHash ^ ((originalHash >>> 16) | 0));
      }
      this$7.dO(key, $x_2, $x_1, false);
    }
    return result;
  } else {
    return new $c_Ljava_time_ZoneOffset(totalSeconds);
  }
});
$p.VE = (function(totalSeconds) {
  if ((totalSeconds === 0)) {
    return "Z";
  } else {
    var sign = (totalSeconds >> 31);
    var absTotalSeconds = (((totalSeconds ^ sign) - sign) | 0);
    var buf = $j_java$002elang$002e$002dObject.$ct_scm_StringBuilder__(new $j_java$002elang$002e$002dObject.$c_scm_StringBuilder());
    var absHours = ((absTotalSeconds / $j_java$002elang$002e$002dObject.$checkIntDivisor(this.zK)) | 0);
    var absMinutes = ((((absTotalSeconds / $j_java$002elang$002e$002dObject.$checkIntDivisor(this.vj)) | 0) % $j_java$002elang$002e$002dObject.$checkIntDivisor(this.Jl)) | 0);
    buf.eQ(((totalSeconds < 0) ? "-" : "+")).eQ(((absHours < 10) ? "0" : "")).d9(absHours).eQ(((absMinutes < 10) ? ":0" : ":")).d9(absMinutes);
    var absSeconds = ((absTotalSeconds % $j_java$002elang$002e$002dObject.$checkIntDivisor(this.vj)) | 0);
    if ((absSeconds !== 0)) {
      buf.eQ(((absSeconds < 10) ? ":0" : ":")).d9(absSeconds);
    }
    return buf.ax.r;
  }
});
var $d_Ljava_time_ZoneOffset$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_ZoneOffset$, "java.time.ZoneOffset$", ({
  la: 1
}));
export { $d_Ljava_time_ZoneOffset$ as $d_Ljava_time_ZoneOffset$ };
var $n_Ljava_time_ZoneOffset$;
function $m_Ljava_time_ZoneOffset$() {
  if ((!$n_Ljava_time_ZoneOffset$)) {
    $n_Ljava_time_ZoneOffset$ = new $c_Ljava_time_ZoneOffset$();
  }
  return $n_Ljava_time_ZoneOffset$;
}
export { $m_Ljava_time_ZoneOffset$ as $m_Ljava_time_ZoneOffset$ };
/** @constructor */
function $c_Ljava_time_ZonedDateTime$() {
}
export { $c_Ljava_time_ZonedDateTime$ as $c_Ljava_time_ZonedDateTime$ };
$p = $c_Ljava_time_ZonedDateTime$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_ZonedDateTime$;
/** @constructor */
function $h_Ljava_time_ZonedDateTime$() {
}
export { $h_Ljava_time_ZonedDateTime$ as $h_Ljava_time_ZonedDateTime$ };
$h_Ljava_time_ZonedDateTime$.prototype = $p;
$p.xN = (function(localDateTime, zone, preferredOffset) {
  var _localDateTime = localDateTime;
  if ((zone instanceof $c_Ljava_time_ZoneOffset)) {
    return new $c_Ljava_time_ZonedDateTime(_localDateTime, zone, zone);
  } else {
    var rules = $m_Ljava_time_zone_ZoneRules$().xM(zone);
    var validOffsets = $j_java$002eutil$002e$002dCollections$0024.$m_ju_Collections$().XE(rules.g9);
    var offset$2 = null;
    if ((validOffsets.T() === 1)) {
      offset$2 = validOffsets.fS(0);
    } else if ((validOffsets.T() === 0)) {
    } else if (((preferredOffset !== null) && validOffsets.ae(preferredOffset))) {
      offset$2 = preferredOffset;
    } else {
      offset$2 = validOffsets.fS(0);
    }
    return new $c_Ljava_time_ZonedDateTime(_localDateTime, offset$2, zone);
  }
});
$p.PL = (function(instant, zone) {
  var $x_1 = instant;
  return this.BU($x_1.er, $x_1.es, instant.d0, zone);
});
$p.Wp = (function(localDateTime, offset, zone) {
  var $x_1 = localDateTime.QH(offset);
  return this.BU($x_1.l, $x_1.h, localDateTime.aO.cv, zone);
});
$p.BU = (function(epochSecond_$_lo, epochSecond_$_hi, nanoOfSecond, zone) {
  var rules = $m_Ljava_time_zone_ZoneRules$().xM(zone);
  var $x_1 = $m_Ljava_time_Instant$();
  var hi = (nanoOfSecond >> 31);
  $x_1.Cd(epochSecond_$_lo, epochSecond_$_hi, nanoOfSecond, hi);
  var offset = rules.g9;
  return new $c_Ljava_time_ZonedDateTime($m_Ljava_time_LocalDateTime$().Cc(epochSecond_$_lo, epochSecond_$_hi, nanoOfSecond, offset), offset, zone);
});
var $d_Ljava_time_ZonedDateTime$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_ZonedDateTime$, "java.time.ZonedDateTime$", ({
  lc: 1
}));
export { $d_Ljava_time_ZonedDateTime$ as $d_Ljava_time_ZonedDateTime$ };
var $n_Ljava_time_ZonedDateTime$;
function $m_Ljava_time_ZonedDateTime$() {
  if ((!$n_Ljava_time_ZonedDateTime$)) {
    $n_Ljava_time_ZonedDateTime$ = new $c_Ljava_time_ZonedDateTime$();
  }
  return $n_Ljava_time_ZonedDateTime$;
}
export { $m_Ljava_time_ZonedDateTime$ as $m_Ljava_time_ZonedDateTime$ };
/** @constructor */
function $c_Ljava_time_chrono_Chronology$() {
}
export { $c_Ljava_time_chrono_Chronology$ as $c_Ljava_time_chrono_Chronology$ };
$p = $c_Ljava_time_chrono_Chronology$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_chrono_Chronology$;
/** @constructor */
function $h_Ljava_time_chrono_Chronology$() {
}
export { $h_Ljava_time_chrono_Chronology$ as $h_Ljava_time_chrono_Chronology$ };
$h_Ljava_time_chrono_Chronology$.prototype = $p;
$p.Ua = (function(temporal) {
  var obj = temporal.cg($m_Ljava_time_temporal_TemporalQueries$().eR());
  return ((obj !== null) ? obj : $m_Ljava_time_chrono_IsoChronology$().bz());
});
var $d_Ljava_time_chrono_Chronology$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_chrono_Chronology$, "java.time.chrono.Chronology$", ({
  le: 1
}));
export { $d_Ljava_time_chrono_Chronology$ as $d_Ljava_time_chrono_Chronology$ };
var $n_Ljava_time_chrono_Chronology$;
function $m_Ljava_time_chrono_Chronology$() {
  if ((!$n_Ljava_time_chrono_Chronology$)) {
    $n_Ljava_time_chrono_Chronology$ = new $c_Ljava_time_chrono_Chronology$();
  }
  return $n_Ljava_time_chrono_Chronology$;
}
export { $m_Ljava_time_chrono_Chronology$ as $m_Ljava_time_chrono_Chronology$ };
/** @constructor */
function $c_Ljava_time_chrono_IsoChronology$() {
  this.Jq = null;
  this.Jr = false;
}
export { $c_Ljava_time_chrono_IsoChronology$ as $c_Ljava_time_chrono_IsoChronology$ };
$p = $c_Ljava_time_chrono_IsoChronology$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_chrono_IsoChronology$;
/** @constructor */
function $h_Ljava_time_chrono_IsoChronology$() {
}
export { $h_Ljava_time_chrono_IsoChronology$ as $h_Ljava_time_chrono_IsoChronology$ };
$h_Ljava_time_chrono_IsoChronology$.prototype = $p;
$p.bz = (function() {
  if ((!this.Jr)) {
    this.Jq = new $c_Ljava_time_chrono_IsoChronology();
    this.Jr = true;
  }
  return this.Jq;
});
var $d_Ljava_time_chrono_IsoChronology$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_chrono_IsoChronology$, "java.time.chrono.IsoChronology$", ({
  lf: 1
}));
export { $d_Ljava_time_chrono_IsoChronology$ as $d_Ljava_time_chrono_IsoChronology$ };
var $n_Ljava_time_chrono_IsoChronology$;
function $m_Ljava_time_chrono_IsoChronology$() {
  if ((!$n_Ljava_time_chrono_IsoChronology$)) {
    $n_Ljava_time_chrono_IsoChronology$ = new $c_Ljava_time_chrono_IsoChronology$();
  }
  return $n_Ljava_time_chrono_IsoChronology$;
}
export { $m_Ljava_time_chrono_IsoChronology$ as $m_Ljava_time_chrono_IsoChronology$ };
function $p_Ljava_time_format_DateTimeFormatter__createError__jl_CharSequence__jl_RuntimeException__Ljava_time_format_DateTimeParseException($thiz, text, ex) {
  return $j_java$002etime$002eformat$002e$002dDate$002dTime$002dParse$002dException.$ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__jl_Throwable__(new $j_java$002etime$002eformat$002e$002dDate$002dTime$002dParse$002dException.$c_Ljava_time_format_DateTimeParseException(), ((("Text '" + (($j_java$002elang$002e$002dObject.$dp_length__I(text) > 64) ? ($j_java$002elang$002e$002dObject.$dp_toString__T($j_java$002elang$002e$002dObject.$dp_subSequence__I__I__jl_CharSequence(text, 0, 64)) + "...") : $j_java$002elang$002e$002dObject.$dp_toString__T(text))) + "' could not be parsed: ") + ex.ii()), text, 0, ex);
}
export { $p_Ljava_time_format_DateTimeFormatter__createError__jl_CharSequence__jl_RuntimeException__Ljava_time_format_DateTimeParseException as $p_Ljava_time_format_DateTimeFormatter__createError__jl_CharSequence__jl_RuntimeException__Ljava_time_format_DateTimeParseException };
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatter(printerParser, locale, decimalStyle, resolverStyle, resolverFields, chrono, zone) {
  this.hG = null;
  this.s1 = null;
  this.s0 = null;
  this.vl = null;
  this.vk = null;
  this.rZ = null;
  this.s2 = null;
  this.hG = printerParser;
  this.s1 = locale;
  this.s0 = decimalStyle;
  this.vl = resolverStyle;
  this.vk = resolverFields;
  this.rZ = chrono;
  this.s2 = zone;
}
export { $c_Ljava_time_format_DateTimeFormatter as $c_Ljava_time_format_DateTimeFormatter };
$p = $c_Ljava_time_format_DateTimeFormatter.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_DateTimeFormatter;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatter() {
}
export { $h_Ljava_time_format_DateTimeFormatter as $h_Ljava_time_format_DateTimeFormatter };
$h_Ljava_time_format_DateTimeFormatter.prototype = $p;
$p.Yu = (function(chrono) {
  var a = this.rZ;
  if (((a === null) ? (chrono === null) : $j_java$002etime$002echrono$002e$002dChronology.$f_Ljava_time_chrono_Chronology__equals__O__Z(a, chrono))) {
    return this;
  } else {
    return new $c_Ljava_time_format_DateTimeFormatter(this.hG, this.s1, this.s0, this.vl, this.vk, chrono, this.s2);
  }
});
$p.R1 = (function(resolverStyle) {
  var a = this.vl;
  if (((a === null) ? (resolverStyle === null) : (a === resolverStyle))) {
    return this;
  } else {
    return new $c_Ljava_time_format_DateTimeFormatter(this.hG, this.s1, this.s0, resolverStyle, this.vk, this.rZ, this.s2);
  }
});
$p.U7 = (function(temporal) {
  var buf = $j_java$002elang$002e$002dObject.$ct_jl_StringBuilder__I__(new $j_java$002elang$002e$002dObject.$c_jl_StringBuilder(), 32);
  this.U8(temporal, buf);
  return buf.r;
});
$p.U8 = (function(temporal, appendable) {
  try {
    var context = $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__(new $c_Ljava_time_format_internal_TTBPDateTimePrintContext(), temporal, this);
    if ((appendable instanceof $j_java$002elang$002e$002dObject.$c_jl_StringBuilder)) {
      this.hG.hr(context, appendable);
    } else {
      var buf = $j_java$002elang$002e$002dObject.$ct_jl_StringBuilder__I__(new $j_java$002elang$002e$002dObject.$c_jl_StringBuilder(), 32);
      this.hG.hr(context, buf);
      appendable.NY(buf);
    }
  } catch (e) {
    if (false) {
      var ex = e;
      throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__jl_Throwable__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ex.ii(), ex);
    } else {
      throw e;
    }
  }
});
$p.Wz = (function(text, type) {
  try {
    var builder = this.VF(text, null).X7(this.vl, this.vk);
    return type.dQ(builder);
  } catch (e) {
    var e$2 = ((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e));
    if ((e$2 instanceof $j_java$002etime$002eformat$002e$002dDate$002dTime$002dParse$002dException.$c_Ljava_time_format_DateTimeParseException)) {
      throw e$2;
    } else if ((e$2 instanceof $j_java$002elang$002e$002dObject.$c_jl_RuntimeException)) {
      throw $p_Ljava_time_format_DateTimeFormatter__createError__jl_CharSequence__jl_RuntimeException__Ljava_time_format_DateTimeParseException(this, text, e$2);
    } else {
      throw e;
    }
  }
});
$p.VF = (function(text, position) {
  var pos = ((position !== null) ? position : new $j_java$002etext$002e$002dParse$002dPosition.$c_Ljava_text_ParsePosition(0));
  var result = this.VG(text, pos);
  if ((((result === null) || (pos.gQ >= 0)) || ((position === null) && (pos.gR < $j_java$002elang$002e$002dObject.$dp_length__I(text))))) {
    var abbr = (($j_java$002elang$002e$002dObject.$dp_length__I(text) > 64) ? ($j_java$002elang$002e$002dObject.$dp_toString__T($j_java$002elang$002e$002dObject.$dp_subSequence__I__I__jl_CharSequence(text, 0, 64)) + "...") : $j_java$002elang$002e$002dObject.$dp_toString__T(text));
    if ((pos.gQ >= 0)) {
      throw $j_java$002etime$002eformat$002e$002dDate$002dTime$002dParse$002dException.$ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__(new $j_java$002etime$002eformat$002e$002dDate$002dTime$002dParse$002dException.$c_Ljava_time_format_DateTimeParseException(), ((("Text '" + abbr) + "' could not be parsed at index ") + pos.gQ), text, pos.gQ);
    } else {
      throw $j_java$002etime$002eformat$002e$002dDate$002dTime$002dParse$002dException.$ct_Ljava_time_format_DateTimeParseException__T__jl_CharSequence__I__(new $j_java$002etime$002eformat$002e$002dDate$002dTime$002dParse$002dException.$c_Ljava_time_format_DateTimeParseException(), ((("Text '" + abbr) + "' could not be parsed, unparsed text found at index ") + pos.gR), text, pos.gR);
    }
  }
  return result.Y5();
});
$p.VG = (function(text, position) {
  var context = $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_DateTimeFormatter__(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext(), this);
  var pos = this.hG.gG(context, text, position.gR);
  if ((pos < 0)) {
    position.gQ = (~pos);
    return null;
  } else {
    position.gR = pos;
    return $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(context);
  }
});
$p.b = (function() {
  var pattern = this.hG.b();
  if ((!(!pattern.startsWith("[")))) {
    return pattern;
  } else {
    var endIndex = ((pattern.length - 1) | 0);
    return pattern.substring(1, endIndex);
  }
});
var $d_Ljava_time_format_DateTimeFormatter = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_DateTimeFormatter, "java.time.format.DateTimeFormatter", ({
  lh: 1
}));
export { $d_Ljava_time_format_DateTimeFormatter as $d_Ljava_time_format_DateTimeFormatter };
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatter$() {
  this.Ju = null;
  this.Jv = false;
  this.Js = null;
  this.Jt = false;
}
export { $c_Ljava_time_format_DateTimeFormatter$ as $c_Ljava_time_format_DateTimeFormatter$ };
$p = $c_Ljava_time_format_DateTimeFormatter$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_DateTimeFormatter$;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatter$() {
}
export { $h_Ljava_time_format_DateTimeFormatter$ as $h_Ljava_time_format_DateTimeFormatter$ };
$h_Ljava_time_format_DateTimeFormatter$.prototype = $p;
$p.NK = (function() {
  if ((!this.Jv)) {
    var this$1 = $ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).Sl($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField(), 4, 10, $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024.$s_Ljava_time_format_SignStyle$__EXCEEDS_PAD__Ljava_time_format_SignStyle()).qQ(45).qR($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField(), 2).qQ(45).qR($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField(), 2);
    var style = $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle();
    this.Ju = this$1.CG($j_java$002eutil$002e$002dLocale.$m_ju_Locale$().sc).R1(style).Yu($m_Ljava_time_chrono_IsoChronology$().bz());
    this.Jv = true;
  }
  return this.Ju;
});
$p.RL = (function() {
  if ((!this.Jt)) {
    var this$1 = $ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).WA().Sk();
    var style = $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle();
    this.Js = this$1.CG($j_java$002eutil$002e$002dLocale.$m_ju_Locale$().sc).R1(style);
    this.Jt = true;
  }
  return this.Js;
});
var $d_Ljava_time_format_DateTimeFormatter$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_DateTimeFormatter$, "java.time.format.DateTimeFormatter$", ({
  li: 1
}));
export { $d_Ljava_time_format_DateTimeFormatter$ as $d_Ljava_time_format_DateTimeFormatter$ };
var $n_Ljava_time_format_DateTimeFormatter$;
function $m_Ljava_time_format_DateTimeFormatter$() {
  if ((!$n_Ljava_time_format_DateTimeFormatter$)) {
    $n_Ljava_time_format_DateTimeFormatter$ = new $c_Ljava_time_format_DateTimeFormatter$();
  }
  return $n_Ljava_time_format_DateTimeFormatter$;
}
export { $m_Ljava_time_format_DateTimeFormatter$ as $m_Ljava_time_format_DateTimeFormatter$ };
function $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__($thiz, parent, optional) {
  $thiz.s3 = parent;
  $thiz.Jw = optional;
  $thiz.bj = $thiz;
  $thiz.hH = $j_java$002eutil$002e$002dArray$002dList.$ct_ju_ArrayList__(new $j_java$002eutil$002e$002dArray$002dList.$c_ju_ArrayList());
  $thiz.vm = 0;
  $thiz.zL = 0;
  $thiz.iL = (-1);
  return $thiz;
}
export { $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__ as $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__ };
function $ct_Ljava_time_format_DateTimeFormatterBuilder__($thiz) {
  $ct_Ljava_time_format_DateTimeFormatterBuilder__Ljava_time_format_DateTimeFormatterBuilder__Z__($thiz, null, false);
  return $thiz;
}
export { $ct_Ljava_time_format_DateTimeFormatterBuilder__ as $ct_Ljava_time_format_DateTimeFormatterBuilder__ };
function $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder($thiz, pp) {
  if ((($thiz.bj.iL >= 0) && ($thiz.bj.hH.fS($thiz.bj.iL) instanceof $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dNumber$002dPrinter$002dParser.$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser))) {
    var activeValueParser = $thiz.bj.iL;
    var basePP = $thiz.bj.hH.fS(activeValueParser);
    if (((pp.dk === pp.eh) && (pp.ei === $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024.$s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle()))) {
      basePP = basePP.YA(pp.eh);
      $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, pp.QY());
      $thiz.bj.iL = activeValueParser;
    } else {
      basePP = basePP.QY();
      $thiz.bj.iL = $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, pp);
    }
    $thiz.bj.hH.Ct(activeValueParser, basePP);
  } else {
    $thiz.bj.iL = $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, pp);
  }
  return $thiz;
}
export { $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder as $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder };
function $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I($thiz, pp) {
  var _pp = pp;
  if (($thiz.bj.vm > 0)) {
    if ((_pp !== null)) {
      _pp = new $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dPad$002dPrinter$002dParser$002dDecorator.$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$PadPrinterParserDecorator(_pp, $thiz.bj.vm, $thiz.bj.zL);
    }
    $thiz.bj.vm = 0;
    $thiz.bj.zL = 0;
  }
  $thiz.bj.hH.eP(_pp);
  $thiz.bj.iL = (-1);
  return (($thiz.bj.hH.T() - 1) | 0);
}
export { $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I as $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I };
/** @constructor */
function $c_Ljava_time_format_DateTimeFormatterBuilder() {
  this.s3 = null;
  this.Jw = false;
  this.bj = null;
  this.hH = null;
  this.vm = 0;
  this.zL = 0;
  this.iL = 0;
}
export { $c_Ljava_time_format_DateTimeFormatterBuilder as $c_Ljava_time_format_DateTimeFormatterBuilder };
$p = $c_Ljava_time_format_DateTimeFormatterBuilder.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_DateTimeFormatterBuilder;
/** @constructor */
function $h_Ljava_time_format_DateTimeFormatterBuilder() {
}
export { $h_Ljava_time_format_DateTimeFormatterBuilder as $h_Ljava_time_format_DateTimeFormatterBuilder };
$h_Ljava_time_format_DateTimeFormatterBuilder.prototype = $p;
$p.WA = (function() {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dSettings$002dParser$0024.$s_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser$__INSENSITIVE__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$SettingsParser());
  return this;
});
$p.qR = (function(field, width) {
  if (((((width - 1) | 0) >>> 0) > 18)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), ("The width must be from 1 to 19 inclusive but was " + width));
  }
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder(this, $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dNumber$002dPrinter$002dParser.$ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dNumber$002dPrinter$002dParser.$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), field, width, width, $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024.$s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle()));
  return this;
});
$p.Sl = (function(field, minWidth, maxWidth, signStyle) {
  if (((minWidth === maxWidth) && (signStyle === $j_java$002etime$002eformat$002e$002dSign$002dStyle$0024.$s_Ljava_time_format_SignStyle$__NOT_NEGATIVE__Ljava_time_format_SignStyle()))) {
    return this.qR(field, maxWidth);
  }
  if (((((minWidth - 1) | 0) >>> 0) > 18)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), ("The minimum width must be from 1 to 19 inclusive but was " + minWidth));
  }
  if (((((maxWidth - 1) | 0) >>> 0) > 18)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), ("The maximum width must be from 1 to 19 inclusive but was " + maxWidth));
  }
  if ((maxWidth < minWidth)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalArgumentException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalArgumentException(), ((("The maximum width must exceed or equal the minimum width but " + maxWidth) + " < ") + minWidth));
  }
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendValue__Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_format_DateTimeFormatterBuilder(this, $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dNumber$002dPrinter$002dParser.$ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser__Ljava_time_temporal_TemporalField__I__I__Ljava_time_format_SignStyle__(new $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dNumber$002dPrinter$002dParser.$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$NumberPrinterParser(), field, minWidth, maxWidth, signStyle));
  return this;
});
$p.Sj = (function(field, minWidth, maxWidth, decimalPoint) {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dFraction$002dPrinter$002dParser.$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$FractionPrinterParser(field, minWidth, maxWidth, decimalPoint));
  return this;
});
$p.Sk = (function() {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser((-2)));
  return this;
});
$p.qQ = (function(literal) {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, new $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dChar$002dLiteral$002dPrinter$002dParser.$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CharLiteralPrinterParser(literal));
  return this;
});
$p.Sh = (function(formatter) {
  $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, formatter.hG.R0(false));
  return this;
});
$p.Ww = (function() {
  if ((this.bj.s3 === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_IllegalStateException__T__(new $j_java$002elang$002e$002dObject.$c_jl_IllegalStateException(), "Cannot call optionalEnd() as there was no previous call to optionalStart()");
  }
  if ((this.bj.hH.T() > 0)) {
    var cpp = $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dComposite$002dPrinter$002dParser.$ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__(new $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dComposite$002dPrinter$002dParser.$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(), this.bj.hH, this.bj.Jw);
    this.bj = this.bj.s3;
    $p_Ljava_time_format_DateTimeFormatterBuilder__appendInternal__Ljava_time_format_internal_DateTimePrinterParser__I(this, cpp);
  } else {
    this.bj = this.bj.s3;
  }
  return this;
});
$p.CG = (function(locale) {
  while ((this.bj.s3 !== null)) {
    this.Ww();
  }
  return new $c_Ljava_time_format_DateTimeFormatter($j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dComposite$002dPrinter$002dParser.$ct_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser__ju_List__Z__(new $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dComposite$002dPrinter$002dParser.$c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$CompositePrinterParser(), this.hH, false), locale, $j_java$002etime$002eformat$002e$002dDecimal$002dStyle$0024.$m_Ljava_time_format_DecimalStyle$().RN(), $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle(), null, null, null);
});
var $d_Ljava_time_format_DateTimeFormatterBuilder = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_DateTimeFormatterBuilder, "java.time.format.DateTimeFormatterBuilder", ({
  lj: 1
}));
export { $d_Ljava_time_format_DateTimeFormatterBuilder as $d_Ljava_time_format_DateTimeFormatterBuilder };
function $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__ju_Locale__Ljava_time_format_DecimalStyle__Ljava_time_chrono_Chronology__Ljava_time_ZoneId__Z__Z__($thiz, locale, symbols, overrideChronology, overrideZone, caseSensitive, strict) {
  $thiz.JA = locale;
  $thiz.k0 = symbols;
  $thiz.zM = overrideChronology;
  $thiz.zN = overrideZone;
  $thiz.lX = caseSensitive;
  $thiz.ej = strict;
  var list = $j_java$002eutil$002e$002dArray$002dList.$ct_ju_ArrayList__(new $j_java$002eutil$002e$002dArray$002dList.$c_ju_ArrayList());
  list.eP(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed($thiz));
  $thiz.iO = list;
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__ju_Locale__Ljava_time_format_DecimalStyle__Ljava_time_chrono_Chronology__Ljava_time_ZoneId__Z__Z__ as $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__ju_Locale__Ljava_time_format_DecimalStyle__Ljava_time_chrono_Chronology__Ljava_time_ZoneId__Z__Z__ };
function $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_DateTimeFormatter__($thiz, formatter) {
  $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__ju_Locale__Ljava_time_format_DecimalStyle__Ljava_time_chrono_Chronology__Ljava_time_ZoneId__Z__Z__($thiz, formatter.s1, formatter.s0, formatter.rZ, formatter.s2, true, true);
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_DateTimeFormatter__ as $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_DateTimeFormatter__ };
function $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__($thiz, other) {
  $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__ju_Locale__Ljava_time_format_DecimalStyle__Ljava_time_chrono_Chronology__Ljava_time_ZoneId__Z__Z__($thiz, other.JA, other.k0, other.zM, other.zN, other.lX, other.ej);
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__ as $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__ };
function $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed($thiz) {
  return $thiz.iO.fS((($thiz.iO.T() - 1) | 0));
}
export { $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed as $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeParseContext() {
  this.JA = null;
  this.k0 = null;
  this.zM = null;
  this.zN = null;
  this.lX = false;
  this.ej = false;
  this.iO = null;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeParseContext as $c_Ljava_time_format_internal_TTBPDateTimeParseContext };
$p = $c_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_internal_TTBPDateTimeParseContext;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeParseContext() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeParseContext as $h_Ljava_time_format_internal_TTBPDateTimeParseContext };
$h_Ljava_time_format_internal_TTBPDateTimeParseContext.prototype = $p;
$p.UO = (function() {
  var chrono = $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).lY;
  if ((chrono === null)) {
    chrono = this.zM;
    if ((chrono === null)) {
      chrono = $m_Ljava_time_chrono_IsoChronology$().bz();
    }
  }
  return chrono;
});
$p.O7 = (function(ch1, ch2) {
  return (this.lX ? (ch1 === ch2) : $j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dParse$002dContext$0024.$m_Ljava_time_format_internal_TTBPDateTimeParseContext$().SF(ch1, ch2));
});
$p.CB = (function() {
  this.iO.eP($p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).T0());
});
$p.OO = (function(successful) {
  if (successful) {
    this.iO.us(((this.iO.T() - 2) | 0));
  } else {
    this.iO.us(((this.iO.T() - 1) | 0));
  }
});
$p.kV = (function(field) {
  return $j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).fu, field, null);
});
$p.y8 = (function(field, value_$_lo, value_$_hi, errorPos, successPos) {
  var $x_2 = $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).fu;
  if ((field === null)) {
    var $x_1 = 0;
  } else {
    var originalHash = $j_java$002elang$002e$002dObject.$systemIdentityHashCode(field);
    var $x_1 = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  var old = $x_2.dO(field, $j_java$002elang$002e$002dObject.$bL(value_$_lo, value_$_hi), $x_1, false);
  if ((old !== null)) {
    var $x_4 = old;
    var this$4_$_lo = $x_4.l;
    var this$4_$_hi = $x_4.h;
    var $x_3 = (((this$4_$_lo ^ value_$_lo) | (this$4_$_hi ^ value_$_hi)) !== 0);
  } else {
    var $x_3 = false;
  }
  if ($x_3) {
    return (~errorPos);
  } else {
    return successPos;
  }
});
$p.b = (function() {
  return $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this).b();
});
var $d_Ljava_time_format_internal_TTBPDateTimeParseContext = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_internal_TTBPDateTimeParseContext, "java.time.format.internal.TTBPDateTimeParseContext", ({
  lH: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeParseContext as $d_Ljava_time_format_internal_TTBPDateTimeParseContext };
function $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__ju_Locale__Ljava_time_format_DecimalStyle__($thiz, temporal, locale, symbols) {
  $thiz.s6 = temporal;
  $thiz.zO = symbols;
  $thiz.lZ = 0;
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__ju_Locale__Ljava_time_format_DecimalStyle__ as $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__ju_Locale__Ljava_time_format_DecimalStyle__ };
function $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__($thiz, temporal, formatter) {
  $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__ju_Locale__Ljava_time_format_DecimalStyle__($thiz, $m_Ljava_time_format_internal_TTBPDateTimePrintContext$().Sc(temporal, formatter), formatter.s1, formatter.s0);
  return $thiz;
}
export { $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__ as $ct_Ljava_time_format_internal_TTBPDateTimePrintContext__Ljava_time_temporal_TemporalAccessor__Ljava_time_format_DateTimeFormatter__ };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimePrintContext() {
  this.s6 = null;
  this.zO = null;
  this.lZ = 0;
}
export { $c_Ljava_time_format_internal_TTBPDateTimePrintContext as $c_Ljava_time_format_internal_TTBPDateTimePrintContext };
$p = $c_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_internal_TTBPDateTimePrintContext;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimePrintContext() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimePrintContext as $h_Ljava_time_format_internal_TTBPDateTimePrintContext };
$h_Ljava_time_format_internal_TTBPDateTimePrintContext.prototype = $p;
$p.CB = (function() {
  this.lZ = ((1 + this.lZ) | 0);
});
$p.TK = (function() {
  this.lZ = ((this.lZ - 1) | 0);
});
$p.BF = (function(field) {
  try {
    return this.s6.ai(field);
  } catch (e) {
    if ((e instanceof $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException)) {
      var ex = e;
      if ((this.lZ > 0)) {
        return null;
      } else {
        throw ex;
      }
    } else {
      throw e;
    }
  }
});
$p.b = (function() {
  return this.s6.b();
});
var $d_Ljava_time_format_internal_TTBPDateTimePrintContext = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_internal_TTBPDateTimePrintContext, "java.time.format.internal.TTBPDateTimePrintContext", ({
  lK: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimePrintContext as $d_Ljava_time_format_internal_TTBPDateTimePrintContext };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimePrintContext$() {
}
export { $c_Ljava_time_format_internal_TTBPDateTimePrintContext$ as $c_Ljava_time_format_internal_TTBPDateTimePrintContext$ };
$p = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimePrintContext$() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimePrintContext$ as $h_Ljava_time_format_internal_TTBPDateTimePrintContext$ };
$h_Ljava_time_format_internal_TTBPDateTimePrintContext$.prototype = $p;
$p.Sc = (function(temporal, formatter) {
  var overrideChrono = new $j_java$002elang$002e$002dObject.$c_sr_ObjectRef(formatter.rZ);
  var overrideZone = formatter.s2;
  if (((overrideChrono.aK === null) && (overrideZone === null))) {
    return temporal;
  } else {
    var temporalChrono = temporal.cg($m_Ljava_time_temporal_TemporalQueries$().eR());
    var temporalZone = temporal.cg($m_Ljava_time_temporal_TemporalQueries$().f1());
    var b = overrideChrono.aK;
    if (((temporalChrono === null) ? (b === null) : $j_java$002etime$002echrono$002e$002dChronology.$f_Ljava_time_chrono_Chronology__equals__O__Z(temporalChrono, b))) {
      overrideChrono.aK = null;
    }
    var b$1 = overrideZone;
    if (((temporalZone === null) ? (b$1 === null) : temporalZone.f(b$1))) {
      overrideZone = null;
    }
    if (((overrideChrono.aK === null) && (overrideZone === null))) {
      return temporal;
    }
    var effectiveChrono = ((overrideChrono.aK !== null) ? overrideChrono.aK : temporalChrono);
    var effectiveZone = ((overrideZone !== null) ? overrideZone : temporalZone);
    if ((overrideZone !== null)) {
      if (temporal.ba($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField())) {
        if ((effectiveChrono === null)) {
          $m_Ljava_time_chrono_IsoChronology$().bz();
        }
        return $m_Ljava_time_ZonedDateTime$().PL($m_Ljava_time_Instant$().U9(temporal), overrideZone);
      }
      var normalizedOffset = overrideZone.Wl();
      var temporalOffset = temporal.cg($m_Ljava_time_temporal_TemporalQueries$().gF());
      if ((((normalizedOffset instanceof $c_Ljava_time_ZoneOffset) && (temporalOffset !== null)) && (!((normalizedOffset === null) ? (temporalOffset === null) : normalizedOffset.f(temporalOffset))))) {
        throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ((("Invalid override zone for temporal: " + overrideZone) + " ") + temporal));
      }
    }
    if ((overrideChrono.aK !== null)) {
      if (temporal.ba($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
        var $x_1 = $m_Ljava_time_LocalDate$().Bw(temporal);
      } else {
        if ((!((overrideChrono.aK === $m_Ljava_time_chrono_IsoChronology$().bz()) && (temporalChrono === null)))) {
          var xs = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$m_Ljava_time_temporal_ChronoField$().Yn();
          var f = ((f$3) => {
            if ((f$3.hk() && temporal.ba(f$3))) {
              throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ((("Invalid override chronology for temporal: " + overrideChrono.aK) + " ") + temporal));
            }
          });
          var len = xs.a.length;
          var i = 0;
          if ((xs !== null)) {
            while ((i < len)) {
              var x0 = xs.a[i];
              f(x0);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_I)) {
            while ((i < len)) {
              var x0$1 = xs.a[i];
              f(x0$1);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_D)) {
            while ((i < len)) {
              var x0$2 = xs.a[i];
              f(x0$2);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_J)) {
            while ((i < len)) {
              var $x_2 = xs.a;
              var $x_3 = (i << 1);
              var x0$3_$_lo = $x_2[$x_3];
              var x0$3_$_hi = $x_2[(($x_3 + 1) | 0)];
              f($j_java$002elang$002e$002dObject.$bL(x0$3_$_lo, x0$3_$_hi));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_F)) {
            while ((i < len)) {
              var x0$4 = xs.a[i];
              f(x0$4);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_C)) {
            while ((i < len)) {
              var x0$5 = xs.a[i];
              f($j_java$002elang$002e$002dObject.$bC(x0$5));
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_B)) {
            while ((i < len)) {
              var x0$6 = xs.a[i];
              f(x0$6);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_S)) {
            while ((i < len)) {
              var x0$7 = xs.a[i];
              f(x0$7);
              i = ((1 + i) | 0);
            }
          } else if ((xs instanceof $j_java$002elang$002e$002dObject.$ac_Z)) {
            while ((i < len)) {
              var x0$8 = xs.a[i];
              f(x0$8);
              i = ((1 + i) | 0);
            }
          } else {
            throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(xs);
          }
        }
        var $x_1 = null;
      }
    } else {
      var $x_1 = null;
    }
    return new $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1($x_1, temporal, effectiveChrono, effectiveZone);
  }
});
var $d_Ljava_time_format_internal_TTBPDateTimePrintContext$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_internal_TTBPDateTimePrintContext$, "java.time.format.internal.TTBPDateTimePrintContext$", ({
  lL: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimePrintContext$ as $d_Ljava_time_format_internal_TTBPDateTimePrintContext$ };
var $n_Ljava_time_format_internal_TTBPDateTimePrintContext$;
function $m_Ljava_time_format_internal_TTBPDateTimePrintContext$() {
  if ((!$n_Ljava_time_format_internal_TTBPDateTimePrintContext$)) {
    $n_Ljava_time_format_internal_TTBPDateTimePrintContext$ = new $c_Ljava_time_format_internal_TTBPDateTimePrintContext$();
  }
  return $n_Ljava_time_format_internal_TTBPDateTimePrintContext$;
}
export { $m_Ljava_time_format_internal_TTBPDateTimePrintContext$ as $m_Ljava_time_format_internal_TTBPDateTimePrintContext$ };
function $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange($thiz, field) {
  if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    if ($thiz.ba(field)) {
      return field.G;
    } else {
      throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
    }
  } else {
    return $thiz.bX(field);
  }
}
export { $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange as $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange };
function $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I($thiz, field) {
  var $x_2 = $thiz.bX(field);
  var $x_1 = $thiz.ai(field);
  return $x_2.b0($x_1.l, $x_1.h, field);
}
export { $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I as $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I };
function $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O($thiz, query) {
  matchAlts1: {
    matchAlts2: {
      var x = $m_Ljava_time_temporal_TemporalQueries$().f1();
      if (((x === null) ? (query === null) : (x === query))) {
        break matchAlts2;
      }
      var x$3 = $m_Ljava_time_temporal_TemporalQueries$().eR();
      if (((x$3 === null) ? (query === null) : (x$3 === query))) {
        break matchAlts2;
      }
      var x$5 = $m_Ljava_time_temporal_TemporalQueries$().gH();
      if (((x$5 === null) ? (query === null) : (x$5 === query))) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return null;
  }
  return query.dQ($thiz);
}
export { $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O as $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O };
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$() {
  this.JQ = null;
  this.JR = false;
  this.JF = null;
  this.JG = false;
  this.JN = null;
  this.JO = false;
  this.JL = null;
  this.JM = false;
  this.JP = null;
  this.JS = false;
  this.JH = null;
  this.JI = false;
  this.JJ = null;
  this.JK = false;
}
export { $c_Ljava_time_temporal_TemporalQueries$ as $c_Ljava_time_temporal_TemporalQueries$ };
$p = $c_Ljava_time_temporal_TemporalQueries$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_temporal_TemporalQueries$;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$() {
}
export { $h_Ljava_time_temporal_TemporalQueries$ as $h_Ljava_time_temporal_TemporalQueries$ };
$h_Ljava_time_temporal_TemporalQueries$.prototype = $p;
$p.f1 = (function() {
  if ((!this.JR)) {
    this.JQ = new $j_java$002etime$002etemporal$002e$002dTemporal$002dQueries$0024$0024anon$00241.$c_Ljava_time_temporal_TemporalQueries$$anon$1();
    this.JR = true;
  }
  return this.JQ;
});
$p.eR = (function() {
  if ((!this.JG)) {
    this.JF = new $j_java$002etime$002etemporal$002e$002dTemporal$002dQueries$0024$0024anon$00242.$c_Ljava_time_temporal_TemporalQueries$$anon$2();
    this.JG = true;
  }
  return this.JF;
});
$p.gH = (function() {
  if ((!this.JO)) {
    this.JN = new $j_java$002etime$002etemporal$002e$002dTemporal$002dQueries$0024$0024anon$00243.$c_Ljava_time_temporal_TemporalQueries$$anon$3();
    this.JO = true;
  }
  return this.JN;
});
$p.gF = (function() {
  if ((!this.JM)) {
    this.JL = new $c_Ljava_time_temporal_TemporalQueries$$anon$4();
    this.JM = true;
  }
  return this.JL;
});
$p.hx = (function() {
  if ((!this.JS)) {
    this.JP = new $c_Ljava_time_temporal_TemporalQueries$$anon$5();
    this.JS = true;
  }
  return this.JP;
});
$p.fl = (function() {
  if ((!this.JI)) {
    this.JH = new $c_Ljava_time_temporal_TemporalQueries$$anon$6();
    this.JI = true;
  }
  return this.JH;
});
$p.ik = (function() {
  if ((!this.JK)) {
    this.JJ = new $c_Ljava_time_temporal_TemporalQueries$$anon$7();
    this.JK = true;
  }
  return this.JJ;
});
var $d_Ljava_time_temporal_TemporalQueries$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_TemporalQueries$, "java.time.temporal.TemporalQueries$", ({
  mA: 1
}));
export { $d_Ljava_time_temporal_TemporalQueries$ as $d_Ljava_time_temporal_TemporalQueries$ };
var $n_Ljava_time_temporal_TemporalQueries$;
function $m_Ljava_time_temporal_TemporalQueries$() {
  if ((!$n_Ljava_time_temporal_TemporalQueries$)) {
    $n_Ljava_time_temporal_TemporalQueries$ = new $c_Ljava_time_temporal_TemporalQueries$();
  }
  return $n_Ljava_time_temporal_TemporalQueries$;
}
export { $m_Ljava_time_temporal_TemporalQueries$ as $m_Ljava_time_temporal_TemporalQueries$ };
/** @constructor */
function $c_Ljava_time_zone_ZoneRules$() {
}
export { $c_Ljava_time_zone_ZoneRules$ as $c_Ljava_time_zone_ZoneRules$ };
$p = $c_Ljava_time_zone_ZoneRules$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_zone_ZoneRules$;
/** @constructor */
function $h_Ljava_time_zone_ZoneRules$() {
}
export { $h_Ljava_time_zone_ZoneRules$ as $h_Ljava_time_zone_ZoneRules$ };
$h_Ljava_time_zone_ZoneRules$.prototype = $p;
$p.xM = (function(offset) {
  return new $c_Ljava_time_zone_ZoneRules$Fixed(offset);
});
var $d_Ljava_time_zone_ZoneRules$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_zone_ZoneRules$, "java.time.zone.ZoneRules$", ({
  mM: 1
}));
export { $d_Ljava_time_zone_ZoneRules$ as $d_Ljava_time_zone_ZoneRules$ };
var $n_Ljava_time_zone_ZoneRules$;
function $m_Ljava_time_zone_ZoneRules$() {
  if ((!$n_Ljava_time_zone_ZoneRules$)) {
    $n_Ljava_time_zone_ZoneRules$ = new $c_Ljava_time_zone_ZoneRules$();
  }
  return $n_Ljava_time_zone_ZoneRules$;
}
export { $m_Ljava_time_zone_ZoneRules$ as $m_Ljava_time_zone_ZoneRules$ };
/** @constructor */
function $c_Ljava_time_LocalDate$$anon$1() {
}
export { $c_Ljava_time_LocalDate$$anon$1 as $c_Ljava_time_LocalDate$$anon$1 };
$p = $c_Ljava_time_LocalDate$$anon$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_LocalDate$$anon$1;
/** @constructor */
function $h_Ljava_time_LocalDate$$anon$1() {
}
export { $h_Ljava_time_LocalDate$$anon$1 as $h_Ljava_time_LocalDate$$anon$1 };
$h_Ljava_time_LocalDate$$anon$1.prototype = $p;
$p.dQ = (function(temporal) {
  return $m_Ljava_time_LocalDate$().Bw(temporal);
});
var $d_Ljava_time_LocalDate$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_LocalDate$$anon$1, "java.time.LocalDate$$anon$1", ({
  kS: 1,
  aT: 1
}));
export { $d_Ljava_time_LocalDate$$anon$1 as $d_Ljava_time_LocalDate$$anon$1 };
function $ct_Ljava_time_ZoneId__($thiz) {
  if ((($j_java$002elang$002e$002dObject.$objectGetClass($thiz) !== $d_Ljava_time_ZoneOffset.l()) && ($j_java$002elang$002e$002dObject.$objectGetClass($thiz) !== $j_java$002etime$002e$002dZone$002dRegion.$d_Ljava_time_ZoneRegion.l()))) {
    throw new $j_java$002elang$002e$002dObject.$c_jl_AssertionError("Invalid subclass");
  }
  return $thiz;
}
export { $ct_Ljava_time_ZoneId__ as $ct_Ljava_time_ZoneId__ };
/** @constructor */
function $c_Ljava_time_ZoneId() {
}
export { $c_Ljava_time_ZoneId as $c_Ljava_time_ZoneId };
$p = $c_Ljava_time_ZoneId.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_ZoneId;
/** @constructor */
function $h_Ljava_time_ZoneId() {
}
export { $h_Ljava_time_ZoneId as $h_Ljava_time_ZoneId };
$h_Ljava_time_ZoneId.prototype = $p;
$p.Wl = (function() {
  try {
    var rules = $m_Ljava_time_zone_ZoneRules$().xM(this);
    $m_Ljava_time_Instant$().AY();
    return rules.g9;
  } catch (e) {
    if ((!false)) {
      throw e;
    }
  }
  return this;
});
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser(fractionalDigits) {
  this.gV = 0;
  this.gV = fractionalDigits;
}
export { $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser as $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser };
$p = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser as $h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser };
$h_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser.prototype = $p;
$p.hr = (function(context, buf) {
  var inSecs = context.BF($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
  var inNanos = $j_java$002elang$002e$002dObject.$bL(0, 0);
  if (context.s6.ba($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
    var $x_1 = context.s6.ai($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
    inNanos = $x_1;
  }
  if ((inSecs === null)) {
    return false;
  }
  var this$4 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var $x_2 = $j_java$002elang$002e$002dObject.$uJ(inNanos);
  var value_$_lo = $x_2.l;
  var value_$_hi = $x_2.h;
  var inNano = this$4.G.b0(value_$_lo, value_$_hi, this$4);
  var $x_3 = $j_java$002elang$002e$002dObject.$uJ(inSecs);
  var x$4_$_lo = $x_3.l;
  var x$4_$_hi = $x_3.h;
  var $x_4 = $j_java$002elang$002e$002dObject.$uJ($j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dInstant$002dPrinter$002dParser$0024.$m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().lU);
  var x$3_$_lo = $x_4.l;
  var x$3_$_hi = $x_4.h;
  var lo = ((-x$3_$_lo) | 0);
  var hi = ((((-x$3_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
  if (((x$4_$_hi === hi) ? ((x$4_$_lo >>> 0) >= (lo >>> 0)) : (x$4_$_hi > hi))) {
    var $x_5 = $j_java$002elang$002e$002dObject.$uJ(inSecs);
    var x$6_$_lo = $x_5.l;
    var x$6_$_hi = $x_5.h;
    var $x_6 = $j_java$002elang$002e$002dObject.$uJ($j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dInstant$002dPrinter$002dParser$0024.$m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().jY);
    var x$7_$_lo = $x_6.l;
    var x$7_$_hi = $x_6.h;
    var lo$1 = ((x$6_$_lo - x$7_$_lo) | 0);
    var hi$1 = ((((x$6_$_hi - x$7_$_hi) | 0) - (((lo$1 >>> 0) > (x$6_$_lo >>> 0)) | 0)) | 0);
    var $x_7 = $j_java$002elang$002e$002dObject.$uJ($j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dInstant$002dPrinter$002dParser$0024.$m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().lU);
    var x$9_$_lo = $x_7.l;
    var x$9_$_hi = $x_7.h;
    var lo$2 = ((lo$1 + x$9_$_lo) | 0);
    var hi$2 = ((((hi$1 + x$9_$_hi) | 0) + (((lo$2 >>> 0) < (lo$1 >>> 0)) | 0)) | 0);
    var $x_8 = $j_java$002elang$002e$002dObject.$uJ($j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dInstant$002dPrinter$002dParser$0024.$m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().jY);
    var b_$_lo = $x_8.l;
    var b_$_hi = $x_8.h;
    var $x_9 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo$2, hi$2, b_$_lo, b_$_hi);
    var quot_$_lo = $x_9.l;
    var quot_$_hi = $x_9.h;
    if (((hi$2 ^ b_$_hi) >= 0)) {
      var $x_10 = true;
    } else {
      var a0 = (65535 & quot_$_lo);
      var a1 = ((quot_$_lo >>> 16) | 0);
      var b0 = (65535 & b_$_lo);
      var b1 = ((b_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(a0, b0);
      var a1b0 = Math.imul(a1, b0);
      var a0b1 = Math.imul(a0, b1);
      var lo$4 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var $x_10 = (((lo$4 ^ lo$2) | (((((((((Math.imul(quot_$_lo, b_$_hi) + Math.imul(quot_$_hi, b_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0) ^ hi$2)) === 0);
    }
    if ($x_10) {
      var x$11_$_lo = quot_$_lo;
      var x$11_$_hi = quot_$_hi;
    } else {
      var lo$5 = ((quot_$_lo - 1) | 0);
      var hi$5 = ((((quot_$_hi - 1) | 0) + ((lo$5 !== (-1)) | 0)) | 0);
      var x$11_$_lo = lo$5;
      var x$11_$_hi = hi$5;
    }
    var lo$6 = ((1 + x$11_$_lo) | 0);
    var hi$6 = ((x$11_$_hi + ((lo$6 === 0) | 0)) | 0);
    var $x_11 = $j_java$002elang$002e$002dObject.$uJ($j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dInstant$002dPrinter$002dParser$0024.$m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().jY);
    var b$1_$_lo = $x_11.l;
    var b$1_$_hi = $x_11.h;
    var $x_12 = $j_java$002elang$002e$002dObject.$m_RTLong$().Ck(lo$2, hi$2, b$1_$_lo, b$1_$_hi);
    var rem_$_lo = $x_12.l;
    var rem_$_hi = $x_12.h;
    if ((((hi$2 ^ b$1_$_hi) >= 0) || ((rem_$_lo | rem_$_hi) === 0))) {
      var x$13_$_lo = rem_$_lo;
      var x$13_$_hi = rem_$_hi;
    } else {
      var lo$8 = ((rem_$_lo + b$1_$_lo) | 0);
      var hi$8 = ((((rem_$_hi + b$1_$_hi) | 0) + (((lo$8 >>> 0) < (rem_$_lo >>> 0)) | 0)) | 0);
      var x$13_$_lo = lo$8;
      var x$13_$_hi = hi$8;
    }
    var $x_14 = $m_Ljava_time_LocalDateTime$();
    var $x_13 = $j_java$002elang$002e$002dObject.$uJ($j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dInstant$002dPrinter$002dParser$0024.$m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().lU);
    var x$15_$_lo = $x_13.l;
    var x$15_$_hi = $x_13.h;
    var lo$9 = ((x$13_$_lo - x$15_$_lo) | 0);
    var hi$9 = ((((x$13_$_hi - x$15_$_hi) | 0) - (((lo$9 >>> 0) > (x$13_$_lo >>> 0)) | 0)) | 0);
    var ldt = $x_14.Cc(lo$9, hi$9, 0, $m_Ljava_time_ZoneOffset$().B0());
    if (((hi$6 === 0) ? (lo$6 !== 0) : (hi$6 > 0))) {
      buf.r = (buf.r + "+");
      buf.r = (buf.r + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(lo$6, hi$6));
    }
    buf.r = (("" + buf.r) + ldt);
    if ((ldt.aO.di === 0)) {
      buf.r = (buf.r + ":00");
    }
  } else {
    var $x_15 = $j_java$002elang$002e$002dObject.$uJ(inSecs);
    var x$17_$_lo = $x_15.l;
    var x$17_$_hi = $x_15.h;
    var $x_16 = $j_java$002elang$002e$002dObject.$uJ($j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dInstant$002dPrinter$002dParser$0024.$m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().lU);
    var x$18_$_lo = $x_16.l;
    var x$18_$_hi = $x_16.h;
    var lo$10 = ((x$17_$_lo + x$18_$_lo) | 0);
    var hi$10 = ((((x$17_$_hi + x$18_$_hi) | 0) + (((lo$10 >>> 0) < (x$17_$_lo >>> 0)) | 0)) | 0);
    var $x_17 = $j_java$002elang$002e$002dObject.$uJ($j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dInstant$002dPrinter$002dParser$0024.$m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().jY);
    var x$20_$_lo = $x_17.l;
    var x$20_$_hi = $x_17.h;
    var $x_18 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo$10, hi$10, x$20_$_lo, x$20_$_hi);
    var x$21_$_lo = $x_18.l;
    var x$21_$_hi = $x_18.h;
    var $x_19 = $j_java$002elang$002e$002dObject.$uJ($j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dInstant$002dPrinter$002dParser$0024.$m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().jY);
    var x$23_$_lo = $x_19.l;
    var x$23_$_hi = $x_19.h;
    var $x_20 = $j_java$002elang$002e$002dObject.$m_RTLong$().Ck(lo$10, hi$10, x$23_$_lo, x$23_$_hi);
    var x$24_$_lo = $x_20.l;
    var x$24_$_hi = $x_20.h;
    var $x_22 = $m_Ljava_time_LocalDateTime$();
    var $x_21 = $j_java$002elang$002e$002dObject.$uJ($j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dInstant$002dPrinter$002dParser$0024.$m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().lU);
    var x$26_$_lo = $x_21.l;
    var x$26_$_hi = $x_21.h;
    var lo$11 = ((x$24_$_lo - x$26_$_lo) | 0);
    var hi$11 = ((((x$24_$_hi - x$26_$_hi) | 0) - (((lo$11 >>> 0) > (x$24_$_lo >>> 0)) | 0)) | 0);
    var ldt$2 = $x_22.Cc(lo$11, hi$11, 0, $m_Ljava_time_ZoneOffset$().B0());
    var pos = buf.l();
    buf.r = (("" + buf.r) + ldt$2);
    if ((ldt$2.aO.di === 0)) {
      buf.r = (buf.r + ":00");
    }
    if ((x$21_$_hi < 0)) {
      if ((ldt$2.aJ.bi === (-10000))) {
        var lo$12 = ((x$21_$_lo - 1) | 0);
        buf.X1(pos, ((2 + pos) | 0), $j_java$002elang$002e$002dObject.$m_RTLong$().jv(lo$12, ((((x$21_$_hi - 1) | 0) + ((lo$12 !== (-1)) | 0)) | 0)));
      } else if ($j_java$002elang$002e$002dObject.$m_sr_BoxesRunTime$().ig($j_java$002elang$002e$002dObject.$bL(x$24_$_lo, x$24_$_hi), 0)) {
        buf.BP(pos, ("" + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(x$21_$_lo, x$21_$_hi)));
      } else {
        var offset = ((1 + pos) | 0);
        var sign = (x$21_$_hi >> 31);
        var xlo = (x$21_$_lo ^ sign);
        var rlo = ((xlo - sign) | 0);
        buf.BP(offset, $j_java$002elang$002e$002dObject.$m_RTLong$().jv(rlo, (((x$21_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0)));
      }
    }
  }
  if ((this.gV === (-2))) {
    if ((inNano !== 0)) {
      buf.r = (buf.r + ".");
      if ((((inNano % 1000000) | 0) === 0)) {
        var i = ((1000 + ((inNano / 1000000) | 0)) | 0);
        var this$64 = ("" + i);
        var str = this$64.substring(1);
        buf.r = (("" + buf.r) + str);
      } else if ((((inNano % 1000) | 0) === 0)) {
        var i$1 = ((1000000 + ((inNano / 1000) | 0)) | 0);
        var this$68 = ("" + i$1);
        var str$1 = this$68.substring(1);
        buf.r = (("" + buf.r) + str$1);
      } else {
        var i$2 = ((1000000000 + inNano) | 0);
        var this$72 = ("" + i$2);
        var str$2 = this$72.substring(1);
        buf.r = (("" + buf.r) + str$2);
      }
    }
  } else if (((this.gV > 0) || ((this.gV === (-1)) && (inNano > 0)))) {
    buf.r = (buf.r + ".");
    var div = 100000000;
    var i$3 = 0;
    while ((((this.gV === (-1)) && (inNano > 0)) || (i$3 < this.gV))) {
      var digit = ((inNano / $j_java$002elang$002e$002dObject.$checkIntDivisor(div)) | 0);
      var c = (65535 & ((48 + digit) | 0));
      var str$3 = ("" + $j_java$002elang$002e$002dObject.$cToS(c));
      buf.r = (buf.r + str$3);
      inNano = ((inNano - Math.imul(digit, div)) | 0);
      div = ((div / 10) | 0);
      i$3 = ((1 + i$3) | 0);
    }
  }
  buf.r = (buf.r + "Z");
  return true;
});
$p.gG = (function(context, text, position) {
  var newContext = $ct_Ljava_time_format_internal_TTBPDateTimeParseContext__Ljava_time_format_internal_TTBPDateTimeParseContext__(new $c_Ljava_time_format_internal_TTBPDateTimeParseContext(), context);
  var minDigits = ((this.gV < 0) ? 0 : this.gV);
  var maxDigits = ((this.gV < 0) ? 9 : this.gV);
  var parser = $ct_Ljava_time_format_DateTimeFormatterBuilder__(new $c_Ljava_time_format_DateTimeFormatterBuilder()).Sh($m_Ljava_time_format_DateTimeFormatter$().NK()).qQ(84).qR($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), 2).qQ(58).qR($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField(), 2).qQ(58).qR($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField(), 2).Sj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), minDigits, maxDigits, true).qQ(90).CG($j_java$002eutil$002e$002dLocale.$m_ju_Locale$().sc).hG.R0(false);
  var pos = parser.gG(newContext, text, position);
  if ((pos < 0)) {
    return pos;
  }
  var yearParsed = newContext.kV($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField());
  var $x_1 = newContext.kV($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField());
  var this$4_$_lo = $x_1.l;
  var this$4_$_hi = $x_1.h;
  var $x_2 = newContext.kV($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField());
  var this$6_$_lo = $x_2.l;
  var this$6_$_hi = $x_2.h;
  var $x_3 = newContext.kV($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField());
  var hour = $j_java$002elang$002e$002dObject.$s_RTLong__toInt__I__I__I($x_3.l, $x_3.h);
  var $x_4 = newContext.kV($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField());
  var this$10_$_lo = $x_4.l;
  var this$10_$_hi = $x_4.h;
  var secVal = newContext.kV($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField());
  var nanoVal = newContext.kV($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
  if ((secVal !== null)) {
    var $x_5 = secVal;
    var sec = $j_java$002elang$002e$002dObject.$s_RTLong__toInt__I__I__I($x_5.l, $x_5.h);
  } else {
    var sec = 0;
  }
  if ((nanoVal !== null)) {
    var $x_6 = nanoVal;
    var nano = $j_java$002elang$002e$002dObject.$s_RTLong__toInt__I__I__I($x_6.l, $x_6.h);
  } else {
    var nano = 0;
  }
  var $x_7 = $j_java$002elang$002e$002dObject.$uJ(yearParsed);
  var year = (($j_java$002elang$002e$002dObject.$s_RTLong__toInt__I__I__I($x_7.l, $x_7.h) % 10000) | 0);
  var days = 0;
  if ((((((24 ^ hour) | this$10_$_lo) === 0) && (sec === 0)) && (nano === 0))) {
    hour = 0;
    days = 1;
  } else if (((((23 ^ hour) | (59 ^ this$10_$_lo)) === 0) && (sec === 60))) {
    $p_Ljava_time_format_internal_TTBPDateTimeParseContext__currentParsed__Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(context).vq = true;
    sec = 59;
  }
  var instantSecs = $j_java$002elang$002e$002dObject.$bL(0, 0);
  try {
    var $x_8 = $m_Ljava_time_LocalDateTime$().Wn(year, this$4_$_lo, this$6_$_lo, hour, this$10_$_lo, sec, 0);
    var value = days;
    var hi = (value >> 31);
    var ldt = $x_8.xT(value, hi);
    var $x_9 = ldt.QH($m_Ljava_time_ZoneOffset$().B0());
    instantSecs = $x_9;
    var $x_10 = $j_java$002elang$002e$002dObject.$uJ(instantSecs);
    var x$6_$_lo = $x_10.l;
    var x$6_$_hi = $x_10.h;
    var $x_11 = $j_java$002elang$002e$002dObject.$uJ(yearParsed);
    var num_$_lo = $x_11.l;
    var num_$_hi = $x_11.h;
    var sign = (num_$_hi >> 31);
    var xlo = (num_$_lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((num_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var quotHi = (((rhi >>> 0) / 10000) | 0);
    var k = ((rhi - Math.imul(10000, quotHi)) | 0);
    var quotLo = ((1.0000000000000005E-4 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
    if ((num_$_hi < 0)) {
      var lo = ((-quotLo) | 0);
      var hi$1 = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
      var a_$_lo = lo;
      var a_$_hi = hi$1;
    } else {
      var a_$_lo = quotLo;
      var a_$_hi = quotHi;
    }
    var $x_12 = $j_java$002elang$002e$002dObject.$uJ($j_java$002etime$002eformat$002einternal$002e$002dT$002dT$002dB$002dP$002dDate$002dTime$002dFormatter$002dBuilder$0024$002dInstant$002dPrinter$002dParser$0024.$m_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser$().jY);
    var b_$_lo = $x_12.l;
    var b_$_hi = $x_12.h;
    var this$34 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
    var a0 = (65535 & a_$_lo);
    var a1 = ((a_$_lo >>> 16) | 0);
    var b0 = (65535 & b_$_lo);
    var b1 = ((b_$_lo >>> 16) | 0);
    var a0b0 = Math.imul(a0, b0);
    var a1b0 = Math.imul(a1, b0);
    var a0b1 = Math.imul(a0, b1);
    var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$2 = ((((((((Math.imul(a_$_lo, b_$_hi) + Math.imul(a_$_hi, b_$_lo)) | 0) + Math.imul(a1, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
    if (((a_$_hi < 0) && ((b_$_lo | ((-2147483648) ^ b_$_hi)) === 0))) {
      var $x_13 = true;
    } else if (((a_$_lo | a_$_hi) !== 0)) {
      var $x_14 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo$1, hi$2, a_$_lo, a_$_hi);
      var x$5_$_lo = $x_14.l;
      var x$5_$_hi = $x_14.h;
      var $x_13 = (((x$5_$_lo ^ b_$_lo) | (x$5_$_hi ^ b_$_hi)) !== 0);
    } else {
      var $x_13 = false;
    }
    if ($x_13) {
      this$34.au();
    }
    var lo$2 = ((x$6_$_lo + lo$1) | 0);
    var hi$3 = ((((x$6_$_hi + hi$2) | 0) + (((lo$2 >>> 0) < (x$6_$_lo >>> 0)) | 0)) | 0);
    instantSecs = $j_java$002elang$002e$002dObject.$bL(lo$2, hi$3);
  } catch (e) {
    if ((((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e)) instanceof $j_java$002elang$002e$002dObject.$c_jl_RuntimeException)) {
      return (~position);
    } else {
      throw e;
    }
  }
  var successPos = pos;
  var $x_16 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
  var $x_15 = $j_java$002elang$002e$002dObject.$uJ(instantSecs);
  successPos = context.y8($x_16, $x_15.l, $x_15.h, position, successPos);
  var $x_17 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var hi$4 = (nano >> 31);
  return context.y8($x_17, nano, hi$4, position, successPos);
});
$p.b = (function() {
  return "Instant()";
});
var $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser, "java.time.format.internal.TTBPDateTimeFormatterBuilder$InstantPrinterParser", ({
  ly: 1,
  av: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser as $d_Ljava_time_format_internal_TTBPDateTimeFormatterBuilder$InstantPrinterParser };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(outer) {
  this.lY = null;
  this.k1 = null;
  this.fu = null;
  this.vq = false;
  this.JB = null;
  this.vp = null;
  if ((outer === null)) {
    throw $j_java$002elang$002e$002dObject.$ct_jl_NullPointerException__(new $j_java$002elang$002e$002dObject.$c_jl_NullPointerException());
  }
  this.vp = outer;
  this.lY = null;
  this.k1 = null;
  this.fu = $j_java$002eutil$002e$002dAbstract$002dMap.$ct_ju_HashMap__(new $j_java$002eutil$002e$002dAbstract$002dMap.$c_ju_HashMap());
  this.vq = false;
  this.JB = $j_java$002etime$002e$002dPeriod.$m_Ljava_time_Period$().tP();
}
export { $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed as $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed };
$p = $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed as $h_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed };
$h_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed.prototype = $p;
$p.bX = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field);
});
$p.T0 = (function() {
  var cloned = new $c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed(this.vp);
  cloned.lY = this.lY;
  cloned.k1 = this.k1;
  cloned.fu.xW(this.fu);
  cloned.vq = this.vq;
  return cloned;
});
$p.b = (function() {
  return ((((this.fu.b() + ",") + this.lY) + ",") + this.k1);
});
$p.ba = (function(field) {
  return this.fu.aj(field);
});
$p.cC = (function(field) {
  if ((!this.fu.aj(field))) {
    throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  }
  var $x_1 = $j_java$002elang$002e$002dObject.$uJ($j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O(this.fu, field, null));
  var value_$_lo = $x_1.l;
  var value_$_hi = $x_1.h;
  var this$3 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
  if ((((value_$_lo ^ value_$_lo) | ((value_$_lo >> 31) ^ value_$_hi)) !== 0)) {
    this$3.xv();
  }
  return value_$_lo;
});
$p.ai = (function(field) {
  if ((!this.fu.aj(field))) {
    throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return $j_java$002elang$002e$002dObject.$uJ($j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O(this.fu, field, null));
  }
});
$p.cg = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().eR()) ? this.lY : (((query === $m_Ljava_time_temporal_TemporalQueries$().f1()) || (query === $m_Ljava_time_temporal_TemporalQueries$().hx())) ? this.k1 : $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O(this, query)));
});
$p.Y5 = (function() {
  var builder = new $c_Ljava_time_format_DateTimeBuilder();
  builder.R.xW(this.fu);
  builder.jT = this.vp.UO();
  if ((this.k1 !== null)) {
    builder.f3 = this.k1;
  } else {
    builder.f3 = this.vp.zN;
  }
  builder.gT = this.JB;
  return builder;
});
var $d_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed, "java.time.format.internal.TTBPDateTimeParseContext$Parsed", ({
  lJ: 1,
  G: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed as $d_Ljava_time_format_internal_TTBPDateTimeParseContext$Parsed };
/** @constructor */
function $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1(effectiveDate$2, temporal$4, effectiveChrono$2, effectiveZone$2) {
  this.k2 = null;
  this.s7 = null;
  this.JC = null;
  this.JD = null;
  this.k2 = effectiveDate$2;
  this.s7 = temporal$4;
  this.JC = effectiveChrono$2;
  this.JD = effectiveZone$2;
}
export { $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 as $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 };
$p = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1;
/** @constructor */
function $h_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1() {
}
export { $h_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 as $h_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 };
$h_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1.prototype = $p;
$p.cC = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field);
});
$p.ba = (function(field) {
  return (((this.k2 !== null) && field.hk()) ? $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this.k2, field) : this.s7.ba(field));
});
$p.bX = (function(field) {
  return (((this.k2 !== null) && field.hk()) ? this.k2.bX(field) : this.s7.bX(field));
});
$p.ai = (function(field) {
  if (((this.k2 !== null) && field.hk())) {
    return this.k2.ai(field);
  } else {
    return this.s7.ai(field);
  }
});
$p.cg = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().eR()) ? this.JC : ((query === $m_Ljava_time_temporal_TemporalQueries$().f1()) ? this.JD : ((query === $m_Ljava_time_temporal_TemporalQueries$().gH()) ? this.s7.cg(query) : query.dQ(this))));
});
var $d_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1, "java.time.format.internal.TTBPDateTimePrintContext$$anon$1", ({
  lM: 1,
  G: 1
}));
export { $d_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 as $d_Ljava_time_format_internal_TTBPDateTimePrintContext$$anon$1 };
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$4() {
}
export { $c_Ljava_time_temporal_TemporalQueries$$anon$4 as $c_Ljava_time_temporal_TemporalQueries$$anon$4 };
$p = $c_Ljava_time_temporal_TemporalQueries$$anon$4.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$4;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$4() {
}
export { $h_Ljava_time_temporal_TemporalQueries$$anon$4 as $h_Ljava_time_temporal_TemporalQueries$$anon$4 };
$h_Ljava_time_temporal_TemporalQueries$$anon$4.prototype = $p;
$p.WM = (function(temporal) {
  return (temporal.ba($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField()) ? $m_Ljava_time_ZoneOffset$().ul(temporal.cC($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) : null);
});
$p.dQ = (function(temporal) {
  return this.WM(temporal);
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$4 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_TemporalQueries$$anon$4, "java.time.temporal.TemporalQueries$$anon$4", ({
  mE: 1,
  aT: 1
}));
export { $d_Ljava_time_temporal_TemporalQueries$$anon$4 as $d_Ljava_time_temporal_TemporalQueries$$anon$4 };
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$5() {
}
export { $c_Ljava_time_temporal_TemporalQueries$$anon$5 as $c_Ljava_time_temporal_TemporalQueries$$anon$5 };
$p = $c_Ljava_time_temporal_TemporalQueries$$anon$5.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$5;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$5() {
}
export { $h_Ljava_time_temporal_TemporalQueries$$anon$5 as $h_Ljava_time_temporal_TemporalQueries$$anon$5 };
$h_Ljava_time_temporal_TemporalQueries$$anon$5.prototype = $p;
$p.WL = (function(temporal) {
  var zone = temporal.cg($m_Ljava_time_temporal_TemporalQueries$().f1());
  return ((zone !== null) ? zone : temporal.cg($m_Ljava_time_temporal_TemporalQueries$().gF()));
});
$p.dQ = (function(temporal) {
  return this.WL(temporal);
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$5 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_TemporalQueries$$anon$5, "java.time.temporal.TemporalQueries$$anon$5", ({
  mF: 1,
  aT: 1
}));
export { $d_Ljava_time_temporal_TemporalQueries$$anon$5 as $d_Ljava_time_temporal_TemporalQueries$$anon$5 };
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$6() {
}
export { $c_Ljava_time_temporal_TemporalQueries$$anon$6 as $c_Ljava_time_temporal_TemporalQueries$$anon$6 };
$p = $c_Ljava_time_temporal_TemporalQueries$$anon$6.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$6;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$6() {
}
export { $h_Ljava_time_temporal_TemporalQueries$$anon$6 as $h_Ljava_time_temporal_TemporalQueries$$anon$6 };
$h_Ljava_time_temporal_TemporalQueries$$anon$6.prototype = $p;
$p.WJ = (function(temporal) {
  if (temporal.ba($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
    var $x_2 = $m_Ljava_time_LocalDate$();
    var $x_1 = temporal.ai($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField());
    return $x_2.gE($x_1.l, $x_1.h);
  } else {
    return null;
  }
});
$p.dQ = (function(temporal) {
  return this.WJ(temporal);
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$6 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_TemporalQueries$$anon$6, "java.time.temporal.TemporalQueries$$anon$6", ({
  mG: 1,
  aT: 1
}));
export { $d_Ljava_time_temporal_TemporalQueries$$anon$6 as $d_Ljava_time_temporal_TemporalQueries$$anon$6 };
/** @constructor */
function $c_Ljava_time_temporal_TemporalQueries$$anon$7() {
}
export { $c_Ljava_time_temporal_TemporalQueries$$anon$7 as $c_Ljava_time_temporal_TemporalQueries$$anon$7 };
$p = $c_Ljava_time_temporal_TemporalQueries$$anon$7.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_temporal_TemporalQueries$$anon$7;
/** @constructor */
function $h_Ljava_time_temporal_TemporalQueries$$anon$7() {
}
export { $h_Ljava_time_temporal_TemporalQueries$$anon$7 as $h_Ljava_time_temporal_TemporalQueries$$anon$7 };
$h_Ljava_time_temporal_TemporalQueries$$anon$7.prototype = $p;
$p.WK = (function(temporal) {
  if (temporal.ba($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var $x_2 = $m_Ljava_time_LocalTime$();
    var $x_1 = temporal.ai($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField());
    return $x_2.l5($x_1.l, $x_1.h);
  } else {
    return null;
  }
});
$p.dQ = (function(temporal) {
  return this.WK(temporal);
});
var $d_Ljava_time_temporal_TemporalQueries$$anon$7 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_temporal_TemporalQueries$$anon$7, "java.time.temporal.TemporalQueries$$anon$7", ({
  mH: 1,
  aT: 1
}));
export { $d_Ljava_time_temporal_TemporalQueries$$anon$7 as $d_Ljava_time_temporal_TemporalQueries$$anon$7 };
function $s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__MONDAY;
}
export { $s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek as $s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek };
function $s_Ljava_time_DayOfWeek$__TUESDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__TUESDAY;
}
export { $s_Ljava_time_DayOfWeek$__TUESDAY__Ljava_time_DayOfWeek as $s_Ljava_time_DayOfWeek$__TUESDAY__Ljava_time_DayOfWeek };
function $s_Ljava_time_DayOfWeek$__WEDNESDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__WEDNESDAY;
}
export { $s_Ljava_time_DayOfWeek$__WEDNESDAY__Ljava_time_DayOfWeek as $s_Ljava_time_DayOfWeek$__WEDNESDAY__Ljava_time_DayOfWeek };
function $s_Ljava_time_DayOfWeek$__THURSDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__THURSDAY;
}
export { $s_Ljava_time_DayOfWeek$__THURSDAY__Ljava_time_DayOfWeek as $s_Ljava_time_DayOfWeek$__THURSDAY__Ljava_time_DayOfWeek };
function $s_Ljava_time_DayOfWeek$__FRIDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__FRIDAY;
}
export { $s_Ljava_time_DayOfWeek$__FRIDAY__Ljava_time_DayOfWeek as $s_Ljava_time_DayOfWeek$__FRIDAY__Ljava_time_DayOfWeek };
function $s_Ljava_time_DayOfWeek$__SATURDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__SATURDAY;
}
export { $s_Ljava_time_DayOfWeek$__SATURDAY__Ljava_time_DayOfWeek as $s_Ljava_time_DayOfWeek$__SATURDAY__Ljava_time_DayOfWeek };
function $s_Ljava_time_DayOfWeek$__SUNDAY__Ljava_time_DayOfWeek() {
  $m_Ljava_time_DayOfWeek$();
  return $t_Ljava_time_DayOfWeek$__SUNDAY;
}
export { $s_Ljava_time_DayOfWeek$__SUNDAY__Ljava_time_DayOfWeek as $s_Ljava_time_DayOfWeek$__SUNDAY__Ljava_time_DayOfWeek };
/** @constructor */
function $c_Ljava_time_DayOfWeek$() {
  this.J0 = null;
  this.J1 = null;
  this.J2 = false;
  $n_Ljava_time_DayOfWeek$ = this;
  $t_Ljava_time_DayOfWeek$__MONDAY = new $c_Ljava_time_DayOfWeek$$anon$1();
  $t_Ljava_time_DayOfWeek$__TUESDAY = new $c_Ljava_time_DayOfWeek$$anon$2();
  $t_Ljava_time_DayOfWeek$__WEDNESDAY = new $c_Ljava_time_DayOfWeek$$anon$3();
  $t_Ljava_time_DayOfWeek$__THURSDAY = new $c_Ljava_time_DayOfWeek$$anon$4();
  $t_Ljava_time_DayOfWeek$__FRIDAY = new $c_Ljava_time_DayOfWeek$$anon$5();
  $t_Ljava_time_DayOfWeek$__SATURDAY = new $c_Ljava_time_DayOfWeek$$anon$6();
  $t_Ljava_time_DayOfWeek$__SUNDAY = new $c_Ljava_time_DayOfWeek$$anon$7();
  this.J0 = new ($d_Ljava_time_DayOfWeek.r().C)([$s_Ljava_time_DayOfWeek$__MONDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__TUESDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__WEDNESDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__THURSDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__FRIDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__SATURDAY__Ljava_time_DayOfWeek(), $s_Ljava_time_DayOfWeek$__SUNDAY__Ljava_time_DayOfWeek()]);
}
export { $c_Ljava_time_DayOfWeek$ as $c_Ljava_time_DayOfWeek$ };
$p = $c_Ljava_time_DayOfWeek$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_DayOfWeek$;
/** @constructor */
function $h_Ljava_time_DayOfWeek$() {
}
export { $h_Ljava_time_DayOfWeek$ as $h_Ljava_time_DayOfWeek$ };
$h_Ljava_time_DayOfWeek$.prototype = $p;
$p.Yl = (function() {
  return this.J0.x();
});
$p.VD = (function() {
  if ((!this.J2)) {
    this.J1 = $m_Ljava_time_DayOfWeek$().Yl();
    this.J2 = true;
  }
  return this.J1;
});
$p.Ca = (function(dayOfWeek) {
  if (((((dayOfWeek - 1) | 0) >>> 0) > 6)) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ("Invalid value for DayOfWeek: " + dayOfWeek));
  } else {
    return this.VD().a[((dayOfWeek - 1) | 0)];
  }
});
var $d_Ljava_time_DayOfWeek$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_DayOfWeek$, "java.time.DayOfWeek$", ({
  kH: 1,
  e: 1,
  aa: 1
}));
export { $d_Ljava_time_DayOfWeek$ as $d_Ljava_time_DayOfWeek$ };
var $n_Ljava_time_DayOfWeek$;
function $m_Ljava_time_DayOfWeek$() {
  if ((!$n_Ljava_time_DayOfWeek$)) {
    $n_Ljava_time_DayOfWeek$ = new $c_Ljava_time_DayOfWeek$();
  }
  return $n_Ljava_time_DayOfWeek$;
}
export { $m_Ljava_time_DayOfWeek$ as $m_Ljava_time_DayOfWeek$ };
function $s_Ljava_time_Month$__JANUARY__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__JANUARY;
}
export { $s_Ljava_time_Month$__JANUARY__Ljava_time_Month as $s_Ljava_time_Month$__JANUARY__Ljava_time_Month };
function $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__FEBRUARY;
}
export { $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month as $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month };
function $s_Ljava_time_Month$__MARCH__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__MARCH;
}
export { $s_Ljava_time_Month$__MARCH__Ljava_time_Month as $s_Ljava_time_Month$__MARCH__Ljava_time_Month };
function $s_Ljava_time_Month$__APRIL__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__APRIL;
}
export { $s_Ljava_time_Month$__APRIL__Ljava_time_Month as $s_Ljava_time_Month$__APRIL__Ljava_time_Month };
function $s_Ljava_time_Month$__MAY__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__MAY;
}
export { $s_Ljava_time_Month$__MAY__Ljava_time_Month as $s_Ljava_time_Month$__MAY__Ljava_time_Month };
function $s_Ljava_time_Month$__JUNE__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__JUNE;
}
export { $s_Ljava_time_Month$__JUNE__Ljava_time_Month as $s_Ljava_time_Month$__JUNE__Ljava_time_Month };
function $s_Ljava_time_Month$__JULY__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__JULY;
}
export { $s_Ljava_time_Month$__JULY__Ljava_time_Month as $s_Ljava_time_Month$__JULY__Ljava_time_Month };
function $s_Ljava_time_Month$__AUGUST__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__AUGUST;
}
export { $s_Ljava_time_Month$__AUGUST__Ljava_time_Month as $s_Ljava_time_Month$__AUGUST__Ljava_time_Month };
function $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__SEPTEMBER;
}
export { $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month as $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month };
function $s_Ljava_time_Month$__OCTOBER__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__OCTOBER;
}
export { $s_Ljava_time_Month$__OCTOBER__Ljava_time_Month as $s_Ljava_time_Month$__OCTOBER__Ljava_time_Month };
function $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__NOVEMBER;
}
export { $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month as $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month };
function $s_Ljava_time_Month$__DECEMBER__Ljava_time_Month() {
  $m_Ljava_time_Month$();
  return $t_Ljava_time_Month$__DECEMBER;
}
export { $s_Ljava_time_Month$__DECEMBER__Ljava_time_Month as $s_Ljava_time_Month$__DECEMBER__Ljava_time_Month };
/** @constructor */
function $c_Ljava_time_Month$() {
  this.J9 = null;
  this.Ja = null;
  this.Jb = false;
  $n_Ljava_time_Month$ = this;
  $t_Ljava_time_Month$__JANUARY = new $c_Ljava_time_Month$$anon$1();
  $t_Ljava_time_Month$__FEBRUARY = new $c_Ljava_time_Month$$anon$2();
  $t_Ljava_time_Month$__MARCH = new $c_Ljava_time_Month$$anon$3();
  $t_Ljava_time_Month$__APRIL = new $c_Ljava_time_Month$$anon$4();
  $t_Ljava_time_Month$__MAY = new $c_Ljava_time_Month$$anon$5();
  $t_Ljava_time_Month$__JUNE = new $c_Ljava_time_Month$$anon$6();
  $t_Ljava_time_Month$__JULY = new $c_Ljava_time_Month$$anon$7();
  $t_Ljava_time_Month$__AUGUST = new $c_Ljava_time_Month$$anon$8();
  $t_Ljava_time_Month$__SEPTEMBER = new $c_Ljava_time_Month$$anon$9();
  $t_Ljava_time_Month$__OCTOBER = new $c_Ljava_time_Month$$anon$10();
  $t_Ljava_time_Month$__NOVEMBER = new $c_Ljava_time_Month$$anon$11();
  $t_Ljava_time_Month$__DECEMBER = new $c_Ljava_time_Month$$anon$12();
  this.J9 = new ($d_Ljava_time_Month.r().C)([$s_Ljava_time_Month$__JANUARY__Ljava_time_Month(), $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month(), $s_Ljava_time_Month$__MARCH__Ljava_time_Month(), $s_Ljava_time_Month$__APRIL__Ljava_time_Month(), $s_Ljava_time_Month$__MAY__Ljava_time_Month(), $s_Ljava_time_Month$__JUNE__Ljava_time_Month(), $s_Ljava_time_Month$__JULY__Ljava_time_Month(), $s_Ljava_time_Month$__AUGUST__Ljava_time_Month(), $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month(), $s_Ljava_time_Month$__OCTOBER__Ljava_time_Month(), $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month(), $s_Ljava_time_Month$__DECEMBER__Ljava_time_Month()]);
}
export { $c_Ljava_time_Month$ as $c_Ljava_time_Month$ };
$p = $c_Ljava_time_Month$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_Month$;
/** @constructor */
function $h_Ljava_time_Month$() {
}
export { $h_Ljava_time_Month$ as $h_Ljava_time_Month$ };
$h_Ljava_time_Month$.prototype = $p;
$p.Ym = (function() {
  return this.J9.x();
});
$p.Pt = (function() {
  if ((!this.Jb)) {
    this.Ja = $m_Ljava_time_Month$().Ym();
    this.Jb = true;
  }
  return this.Ja;
});
$p.xK = (function(month) {
  if (((((month - 1) | 0) >>> 0) > 11)) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ("Invalid value for MonthOfYear: " + month));
  } else {
    return this.Pt().a[((month - 1) | 0)];
  }
});
var $d_Ljava_time_Month$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Month$, "java.time.Month$", ({
  kV: 1,
  e: 1,
  aa: 1
}));
export { $d_Ljava_time_Month$ as $d_Ljava_time_Month$ };
var $n_Ljava_time_Month$;
function $m_Ljava_time_Month$() {
  if ((!$n_Ljava_time_Month$)) {
    $n_Ljava_time_Month$ = new $c_Ljava_time_Month$();
  }
  return $n_Ljava_time_Month$;
}
export { $m_Ljava_time_Month$ as $m_Ljava_time_Month$ };
function $p_Ljava_time_format_DateTimeBuilder__putFieldValue0__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder($thiz, field, value_$_lo, value_$_hi) {
  var $x_2 = $thiz.R;
  if ((field === null)) {
    var $x_1 = 0;
  } else {
    var originalHash = $j_java$002elang$002e$002dObject.$systemIdentityHashCode(field);
    var $x_1 = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  $x_2.dO(field, $j_java$002elang$002e$002dObject.$bL(value_$_lo, value_$_hi), $x_1, false);
  return $thiz;
}
export { $p_Ljava_time_format_DateTimeBuilder__putFieldValue0__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder as $p_Ljava_time_format_DateTimeBuilder__putFieldValue0__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder };
function $p_Ljava_time_format_DateTimeBuilder__resolveFields__Ljava_time_format_ResolverStyle__Z($thiz, resolverStyle) {
  var changes = 0;
  var entries = new $j_java$002eutil$002e$002dHash$002dMap$0024$002dEntry$002dSet.$c_ju_HashMap$EntrySet($thiz.R).cV();
  var break$1 = false;
  while (((!break$1) && entries.i())) {
    var entry = entries.e();
    var targetField = entry.ek;
    var resolvedObject = null;
    matchResult1: {
      var x1 = resolvedObject;
      if ($is_Ljava_time_chrono_ChronoZonedDateTime(x1)) {
        if (($thiz.f3 === null)) {
          $thiz.f3 = x1.dA;
        } else {
          var x = $thiz.f3;
          var x$2 = x1.dA;
          if ((!((x === null) ? (x$2 === null) : x.f(x$2)))) {
            throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ("ChronoZonedDateTime must use the effective parsed zone: " + $thiz.f3));
          }
        }
        resolvedObject = x1.bc;
        break matchResult1;
      }
      if ($is_Ljava_time_chrono_ChronoLocalDate(x1)) {
        $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V($thiz, targetField, x1);
        changes = ((1 + changes) | 0);
        break$1 = true;
        break matchResult1;
      }
      if ((x1 instanceof $c_Ljava_time_LocalTime)) {
        $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_LocalTime__V($thiz, targetField, x1);
        changes = ((1 + changes) | 0);
        break$1 = true;
        break matchResult1;
      }
      if ((x1 instanceof $c_Ljava_time_chrono_ChronoLocalDateTime)) {
        $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V($thiz, targetField, x1.aJ);
        $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_LocalTime__V($thiz, targetField, x1.aO);
        changes = ((1 + changes) | 0);
        break$1 = true;
        break matchResult1;
      }
      if ((x1 === null)) {
        if ((!$thiz.R.aj(targetField))) {
          changes = ((1 + changes) | 0);
          break$1 = true;
          break matchResult1;
        } else {
          break matchResult1;
        }
      }
      throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ("Unknown type: " + $j_java$002elang$002e$002dObject.$objectClassName(resolvedObject)));
    }
  }
  if ((changes === 100)) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), "Badly written field");
  }
  return (changes > 0);
}
export { $p_Ljava_time_format_DateTimeBuilder__resolveFields__Ljava_time_format_ResolverStyle__Z as $p_Ljava_time_format_DateTimeBuilder__resolveFields__Ljava_time_format_ResolverStyle__Z };
function $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V($thiz, targetField, date) {
  var x = $thiz.jT;
  var x$2 = $m_Ljava_time_chrono_IsoChronology$().bz();
  if ((!((x === null) ? (x$2 === null) : $j_java$002etime$002echrono$002e$002dChronology.$f_Ljava_time_chrono_Chronology__equals__O__Z(x, x$2)))) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ("ChronoLocalDate must use the effective parsed chronology: " + $thiz.jT));
  }
  var $x_1 = date.fo();
  var epochDay_$_lo = $x_1.l;
  var epochDay_$_hi = $x_1.h;
  var this$2 = $thiz.R;
  var key = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
  if ((key === null)) {
    var $x_2 = 0;
  } else {
    var originalHash = $j_java$002elang$002e$002dObject.$systemIdentityHashCode(key);
    var $x_2 = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  var old = this$2.dO(key, $j_java$002elang$002e$002dObject.$bL(epochDay_$_lo, epochDay_$_hi), $x_2, false);
  if ((old !== null)) {
    var $x_4 = old;
    var this$4_$_lo = $x_4.l;
    var this$4_$_hi = $x_4.h;
    var $x_3 = (((this$4_$_lo ^ epochDay_$_lo) | (this$4_$_hi ^ epochDay_$_hi)) !== 0);
  } else {
    var $x_3 = false;
  }
  if ($x_3) {
    var $x_6 = $m_Ljava_time_LocalDate$();
    var $x_5 = $j_java$002elang$002e$002dObject.$uJ(old);
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ((((("Conflict found: " + $x_6.gE($x_5.l, $x_5.h)) + " differs from ") + $m_Ljava_time_LocalDate$().gE(epochDay_$_lo, epochDay_$_hi)) + " while resolving  ") + targetField));
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V as $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V };
function $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_LocalTime__V($thiz, targetField, time) {
  var $x_1 = time.iv();
  var nanOfDay_$_lo = $x_1.l;
  var nanOfDay_$_hi = $x_1.h;
  var this$2 = $thiz.R;
  var key = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
  if ((key === null)) {
    var $x_2 = 0;
  } else {
    var originalHash = $j_java$002elang$002e$002dObject.$systemIdentityHashCode(key);
    var $x_2 = (originalHash ^ ((originalHash >>> 16) | 0));
  }
  var old = this$2.dO(key, $j_java$002elang$002e$002dObject.$bL(nanOfDay_$_lo, nanOfDay_$_hi), $x_2, false);
  if ((old !== null)) {
    var $x_4 = old;
    var this$4_$_lo = $x_4.l;
    var this$4_$_hi = $x_4.h;
    var $x_3 = (((this$4_$_lo ^ nanOfDay_$_lo) | (this$4_$_hi ^ nanOfDay_$_hi)) !== 0);
  } else {
    var $x_3 = false;
  }
  if ($x_3) {
    var $x_6 = $m_Ljava_time_LocalTime$();
    var $x_5 = $j_java$002elang$002e$002dObject.$uJ(old);
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ((((("Conflict found: " + $x_6.l5($x_5.l, $x_5.h)) + " differs from ") + time) + " while resolving  ") + targetField));
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_LocalTime__V as $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_LocalTime__V };
function $p_Ljava_time_format_DateTimeBuilder__mergeDate__Ljava_time_format_ResolverStyle__V($thiz, resolverStyle) {
  if (($thiz.jT instanceof $c_Ljava_time_chrono_IsoChronology)) {
    $p_Ljava_time_format_DateTimeBuilder__checkDate__Ljava_time_LocalDate__V($thiz, $m_Ljava_time_chrono_IsoChronology$().bz().X8($thiz.R, resolverStyle));
  } else if ($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
    var $x_2 = $m_Ljava_time_LocalDate$();
    var $x_1 = $j_java$002elang$002e$002dObject.$uJ($thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField()));
    $p_Ljava_time_format_DateTimeBuilder__checkDate__Ljava_time_LocalDate__V($thiz, $x_2.gE($x_1.l, $x_1.h));
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__mergeDate__Ljava_time_format_ResolverStyle__V as $p_Ljava_time_format_DateTimeBuilder__mergeDate__Ljava_time_format_ResolverStyle__V };
function $p_Ljava_time_format_DateTimeBuilder__checkDate__Ljava_time_LocalDate__V($thiz, date) {
  if ((date !== null)) {
    $thiz.ck = date;
    var fields = new $j_java$002eutil$002e$002dHash$002dMap$0024$002dKey$002dSet.$c_ju_HashMap$KeySet($thiz.R).cV();
    var break$1 = false;
    while (((!break$1) && fields.i())) {
      var field = fields.e();
      if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
        if (field.hk()) {
          var val1_$_lo = 0;
          var val1_$_hi = 0;
          try {
            var $x_1 = date.ai(field);
            val1_$_lo = $x_1.l;
            val1_$_hi = $x_1.h;
          } catch (e) {
            if ((e instanceof $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException)) {
              break$1 = true;
            } else {
              throw e;
            }
          }
          if ((!break$1)) {
            var $x_2 = $j_java$002elang$002e$002dObject.$uJ($j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz.R, field, null));
            var val2_$_lo = $x_2.l;
            var val2_$_hi = $x_2.h;
            var x$1_$_lo = val1_$_lo;
            var x$1_$_hi = val1_$_hi;
            if ((((x$1_$_lo ^ val2_$_lo) | (x$1_$_hi ^ val2_$_hi)) !== 0)) {
              throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ((((((((("Conflict found: Field " + field) + " ") + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(val1_$_lo, val1_$_hi)) + " differs from ") + field) + " ") + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(val2_$_lo, val2_$_hi)) + " derived from ") + date));
            }
          }
        }
      }
    }
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__checkDate__Ljava_time_LocalDate__V as $p_Ljava_time_format_DateTimeBuilder__checkDate__Ljava_time_LocalDate__V };
function $p_Ljava_time_format_DateTimeBuilder__mergeTime__Ljava_time_format_ResolverStyle__V($thiz, resolverStyle) {
  if ($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var $x_1 = $j_java$002elang$002e$002dObject.$uJ($thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField()));
    var ch_$_lo = $x_1.l;
    var ch_$_hi = $x_1.h;
    if ((resolverStyle !== $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      if ((!((resolverStyle === $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle()) && ((ch_$_lo | ch_$_hi) === 0)))) {
        var this$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
        this$3.G.ak(ch_$_lo, ch_$_hi, this$3);
      }
    }
    var $x_3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    if ((((24 ^ ch_$_lo) | ch_$_hi) === 0)) {
      var $x_2_$_lo = 0;
      var $x_2_$_hi = 0;
    } else {
      var $x_2_$_lo = ch_$_lo;
      var $x_2_$_hi = ch_$_hi;
    }
    $thiz.cR($x_3, $x_2_$_lo, $x_2_$_hi);
  }
  if ($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField())) {
    var $x_4 = $j_java$002elang$002e$002dObject.$uJ($thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField()));
    var ch$2_$_lo = $x_4.l;
    var ch$2_$_hi = $x_4.h;
    if ((resolverStyle !== $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      if ((!((resolverStyle === $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle()) && ((ch$2_$_lo | ch$2_$_hi) === 0)))) {
        var this$7 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
        this$7.G.ak(ch$2_$_lo, ch$2_$_hi, this$7);
      }
    }
    var $x_6 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
    if ((((12 ^ ch$2_$_lo) | ch$2_$_hi) === 0)) {
      var $x_5_$_lo = 0;
      var $x_5_$_hi = 0;
    } else {
      var $x_5_$_lo = ch$2_$_lo;
      var $x_5_$_hi = ch$2_$_hi;
    }
    $thiz.cR($x_6, $x_5_$_lo, $x_5_$_hi);
  }
  if ((resolverStyle !== $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
    if ($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField())) {
      var this$11 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField();
      var $x_7 = $j_java$002elang$002e$002dObject.$uJ($j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz.R, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField(), null));
      var value_$_lo = $x_7.l;
      var value_$_hi = $x_7.h;
      this$11.G.ak(value_$_lo, value_$_hi, this$11);
    }
    if ($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField())) {
      var this$14 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
      var $x_8 = $j_java$002elang$002e$002dObject.$uJ($j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz.R, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField(), null));
      var value$1_$_lo = $x_8.l;
      var value$1_$_hi = $x_8.h;
      this$14.G.ak(value$1_$_lo, value$1_$_hi, this$14);
    }
  }
  if (($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField()) && $thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField()))) {
    var $x_9 = $j_java$002elang$002e$002dObject.$uJ($thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField()));
    var ap_$_lo = $x_9.l;
    var ap_$_hi = $x_9.h;
    var $x_10 = $j_java$002elang$002e$002dObject.$uJ($thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField()));
    var hap_$_lo = $x_10.l;
    var hap_$_hi = $x_10.h;
    var $x_11 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    var b0 = (65535 & ap_$_lo);
    var b1 = ((ap_$_lo >>> 16) | 0);
    var a0b0 = Math.imul(12, b0);
    var a0b1 = Math.imul(12, b1);
    var lo = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi = ((Math.imul(12, ap_$_hi) + ((c1part >>> 16) | 0)) | 0);
    var lo$1 = ((lo + hap_$_lo) | 0);
    var hi$1 = ((((hi + hap_$_hi) | 0) + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
    $thiz.cR($x_11, lo$1, hi$1);
  }
  if ($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var $x_12 = $j_java$002elang$002e$002dObject.$uJ($thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField()));
    var nod_$_lo = $x_12.l;
    var nod_$_hi = $x_12.h;
    if ((resolverStyle !== $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$20 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
      this$20.G.ak(nod_$_lo, nod_$_hi, this$20);
    }
    var $x_14 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
    var sign = (nod_$_hi >> 31);
    var xlo = (nod_$_lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((nod_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
    var x$7 = (1.0000000000000017E-9 * aHat);
    var lo$2 = (x$7 | 0.0);
    var hi$2 = ((2.3283064365386963E-10 * x$7) | 0.0);
    var rHat = ((rlo - Math.imul(1000000000, lo$2)) | 0);
    if ((rHat < 0)) {
      var lo$3 = ((lo$2 - 1) | 0);
      var hi$3 = ((((hi$2 - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
      var absR_$_lo = lo$3;
      var absR_$_hi = hi$3;
    } else {
      var absR_$_lo = lo$2;
      var absR_$_hi = hi$2;
    }
    if ((nod_$_hi < 0)) {
      var lo$4 = ((-absR_$_lo) | 0);
      var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
      var $x_13_$_lo = lo$4;
      var $x_13_$_hi = hi$4;
    } else {
      var $x_13_$_lo = absR_$_lo;
      var $x_13_$_hi = absR_$_hi;
    }
    $thiz.cR($x_14, $x_13_$_lo, $x_13_$_hi);
    var $x_16 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var sign$1 = (nod_$_hi >> 31);
    var xlo$1 = (nod_$_lo ^ sign$1);
    var rlo$1 = ((xlo$1 - sign$1) | 0);
    var rhi$1 = (((nod_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
    var aHat$1 = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
    var x$9 = (1.0000000000000017E-9 * aHat$1);
    var lo$5 = (x$9 | 0.0);
    ((2.3283064365386963E-10 * x$9) | 0.0);
    var rHat$1 = ((rlo$1 - Math.imul(1000000000, lo$5)) | 0);
    if ((rHat$1 < 0)) {
      var lo$6 = ((1000000000 + rHat$1) | 0);
      var absR$1_$_lo = lo$6;
      var absR$1_$_hi = 0;
    } else {
      var absR$1_$_lo = rHat$1;
      var absR$1_$_hi = 0;
    }
    if ((nod_$_hi < 0)) {
      var lo$7 = ((-absR$1_$_lo) | 0);
      var hi$6 = ((((-absR$1_$_hi) | 0) - ((lo$7 !== 0) | 0)) | 0);
      var $x_15_$_lo = lo$7;
      var $x_15_$_hi = hi$6;
    } else {
      var $x_15_$_lo = absR$1_$_lo;
      var $x_15_$_hi = absR$1_$_hi;
    }
    $thiz.cR($x_16, $x_15_$_lo, $x_15_$_hi);
  }
  if ($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var $x_17 = $j_java$002elang$002e$002dObject.$uJ($thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField()));
    var cod_$_lo = $x_17.l;
    var cod_$_hi = $x_17.h;
    if ((resolverStyle !== $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$45 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField();
      this$45.G.ak(cod_$_lo, cod_$_hi, this$45);
    }
    var $x_19 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
    var sign$2 = (cod_$_hi >> 31);
    var xlo$2 = (cod_$_lo ^ sign$2);
    var rlo$2 = ((xlo$2 - sign$2) | 0);
    var rhi$2 = (((cod_$_hi ^ sign$2) + (((rlo$2 >>> 0) < (xlo$2 >>> 0)) | 0)) | 0);
    var aHat$2 = ((4.294967296E9 * (rhi$2 >>> 0.0)) + (rlo$2 >>> 0.0));
    var x$12 = (1.0000000000000016E-6 * aHat$2);
    var lo$8 = (x$12 | 0.0);
    var hi$7 = ((2.3283064365386963E-10 * x$12) | 0.0);
    var rHat$2 = ((rlo$2 - Math.imul(1000000, lo$8)) | 0);
    if ((rHat$2 < 0)) {
      var lo$9 = ((lo$8 - 1) | 0);
      var hi$8 = ((((hi$7 - 1) | 0) + ((lo$9 !== (-1)) | 0)) | 0);
      var absR$2_$_lo = lo$9;
      var absR$2_$_hi = hi$8;
    } else {
      var absR$2_$_lo = lo$8;
      var absR$2_$_hi = hi$7;
    }
    if ((cod_$_hi < 0)) {
      var lo$10 = ((-absR$2_$_lo) | 0);
      var hi$9 = ((((-absR$2_$_hi) | 0) - ((lo$10 !== 0) | 0)) | 0);
      var $x_18_$_lo = lo$10;
      var $x_18_$_hi = hi$9;
    } else {
      var $x_18_$_lo = absR$2_$_lo;
      var $x_18_$_hi = absR$2_$_hi;
    }
    $thiz.cR($x_19, $x_18_$_lo, $x_18_$_hi);
    var $x_21 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var sign$3 = (cod_$_hi >> 31);
    var xlo$3 = (cod_$_lo ^ sign$3);
    var rlo$3 = ((xlo$3 - sign$3) | 0);
    var rhi$3 = (((cod_$_hi ^ sign$3) + (((rlo$3 >>> 0) < (xlo$3 >>> 0)) | 0)) | 0);
    var aHat$3 = ((4.294967296E9 * (rhi$3 >>> 0.0)) + (rlo$3 >>> 0.0));
    var x$14 = (1.0000000000000016E-6 * aHat$3);
    var lo$11 = (x$14 | 0.0);
    ((2.3283064365386963E-10 * x$14) | 0.0);
    var rHat$3 = ((rlo$3 - Math.imul(1000000, lo$11)) | 0);
    if ((rHat$3 < 0)) {
      var lo$12 = ((1000000 + rHat$3) | 0);
      var absR$3_$_lo = lo$12;
      var absR$3_$_hi = 0;
    } else {
      var absR$3_$_lo = rHat$3;
      var absR$3_$_hi = 0;
    }
    if ((cod_$_hi < 0)) {
      var lo$13 = ((-absR$3_$_lo) | 0);
      var hi$11 = ((((-absR$3_$_hi) | 0) - ((lo$13 !== 0) | 0)) | 0);
      var $x_20_$_lo = lo$13;
      var $x_20_$_hi = hi$11;
    } else {
      var $x_20_$_lo = absR$3_$_lo;
      var $x_20_$_hi = absR$3_$_hi;
    }
    $thiz.cR($x_21, $x_20_$_lo, $x_20_$_hi);
  }
  if ($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var $x_22 = $j_java$002elang$002e$002dObject.$uJ($thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField()));
    var lod_$_lo = $x_22.l;
    var lod_$_hi = $x_22.h;
    if ((resolverStyle !== $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$70 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField();
      this$70.G.ak(lod_$_lo, lod_$_hi, this$70);
    }
    var $x_24 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
    var sign$4 = (lod_$_hi >> 31);
    var xlo$4 = (lod_$_lo ^ sign$4);
    var rlo$4 = ((xlo$4 - sign$4) | 0);
    var rhi$4 = (((lod_$_hi ^ sign$4) + (((rlo$4 >>> 0) < (xlo$4 >>> 0)) | 0)) | 0);
    var quotHi = (((rhi$4 >>> 0) / 1000) | 0);
    var k = ((rhi$4 - Math.imul(1000, quotHi)) | 0);
    var quotLo = ((0.0010000000000000005 * ((4.294967296E9 * k) + (rlo$4 >>> 0.0))) | 0.0);
    if ((lod_$_hi < 0)) {
      var lo$14 = ((-quotLo) | 0);
      var hi$12 = ((((-quotHi) | 0) - ((lo$14 !== 0) | 0)) | 0);
      var $x_23_$_lo = lo$14;
      var $x_23_$_hi = hi$12;
    } else {
      var $x_23_$_lo = quotLo;
      var $x_23_$_hi = quotHi;
    }
    $thiz.cR($x_24, $x_23_$_lo, $x_23_$_hi);
    var $x_26 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    var sign$5 = (lod_$_hi >> 31);
    var xlo$5 = (lod_$_lo ^ sign$5);
    var rlo$5 = ((xlo$5 - sign$5) | 0);
    var rhi$5 = (((lod_$_hi ^ sign$5) + (((rlo$5 >>> 0) < (xlo$5 >>> 0)) | 0)) | 0);
    var k$2 = (((rhi$5 >>> 0) % 1000) | 0);
    var quotLo$2 = ((0.0010000000000000005 * ((4.294967296E9 * k$2) + (rlo$5 >>> 0.0))) | 0.0);
    var remLo = ((rlo$5 - Math.imul(1000, quotLo$2)) | 0);
    if ((lod_$_hi < 0)) {
      var lo$15 = ((-remLo) | 0);
      var hi$13 = ((-((lo$15 !== 0) | 0)) | 0);
      var $x_25_$_lo = lo$15;
      var $x_25_$_hi = hi$13;
    } else {
      var $x_25_$_lo = remLo;
      var $x_25_$_hi = 0;
    }
    $thiz.cR($x_26, $x_25_$_lo, $x_25_$_hi);
  }
  if ($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var $x_27 = $j_java$002elang$002e$002dObject.$uJ($thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField()));
    var sod_$_lo = $x_27.l;
    var sod_$_hi = $x_27.h;
    if ((resolverStyle !== $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$92 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
      this$92.G.ak(sod_$_lo, sod_$_hi, this$92);
    }
    var $x_29 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    var sign$6 = (sod_$_hi >> 31);
    var xlo$6 = (sod_$_lo ^ sign$6);
    var rlo$6 = ((xlo$6 - sign$6) | 0);
    var rhi$6 = (((sod_$_hi ^ sign$6) + (((rlo$6 >>> 0) < (xlo$6 >>> 0)) | 0)) | 0);
    var quotHi$1 = (((rhi$6 >>> 0) / 3600) | 0);
    var k$1 = ((rhi$6 - Math.imul(3600, quotHi$1)) | 0);
    var quotLo$1 = ((2.777777777777779E-4 * ((4.294967296E9 * k$1) + (rlo$6 >>> 0.0))) | 0.0);
    if ((sod_$_hi < 0)) {
      var lo$16 = ((-quotLo$1) | 0);
      var hi$14 = ((((-quotHi$1) | 0) - ((lo$16 !== 0) | 0)) | 0);
      var $x_28_$_lo = lo$16;
      var $x_28_$_hi = hi$14;
    } else {
      var $x_28_$_lo = quotLo$1;
      var $x_28_$_hi = quotHi$1;
    }
    $thiz.cR($x_29, $x_28_$_lo, $x_28_$_hi);
    var $x_31 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    var sign$7 = (sod_$_hi >> 31);
    var xlo$7 = (sod_$_lo ^ sign$7);
    var rlo$7 = ((xlo$7 - sign$7) | 0);
    var rhi$7 = (((sod_$_hi ^ sign$7) + (((rlo$7 >>> 0) < (xlo$7 >>> 0)) | 0)) | 0);
    var quotHi$2 = (((rhi$7 >>> 0) / 60) | 0);
    var k$3 = ((rhi$7 - Math.imul(60, quotHi$2)) | 0);
    var quotLo$3 = ((0.016666666666666673 * ((4.294967296E9 * k$3) + (rlo$7 >>> 0.0))) | 0.0);
    if ((sod_$_hi < 0)) {
      var lo$17 = ((-quotLo$3) | 0);
      var hi$15 = ((((-quotHi$2) | 0) - ((lo$17 !== 0) | 0)) | 0);
      var num_$_lo = lo$17;
      var num_$_hi = hi$15;
    } else {
      var num_$_lo = quotLo$3;
      var num_$_hi = quotHi$2;
    }
    var sign$8 = (num_$_hi >> 31);
    var xlo$8 = (num_$_lo ^ sign$8);
    var rlo$8 = ((xlo$8 - sign$8) | 0);
    var rhi$8 = (((num_$_hi ^ sign$8) + (((rlo$8 >>> 0) < (xlo$8 >>> 0)) | 0)) | 0);
    var k$2$1 = (((rhi$8 >>> 0) % 60) | 0);
    var quotLo$2$1 = ((0.016666666666666673 * ((4.294967296E9 * k$2$1) + (rlo$8 >>> 0.0))) | 0.0);
    var remLo$1 = ((rlo$8 - Math.imul(60, quotLo$2$1)) | 0);
    if ((num_$_hi < 0)) {
      var lo$18 = ((-remLo$1) | 0);
      var hi$16 = ((-((lo$18 !== 0) | 0)) | 0);
      var $x_30_$_lo = lo$18;
      var $x_30_$_hi = hi$16;
    } else {
      var $x_30_$_lo = remLo$1;
      var $x_30_$_hi = 0;
    }
    $thiz.cR($x_31, $x_30_$_lo, $x_30_$_hi);
    var $x_33 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
    var sign$9 = (sod_$_hi >> 31);
    var xlo$9 = (sod_$_lo ^ sign$9);
    var rlo$9 = ((xlo$9 - sign$9) | 0);
    var rhi$9 = (((sod_$_hi ^ sign$9) + (((rlo$9 >>> 0) < (xlo$9 >>> 0)) | 0)) | 0);
    var k$2$2 = (((rhi$9 >>> 0) % 60) | 0);
    var quotLo$2$2 = ((0.016666666666666673 * ((4.294967296E9 * k$2$2) + (rlo$9 >>> 0.0))) | 0.0);
    var remLo$2 = ((rlo$9 - Math.imul(60, quotLo$2$2)) | 0);
    if ((sod_$_hi < 0)) {
      var lo$19 = ((-remLo$2) | 0);
      var hi$17 = ((-((lo$19 !== 0) | 0)) | 0);
      var $x_32_$_lo = lo$19;
      var $x_32_$_hi = hi$17;
    } else {
      var $x_32_$_lo = remLo$2;
      var $x_32_$_hi = 0;
    }
    $thiz.cR($x_33, $x_32_$_lo, $x_32_$_hi);
  }
  if ($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField())) {
    var $x_34 = $j_java$002elang$002e$002dObject.$uJ($thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField()));
    var mod_$_lo = $x_34.l;
    var mod_$_hi = $x_34.h;
    if ((resolverStyle !== $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$134 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField();
      this$134.G.ak(mod_$_lo, mod_$_hi, this$134);
    }
    var $x_36 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    var sign$10 = (mod_$_hi >> 31);
    var xlo$10 = (mod_$_lo ^ sign$10);
    var rlo$10 = ((xlo$10 - sign$10) | 0);
    var rhi$10 = (((mod_$_hi ^ sign$10) + (((rlo$10 >>> 0) < (xlo$10 >>> 0)) | 0)) | 0);
    var quotHi$3 = (((rhi$10 >>> 0) / 60) | 0);
    var k$4 = ((rhi$10 - Math.imul(60, quotHi$3)) | 0);
    var quotLo$4 = ((0.016666666666666673 * ((4.294967296E9 * k$4) + (rlo$10 >>> 0.0))) | 0.0);
    if ((mod_$_hi < 0)) {
      var lo$20 = ((-quotLo$4) | 0);
      var hi$18 = ((((-quotHi$3) | 0) - ((lo$20 !== 0) | 0)) | 0);
      var $x_35_$_lo = lo$20;
      var $x_35_$_hi = hi$18;
    } else {
      var $x_35_$_lo = quotLo$4;
      var $x_35_$_hi = quotHi$3;
    }
    $thiz.cR($x_36, $x_35_$_lo, $x_35_$_hi);
    var $x_38 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    var sign$11 = (mod_$_hi >> 31);
    var xlo$11 = (mod_$_lo ^ sign$11);
    var rlo$11 = ((xlo$11 - sign$11) | 0);
    var rhi$11 = (((mod_$_hi ^ sign$11) + (((rlo$11 >>> 0) < (xlo$11 >>> 0)) | 0)) | 0);
    var k$2$3 = (((rhi$11 >>> 0) % 60) | 0);
    var quotLo$2$3 = ((0.016666666666666673 * ((4.294967296E9 * k$2$3) + (rlo$11 >>> 0.0))) | 0.0);
    var remLo$3 = ((rlo$11 - Math.imul(60, quotLo$2$3)) | 0);
    if ((mod_$_hi < 0)) {
      var lo$21 = ((-remLo$3) | 0);
      var hi$19 = ((-((lo$21 !== 0) | 0)) | 0);
      var $x_37_$_lo = lo$21;
      var $x_37_$_hi = hi$19;
    } else {
      var $x_37_$_lo = remLo$3;
      var $x_37_$_hi = 0;
    }
    $thiz.cR($x_38, $x_37_$_lo, $x_37_$_hi);
  }
  if ((resolverStyle !== $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
    if ($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField())) {
      var this$157 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
      var $x_39 = $j_java$002elang$002e$002dObject.$uJ($j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz.R, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField(), null));
      var value$2_$_lo = $x_39.l;
      var value$2_$_hi = $x_39.h;
      this$157.G.ak(value$2_$_lo, value$2_$_hi, this$157);
    }
    if ($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
      var this$160 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      var $x_40 = $j_java$002elang$002e$002dObject.$uJ($j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz.R, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField(), null));
      var value$3_$_lo = $x_40.l;
      var value$3_$_hi = $x_40.h;
      this$160.G.ak(value$3_$_lo, value$3_$_hi, this$160);
    }
  }
  if (($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField()) && $thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField()))) {
    var $x_41 = $j_java$002elang$002e$002dObject.$uJ($thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField()));
    var los_$_lo = $x_41.l;
    var los_$_hi = $x_41.h;
    var $x_42 = $j_java$002elang$002e$002dObject.$uJ($j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz.R, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField(), null));
    var cos_$_lo = $x_42.l;
    var cos_$_hi = $x_42.h;
    var $x_43 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var b0$1 = (65535 & los_$_lo);
    var b1$1 = ((los_$_lo >>> 16) | 0);
    var a0b0$1 = Math.imul(1000, b0$1);
    var a0b1$1 = Math.imul(1000, b1$1);
    var lo$22 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
    var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
    var hi$20 = ((Math.imul(1000, los_$_hi) + ((c1part$1 >>> 16) | 0)) | 0);
    var sign$12 = (cos_$_hi >> 31);
    var xlo$12 = (cos_$_lo ^ sign$12);
    var rlo$12 = ((xlo$12 - sign$12) | 0);
    var rhi$12 = (((cos_$_hi ^ sign$12) + (((rlo$12 >>> 0) < (xlo$12 >>> 0)) | 0)) | 0);
    var k$2$4 = (((rhi$12 >>> 0) % 1000) | 0);
    var quotLo$2$4 = ((0.0010000000000000005 * ((4.294967296E9 * k$2$4) + (rlo$12 >>> 0.0))) | 0.0);
    var remLo$4 = ((rlo$12 - Math.imul(1000, quotLo$2$4)) | 0);
    if ((cos_$_hi < 0)) {
      var lo$23 = ((-remLo$4) | 0);
      var hi$21 = ((-((lo$23 !== 0) | 0)) | 0);
      var x$32_$_lo = lo$23;
      var x$32_$_hi = hi$21;
    } else {
      var x$32_$_lo = remLo$4;
      var x$32_$_hi = 0;
    }
    var lo$24 = ((lo$22 + x$32_$_lo) | 0);
    var hi$22 = ((((hi$20 + x$32_$_hi) | 0) + (((lo$24 >>> 0) < (lo$22 >>> 0)) | 0)) | 0);
    $thiz.cR($x_43, lo$24, hi$22);
  }
  if (($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField()) && $thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField()))) {
    var $x_44 = $j_java$002elang$002e$002dObject.$uJ($j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz.R, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), null));
    var nos_$_lo = $x_44.l;
    var nos_$_hi = $x_44.h;
    var $x_46 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var sign$13 = (nos_$_hi >> 31);
    var xlo$13 = (nos_$_lo ^ sign$13);
    var rlo$13 = ((xlo$13 - sign$13) | 0);
    var rhi$13 = (((nos_$_hi ^ sign$13) + (((rlo$13 >>> 0) < (xlo$13 >>> 0)) | 0)) | 0);
    var quotHi$4 = (((rhi$13 >>> 0) / 1000) | 0);
    var k$5 = ((rhi$13 - Math.imul(1000, quotHi$4)) | 0);
    var quotLo$5 = ((0.0010000000000000005 * ((4.294967296E9 * k$5) + (rlo$13 >>> 0.0))) | 0.0);
    if ((nos_$_hi < 0)) {
      var lo$25 = ((-quotLo$5) | 0);
      var hi$23 = ((((-quotHi$4) | 0) - ((lo$25 !== 0) | 0)) | 0);
      var $x_45_$_lo = lo$25;
      var $x_45_$_hi = hi$23;
    } else {
      var $x_45_$_lo = quotLo$5;
      var $x_45_$_hi = quotHi$4;
    }
    $thiz.cR($x_46, $x_45_$_lo, $x_45_$_hi);
    $thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField());
  }
  if (($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField()) && $thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField()))) {
    var $x_47 = $j_java$002elang$002e$002dObject.$uJ($j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz.R, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), null));
    var nos$2_$_lo = $x_47.l;
    var nos$2_$_hi = $x_47.h;
    var $x_49 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    var sign$14 = (nos$2_$_hi >> 31);
    var xlo$14 = (nos$2_$_lo ^ sign$14);
    var rlo$14 = ((xlo$14 - sign$14) | 0);
    var rhi$14 = (((nos$2_$_hi ^ sign$14) + (((rlo$14 >>> 0) < (xlo$14 >>> 0)) | 0)) | 0);
    var aHat$4 = ((4.294967296E9 * (rhi$14 >>> 0.0)) + (rlo$14 >>> 0.0));
    var x$36 = (1.0000000000000016E-6 * aHat$4);
    var lo$26 = (x$36 | 0.0);
    var hi$24 = ((2.3283064365386963E-10 * x$36) | 0.0);
    var rHat$4 = ((rlo$14 - Math.imul(1000000, lo$26)) | 0);
    if ((rHat$4 < 0)) {
      var lo$27 = ((lo$26 - 1) | 0);
      var hi$25 = ((((hi$24 - 1) | 0) + ((lo$27 !== (-1)) | 0)) | 0);
      var absR$4_$_lo = lo$27;
      var absR$4_$_hi = hi$25;
    } else {
      var absR$4_$_lo = lo$26;
      var absR$4_$_hi = hi$24;
    }
    if ((nos$2_$_hi < 0)) {
      var lo$28 = ((-absR$4_$_lo) | 0);
      var hi$26 = ((((-absR$4_$_hi) | 0) - ((lo$28 !== 0) | 0)) | 0);
      var $x_48_$_lo = lo$28;
      var $x_48_$_hi = hi$26;
    } else {
      var $x_48_$_lo = absR$4_$_lo;
      var $x_48_$_hi = absR$4_$_hi;
    }
    $thiz.cR($x_49, $x_48_$_lo, $x_48_$_hi);
    $thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField());
  }
  if ($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
    var $x_50 = $j_java$002elang$002e$002dObject.$uJ($thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField()));
    var cos$2_$_lo = $x_50.l;
    var cos$2_$_hi = $x_50.h;
    var $x_51 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var b0$2 = (65535 & cos$2_$_lo);
    var b1$2 = ((cos$2_$_lo >>> 16) | 0);
    var a0b0$2 = Math.imul(1000, b0$2);
    var a0b1$2 = Math.imul(1000, b1$2);
    var lo$29 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
    var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
    var hi$27 = ((Math.imul(1000, cos$2_$_hi) + ((c1part$2 >>> 16) | 0)) | 0);
    $thiz.cR($x_51, lo$29, hi$27);
  } else if ($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField())) {
    var $x_52 = $j_java$002elang$002e$002dObject.$uJ($thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField()));
    var los$2_$_lo = $x_52.l;
    var los$2_$_hi = $x_52.h;
    var $x_53 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var b0$3 = (65535 & los$2_$_lo);
    var b1$3 = ((los$2_$_lo >>> 16) | 0);
    var a0b0$3 = Math.imul(16960, b0$3);
    var a1b0 = Math.imul(15, b0$3);
    var a0b1$3 = Math.imul(16960, b1$3);
    var lo$30 = ((a0b0$3 + (((a1b0 + a0b1$3) | 0) << 16)) | 0);
    var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
    var hi$28 = ((((((Math.imul(1000000, los$2_$_hi) + Math.imul(15, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0) | 0) >>> 16) | 0)) | 0);
    $thiz.cR($x_53, lo$30, hi$28);
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__mergeTime__Ljava_time_format_ResolverStyle__V as $p_Ljava_time_format_DateTimeBuilder__mergeTime__Ljava_time_format_ResolverStyle__V };
function $p_Ljava_time_format_DateTimeBuilder__resolveTimeInferZeroes__Ljava_time_format_ResolverStyle__V($thiz, resolverStyle) {
  var hod = $j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz.R, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField(), null);
  var moh = $j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz.R, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField(), null);
  var som = $j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz.R, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField(), null);
  var nos = $j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz.R, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), null);
  if ((hod === null)) {
    return (void 0);
  }
  if (((moh === null) && ((som !== null) || (nos !== null)))) {
    return (void 0);
  }
  if ((((moh !== null) && (som === null)) && (nos !== null))) {
    return (void 0);
  }
  if ((resolverStyle !== $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
    if ((hod !== null)) {
      if ((resolverStyle === $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle())) {
        var $x_5 = hod;
        var this$5_$_lo = $x_5.l;
        var this$5_$_hi = $x_5.h;
        var $x_4 = (((24 ^ this$5_$_lo) | this$5_$_hi) === 0);
      } else {
        var $x_4 = false;
      }
      if ($x_4) {
        if ((moh === null)) {
          var $x_3 = true;
        } else {
          var $x_6 = moh;
          var this$7_$_lo = $x_6.l;
          var this$7_$_hi = $x_6.h;
          var $x_3 = ((this$7_$_lo | this$7_$_hi) === 0);
        }
      } else {
        var $x_3 = false;
      }
      if ($x_3) {
        if ((som === null)) {
          var $x_2 = true;
        } else {
          var $x_7 = som;
          var this$9_$_lo = $x_7.l;
          var this$9_$_hi = $x_7.h;
          var $x_2 = ((this$9_$_lo | this$9_$_hi) === 0);
        }
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        if ((nos === null)) {
          var $x_1 = true;
        } else {
          var $x_8 = nos;
          var this$11_$_lo = $x_8.l;
          var this$11_$_hi = $x_8.h;
          var $x_1 = ((this$11_$_lo | this$11_$_hi) === 0);
        }
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        hod = $j_java$002elang$002e$002dObject.$bL(0, 0);
        $thiz.gT = $j_java$002etime$002e$002dPeriod.$m_Ljava_time_Period$().xy(0, 0, 1);
      }
      var this$16 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
      var $x_9 = $j_java$002elang$002e$002dObject.$uJ(hod);
      var value_$_lo = $x_9.l;
      var value_$_hi = $x_9.h;
      var hodVal = this$16.G.b0(value_$_lo, value_$_hi, this$16);
      if ((moh !== null)) {
        var this$18 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
        var $x_10 = $j_java$002elang$002e$002dObject.$uJ(moh);
        var value$1_$_lo = $x_10.l;
        var value$1_$_hi = $x_10.h;
        var mohVal = this$18.G.b0(value$1_$_lo, value$1_$_hi, this$18);
        if ((som !== null)) {
          var this$20 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
          var $x_11 = $j_java$002elang$002e$002dObject.$uJ(som);
          var value$2_$_lo = $x_11.l;
          var value$2_$_hi = $x_11.h;
          var somVal = this$20.G.b0(value$2_$_lo, value$2_$_hi, this$20);
          if ((nos !== null)) {
            var this$22 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
            var $x_12 = $j_java$002elang$002e$002dObject.$uJ(nos);
            var value$3_$_lo = $x_12.l;
            var value$3_$_hi = $x_12.h;
            var nosVal = this$22.G.b0(value$3_$_lo, value$3_$_hi, this$22);
            var time = $m_Ljava_time_LocalTime$().PK(hodVal, mohVal, somVal, nosVal);
            $thiz.c0 = time;
          } else {
            var time$1 = $m_Ljava_time_LocalTime$().Wo(hodVal, mohVal, somVal);
            $thiz.c0 = time$1;
          }
        } else if ((nos === null)) {
          var time$2 = $m_Ljava_time_LocalTime$().C9(hodVal, mohVal);
          $thiz.c0 = time$2;
        }
      } else if (((som === null) && (nos === null))) {
        var time$3 = $m_Ljava_time_LocalTime$().C9(hodVal, 0);
        $thiz.c0 = time$3;
      }
    }
  } else if ((hod !== null)) {
    var $x_13 = $j_java$002elang$002e$002dObject.$uJ(hod);
    var hodVal$2_$_lo = $x_13.l;
    var hodVal$2_$_hi = $x_13.h;
    if ((moh !== null)) {
      if ((som !== null)) {
        if ((nos === null)) {
          nos = $j_java$002elang$002e$002dObject.$bL(0, 0);
        }
        var a_$_lo = hodVal$2_$_lo;
        var a_$_hi = hodVal$2_$_hi;
        var this$25 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
        var b0 = (65535 & a_$_lo);
        var b1 = ((a_$_lo >>> 16) | 0);
        var a0b0 = Math.imul(40960, b0);
        var a1b0 = Math.imul(12472, b0);
        var a0b1 = Math.imul(40960, b1);
        var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi = ((((((((Math.imul(817405952, a_$_hi) + Math.imul(838, a_$_lo)) | 0) + Math.imul(12472, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        if (((a_$_lo | a_$_hi) !== 0)) {
          var $x_15 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo, hi, a_$_lo, a_$_hi);
          var x$3_$_lo = $x_15.l;
          var x$3_$_hi = $x_15.h;
          var $x_14 = (((817405952 ^ x$3_$_lo) | (838 ^ x$3_$_hi)) !== 0);
        } else {
          var $x_14 = false;
        }
        if ($x_14) {
          this$25.au();
        }
        var totalNanos_$_lo = lo;
        var totalNanos_$_hi = hi;
        var a$2_$_lo = totalNanos_$_lo;
        var a$2_$_hi = totalNanos_$_hi;
        var $x_16 = $j_java$002elang$002e$002dObject.$uJ(moh);
        var a$1_$_lo = $x_16.l;
        var a$1_$_hi = $x_16.h;
        var this$31 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
        var b0$1 = (65535 & a$1_$_lo);
        var b1$1 = ((a$1_$_lo >>> 16) | 0);
        var a0b0$1 = Math.imul(22528, b0$1);
        var a1b0$1 = Math.imul(63559, b0$1);
        var a0b1$1 = Math.imul(22528, b1$1);
        var lo$1 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$1 = ((((((((Math.imul((-129542144), a$1_$_hi) + Math.imul(13, a$1_$_lo)) | 0) + Math.imul(63559, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
        if (((a$1_$_lo | a$1_$_hi) !== 0)) {
          var $x_18 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo$1, hi$1, a$1_$_lo, a$1_$_hi);
          var x$4_$_lo = $x_18.l;
          var x$4_$_hi = $x_18.h;
          var $x_17 = ((((-129542144) ^ x$4_$_lo) | (13 ^ x$4_$_hi)) !== 0);
        } else {
          var $x_17 = false;
        }
        if ($x_17) {
          this$31.au();
        }
        var this$36 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
        var lo$2 = ((a$2_$_lo + lo$1) | 0);
        var hi$2 = ((((a$2_$_hi + hi$1) | 0) + (((lo$2 >>> 0) < (a$2_$_lo >>> 0)) | 0)) | 0);
        if ((((hi$2 ^ a$2_$_hi) & (hi$2 ^ hi$1)) < 0)) {
          this$36.au();
        }
        totalNanos_$_lo = lo$2;
        totalNanos_$_hi = hi$2;
        var a$4_$_lo = totalNanos_$_lo;
        var a$4_$_hi = totalNanos_$_hi;
        var $x_19 = $j_java$002elang$002e$002dObject.$uJ(som);
        var a$3_$_lo = $x_19.l;
        var a$3_$_hi = $x_19.h;
        var this$43 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
        var b0$2 = (65535 & a$3_$_lo);
        var b1$2 = ((a$3_$_lo >>> 16) | 0);
        var a0b0$2 = Math.imul(51712, b0$2);
        var a1b0$2 = Math.imul(15258, b0$2);
        var a0b1$2 = Math.imul(51712, b1$2);
        var lo$6 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
        var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
        var hi$6 = ((((((Math.imul(1000000000, a$3_$_hi) + Math.imul(15258, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
        if (((a$3_$_lo | a$3_$_hi) !== 0)) {
          var $x_21 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo$6, hi$6, a$3_$_lo, a$3_$_hi);
          var x$5_$_lo = $x_21.l;
          var x$5_$_hi = $x_21.h;
          var $x_20 = (((1000000000 ^ x$5_$_lo) | x$5_$_hi) !== 0);
        } else {
          var $x_20 = false;
        }
        if ($x_20) {
          this$43.au();
        }
        var this$48 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
        var lo$7 = ((a$4_$_lo + lo$6) | 0);
        var hi$7 = ((((a$4_$_hi + hi$6) | 0) + (((lo$7 >>> 0) < (a$4_$_lo >>> 0)) | 0)) | 0);
        if ((((hi$7 ^ a$4_$_hi) & (hi$7 ^ hi$6)) < 0)) {
          this$48.au();
        }
        totalNanos_$_lo = lo$7;
        totalNanos_$_hi = hi$7;
        var a$5_$_lo = totalNanos_$_lo;
        var a$5_$_hi = totalNanos_$_hi;
        var $x_22 = $j_java$002elang$002e$002dObject.$uJ(nos);
        var b_$_lo = $x_22.l;
        var b_$_hi = $x_22.h;
        var this$55 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
        var lo$11 = ((a$5_$_lo + b_$_lo) | 0);
        var hi$11 = ((((a$5_$_hi + b_$_hi) | 0) + (((lo$11 >>> 0) < (a$5_$_lo >>> 0)) | 0)) | 0);
        if ((((hi$11 ^ a$5_$_hi) & (hi$11 ^ b_$_hi)) < 0)) {
          this$55.au();
        }
        totalNanos_$_lo = lo$11;
        totalNanos_$_hi = hi$11;
        var a$6_$_lo = totalNanos_$_lo;
        var a$6_$_hi = totalNanos_$_hi;
        var sign = (a$6_$_hi >> 31);
        var xlo = (a$6_$_lo ^ sign);
        var rlo = ((xlo - sign) | 0);
        var rhi = (((a$6_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
        var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
        var x$7 = (1.1574074074074086E-14 * aHat);
        var lo$15 = (x$7 | 0.0);
        var hi$15 = ((2.3283064365386963E-10 * x$7) | 0.0);
        var b0$3 = (65535 & lo$15);
        var b1$3 = ((lo$15 >>> 16) | 0);
        var a1b0$3 = Math.imul(37199, b0$3);
        var lo$16 = (a1b0$3 << 16);
        var hi$16 = ((((((Math.imul((-1857093632), hi$15) + Math.imul(20116, lo$15)) | 0) + Math.imul(37199, b1$3)) | 0) + ((a1b0$3 >>> 16) | 0)) | 0);
        var lo$17 = ((rlo - lo$16) | 0);
        var hi$17 = ((((rhi - hi$16) | 0) - (((lo$17 >>> 0) > (rlo >>> 0)) | 0)) | 0);
        if ((hi$17 < 0)) {
          var lo$18 = ((lo$15 - 1) | 0);
          var hi$18 = ((((hi$15 - 1) | 0) + ((lo$18 !== (-1)) | 0)) | 0);
          var absR_$_lo = lo$18;
          var absR_$_hi = hi$18;
        } else {
          var absR_$_lo = lo$15;
          var absR_$_hi = hi$15;
        }
        if ((a$6_$_hi < 0)) {
          var lo$19 = ((-absR_$_lo) | 0);
          var hi$19 = ((((-absR_$_hi) | 0) - ((lo$19 !== 0) | 0)) | 0);
          var quot_$_lo = lo$19;
          var quot_$_hi = hi$19;
        } else {
          var quot_$_lo = absR_$_lo;
          var quot_$_hi = absR_$_hi;
        }
        if (((20116 ^ a$6_$_hi) >= 0)) {
          var $x_23 = true;
        } else {
          var b0$4 = (65535 & quot_$_lo);
          var b1$4 = ((quot_$_lo >>> 16) | 0);
          var a1b0$4 = Math.imul(37199, b0$4);
          var $x_23 = ((((a1b0$4 << 16) ^ a$6_$_lo) | (((((((Math.imul((-1857093632), quot_$_hi) + Math.imul(20116, quot_$_lo)) | 0) + Math.imul(37199, b1$4)) | 0) + ((a1b0$4 >>> 16) | 0)) | 0) ^ a$6_$_hi)) === 0);
        }
        if ($x_23) {
          var x$9_$_lo = quot_$_lo;
          var x$9_$_hi = quot_$_hi;
        } else {
          var lo$22 = ((quot_$_lo - 1) | 0);
          var hi$22 = ((((quot_$_hi - 1) | 0) + ((lo$22 !== (-1)) | 0)) | 0);
          var x$9_$_lo = lo$22;
          var x$9_$_hi = hi$22;
        }
        var a$7_$_lo = totalNanos_$_lo;
        var a$7_$_hi = totalNanos_$_hi;
        var sign$1 = (a$7_$_hi >> 31);
        var xlo$1 = (a$7_$_lo ^ sign$1);
        var rlo$1 = ((xlo$1 - sign$1) | 0);
        var rhi$1 = (((a$7_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
        var aHat$1 = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
        var x$10 = (1.1574074074074086E-14 * aHat$1);
        var lo$23 = (x$10 | 0.0);
        var hi$23 = ((2.3283064365386963E-10 * x$10) | 0.0);
        var b0$5 = (65535 & lo$23);
        var b1$5 = ((lo$23 >>> 16) | 0);
        var a1b0$5 = Math.imul(37199, b0$5);
        var lo$24 = (a1b0$5 << 16);
        var hi$24 = ((((((Math.imul((-1857093632), hi$23) + Math.imul(20116, lo$23)) | 0) + Math.imul(37199, b1$5)) | 0) + ((a1b0$5 >>> 16) | 0)) | 0);
        var lo$25 = ((rlo$1 - lo$24) | 0);
        var hi$25 = ((((rhi$1 - hi$24) | 0) - (((lo$25 >>> 0) > (rlo$1 >>> 0)) | 0)) | 0);
        if ((hi$25 < 0)) {
          var lo$26 = ((lo$25 - 1857093632) | 0);
          var hi$26 = ((((20116 + hi$25) | 0) + (((lo$26 >>> 0) < 2437873664) | 0)) | 0);
          var absR$1_$_lo = lo$26;
          var absR$1_$_hi = hi$26;
        } else {
          var absR$1_$_lo = lo$25;
          var absR$1_$_hi = hi$25;
        }
        if ((a$7_$_hi < 0)) {
          var lo$27 = ((-absR$1_$_lo) | 0);
          var hi$27 = ((((-absR$1_$_hi) | 0) - ((lo$27 !== 0) | 0)) | 0);
          var rem_$_lo = lo$27;
          var rem_$_hi = hi$27;
        } else {
          var rem_$_lo = absR$1_$_lo;
          var rem_$_hi = absR$1_$_hi;
        }
        if ((((20116 ^ a$7_$_hi) >= 0) || ((rem_$_lo | rem_$_hi) === 0))) {
          var nod_$_lo = rem_$_lo;
          var nod_$_hi = rem_$_hi;
        } else {
          var lo$29 = ((rem_$_lo - 1857093632) | 0);
          var hi$29 = ((((20116 + rem_$_hi) | 0) + (((lo$29 >>> 0) < 2437873664) | 0)) | 0);
          var nod_$_lo = lo$29;
          var nod_$_hi = hi$29;
        }
        var time$4 = $m_Ljava_time_LocalTime$().l5(nod_$_lo, nod_$_hi);
        $thiz.c0 = time$4;
        $thiz.gT = $j_java$002etime$002e$002dPeriod.$m_Ljava_time_Period$().xy(0, 0, x$9_$_lo);
      } else {
        var a$8_$_lo = hodVal$2_$_lo;
        var a$8_$_hi = hodVal$2_$_hi;
        var this$100 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
        var b0$6 = (65535 & a$8_$_lo);
        var b1$6 = ((a$8_$_lo >>> 16) | 0);
        var a0b0$3 = Math.imul(3600, b0$6);
        var a0b1$3 = Math.imul(3600, b1$6);
        var lo$30 = ((a0b0$3 + (a0b1$3 << 16)) | 0);
        var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
        var hi$30 = ((Math.imul(3600, a$8_$_hi) + ((c1part$3 >>> 16) | 0)) | 0);
        if (((a$8_$_lo | a$8_$_hi) !== 0)) {
          var $x_25 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo$30, hi$30, a$8_$_lo, a$8_$_hi);
          var x$12_$_lo = $x_25.l;
          var x$12_$_hi = $x_25.h;
          var $x_24 = (((3600 ^ x$12_$_lo) | x$12_$_hi) !== 0);
        } else {
          var $x_24 = false;
        }
        if ($x_24) {
          this$100.au();
        }
        var totalSecs_$_lo = lo$30;
        var totalSecs_$_hi = hi$30;
        var a$10_$_lo = totalSecs_$_lo;
        var a$10_$_hi = totalSecs_$_hi;
        var $x_26 = $j_java$002elang$002e$002dObject.$uJ(moh);
        var a$9_$_lo = $x_26.l;
        var a$9_$_hi = $x_26.h;
        var this$106 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
        var b0$7 = (65535 & a$9_$_lo);
        var b1$7 = ((a$9_$_lo >>> 16) | 0);
        var a0b0$4 = Math.imul(60, b0$7);
        var a0b1$4 = Math.imul(60, b1$7);
        var lo$31 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
        var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
        var hi$31 = ((Math.imul(60, a$9_$_hi) + ((c1part$4 >>> 16) | 0)) | 0);
        if (((a$9_$_lo | a$9_$_hi) !== 0)) {
          var $x_28 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo$31, hi$31, a$9_$_lo, a$9_$_hi);
          var x$13_$_lo = $x_28.l;
          var x$13_$_hi = $x_28.h;
          var $x_27 = (((60 ^ x$13_$_lo) | x$13_$_hi) !== 0);
        } else {
          var $x_27 = false;
        }
        if ($x_27) {
          this$106.au();
        }
        var this$111 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
        var lo$32 = ((a$10_$_lo + lo$31) | 0);
        var hi$32 = ((((a$10_$_hi + hi$31) | 0) + (((lo$32 >>> 0) < (a$10_$_lo >>> 0)) | 0)) | 0);
        if ((((hi$32 ^ a$10_$_hi) & (hi$32 ^ hi$31)) < 0)) {
          this$111.au();
        }
        totalSecs_$_lo = lo$32;
        totalSecs_$_hi = hi$32;
        var a$11_$_lo = totalSecs_$_lo;
        var a$11_$_hi = totalSecs_$_hi;
        var sign$2 = (a$11_$_hi >> 31);
        var xlo$2 = (a$11_$_lo ^ sign$2);
        var rlo$2 = ((xlo$2 - sign$2) | 0);
        var rhi$2 = (((a$11_$_hi ^ sign$2) + (((rlo$2 >>> 0) < (xlo$2 >>> 0)) | 0)) | 0);
        var quotHi = (((rhi$2 >>> 0) / 86400) | 0);
        var k = ((rhi$2 - Math.imul(86400, quotHi)) | 0);
        var quotLo = ((1.1574074074074079E-5 * ((4.294967296E9 * k) + (rlo$2 >>> 0.0))) | 0.0);
        if ((a$11_$_hi < 0)) {
          var lo$36 = ((-quotLo) | 0);
          var hi$36 = ((((-quotHi) | 0) - ((lo$36 !== 0) | 0)) | 0);
          var quot$1_$_lo = lo$36;
          var quot$1_$_hi = hi$36;
        } else {
          var quot$1_$_lo = quotLo;
          var quot$1_$_hi = quotHi;
        }
        if ((a$11_$_hi >= 0)) {
          var $x_29 = true;
        } else {
          var b0$8 = (65535 & quot$1_$_lo);
          var b1$8 = ((quot$1_$_lo >>> 16) | 0);
          var a0b0$5 = Math.imul(20864, b0$8);
          var a0b1$5 = Math.imul(20864, b1$8);
          var lo$38 = ((a0b0$5 + (((b0$8 + a0b1$5) | 0) << 16)) | 0);
          var c1part$5 = ((((a0b0$5 >>> 16) | 0) + a0b1$5) | 0);
          var $x_29 = (((lo$38 ^ a$11_$_lo) | (((((((Math.imul(86400, quot$1_$_hi) + b1$8) | 0) + ((c1part$5 >>> 16) | 0)) | 0) + (((((65535 & c1part$5) + b0$8) | 0) >>> 16) | 0)) | 0) ^ a$11_$_hi)) === 0);
        }
        if ($x_29) {
          var x$15_$_lo = quot$1_$_lo;
          var x$15_$_hi = quot$1_$_hi;
        } else {
          var lo$39 = ((quot$1_$_lo - 1) | 0);
          var hi$38 = ((((quot$1_$_hi - 1) | 0) + ((lo$39 !== (-1)) | 0)) | 0);
          var x$15_$_lo = lo$39;
          var x$15_$_hi = hi$38;
        }
        var a$12_$_lo = totalSecs_$_lo;
        var a$12_$_hi = totalSecs_$_hi;
        var sign$3 = (a$12_$_hi >> 31);
        var xlo$3 = (a$12_$_lo ^ sign$3);
        var rlo$3 = ((xlo$3 - sign$3) | 0);
        var rhi$3 = (((a$12_$_hi ^ sign$3) + (((rlo$3 >>> 0) < (xlo$3 >>> 0)) | 0)) | 0);
        var k$2 = (((rhi$3 >>> 0) % 86400) | 0);
        var quotLo$2 = ((1.1574074074074079E-5 * ((4.294967296E9 * k$2) + (rlo$3 >>> 0.0))) | 0.0);
        var remLo = ((rlo$3 - Math.imul(86400, quotLo$2)) | 0);
        if ((a$12_$_hi < 0)) {
          var lo$40 = ((-remLo) | 0);
          var hi$39 = ((-((lo$40 !== 0) | 0)) | 0);
          var rem$1_$_lo = lo$40;
          var rem$1_$_hi = hi$39;
        } else {
          var rem$1_$_lo = remLo;
          var rem$1_$_hi = 0;
        }
        if (((a$12_$_hi >= 0) || ((rem$1_$_lo | rem$1_$_hi) === 0))) {
          var sod_$_lo = rem$1_$_lo;
          var sod_$_hi = rem$1_$_hi;
        } else {
          var lo$42 = ((86400 + rem$1_$_lo) | 0);
          var hi$40 = ((rem$1_$_hi + (((lo$42 >>> 0) < 86400) | 0)) | 0);
          var sod_$_lo = lo$42;
          var sod_$_hi = hi$40;
        }
        var time$5 = $m_Ljava_time_LocalTime$().Wr(sod_$_lo, sod_$_hi);
        $thiz.c0 = time$5;
        $thiz.gT = $j_java$002etime$002e$002dPeriod.$m_Ljava_time_Period$().xy(0, 0, x$15_$_lo);
      }
    } else {
      var a$13_$_lo = hodVal$2_$_lo;
      var a$13_$_hi = hodVal$2_$_hi;
      var sign$4 = (a$13_$_hi >> 31);
      var xlo$4 = (a$13_$_lo ^ sign$4);
      var rlo$4 = ((xlo$4 - sign$4) | 0);
      var rhi$4 = (((a$13_$_hi ^ sign$4) + (((rlo$4 >>> 0) < (xlo$4 >>> 0)) | 0)) | 0);
      var quotHi$1 = (((rhi$4 >>> 0) / 24) | 0);
      var k$1 = ((rhi$4 - Math.imul(24, quotHi$1)) | 0);
      var quotLo$1 = ((0.041666666666666685 * ((4.294967296E9 * k$1) + (rlo$4 >>> 0.0))) | 0.0);
      if ((a$13_$_hi < 0)) {
        var lo$43 = ((-quotLo$1) | 0);
        var hi$41 = ((((-quotHi$1) | 0) - ((lo$43 !== 0) | 0)) | 0);
        var quot$2_$_lo = lo$43;
        var quot$2_$_hi = hi$41;
      } else {
        var quot$2_$_lo = quotLo$1;
        var quot$2_$_hi = quotHi$1;
      }
      if ((a$13_$_hi >= 0)) {
        var $x_30 = true;
      } else {
        var b0$9 = (65535 & quot$2_$_lo);
        var b1$9 = ((quot$2_$_lo >>> 16) | 0);
        var a0b0$6 = Math.imul(24, b0$9);
        var a0b1$6 = Math.imul(24, b1$9);
        var lo$45 = ((a0b0$6 + (a0b1$6 << 16)) | 0);
        var c1part$6 = ((((a0b0$6 >>> 16) | 0) + a0b1$6) | 0);
        var $x_30 = (((lo$45 ^ a$13_$_lo) | (((Math.imul(24, quot$2_$_hi) + ((c1part$6 >>> 16) | 0)) | 0) ^ a$13_$_hi)) === 0);
      }
      if ($x_30) {
        var a$14_$_lo = quot$2_$_lo;
        var a$14_$_hi = quot$2_$_hi;
      } else {
        var lo$46 = ((quot$2_$_lo - 1) | 0);
        var hi$43 = ((((quot$2_$_hi - 1) | 0) + ((lo$46 !== (-1)) | 0)) | 0);
        var a$14_$_lo = lo$46;
        var a$14_$_hi = hi$43;
      }
      var this$166 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
      if ((((a$14_$_lo ^ a$14_$_lo) | ((a$14_$_lo >> 31) ^ a$14_$_hi)) !== 0)) {
        this$166.xv();
      }
      var a$15_$_lo = hodVal$2_$_lo;
      var a$15_$_hi = hodVal$2_$_hi;
      var sign$5 = (a$15_$_hi >> 31);
      var xlo$5 = (a$15_$_lo ^ sign$5);
      var rlo$5 = ((xlo$5 - sign$5) | 0);
      var rhi$5 = (((a$15_$_hi ^ sign$5) + (((rlo$5 >>> 0) < (xlo$5 >>> 0)) | 0)) | 0);
      var k$2$1 = (((rhi$5 >>> 0) % 24) | 0);
      var quotLo$2$1 = ((0.041666666666666685 * ((4.294967296E9 * k$2$1) + (rlo$5 >>> 0.0))) | 0.0);
      var remLo$1 = ((rlo$5 - Math.imul(24, quotLo$2$1)) | 0);
      if ((a$15_$_hi < 0)) {
        var lo$47 = ((-remLo$1) | 0);
        var hi$45 = ((-((lo$47 !== 0) | 0)) | 0);
        var rem$2_$_lo = lo$47;
        var rem$2_$_hi = hi$45;
      } else {
        var rem$2_$_lo = remLo$1;
        var rem$2_$_hi = 0;
      }
      if (((a$15_$_hi >= 0) || ((rem$2_$_lo | rem$2_$_hi) === 0))) {
        hodVal$2_$_lo = rem$2_$_lo;
        hodVal$2_$_hi = rem$2_$_hi;
      } else {
        var lo$49 = ((24 + rem$2_$_lo) | 0);
        var hi$46 = ((rem$2_$_hi + (((lo$49 >>> 0) < 24) | 0)) | 0);
        hodVal$2_$_lo = lo$49;
        hodVal$2_$_hi = hi$46;
      }
      var time$6 = $m_Ljava_time_LocalTime$().C9(hodVal$2_$_lo, 0);
      $thiz.c0 = time$6;
      $thiz.gT = $j_java$002etime$002e$002dPeriod.$m_Ljava_time_Period$().xy(0, 0, a$14_$_lo);
    }
  }
  $thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField());
  $thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField());
  $thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField());
  $thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField());
}
export { $p_Ljava_time_format_DateTimeBuilder__resolveTimeInferZeroes__Ljava_time_format_ResolverStyle__V as $p_Ljava_time_format_DateTimeBuilder__resolveTimeInferZeroes__Ljava_time_format_ResolverStyle__V };
function $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields__V($thiz) {
  if ($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField())) {
    if (($thiz.f3 !== null)) {
      $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields0__Ljava_time_ZoneId__V($thiz, $thiz.f3);
    } else {
      var offsetSecs = $j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz.R, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), null);
      if ((offsetSecs !== null)) {
        var $x_2 = $m_Ljava_time_ZoneOffset$();
        var $x_1 = offsetSecs;
        $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields0__Ljava_time_ZoneId__V($thiz, $x_2.ul($j_java$002elang$002e$002dObject.$s_RTLong__toInt__I__I__I($x_1.l, $x_1.h)));
      }
    }
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields__V as $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields__V };
function $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields0__Ljava_time_ZoneId__V($thiz, selectedZone) {
  var $x_2 = $m_Ljava_time_Instant$();
  var $x_1 = $j_java$002elang$002e$002dObject.$uJ($thiz.R.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField()));
  var instant = $x_2.r7($x_1.l, $x_1.h, 0);
  var zdt = $m_Ljava_time_ZonedDateTime$().PL(instant, selectedZone);
  if (($thiz.ck === null)) {
    var date = zdt.bc.aJ;
    $thiz.ck = date;
  } else {
    $p_Ljava_time_format_DateTimeBuilder__resolveMakeChanges__Ljava_time_temporal_TemporalField__Ljava_time_chrono_ChronoLocalDate__V($thiz, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField(), zdt.bc.aJ);
  }
  var $x_3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
  var value = zdt.bc.aO.uF();
  var hi = (value >> 31);
  $thiz.cR($x_3, value, hi);
}
export { $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields0__Ljava_time_ZoneId__V as $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields0__Ljava_time_ZoneId__V };
function $p_Ljava_time_format_DateTimeBuilder__crossCheck__V($thiz) {
  if (($thiz.R.ga > 0)) {
    if ((($thiz.ck !== null) && ($thiz.c0 !== null))) {
      $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V($thiz, $m_Ljava_time_LocalDateTime$().Cb($thiz.ck, $thiz.c0));
    } else if (($thiz.ck !== null)) {
      $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V($thiz, $thiz.ck);
    } else if (($thiz.c0 !== null)) {
      $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V($thiz, $thiz.c0);
    }
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__crossCheck__V as $p_Ljava_time_format_DateTimeBuilder__crossCheck__V };
function $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V($thiz, temporal) {
  var it = new $j_java$002eutil$002e$002dHash$002dMap$0024$002dEntry$002dSet.$c_ju_HashMap$EntrySet($thiz.R).cV();
  while (it.i()) {
    var entry = it.e();
    var field = entry.ek;
    var $x_1 = $j_java$002elang$002e$002dObject.$uJ(entry.dn);
    var value_$_lo = $x_1.l;
    var value_$_hi = $x_1.h;
    if (temporal.ba(field)) {
      var temporalValue_$_lo = 0;
      var temporalValue_$_hi = 0;
      try {
        var $x_2 = temporal.ai(field);
        temporalValue_$_lo = $x_2.l;
        temporalValue_$_hi = $x_2.h;
      } catch (e) {
        if ((!(((e instanceof $j_java$002elang$002e$002dObject.$c_jl_Throwable) ? e : new $j_java$002elang$002e$002dObject.$c_sjs_js_JavaScriptException(e)) instanceof $j_java$002elang$002e$002dObject.$c_jl_RuntimeException))) {
          throw e;
        }
      }
      var x$1_$_lo = temporalValue_$_lo;
      var x$1_$_hi = temporalValue_$_hi;
      if ((((x$1_$_lo ^ value_$_lo) | (x$1_$_hi ^ value_$_hi)) !== 0)) {
        throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ((((((("Cross check failed: " + field) + " ") + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(temporalValue_$_lo, temporalValue_$_hi)) + " vs ") + field) + " ") + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(value_$_lo, value_$_hi)));
      }
      it.rg();
    }
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V as $p_Ljava_time_format_DateTimeBuilder__crossCheck__Ljava_time_temporal_TemporalAccessor__V };
function $p_Ljava_time_format_DateTimeBuilder__resolveFractional__V($thiz) {
  if ((($thiz.c0 === null) && (($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || $thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField())) || $thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField())))) {
    if ($thiz.R.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField())) {
      var $x_1 = $j_java$002elang$002e$002dObject.$uJ($j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz.R, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField(), null));
      var nos_$_lo = $x_1.l;
      var nos_$_hi = $x_1.h;
      var this$14 = $thiz.R;
      var key$1 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      var sign = (nos_$_hi >> 31);
      var xlo = (nos_$_lo ^ sign);
      var rlo = ((xlo - sign) | 0);
      var rhi = (((nos_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
      var quotHi = (((rhi >>> 0) / 1000) | 0);
      var k = ((rhi - Math.imul(1000, quotHi)) | 0);
      var quotLo = ((0.0010000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
      if ((nos_$_hi < 0)) {
        var lo = ((-quotLo) | 0);
        var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
        var $x_3_$_lo = lo;
        var $x_3_$_hi = hi;
      } else {
        var $x_3_$_lo = quotLo;
        var $x_3_$_hi = quotHi;
      }
      if ((key$1 === null)) {
        var $x_2 = 0;
      } else {
        var originalHash = $j_java$002elang$002e$002dObject.$systemIdentityHashCode(key$1);
        var $x_2 = (originalHash ^ ((originalHash >>> 16) | 0));
      }
      this$14.dO(key$1, $j_java$002elang$002e$002dObject.$bL($x_3_$_lo, $x_3_$_hi), $x_2, false);
      var this$29 = $thiz.R;
      var key$2 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
      var sign$1 = (nos_$_hi >> 31);
      var xlo$1 = (nos_$_lo ^ sign$1);
      var rlo$1 = ((xlo$1 - sign$1) | 0);
      var rhi$1 = (((nos_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
      var aHat = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
      var x$3 = (1.0000000000000016E-6 * aHat);
      var lo$1 = (x$3 | 0.0);
      var hi$1 = ((2.3283064365386963E-10 * x$3) | 0.0);
      var rHat = ((rlo$1 - Math.imul(1000000, lo$1)) | 0);
      if ((rHat < 0)) {
        var lo$2 = ((lo$1 - 1) | 0);
        var hi$2 = ((((hi$1 - 1) | 0) + ((lo$2 !== (-1)) | 0)) | 0);
        var absR_$_lo = lo$2;
        var absR_$_hi = hi$2;
      } else {
        var absR_$_lo = lo$1;
        var absR_$_hi = hi$1;
      }
      if ((nos_$_hi < 0)) {
        var lo$3 = ((-absR_$_lo) | 0);
        var hi$3 = ((((-absR_$_hi) | 0) - ((lo$3 !== 0) | 0)) | 0);
        var $x_5_$_lo = lo$3;
        var $x_5_$_hi = hi$3;
      } else {
        var $x_5_$_lo = absR_$_lo;
        var $x_5_$_hi = absR_$_hi;
      }
      if ((key$2 === null)) {
        var $x_4 = 0;
      } else {
        var originalHash$1 = $j_java$002elang$002e$002dObject.$systemIdentityHashCode(key$2);
        var $x_4 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
      }
      this$29.dO(key$2, $j_java$002elang$002e$002dObject.$bL($x_5_$_lo, $x_5_$_hi), $x_4, false);
    } else {
      var this$32 = $thiz.R;
      var key$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
      if ((key$3 === null)) {
        var $x_6 = 0;
      } else {
        var originalHash$2 = $j_java$002elang$002e$002dObject.$systemIdentityHashCode(key$3);
        var $x_6 = (originalHash$2 ^ ((originalHash$2 >>> 16) | 0));
      }
      this$32.dO(key$3, $j_java$002elang$002e$002dObject.$bL(0, 0), $x_6, false);
      var this$35 = $thiz.R;
      var key$4 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
      if ((key$4 === null)) {
        var $x_7 = 0;
      } else {
        var originalHash$3 = $j_java$002elang$002e$002dObject.$systemIdentityHashCode(key$4);
        var $x_7 = (originalHash$3 ^ ((originalHash$3 >>> 16) | 0));
      }
      this$35.dO(key$4, $j_java$002elang$002e$002dObject.$bL(0, 0), $x_7, false);
      var this$38 = $thiz.R;
      var key$5 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
      if ((key$5 === null)) {
        var $x_8 = 0;
      } else {
        var originalHash$4 = $j_java$002elang$002e$002dObject.$systemIdentityHashCode(key$5);
        var $x_8 = (originalHash$4 ^ ((originalHash$4 >>> 16) | 0));
      }
      this$38.dO(key$5, $j_java$002elang$002e$002dObject.$bL(0, 0), $x_8, false);
    }
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__resolveFractional__V as $p_Ljava_time_format_DateTimeBuilder__resolveFractional__V };
function $p_Ljava_time_format_DateTimeBuilder__resolveInstant__V($thiz) {
  if ((($thiz.ck !== null) && ($thiz.c0 !== null))) {
    var offsetSecs = $j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O($thiz.R, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField(), null);
    if ((offsetSecs !== null)) {
      var $x_2 = $m_Ljava_time_ZoneOffset$();
      var $x_1 = offsetSecs;
      var offset = $x_2.ul($j_java$002elang$002e$002dObject.$s_RTLong__toInt__I__I__I($x_1.l, $x_1.h));
      var $x_3 = $m_Ljava_time_ZonedDateTime$().xN($m_Ljava_time_LocalDateTime$().Cb($thiz.ck, $thiz.c0), offset, null).ai($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
      var instant_$_lo = $x_3.l;
      var instant_$_hi = $x_3.h;
      var this$8 = $thiz.R;
      var key$1 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
      if ((key$1 === null)) {
        var $x_4 = 0;
      } else {
        var originalHash = $j_java$002elang$002e$002dObject.$systemIdentityHashCode(key$1);
        var $x_4 = (originalHash ^ ((originalHash >>> 16) | 0));
      }
      this$8.dO(key$1, $j_java$002elang$002e$002dObject.$bL(instant_$_lo, instant_$_hi), $x_4, false);
    } else if (($thiz.f3 !== null)) {
      var $x_5 = $m_Ljava_time_ZonedDateTime$().xN($m_Ljava_time_LocalDateTime$().Cb($thiz.ck, $thiz.c0), $thiz.f3, null).ai($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField());
      var instant$2_$_lo = $x_5.l;
      var instant$2_$_hi = $x_5.h;
      var this$14 = $thiz.R;
      var key$2 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
      if ((key$2 === null)) {
        var $x_6 = 0;
      } else {
        var originalHash$1 = $j_java$002elang$002e$002dObject.$systemIdentityHashCode(key$2);
        var $x_6 = (originalHash$1 ^ ((originalHash$1 >>> 16) | 0));
      }
      this$14.dO(key$2, $j_java$002elang$002e$002dObject.$bL(instant$2_$_lo, instant$2_$_hi), $x_6, false);
    }
  }
}
export { $p_Ljava_time_format_DateTimeBuilder__resolveInstant__V as $p_Ljava_time_format_DateTimeBuilder__resolveInstant__V };
/** @constructor */
function $c_Ljava_time_format_DateTimeBuilder() {
  this.R = null;
  this.jT = null;
  this.f3 = null;
  this.ck = null;
  this.c0 = null;
  this.gT = null;
  this.R = $j_java$002eutil$002e$002dAbstract$002dMap.$ct_ju_HashMap__(new $j_java$002eutil$002e$002dAbstract$002dMap.$c_ju_HashMap());
  this.jT = null;
  this.f3 = null;
  this.ck = null;
  this.c0 = null;
  this.gT = null;
}
export { $c_Ljava_time_format_DateTimeBuilder as $c_Ljava_time_format_DateTimeBuilder };
$p = $c_Ljava_time_format_DateTimeBuilder.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_format_DateTimeBuilder;
/** @constructor */
function $h_Ljava_time_format_DateTimeBuilder() {
}
export { $h_Ljava_time_format_DateTimeBuilder as $h_Ljava_time_format_DateTimeBuilder };
$h_Ljava_time_format_DateTimeBuilder.prototype = $p;
$p.bX = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field);
});
$p.cC = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field);
});
$p.cR = (function(field, value_$_lo, value_$_hi) {
  var old = $j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O(this.R, field, null);
  if ((old !== null)) {
    var $x_2 = old;
    var this$2_$_lo = $x_2.l;
    var this$2_$_hi = $x_2.h;
    var $x_1 = (((this$2_$_lo ^ value_$_lo) | (this$2_$_hi ^ value_$_hi)) !== 0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ((((((((("Conflict found: " + field) + " ") + old) + " differs from ") + field) + " ") + $j_java$002elang$002e$002dObject.$s_RTLong__toString__I__I__T(value_$_lo, value_$_hi)) + ": ") + this));
  } else {
    return $p_Ljava_time_format_DateTimeBuilder__putFieldValue0__Ljava_time_temporal_TemporalField__J__Ljava_time_format_DateTimeBuilder(this, field, value_$_lo, value_$_hi);
  }
});
$p.X7 = (function(resolverStyle, resolverFields) {
  if ((resolverFields !== null)) {
    new $j_java$002eutil$002e$002dHash$002dMap$0024$002dKey$002dSet.$c_ju_HashMap$KeySet(this.R).Xa(resolverFields);
  }
  $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields__V(this);
  $p_Ljava_time_format_DateTimeBuilder__mergeDate__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
  $p_Ljava_time_format_DateTimeBuilder__mergeTime__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
  if ($p_Ljava_time_format_DateTimeBuilder__resolveFields__Ljava_time_format_ResolverStyle__Z(this, resolverStyle)) {
    $p_Ljava_time_format_DateTimeBuilder__mergeInstantFields__V(this);
    $p_Ljava_time_format_DateTimeBuilder__mergeDate__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
    $p_Ljava_time_format_DateTimeBuilder__mergeTime__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
  }
  $p_Ljava_time_format_DateTimeBuilder__resolveTimeInferZeroes__Ljava_time_format_ResolverStyle__V(this, resolverStyle);
  $p_Ljava_time_format_DateTimeBuilder__crossCheck__V(this);
  if (((((this.gT !== null) && (!this.gT.VB())) && (this.ck !== null)) && (this.c0 !== null))) {
    var this$2 = this.ck;
    this.ck = this.gT.Sa(this$2);
    this.gT = $j_java$002etime$002e$002dPeriod.$m_Ljava_time_Period$().tP();
  }
  $p_Ljava_time_format_DateTimeBuilder__resolveFractional__V(this);
  $p_Ljava_time_format_DateTimeBuilder__resolveInstant__V(this);
  return this;
});
$p.ba = (function(field) {
  return ((field !== null) && ((this.R.aj(field) || ((this.ck !== null) && $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this.ck, field))) || ((this.c0 !== null) && this.c0.ba(field))));
});
$p.ai = (function(field) {
  var value = $j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O(this.R, field, null);
  if ((value === null)) {
    if (((this.ck !== null) && $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this.ck, field))) {
      return this.ck.ai(field);
    }
    if (((this.c0 !== null) && this.c0.ba(field))) {
      return this.c0.ai(field);
    }
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ("Field not found: " + field));
  }
  return $j_java$002elang$002e$002dObject.$uJ(value);
});
$p.cg = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().f1()) ? this.f3 : ((query === $m_Ljava_time_temporal_TemporalQueries$().eR()) ? this.jT : ((query === $m_Ljava_time_temporal_TemporalQueries$().fl()) ? ((this.ck !== null) ? $m_Ljava_time_LocalDate$().Bw(this.ck) : null) : ((query === $m_Ljava_time_temporal_TemporalQueries$().ik()) ? this.c0 : (((query === $m_Ljava_time_temporal_TemporalQueries$().hx()) || (query === $m_Ljava_time_temporal_TemporalQueries$().gF())) ? query.dQ(this) : ((query === $m_Ljava_time_temporal_TemporalQueries$().gH()) ? null : query.dQ(this)))))));
});
$p.b = (function() {
  return (((((((((("DateTimeBuilder[" + ((this.R.ga > 0) ? (("fields=" + this.R) + ", ") : "")) + " ") + this.jT) + ", ") + this.f3) + ", ") + this.ck) + ", ") + this.c0) + "]");
});
var $d_Ljava_time_format_DateTimeBuilder = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_format_DateTimeBuilder, "java.time.format.DateTimeBuilder", ({
  lg: 1,
  G: 1,
  J: 1
}));
export { $d_Ljava_time_format_DateTimeBuilder as $d_Ljava_time_format_DateTimeBuilder };
/** @constructor */
function $c_Ljava_time_zone_ZoneRules$Fixed(offset) {
  this.g9 = null;
  this.g9 = offset;
}
export { $c_Ljava_time_zone_ZoneRules$Fixed as $c_Ljava_time_zone_ZoneRules$Fixed };
$p = $c_Ljava_time_zone_ZoneRules$Fixed.prototype = new $j_java$002etime$002ezone$002e$002dZone$002dRules.$h_Ljava_time_zone_ZoneRules();
$p.constructor = $c_Ljava_time_zone_ZoneRules$Fixed;
/** @constructor */
function $h_Ljava_time_zone_ZoneRules$Fixed() {
}
export { $h_Ljava_time_zone_ZoneRules$Fixed as $h_Ljava_time_zone_ZoneRules$Fixed };
$h_Ljava_time_zone_ZoneRules$Fixed.prototype = $p;
$p.Vz = (function(dateTime, offset) {
  var x = this.g9;
  return ((x === null) ? (offset === null) : x.f(offset));
});
$p.f = (function(obj) {
  if ((obj instanceof $c_Ljava_time_zone_ZoneRules$Fixed)) {
    if ((this === obj)) {
      return true;
    } else {
      var x = this.g9;
      var x$2 = obj.g9;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    }
  } else if (false) {
    if (obj.YO()) {
      var x$3 = this.g9;
      var x$4 = obj.YM($m_Ljava_time_Instant$().AY());
      return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return (1 ^ (((31 + this.g9.dj) | 0) ^ ((31 + this.g9.dj) | 0)));
});
$p.b = (function() {
  return ("FixedRules:" + this.g9);
});
function $isArrayOf_Ljava_time_zone_ZoneRules$Fixed(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dM)));
}
export { $isArrayOf_Ljava_time_zone_ZoneRules$Fixed as $isArrayOf_Ljava_time_zone_ZoneRules$Fixed };
var $d_Ljava_time_zone_ZoneRules$Fixed = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_zone_ZoneRules$Fixed, "java.time.zone.ZoneRules$Fixed", ({
  dM: 1,
  mL: 1,
  a: 1
}));
export { $d_Ljava_time_zone_ZoneRules$Fixed as $d_Ljava_time_zone_ZoneRules$Fixed };
function $f_Ljava_time_chrono_ChronoZonedDateTime__get__Ljava_time_temporal_TemporalField__I($thiz, field) {
  var x = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
  if (((x === null) ? (field === null) : (x === field))) {
    throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Field too large for an int: " + field));
  }
  var x$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
  if (((x$3 === null) ? (field === null) : (x$3 === field))) {
    return $thiz.eg.dj;
  }
  if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    return $thiz.bc.cC(field);
  }
  return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I($thiz, field);
}
export { $f_Ljava_time_chrono_ChronoZonedDateTime__get__Ljava_time_temporal_TemporalField__I as $f_Ljava_time_chrono_ChronoZonedDateTime__get__Ljava_time_temporal_TemporalField__I };
function $f_Ljava_time_chrono_ChronoZonedDateTime__query__Ljava_time_temporal_TemporalQuery__O($thiz, query) {
  matchAlts3: {
    matchAlts4: {
      var x = $m_Ljava_time_temporal_TemporalQueries$().f1();
      if (((x === null) ? (query === null) : (x === query))) {
        break matchAlts4;
      }
      var x$3 = $m_Ljava_time_temporal_TemporalQueries$().hx();
      if (((x$3 === null) ? (query === null) : (x$3 === query))) {
        break matchAlts4;
      }
      break matchAlts3;
    }
    return $thiz.dA;
  }
  var x$5 = $m_Ljava_time_temporal_TemporalQueries$().eR();
  if (((x$5 === null) ? (query === null) : (x$5 === query))) {
    return $m_Ljava_time_chrono_IsoChronology$().bz();
  }
  var x$7 = $m_Ljava_time_temporal_TemporalQueries$().gH();
  if (((x$7 === null) ? (query === null) : (x$7 === query))) {
    return $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
  }
  var x$9 = $m_Ljava_time_temporal_TemporalQueries$().gF();
  if (((x$9 === null) ? (query === null) : (x$9 === query))) {
    return $thiz.eg;
  }
  var x$11 = $m_Ljava_time_temporal_TemporalQueries$().fl();
  if (((x$11 === null) ? (query === null) : (x$11 === query))) {
    var $x_2 = $m_Ljava_time_LocalDate$();
    var $x_1 = $thiz.bc.aJ.fo();
    return $x_2.gE($x_1.l, $x_1.h);
  }
  var x$13 = $m_Ljava_time_temporal_TemporalQueries$().ik();
  if (((x$13 === null) ? (query === null) : (x$13 === query))) {
    return $thiz.bc.aO;
  }
  return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O($thiz, query);
}
export { $f_Ljava_time_chrono_ChronoZonedDateTime__query__Ljava_time_temporal_TemporalQuery__O as $f_Ljava_time_chrono_ChronoZonedDateTime__query__Ljava_time_temporal_TemporalQuery__O };
function $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J($thiz) {
  var $x_1 = $thiz.bc.aJ.fo();
  var epochDay_$_lo = $x_1.l;
  var epochDay_$_hi = $x_1.h;
  var b0 = (65535 & epochDay_$_lo);
  var b1 = ((epochDay_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(20864, b0);
  var a0b1 = Math.imul(20864, b1);
  var lo = ((a0b0 + (((b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((Math.imul(86400, epochDay_$_hi) + b1) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + b0) | 0) >>> 16) | 0)) | 0);
  var value = $thiz.bc.aO.uF();
  var hi$1 = (value >> 31);
  var lo$1 = ((lo + value) | 0);
  var hi$2 = ((((hi + hi$1) | 0) + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
  var secs_$_lo = lo$1;
  var secs_$_hi = hi$2;
  var x_$_lo = secs_$_lo;
  var x_$_hi = secs_$_hi;
  var value$1 = $thiz.eg.dj;
  var hi$3 = (value$1 >> 31);
  var lo$2 = ((x_$_lo - value$1) | 0);
  var hi$4 = ((((x_$_hi - hi$3) | 0) - (((lo$2 >>> 0) > (x_$_lo >>> 0)) | 0)) | 0);
  secs_$_lo = lo$2;
  secs_$_hi = hi$4;
  return $j_java$002elang$002e$002dObject.$bL(secs_$_lo, secs_$_hi);
}
export { $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J as $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J };
function $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I($thiz, other) {
  var $x_1 = $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J($thiz);
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  var $x_2 = $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J(other);
  var y_$_lo = $x_2.l;
  var y_$_hi = $x_2.h;
  var cmp = ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
  if ((cmp === 0)) {
    cmp = (($thiz.bc.aO.cv - other.bc.aO.cv) | 0);
    if ((cmp === 0)) {
      cmp = $thiz.bc.On(other.bc);
      if ((cmp === 0)) {
        cmp = $j_java$002elang$002e$002dObject.$f_T__compareTo__T__I($thiz.dA.lS, other.dA.lS);
        if ((cmp === 0)) {
          $m_Ljava_time_chrono_IsoChronology$().bz();
          $m_Ljava_time_chrono_IsoChronology$().bz();
          cmp = $j_java$002elang$002e$002dObject.$f_T__compareTo__T__I("ISO", "ISO");
        }
      }
    }
  }
  return cmp;
}
export { $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I as $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I };
function $is_Ljava_time_chrono_ChronoZonedDateTime(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.cd)));
}
export { $is_Ljava_time_chrono_ChronoZonedDateTime as $is_Ljava_time_chrono_ChronoZonedDateTime };
function $isArrayOf_Ljava_time_chrono_ChronoZonedDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cd)));
}
export { $isArrayOf_Ljava_time_chrono_ChronoZonedDateTime as $isArrayOf_Ljava_time_chrono_ChronoZonedDateTime };
/** @constructor */
function $c_Ljava_time_chrono_IsoChronology() {
}
export { $c_Ljava_time_chrono_IsoChronology as $c_Ljava_time_chrono_IsoChronology };
$p = $c_Ljava_time_chrono_IsoChronology.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_chrono_IsoChronology;
/** @constructor */
function $h_Ljava_time_chrono_IsoChronology() {
}
export { $h_Ljava_time_chrono_IsoChronology as $h_Ljava_time_chrono_IsoChronology };
$h_Ljava_time_chrono_IsoChronology.prototype = $p;
$p.fh = (function(that) {
  return $j_java$002elang$002e$002dObject.$f_T__compareTo__T__I("ISO", "ISO");
});
$p.f = (function(obj) {
  return $j_java$002etime$002echrono$002e$002dChronology.$f_Ljava_time_chrono_Chronology__equals__O__Z(this, obj);
});
$p.m = (function() {
  return $j_java$002etime$002echrono$002e$002dChronology.$f_Ljava_time_chrono_Chronology__hashCode__I(this);
});
$p.b = (function() {
  return "ISO";
});
$p.jp = (function(prolepticYear_$_lo, prolepticYear_$_hi) {
  if (((3 & prolepticYear_$_lo) === 0)) {
    var sign = (prolepticYear_$_hi >> 31);
    var xlo = (prolepticYear_$_lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((prolepticYear_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var k$2 = (((rhi >>> 0) % 100) | 0);
    var quotLo$2 = ((0.010000000000000004 * ((4.294967296E9 * k$2) + (rlo >>> 0.0))) | 0.0);
    var remLo = ((rlo - Math.imul(100, quotLo$2)) | 0);
    if ((prolepticYear_$_hi < 0)) {
      var lo$1 = ((-remLo) | 0);
      var hi = ((-((lo$1 !== 0) | 0)) | 0);
      var x$1_$_lo = lo$1;
      var x$1_$_hi = hi;
    } else {
      var x$1_$_lo = remLo;
      var x$1_$_hi = 0;
    }
    if (((x$1_$_lo | x$1_$_hi) !== 0)) {
      return true;
    } else {
      var sign$1 = (prolepticYear_$_hi >> 31);
      var xlo$1 = (prolepticYear_$_lo ^ sign$1);
      var rlo$1 = ((xlo$1 - sign$1) | 0);
      var rhi$1 = (((prolepticYear_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
      var k$2$1 = (((rhi$1 >>> 0) % 400) | 0);
      var quotLo$2$1 = ((0.002500000000000001 * ((4.294967296E9 * k$2$1) + (rlo$1 >>> 0.0))) | 0.0);
      var remLo$1 = ((rlo$1 - Math.imul(400, quotLo$2$1)) | 0);
      if ((prolepticYear_$_hi < 0)) {
        var lo$2 = ((-remLo$1) | 0);
        var hi$1 = ((-((lo$2 !== 0) | 0)) | 0);
        var x$3_$_lo = lo$2;
        var x$3_$_hi = hi$1;
      } else {
        var x$3_$_lo = remLo$1;
        var x$3_$_hi = 0;
      }
      return ((x$3_$_lo | x$3_$_hi) === 0);
    }
  } else {
    return false;
  }
});
$p.X8 = (function(fieldValues, resolverStyle) {
  if (fieldValues.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
    var $x_2 = $m_Ljava_time_LocalDate$();
    var $x_1 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField()));
    return $x_2.gE($x_1.l, $x_1.h);
  }
  var prolepticMonth = fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField());
  if ((prolepticMonth !== null)) {
    if ((resolverStyle !== $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField();
      var $x_3 = $j_java$002elang$002e$002dObject.$uJ(prolepticMonth);
      var value_$_lo = $x_3.l;
      var value_$_hi = $x_3.h;
      this$3.G.ak(value_$_lo, value_$_hi, this$3);
    }
    var field = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    var $x_4 = $j_java$002elang$002e$002dObject.$uJ(prolepticMonth);
    var a_$_lo = $x_4.l;
    var a_$_hi = $x_4.h;
    var sign = (a_$_hi >> 31);
    var xlo = (a_$_lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((a_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var k$2 = (((rhi >>> 0) % 12) | 0);
    var quotLo$2 = ((0.08333333333333337 * ((4.294967296E9 * k$2) + (rlo >>> 0.0))) | 0.0);
    var remLo = ((rlo - Math.imul(12, quotLo$2)) | 0);
    if ((a_$_hi < 0)) {
      var lo = ((-remLo) | 0);
      var hi = ((-((lo !== 0) | 0)) | 0);
      var rem_$_lo = lo;
      var rem_$_hi = hi;
    } else {
      var rem_$_lo = remLo;
      var rem_$_hi = 0;
    }
    if (((a_$_hi >= 0) || ((rem_$_lo | rem_$_hi) === 0))) {
      var x$2_$_lo = rem_$_lo;
      var x$2_$_hi = rem_$_hi;
    } else {
      var lo$2 = ((12 + rem_$_lo) | 0);
      var hi$1 = ((rem_$_hi + (((lo$2 >>> 0) < 12) | 0)) | 0);
      var x$2_$_lo = lo$2;
      var x$2_$_hi = hi$1;
    }
    var lo$3 = ((1 + x$2_$_lo) | 0);
    var hi$2 = ((x$2_$_hi + ((lo$3 === 0) | 0)) | 0);
    $j_java$002etime$002echrono$002e$002dChronology.$f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field, lo$3, hi$2);
    var field$1 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    var $x_5 = $j_java$002elang$002e$002dObject.$uJ(prolepticMonth);
    var a$1_$_lo = $x_5.l;
    var a$1_$_hi = $x_5.h;
    var sign$1 = (a$1_$_hi >> 31);
    var xlo$1 = (a$1_$_lo ^ sign$1);
    var rlo$1 = ((xlo$1 - sign$1) | 0);
    var rhi$1 = (((a$1_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
    var quotHi = (((rhi$1 >>> 0) / 12) | 0);
    var k = ((rhi$1 - Math.imul(12, quotHi)) | 0);
    var quotLo = ((0.08333333333333337 * ((4.294967296E9 * k) + (rlo$1 >>> 0.0))) | 0.0);
    if ((a$1_$_hi < 0)) {
      var lo$4 = ((-quotLo) | 0);
      var hi$3 = ((((-quotHi) | 0) - ((lo$4 !== 0) | 0)) | 0);
      var quot_$_lo = lo$4;
      var quot_$_hi = hi$3;
    } else {
      var quot_$_lo = quotLo;
      var quot_$_hi = quotHi;
    }
    if ((a$1_$_hi >= 0)) {
      var $x_7 = true;
    } else {
      var b0 = (65535 & quot_$_lo);
      var b1 = ((quot_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(12, b0);
      var a0b1 = Math.imul(12, b1);
      var lo$6 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var $x_7 = (((lo$6 ^ a$1_$_lo) | (((Math.imul(12, quot_$_hi) + ((c1part >>> 16) | 0)) | 0) ^ a$1_$_hi)) === 0);
    }
    if ($x_7) {
      var $x_6_$_lo = quot_$_lo;
      var $x_6_$_hi = quot_$_hi;
    } else {
      var lo$7 = ((quot_$_lo - 1) | 0);
      var hi$5 = ((((quot_$_hi - 1) | 0) + ((lo$7 !== (-1)) | 0)) | 0);
      var $x_6_$_lo = lo$7;
      var $x_6_$_hi = hi$5;
    }
    $j_java$002etime$002echrono$002e$002dChronology.$f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$1, $x_6_$_lo, $x_6_$_hi);
  }
  var yoeLong = fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField());
  if ((yoeLong !== null)) {
    if ((resolverStyle !== $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
      var this$39 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
      var $x_8 = $j_java$002elang$002e$002dObject.$uJ(yoeLong);
      var value$2_$_lo = $x_8.l;
      var value$2_$_hi = $x_8.h;
      this$39.G.ak(value$2_$_lo, value$2_$_hi, this$39);
    }
    var era = fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField());
    if ((era === null)) {
      var year = $j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O(fieldValues, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField(), null);
      if ((resolverStyle === $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle())) {
        if ((year !== null)) {
          var $x_13 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
          var $x_10 = $j_java$002elang$002e$002dObject.$uJ(year);
          var x$4_$_lo = $x_10.l;
          var x$4_$_hi = $x_10.h;
          if (((x$4_$_hi === 0) ? (x$4_$_lo !== 0) : (x$4_$_hi > 0))) {
            var $x_11 = $j_java$002elang$002e$002dObject.$uJ(yoeLong);
            var $x_9_$_lo = $x_11.l;
            var $x_9_$_hi = $x_11.h;
          } else {
            var $x_12 = $j_java$002elang$002e$002dObject.$uJ(yoeLong);
            var b_$_lo = $x_12.l;
            var b_$_hi = $x_12.h;
            var this$44 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
            var lo$8 = ((1 - b_$_lo) | 0);
            var hi$6 = ((((-b_$_hi) | 0) - (((lo$8 >>> 0) > 1) | 0)) | 0);
            if (((b_$_hi & hi$6) < 0)) {
              this$44.au();
            }
            var $x_9_$_lo = lo$8;
            var $x_9_$_hi = hi$6;
          }
          $j_java$002etime$002echrono$002e$002dChronology.$f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, $x_13, $x_9_$_lo, $x_9_$_hi);
        } else {
          var key$1 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
          if ((key$1 === null)) {
            var $x_14 = 0;
          } else {
            var originalHash = $j_java$002elang$002e$002dObject.$systemIdentityHashCode(key$1);
            var $x_14 = (originalHash ^ ((originalHash >>> 16) | 0));
          }
          fieldValues.dO(key$1, yoeLong, $x_14, false);
        }
      } else {
        var $x_20 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
        if ((year === null)) {
          var $x_16 = true;
        } else {
          var $x_17 = $j_java$002elang$002e$002dObject.$uJ(year);
          var x$5_$_lo = $x_17.l;
          var x$5_$_hi = $x_17.h;
          var $x_16 = ((x$5_$_hi === 0) ? (x$5_$_lo !== 0) : (x$5_$_hi > 0));
        }
        if ($x_16) {
          var $x_18 = $j_java$002elang$002e$002dObject.$uJ(yoeLong);
          var $x_15_$_lo = $x_18.l;
          var $x_15_$_hi = $x_18.h;
        } else {
          var $x_19 = $j_java$002elang$002e$002dObject.$uJ(yoeLong);
          var b$1_$_lo = $x_19.l;
          var b$1_$_hi = $x_19.h;
          var this$55 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
          var lo$12 = ((1 - b$1_$_lo) | 0);
          var hi$8 = ((((-b$1_$_hi) | 0) - (((lo$12 >>> 0) > 1) | 0)) | 0);
          if (((b$1_$_hi & hi$8) < 0)) {
            this$55.au();
          }
          var $x_15_$_lo = lo$12;
          var $x_15_$_hi = hi$8;
        }
        $j_java$002etime$002echrono$002e$002dChronology.$f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, $x_20, $x_15_$_lo, $x_15_$_hi);
      }
    } else {
      var $x_21 = era;
      var this$61_$_lo = $x_21.l;
      var this$61_$_hi = $x_21.h;
      if ((((1 ^ this$61_$_lo) | this$61_$_hi) === 0)) {
        var $x_23 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
        var $x_22 = $j_java$002elang$002e$002dObject.$uJ(yoeLong);
        $j_java$002etime$002echrono$002e$002dChronology.$f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, $x_23, $x_22.l, $x_22.h);
      } else {
        var $x_24 = era;
        var this$64_$_lo = $x_24.l;
        var this$64_$_hi = $x_24.h;
        if (((this$64_$_lo | this$64_$_hi) === 0)) {
          var field$5 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
          var $x_25 = $j_java$002elang$002e$002dObject.$uJ(yoeLong);
          var b$2_$_lo = $x_25.l;
          var b$2_$_hi = $x_25.h;
          var this$67 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
          var lo$16 = ((1 - b$2_$_lo) | 0);
          var hi$10 = ((((-b$2_$_hi) | 0) - (((lo$16 >>> 0) > 1) | 0)) | 0);
          if (((b$2_$_hi & hi$10) < 0)) {
            this$67.au();
          }
          $j_java$002etime$002echrono$002e$002dChronology.$f_Ljava_time_chrono_Chronology__updateResolveMap__ju_Map__Ljava_time_temporal_ChronoField__J__V(this, fieldValues, field$5, lo$16, hi$10);
        } else {
          throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ("Invalid value for era: " + era));
        }
      }
    }
  } else if (fieldValues.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField())) {
    var this$74 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField();
    var $x_26 = $j_java$002elang$002e$002dObject.$uJ($j_java$002eutil$002e$002dAbstract$002dMap.$p_ju_HashMap__getOrDefaultImpl__O__O__O(fieldValues, $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField(), null));
    var value$6_$_lo = $x_26.l;
    var value$6_$_hi = $x_26.h;
    this$74.G.ak(value$6_$_lo, value$6_$_hi, this$74);
  }
  if (fieldValues.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField())) {
    if (fieldValues.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
      if (fieldValues.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField())) {
        var this$76 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
        var $x_27 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()));
        var value$7_$_lo = $x_27.l;
        var value$7_$_hi = $x_27.h;
        var y = this$76.G.b0(value$7_$_lo, value$7_$_hi, this$76);
        var $x_28 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
        var a$2_$_lo = $x_28.l;
        var a$2_$_hi = $x_28.h;
        var this$78 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
        if ((((a$2_$_lo ^ a$2_$_lo) | ((a$2_$_lo >> 31) ^ a$2_$_hi)) !== 0)) {
          this$78.xv();
        }
        var $x_29 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField()));
        var a$3_$_lo = $x_29.l;
        var a$3_$_hi = $x_29.h;
        var this$83 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
        if ((((a$3_$_lo ^ a$3_$_lo) | ((a$3_$_lo >> 31) ^ a$3_$_hi)) !== 0)) {
          this$83.xv();
        }
        var dom = a$3_$_lo;
        if ((resolverStyle === $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
          var hi$14 = (a$2_$_lo >> 31);
          var this$88 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
          var lo$20 = ((a$2_$_lo - 1) | 0);
          var hi$15 = ((((hi$14 - 1) | 0) + ((lo$20 !== (-1)) | 0)) | 0);
          if (((hi$14 & (hi$15 ^ hi$14)) < 0)) {
            this$88.au();
          }
          var value$8 = dom;
          var hi$18 = (value$8 >> 31);
          var this$95 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
          var lo$24 = ((value$8 - 1) | 0);
          var hi$19 = ((((hi$18 - 1) | 0) + ((lo$24 !== (-1)) | 0)) | 0);
          if (((hi$18 & (hi$19 ^ hi$18)) < 0)) {
            this$95.au();
          }
          return $m_Ljava_time_LocalDate$().eA(y, 1, 1).ur(lo$20, hi$15).eC(lo$24, hi$19);
        } else if ((resolverStyle === $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__SMART__Ljava_time_format_ResolverStyle())) {
          var this$102 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
          var value$9 = dom;
          var hi$22 = (value$9 >> 31);
          this$102.G.ak(value$9, hi$22, this$102);
          if (((((a$2_$_lo === 4) || (a$2_$_lo === 6)) || (a$2_$_lo === 9)) || (a$2_$_lo === 11))) {
            var a$4 = dom;
            dom = ((a$4 < 30) ? a$4 : 30);
          } else if ((a$2_$_lo === 2)) {
            var a$5 = dom;
            var $x_31 = $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month();
            var $x_30 = $j_java$002etime$002e$002dYear$0024.$m_Ljava_time_Year$();
            var hi$23 = (y >> 31);
            var b$3 = $x_31.BZ($x_30.Vq(y, hi$23));
            dom = ((a$5 < b$3) ? a$5 : b$3);
          }
          return $m_Ljava_time_LocalDate$().eA(y, a$2_$_lo, dom);
        } else {
          return $m_Ljava_time_LocalDate$().eA(y, a$2_$_lo, dom);
        }
      }
      if (fieldValues.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField())) {
        if (fieldValues.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField())) {
          var this$107 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
          var $x_32 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()));
          var value$10_$_lo = $x_32.l;
          var value$10_$_hi = $x_32.h;
          var y$2 = this$107.G.b0(value$10_$_lo, value$10_$_hi, this$107);
          if ((resolverStyle === $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
            var $x_33 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
            var a$6_$_lo = $x_33.l;
            var a$6_$_hi = $x_33.h;
            var this$109 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
            var lo$28 = ((a$6_$_lo - 1) | 0);
            var hi$24 = ((((a$6_$_hi - 1) | 0) + ((lo$28 !== (-1)) | 0)) | 0);
            var hi$25 = (hi$24 ^ a$6_$_hi);
            if (((a$6_$_hi & hi$25) < 0)) {
              this$109.au();
            }
            var $x_34 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField()));
            var a$7_$_lo = $x_34.l;
            var a$7_$_hi = $x_34.h;
            var this$116 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
            var lo$32 = ((a$7_$_lo - 1) | 0);
            var hi$27 = ((((a$7_$_hi - 1) | 0) + ((lo$32 !== (-1)) | 0)) | 0);
            var hi$28 = (hi$27 ^ a$7_$_hi);
            if (((a$7_$_hi & hi$28) < 0)) {
              this$116.au();
            }
            var $x_35 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField()));
            var a$8_$_lo = $x_35.l;
            var a$8_$_hi = $x_35.h;
            var this$123 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
            var lo$36 = ((a$8_$_lo - 1) | 0);
            var hi$30 = ((((a$8_$_hi - 1) | 0) + ((lo$36 !== (-1)) | 0)) | 0);
            var hi$31 = (hi$30 ^ a$8_$_hi);
            if (((a$8_$_hi & hi$31) < 0)) {
              this$123.au();
            }
            return $m_Ljava_time_LocalDate$().eA(y$2, 1, 1).ur(lo$28, hi$24).it(lo$32, hi$27).eC(lo$36, hi$30);
          }
          var this$130 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
          var $x_36 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
          var value$11_$_lo = $x_36.l;
          var value$11_$_hi = $x_36.h;
          var moy$2 = this$130.G.b0(value$11_$_lo, value$11_$_hi, this$130);
          var this$132 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
          var $x_37 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField()));
          var value$12_$_lo = $x_37.l;
          var value$12_$_hi = $x_37.h;
          var aw = this$132.G.b0(value$12_$_lo, value$12_$_hi, this$132);
          var this$134 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField();
          var $x_38 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField()));
          var value$13_$_lo = $x_38.l;
          var value$13_$_hi = $x_38.h;
          var ad = this$134.G.b0(value$13_$_lo, value$13_$_hi, this$134);
          var $x_39 = $m_Ljava_time_LocalDate$().eA(y$2, moy$2, 1);
          var hi$33 = (aw >> 31);
          var lo$40 = ((aw - 1) | 0);
          var hi$34 = ((((hi$33 - 1) | 0) + ((lo$40 !== (-1)) | 0)) | 0);
          var b0$1 = (65535 & lo$40);
          var b1$1 = ((lo$40 >>> 16) | 0);
          var a0b0$1 = Math.imul(7, b0$1);
          var a0b1$1 = Math.imul(7, b1$1);
          var lo$41 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
          var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
          var hi$35 = ((Math.imul(7, hi$34) + ((c1part$1 >>> 16) | 0)) | 0);
          var hi$36 = (ad >> 31);
          var lo$42 = ((ad - 1) | 0);
          var hi$37 = ((((hi$36 - 1) | 0) + ((lo$42 !== (-1)) | 0)) | 0);
          var lo$43 = ((lo$41 + lo$42) | 0);
          var hi$38 = ((((hi$35 + hi$37) | 0) + (((lo$43 >>> 0) < (lo$41 >>> 0)) | 0)) | 0);
          var date = $x_39.eC(lo$43, hi$38);
          if (((resolverStyle === $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle()) && (date.cC($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) !== moy$2))) {
            throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different month");
          }
          return date;
        }
        if (fieldValues.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
          var this$142 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
          var $x_40 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()));
          var value$14_$_lo = $x_40.l;
          var value$14_$_hi = $x_40.h;
          var y$3 = this$142.G.b0(value$14_$_lo, value$14_$_hi, this$142);
          if ((resolverStyle === $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
            var $x_41 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
            var a$9_$_lo = $x_41.l;
            var a$9_$_hi = $x_41.h;
            var this$144 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
            var lo$44 = ((a$9_$_lo - 1) | 0);
            var hi$39 = ((((a$9_$_hi - 1) | 0) + ((lo$44 !== (-1)) | 0)) | 0);
            var hi$40 = (hi$39 ^ a$9_$_hi);
            if (((a$9_$_hi & hi$40) < 0)) {
              this$144.au();
            }
            var $x_42 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField()));
            var a$10_$_lo = $x_42.l;
            var a$10_$_hi = $x_42.h;
            var this$151 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
            var lo$48 = ((a$10_$_lo - 1) | 0);
            var hi$42 = ((((a$10_$_hi - 1) | 0) + ((lo$48 !== (-1)) | 0)) | 0);
            var hi$43 = (hi$42 ^ a$10_$_hi);
            if (((a$10_$_hi & hi$43) < 0)) {
              this$151.au();
            }
            var $x_43 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()));
            var a$11_$_lo = $x_43.l;
            var a$11_$_hi = $x_43.h;
            var this$158 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
            var lo$52 = ((a$11_$_lo - 1) | 0);
            var hi$45 = ((((a$11_$_hi - 1) | 0) + ((lo$52 !== (-1)) | 0)) | 0);
            var hi$46 = (hi$45 ^ a$11_$_hi);
            if (((a$11_$_hi & hi$46) < 0)) {
              this$158.au();
            }
            return $m_Ljava_time_LocalDate$().eA(y$3, 1, 1).ur(lo$44, hi$39).it(lo$48, hi$42).eC(lo$52, hi$45);
          }
          var this$165 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
          var $x_44 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()));
          var value$15_$_lo = $x_44.l;
          var value$15_$_hi = $x_44.h;
          var moy$3 = this$165.G.b0(value$15_$_lo, value$15_$_hi, this$165);
          var this$167 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
          var $x_45 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField()));
          var value$16_$_lo = $x_45.l;
          var value$16_$_hi = $x_45.h;
          var aw$2 = this$167.G.b0(value$16_$_lo, value$16_$_hi, this$167);
          var this$169 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
          var $x_46 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()));
          var value$17_$_lo = $x_46.l;
          var value$17_$_hi = $x_46.h;
          var dow = this$169.G.b0(value$17_$_lo, value$17_$_hi, this$169);
          var $x_47 = $m_Ljava_time_LocalDate$().eA(y$3, moy$3, 1);
          var hi$48 = (aw$2 >> 31);
          var lo$56 = ((aw$2 - 1) | 0);
          var hi$49 = ((((hi$48 - 1) | 0) + ((lo$56 !== (-1)) | 0)) | 0);
          var date$2 = $x_47.it(lo$56, hi$49).QV(new $j_java$002etime$002etemporal$002e$002dTemporal$002dAdjusters$0024$002dRelative$002dDay$002dOf$002dWeek.$c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek(0, $m_Ljava_time_DayOfWeek$().Ca(dow)));
          if (((resolverStyle === $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle()) && (date$2.cC($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) !== moy$3))) {
            throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different month");
          }
          return date$2;
        }
      }
    }
    if (fieldValues.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField())) {
      var this$174 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
      var $x_48 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()));
      var value$18_$_lo = $x_48.l;
      var value$18_$_hi = $x_48.h;
      var y$4 = this$174.G.b0(value$18_$_lo, value$18_$_hi, this$174);
      if ((resolverStyle === $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
        var $x_49 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField()));
        var a$12_$_lo = $x_49.l;
        var a$12_$_hi = $x_49.h;
        var this$176 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
        var lo$57 = ((a$12_$_lo - 1) | 0);
        var hi$50 = ((((a$12_$_hi - 1) | 0) + ((lo$57 !== (-1)) | 0)) | 0);
        var hi$51 = (hi$50 ^ a$12_$_hi);
        if (((a$12_$_hi & hi$51) < 0)) {
          this$176.au();
        }
        return $m_Ljava_time_LocalDate$().Cf(y$4, 1).eC(lo$57, hi$50);
      }
      var this$183 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
      var $x_50 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField()));
      var value$19_$_lo = $x_50.l;
      var value$19_$_hi = $x_50.h;
      var doy = this$183.G.b0(value$19_$_lo, value$19_$_hi, this$183);
      return $m_Ljava_time_LocalDate$().Cf(y$4, doy);
    }
    if (fieldValues.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField())) {
      if (fieldValues.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField())) {
        var this$185 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
        var $x_51 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()));
        var value$20_$_lo = $x_51.l;
        var value$20_$_hi = $x_51.h;
        var y$5 = this$185.G.b0(value$20_$_lo, value$20_$_hi, this$185);
        if ((resolverStyle === $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
          var $x_52 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField()));
          var a$13_$_lo = $x_52.l;
          var a$13_$_hi = $x_52.h;
          var this$187 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
          var lo$61 = ((a$13_$_lo - 1) | 0);
          var hi$53 = ((((a$13_$_hi - 1) | 0) + ((lo$61 !== (-1)) | 0)) | 0);
          var hi$54 = (hi$53 ^ a$13_$_hi);
          if (((a$13_$_hi & hi$54) < 0)) {
            this$187.au();
          }
          var $x_53 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField()));
          var a$14_$_lo = $x_53.l;
          var a$14_$_hi = $x_53.h;
          var this$194 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
          var lo$65 = ((a$14_$_lo - 1) | 0);
          var hi$56 = ((((a$14_$_hi - 1) | 0) + ((lo$65 !== (-1)) | 0)) | 0);
          var hi$57 = (hi$56 ^ a$14_$_hi);
          if (((a$14_$_hi & hi$57) < 0)) {
            this$194.au();
          }
          return $m_Ljava_time_LocalDate$().eA(y$5, 1, 1).it(lo$61, hi$53).eC(lo$65, hi$56);
        }
        var this$201 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField();
        var $x_54 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField()));
        var value$21_$_lo = $x_54.l;
        var value$21_$_hi = $x_54.h;
        var aw$3 = this$201.G.b0(value$21_$_lo, value$21_$_hi, this$201);
        var this$203 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField();
        var $x_55 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField()));
        var value$22_$_lo = $x_55.l;
        var value$22_$_hi = $x_55.h;
        var ad$2 = this$203.G.b0(value$22_$_lo, value$22_$_hi, this$203);
        var $x_56 = $m_Ljava_time_LocalDate$().eA(y$5, 1, 1);
        var hi$59 = (aw$3 >> 31);
        var lo$69 = ((aw$3 - 1) | 0);
        var hi$60 = ((((hi$59 - 1) | 0) + ((lo$69 !== (-1)) | 0)) | 0);
        var b0$2 = (65535 & lo$69);
        var b1$2 = ((lo$69 >>> 16) | 0);
        var a0b0$2 = Math.imul(7, b0$2);
        var a0b1$2 = Math.imul(7, b1$2);
        var lo$70 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
        var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
        var hi$61 = ((Math.imul(7, hi$60) + ((c1part$2 >>> 16) | 0)) | 0);
        var value$23 = ((ad$2 - 1) | 0);
        var hi$62 = (value$23 >> 31);
        var lo$71 = ((lo$70 + value$23) | 0);
        var hi$63 = ((((hi$61 + hi$62) | 0) + (((lo$71 >>> 0) < (lo$70 >>> 0)) | 0)) | 0);
        var date$3 = $x_56.eC(lo$71, hi$63);
        if (((resolverStyle === $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle()) && (date$3.cC($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()) !== y$5))) {
          throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different year");
        }
        return date$3;
      }
      if (fieldValues.aj($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
        var this$210 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
        var $x_57 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()));
        var value$24_$_lo = $x_57.l;
        var value$24_$_hi = $x_57.h;
        var y$6 = this$210.G.b0(value$24_$_lo, value$24_$_hi, this$210);
        if ((resolverStyle === $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__LENIENT__Ljava_time_format_ResolverStyle())) {
          var $x_58 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField()));
          var a$15_$_lo = $x_58.l;
          var a$15_$_hi = $x_58.h;
          var this$212 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
          var lo$72 = ((a$15_$_lo - 1) | 0);
          var hi$64 = ((((a$15_$_hi - 1) | 0) + ((lo$72 !== (-1)) | 0)) | 0);
          var hi$65 = (hi$64 ^ a$15_$_hi);
          if (((a$15_$_hi & hi$65) < 0)) {
            this$212.au();
          }
          var $x_59 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()));
          var a$16_$_lo = $x_59.l;
          var a$16_$_hi = $x_59.h;
          var this$219 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
          var lo$76 = ((a$16_$_lo - 1) | 0);
          var hi$67 = ((((a$16_$_hi - 1) | 0) + ((lo$76 !== (-1)) | 0)) | 0);
          var hi$68 = (hi$67 ^ a$16_$_hi);
          if (((a$16_$_hi & hi$68) < 0)) {
            this$219.au();
          }
          return $m_Ljava_time_LocalDate$().eA(y$6, 1, 1).it(lo$72, hi$64).eC(lo$76, hi$67);
        }
        var this$226 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField();
        var $x_60 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField()));
        var value$25_$_lo = $x_60.l;
        var value$25_$_hi = $x_60.h;
        var aw$4 = this$226.G.b0(value$25_$_lo, value$25_$_hi, this$226);
        var this$228 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
        var $x_61 = $j_java$002elang$002e$002dObject.$uJ(fieldValues.aa($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()));
        var value$26_$_lo = $x_61.l;
        var value$26_$_hi = $x_61.h;
        var dow$2 = this$228.G.b0(value$26_$_lo, value$26_$_hi, this$228);
        var $x_62 = $m_Ljava_time_LocalDate$().eA(y$6, 1, 1);
        var hi$70 = (aw$4 >> 31);
        var lo$80 = ((aw$4 - 1) | 0);
        var hi$71 = ((((hi$70 - 1) | 0) + ((lo$80 !== (-1)) | 0)) | 0);
        var date$4 = $x_62.it(lo$80, hi$71).QV(new $j_java$002etime$002etemporal$002e$002dTemporal$002dAdjusters$0024$002dRelative$002dDay$002dOf$002dWeek.$c_Ljava_time_temporal_TemporalAdjusters$RelativeDayOfWeek(0, $m_Ljava_time_DayOfWeek$().Ca(dow$2)));
        if (((resolverStyle === $j_java$002etime$002eformat$002e$002dResolver$002dStyle$0024.$s_Ljava_time_format_ResolverStyle$__STRICT__Ljava_time_format_ResolverStyle()) && (date$4.cC($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField()) !== y$6))) {
          throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), "Strict mode rejected date parsed to a different month");
        }
        return date$4;
      }
    }
  }
  return null;
});
$p.ic = (function(that) {
  return $j_java$002elang$002e$002dObject.$f_T__compareTo__T__I("ISO", "ISO");
});
function $isArrayOf_Ljava_time_chrono_IsoChronology(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dG)));
}
export { $isArrayOf_Ljava_time_chrono_IsoChronology as $isArrayOf_Ljava_time_chrono_IsoChronology };
var $d_Ljava_time_chrono_IsoChronology = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_chrono_IsoChronology, "java.time.chrono.IsoChronology", ({
  dG: 1,
  j: 1,
  aK: 1,
  ce: 1,
  a: 1
}));
export { $d_Ljava_time_chrono_IsoChronology as $d_Ljava_time_chrono_IsoChronology };
function $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z($thiz, field) {
  return ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField) ? field.hk() : ((field !== null) && $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z($thiz, field)));
}
export { $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z as $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z };
function $f_Ljava_time_chrono_ChronoLocalDate__query__Ljava_time_temporal_TemporalQuery__O($thiz, query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().eR();
  if (((x === null) ? (query === null) : (x === query))) {
    return $m_Ljava_time_chrono_IsoChronology$().bz();
  }
  var x$3 = $m_Ljava_time_temporal_TemporalQueries$().gH();
  if (((x$3 === null) ? (query === null) : (x$3 === query))) {
    return $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
  }
  var x$5 = $m_Ljava_time_temporal_TemporalQueries$().fl();
  if (((x$5 === null) ? (query === null) : (x$5 === query))) {
    var $x_2 = $m_Ljava_time_LocalDate$();
    var $x_1 = $thiz.fo();
    return $x_2.gE($x_1.l, $x_1.h);
  }
  matchAlts1: {
    matchAlts2: {
      var x$7 = $m_Ljava_time_temporal_TemporalQueries$().ik();
      if (((x$7 === null) ? (query === null) : (x$7 === query))) {
        break matchAlts2;
      }
      var x$9 = $m_Ljava_time_temporal_TemporalQueries$().hx();
      if (((x$9 === null) ? (query === null) : (x$9 === query))) {
        break matchAlts2;
      }
      var x$11 = $m_Ljava_time_temporal_TemporalQueries$().f1();
      if (((x$11 === null) ? (query === null) : (x$11 === query))) {
        break matchAlts2;
      }
      var x$13 = $m_Ljava_time_temporal_TemporalQueries$().gF();
      if (((x$13 === null) ? (query === null) : (x$13 === query))) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return null;
  }
  return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O($thiz, query);
}
export { $f_Ljava_time_chrono_ChronoLocalDate__query__Ljava_time_temporal_TemporalQuery__O as $f_Ljava_time_chrono_ChronoLocalDate__query__Ljava_time_temporal_TemporalQuery__O };
function $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I($thiz, other) {
  var $x_1 = $thiz.fo();
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  var $x_2 = other.fo();
  var y_$_lo = $x_2.l;
  var y_$_hi = $x_2.h;
  var cmp = ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
  if ((cmp === 0)) {
    $m_Ljava_time_chrono_IsoChronology$().bz();
    $m_Ljava_time_chrono_IsoChronology$().bz();
    cmp = $j_java$002elang$002e$002dObject.$f_T__compareTo__T__I("ISO", "ISO");
  }
  return cmp;
}
export { $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I as $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I };
function $is_Ljava_time_chrono_ChronoLocalDate(obj) {
  return (!(!((obj && obj.$classData) && obj.$classData.n.cc)));
}
export { $is_Ljava_time_chrono_ChronoLocalDate as $is_Ljava_time_chrono_ChronoLocalDate };
function $isArrayOf_Ljava_time_chrono_ChronoLocalDate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.cc)));
}
export { $isArrayOf_Ljava_time_chrono_ChronoLocalDate as $isArrayOf_Ljava_time_chrono_ChronoLocalDate };
/** @constructor */
function $c_Ljava_time_chrono_ChronoLocalDateTime() {
}
export { $c_Ljava_time_chrono_ChronoLocalDateTime as $c_Ljava_time_chrono_ChronoLocalDateTime };
$p = $c_Ljava_time_chrono_ChronoLocalDateTime.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_chrono_ChronoLocalDateTime;
/** @constructor */
function $h_Ljava_time_chrono_ChronoLocalDateTime() {
}
export { $h_Ljava_time_chrono_ChronoLocalDateTime as $h_Ljava_time_chrono_ChronoLocalDateTime };
$h_Ljava_time_chrono_ChronoLocalDateTime.prototype = $p;
$p.cg = (function(query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().eR();
  if (((x === null) ? (query === null) : (x === query))) {
    return $m_Ljava_time_chrono_IsoChronology$().bz();
  }
  var x$3 = $m_Ljava_time_temporal_TemporalQueries$().gH();
  if (((x$3 === null) ? (query === null) : (x$3 === query))) {
    return $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
  }
  var x$5 = $m_Ljava_time_temporal_TemporalQueries$().fl();
  if (((x$5 === null) ? (query === null) : (x$5 === query))) {
    var $x_2 = $m_Ljava_time_LocalDate$();
    var $x_1 = this.aJ.fo();
    return $x_2.gE($x_1.l, $x_1.h);
  }
  var x$7 = $m_Ljava_time_temporal_TemporalQueries$().ik();
  if (((x$7 === null) ? (query === null) : (x$7 === query))) {
    return this.aO;
  }
  matchAlts1: {
    matchAlts2: {
      var x$9 = $m_Ljava_time_temporal_TemporalQueries$().hx();
      if (((x$9 === null) ? (query === null) : (x$9 === query))) {
        break matchAlts2;
      }
      var x$11 = $m_Ljava_time_temporal_TemporalQueries$().f1();
      if (((x$11 === null) ? (query === null) : (x$11 === query))) {
        break matchAlts2;
      }
      var x$13 = $m_Ljava_time_temporal_TemporalQueries$().gF();
      if (((x$13 === null) ? (query === null) : (x$13 === query))) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return null;
  }
  return $f_Ljava_time_temporal_TemporalAccessor__query__Ljava_time_temporal_TemporalQuery__O(this, query);
});
$p.he = (function(temporal) {
  var $x_5 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
  var $x_4 = this.aJ.fo();
  var $x_3 = temporal.fq($x_5, $x_4.l, $x_4.h);
  var $x_2 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
  var $x_1 = this.aO.iv();
  return $x_3.fq($x_2, $x_1.l, $x_1.h);
});
$p.QH = (function(offset) {
  var $x_1 = this.aJ.fo();
  var epochDay_$_lo = $x_1.l;
  var epochDay_$_hi = $x_1.h;
  var b0 = (65535 & epochDay_$_lo);
  var b1 = ((epochDay_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(20864, b0);
  var a0b1 = Math.imul(20864, b1);
  var lo = ((a0b0 + (((b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((((((Math.imul(86400, epochDay_$_hi) + b1) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + b0) | 0) >>> 16) | 0)) | 0);
  var value = this.aO.uF();
  var hi$1 = (value >> 31);
  var lo$1 = ((lo + value) | 0);
  var hi$2 = ((((hi + hi$1) | 0) + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
  var secs_$_lo = lo$1;
  var secs_$_hi = hi$2;
  var x_$_lo = secs_$_lo;
  var x_$_hi = secs_$_hi;
  var value$1 = offset.dj;
  var hi$3 = (value$1 >> 31);
  var lo$2 = ((x_$_lo - value$1) | 0);
  var hi$4 = ((((x_$_hi - hi$3) | 0) - (((lo$2 >>> 0) > (x_$_lo >>> 0)) | 0)) | 0);
  secs_$_lo = lo$2;
  secs_$_hi = hi$4;
  return $j_java$002elang$002e$002dObject.$bL(secs_$_lo, secs_$_hi);
});
$p.Oi = (function(other) {
  var cmp = this.aJ.Om(other.aJ);
  if ((cmp === 0)) {
    cmp = this.aO.x9(other.aO);
    if ((cmp === 0)) {
      $m_Ljava_time_chrono_IsoChronology$().bz();
      $m_Ljava_time_chrono_IsoChronology$().bz();
      cmp = $j_java$002elang$002e$002dObject.$f_T__compareTo__T__I("ISO", "ISO");
    }
  }
  return cmp;
});
$p.ic = (function(that) {
  return this.Oi(that);
});
function $isArrayOf_Ljava_time_chrono_ChronoLocalDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dF)));
}
export { $isArrayOf_Ljava_time_chrono_ChronoLocalDateTime as $isArrayOf_Ljava_time_chrono_ChronoLocalDateTime };
function $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant($thiz, secondsToAdd_$_lo, secondsToAdd_$_hi, nanosToAdd_$_lo, nanosToAdd_$_hi) {
  var _nanosToAdd_$_lo = nanosToAdd_$_lo;
  var _nanosToAdd_$_hi = nanosToAdd_$_hi;
  var x_$_lo = _nanosToAdd_$_lo;
  var x_$_hi = _nanosToAdd_$_hi;
  if ((((secondsToAdd_$_lo | x_$_lo) | (secondsToAdd_$_hi | x_$_hi)) === 0)) {
    return $thiz;
  }
  var a_$_lo = $thiz.er;
  var a_$_hi = $thiz.es;
  var this$3 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
  var lo$1 = ((a_$_lo + secondsToAdd_$_lo) | 0);
  var hi$1 = ((((a_$_hi + secondsToAdd_$_hi) | 0) + (((lo$1 >>> 0) < (a_$_lo >>> 0)) | 0)) | 0);
  if ((((hi$1 ^ a_$_hi) & (hi$1 ^ secondsToAdd_$_hi)) < 0)) {
    this$3.au();
  }
  var epochSec_$_lo = lo$1;
  var epochSec_$_hi = hi$1;
  var a$1_$_lo = epochSec_$_lo;
  var a$1_$_hi = epochSec_$_hi;
  var num_$_lo = _nanosToAdd_$_lo;
  var num_$_hi = _nanosToAdd_$_hi;
  var sign = (num_$_hi >> 31);
  var xlo = (num_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((num_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x$1 = (1.0000000000000017E-9 * aHat);
  var lo$5 = (x$1 | 0.0);
  var hi$5 = ((2.3283064365386963E-10 * x$1) | 0.0);
  var rHat = ((rlo - Math.imul(1000000000, lo$5)) | 0);
  if ((rHat < 0)) {
    var lo$6 = ((lo$5 - 1) | 0);
    var hi$6 = ((((hi$5 - 1) | 0) + ((lo$6 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$6;
    var absR_$_hi = hi$6;
  } else {
    var absR_$_lo = lo$5;
    var absR_$_hi = hi$5;
  }
  if ((num_$_hi < 0)) {
    var lo$7 = ((-absR_$_lo) | 0);
    var hi$7 = ((((-absR_$_hi) | 0) - ((lo$7 !== 0) | 0)) | 0);
    var b_$_lo = lo$7;
    var b_$_hi = hi$7;
  } else {
    var b_$_lo = absR_$_lo;
    var b_$_hi = absR_$_hi;
  }
  var this$21 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
  var lo$8 = ((a$1_$_lo + b_$_lo) | 0);
  var hi$8 = ((((a$1_$_hi + b_$_hi) | 0) + (((lo$8 >>> 0) < (a$1_$_lo >>> 0)) | 0)) | 0);
  if ((((hi$8 ^ a$1_$_hi) & (hi$8 ^ b_$_hi)) < 0)) {
    this$21.au();
  }
  epochSec_$_lo = lo$8;
  epochSec_$_hi = hi$8;
  var num$1_$_lo = _nanosToAdd_$_lo;
  var num$1_$_hi = _nanosToAdd_$_hi;
  var sign$1 = (num$1_$_hi >> 31);
  var xlo$1 = (num$1_$_lo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((num$1_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  var aHat$1 = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
  var x$3 = (1.0000000000000017E-9 * aHat$1);
  var lo$12 = (x$3 | 0.0);
  ((2.3283064365386963E-10 * x$3) | 0.0);
  var rHat$1 = ((rlo$1 - Math.imul(1000000000, lo$12)) | 0);
  if ((rHat$1 < 0)) {
    var lo$13 = ((1000000000 + rHat$1) | 0);
    var absR$1_$_lo = lo$13;
    var absR$1_$_hi = 0;
  } else {
    var absR$1_$_lo = rHat$1;
    var absR$1_$_hi = 0;
  }
  if ((num$1_$_hi < 0)) {
    var lo$14 = ((-absR$1_$_lo) | 0);
    var hi$13 = ((((-absR$1_$_hi) | 0) - ((lo$14 !== 0) | 0)) | 0);
    _nanosToAdd_$_lo = lo$14;
    _nanosToAdd_$_hi = hi$13;
  } else {
    _nanosToAdd_$_lo = absR$1_$_lo;
    _nanosToAdd_$_hi = absR$1_$_hi;
  }
  var value = $thiz.d0;
  var hi$14 = (value >> 31);
  var x$5_$_lo = _nanosToAdd_$_lo;
  var x$5_$_hi = _nanosToAdd_$_hi;
  var lo$15 = ((value + x$5_$_lo) | 0);
  var hi$15 = ((((hi$14 + x$5_$_hi) | 0) + (((lo$15 >>> 0) < (value >>> 0)) | 0)) | 0);
  return $m_Ljava_time_Instant$().Cd(epochSec_$_lo, epochSec_$_hi, lo$15, hi$15);
}
export { $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant as $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant };
/** @constructor */
function $c_Ljava_time_Instant(seconds_$_lo, seconds_$_hi, nanos) {
  this.er = 0;
  this.es = 0;
  this.d0 = 0;
  this.er = seconds_$_lo;
  this.es = seconds_$_hi;
  this.d0 = nanos;
}
export { $c_Ljava_time_Instant as $c_Ljava_time_Instant };
$p = $c_Ljava_time_Instant.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_Instant;
/** @constructor */
function $h_Ljava_time_Instant() {
}
export { $h_Ljava_time_Instant as $h_Ljava_time_Instant };
$h_Ljava_time_Instant.prototype = $p;
$p.ba = (function(field) {
  return ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField) ? ((((field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || (field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField())) || (field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField())) || (field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField())) : ((field !== null) && this.ba(field)));
});
$p.bX = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field);
});
$p.cC = (function(field) {
  if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    var x = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      return this.d0;
    }
    var x$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x$3 === null) ? (field === null) : (x$3 === field))) {
      return ((this.d0 / 1000) | 0);
    }
    var x$5 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x$5 === null) ? (field === null) : (x$5 === field))) {
      return ((this.d0 / 1000000) | 0);
    }
    throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    var $x_2 = $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field);
    var $x_1 = this.ai(field);
    return $x_2.b0($x_1.l, $x_1.h, field);
  }
});
$p.ai = (function(field) {
  if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    var x = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      var value = this.d0;
      var hi = (value >> 31);
      return $j_java$002elang$002e$002dObject.$bL(value, hi);
    }
    var x$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x$3 === null) ? (field === null) : (x$3 === field))) {
      var value$1 = this.d0;
      var hi$1 = (value$1 >> 31);
      var sign = (hi$1 >> 31);
      var xlo = (value$1 ^ sign);
      var rlo = ((xlo - sign) | 0);
      var rhi = (((hi$1 ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
      var quotHi = (((rhi >>> 0) / 1000) | 0);
      var k = ((rhi - Math.imul(1000, quotHi)) | 0);
      var quotLo = ((0.0010000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
      if ((hi$1 < 0)) {
        var lo = ((-quotLo) | 0);
        var hi$2 = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
        return $j_java$002elang$002e$002dObject.$bL(lo, hi$2);
      } else {
        return $j_java$002elang$002e$002dObject.$bL(quotLo, quotHi);
      }
    }
    var x$5 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x$5 === null) ? (field === null) : (x$5 === field))) {
      var value$2 = this.d0;
      var hi$3 = (value$2 >> 31);
      var sign$1 = (hi$3 >> 31);
      var xlo$1 = (value$2 ^ sign$1);
      var rlo$1 = ((xlo$1 - sign$1) | 0);
      var rhi$1 = (((hi$3 ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
      var aHat = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
      var x$2 = (1.0000000000000016E-6 * aHat);
      var lo$1 = (x$2 | 0.0);
      var hi$4 = ((2.3283064365386963E-10 * x$2) | 0.0);
      var rHat = ((rlo$1 - Math.imul(1000000, lo$1)) | 0);
      if ((rHat < 0)) {
        var lo$2 = ((lo$1 - 1) | 0);
        var hi$5 = ((((hi$4 - 1) | 0) + ((lo$2 !== (-1)) | 0)) | 0);
        var absR_$_lo = lo$2;
        var absR_$_hi = hi$5;
      } else {
        var absR_$_lo = lo$1;
        var absR_$_hi = hi$4;
      }
      if ((hi$3 < 0)) {
        var lo$3 = ((-absR_$_lo) | 0);
        var hi$6 = ((((-absR_$_hi) | 0) - ((lo$3 !== 0) | 0)) | 0);
        return $j_java$002elang$002e$002dObject.$bL(lo$3, hi$6);
      } else {
        return $j_java$002elang$002e$002dObject.$bL(absR_$_lo, absR_$_hi);
      }
    }
    var x$7 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if (((x$7 === null) ? (field === null) : (x$7 === field))) {
      return $j_java$002elang$002e$002dObject.$bL(this.er, this.es);
    }
    throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return this.ai(field);
  }
});
$p.QW = (function(field, newValue_$_lo, newValue_$_hi) {
  if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    field.G.ak(newValue_$_lo, newValue_$_hi, field);
    var x = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      var nval = Math.imul(1000000, newValue_$_lo);
      return ((nval !== this.d0) ? $m_Ljava_time_Instant$().r7(this.er, this.es, nval) : this);
    }
    var x$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x$3 === null) ? (field === null) : (x$3 === field))) {
      var nval$2 = Math.imul(1000, newValue_$_lo);
      return ((nval$2 !== this.d0) ? $m_Ljava_time_Instant$().r7(this.er, this.es, nval$2) : this);
    }
    var x$5 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x$5 === null) ? (field === null) : (x$5 === field))) {
      var value = this.d0;
      var hi = (value >> 31);
      if ((((newValue_$_lo ^ value) | (newValue_$_hi ^ hi)) !== 0)) {
        return $m_Ljava_time_Instant$().r7(this.er, this.es, newValue_$_lo);
      } else {
        return this;
      }
    }
    var x$7 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if (((x$7 === null) ? (field === null) : (x$7 === field))) {
      var x$1_$_lo = this.er;
      var x$1_$_hi = this.es;
      if ((((newValue_$_lo ^ x$1_$_lo) | (newValue_$_hi ^ x$1_$_hi)) !== 0)) {
        return $m_Ljava_time_Instant$().r7(newValue_$_lo, newValue_$_hi, this.d0);
      } else {
        return this;
      }
    }
    throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  }
  return this.QW(field, newValue_$_lo, newValue_$_hi);
});
$p.un = (function(amountToAdd_$_lo, amountToAdd_$_hi, unit) {
  if ((unit instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$c_Ljava_time_temporal_ChronoUnit)) {
    var x = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
    if (((x === null) ? (unit === null) : (x === unit))) {
      return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, 0, 0, amountToAdd_$_lo, amountToAdd_$_hi);
    }
    var x$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
    if (((x$3 === null) ? (unit === null) : (x$3 === unit))) {
      var sign = (amountToAdd_$_hi >> 31);
      var xlo = (amountToAdd_$_lo ^ sign);
      var rlo = ((xlo - sign) | 0);
      var rhi = (((amountToAdd_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
      var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
      var x$1 = (1.0000000000000016E-6 * aHat);
      var lo = (x$1 | 0.0);
      var hi = ((2.3283064365386963E-10 * x$1) | 0.0);
      var rHat = ((rlo - Math.imul(1000000, lo)) | 0);
      if ((rHat < 0)) {
        var lo$1 = ((lo - 1) | 0);
        var hi$1 = ((((hi - 1) | 0) + ((lo$1 !== (-1)) | 0)) | 0);
        var absR_$_lo = lo$1;
        var absR_$_hi = hi$1;
      } else {
        var absR_$_lo = lo;
        var absR_$_hi = hi;
      }
      if ((amountToAdd_$_hi < 0)) {
        var lo$2 = ((-absR_$_lo) | 0);
        var hi$2 = ((((-absR_$_hi) | 0) - ((lo$2 !== 0) | 0)) | 0);
        var $x_1_$_lo = lo$2;
        var $x_1_$_hi = hi$2;
      } else {
        var $x_1_$_lo = absR_$_lo;
        var $x_1_$_hi = absR_$_hi;
      }
      var sign$1 = (amountToAdd_$_hi >> 31);
      var xlo$1 = (amountToAdd_$_lo ^ sign$1);
      var rlo$1 = ((xlo$1 - sign$1) | 0);
      var rhi$1 = (((amountToAdd_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
      var aHat$1 = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
      var x$4 = (1.0000000000000016E-6 * aHat$1);
      var lo$3 = (x$4 | 0.0);
      ((2.3283064365386963E-10 * x$4) | 0.0);
      var rHat$1 = ((rlo$1 - Math.imul(1000000, lo$3)) | 0);
      if ((rHat$1 < 0)) {
        var lo$4 = ((1000000 + rHat$1) | 0);
        var absR$1_$_lo = lo$4;
        var absR$1_$_hi = 0;
      } else {
        var absR$1_$_lo = rHat$1;
        var absR$1_$_hi = 0;
      }
      if ((amountToAdd_$_hi < 0)) {
        var lo$5 = ((-absR$1_$_lo) | 0);
        var hi$4 = ((((-absR$1_$_hi) | 0) - ((lo$5 !== 0) | 0)) | 0);
        var x$6_$_lo = lo$5;
        var x$6_$_hi = hi$4;
      } else {
        var x$6_$_lo = absR$1_$_lo;
        var x$6_$_hi = absR$1_$_hi;
      }
      var b0 = (65535 & x$6_$_lo);
      var b1 = ((x$6_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(1000, b0);
      var a0b1 = Math.imul(1000, b1);
      var lo$6 = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$5 = ((Math.imul(1000, x$6_$_hi) + ((c1part >>> 16) | 0)) | 0);
      return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, $x_1_$_lo, $x_1_$_hi, lo$6, hi$5);
    }
    var x$5$1 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
    if (((x$5$1 === null) ? (unit === null) : (x$5$1 === unit))) {
      return this.WE(amountToAdd_$_lo, amountToAdd_$_hi);
    }
    var x$7 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
    if (((x$7 === null) ? (unit === null) : (x$7 === unit))) {
      return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, amountToAdd_$_lo, amountToAdd_$_hi, 0, 0);
    }
    var x$9 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
    if (((x$9 === null) ? (unit === null) : (x$9 === unit))) {
      var this$25 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
      var b0$1 = (65535 & amountToAdd_$_lo);
      var b1$1 = ((amountToAdd_$_lo >>> 16) | 0);
      var a0b0$1 = Math.imul(60, b0$1);
      var a0b1$1 = Math.imul(60, b1$1);
      var lo$7 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$6 = ((Math.imul(60, amountToAdd_$_hi) + ((c1part$1 >>> 16) | 0)) | 0);
      if (((amountToAdd_$_lo | amountToAdd_$_hi) !== 0)) {
        var $x_3 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo$7, hi$6, amountToAdd_$_lo, amountToAdd_$_hi);
        var x$8_$_lo = $x_3.l;
        var x$8_$_hi = $x_3.h;
        var $x_2 = (((60 ^ x$8_$_lo) | x$8_$_hi) !== 0);
      } else {
        var $x_2 = false;
      }
      if ($x_2) {
        this$25.au();
      }
      return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, lo$7, hi$6, 0, 0);
    }
    var x$11 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
    if (((x$11 === null) ? (unit === null) : (x$11 === unit))) {
      var this$30 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
      var b0$2 = (65535 & amountToAdd_$_lo);
      var b1$2 = ((amountToAdd_$_lo >>> 16) | 0);
      var a0b0$2 = Math.imul(3600, b0$2);
      var a0b1$2 = Math.imul(3600, b1$2);
      var lo$8 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$7 = ((Math.imul(3600, amountToAdd_$_hi) + ((c1part$2 >>> 16) | 0)) | 0);
      if (((amountToAdd_$_lo | amountToAdd_$_hi) !== 0)) {
        var $x_5 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo$8, hi$7, amountToAdd_$_lo, amountToAdd_$_hi);
        var x$10_$_lo = $x_5.l;
        var x$10_$_hi = $x_5.h;
        var $x_4 = (((3600 ^ x$10_$_lo) | x$10_$_hi) !== 0);
      } else {
        var $x_4 = false;
      }
      if ($x_4) {
        this$30.au();
      }
      return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, lo$8, hi$7, 0, 0);
    }
    var x$13 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
    if (((x$13 === null) ? (unit === null) : (x$13 === unit))) {
      var this$35 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
      var b0$3 = (65535 & amountToAdd_$_lo);
      var b1$3 = ((amountToAdd_$_lo >>> 16) | 0);
      var a0b0$3 = Math.imul(43200, b0$3);
      var a0b1$3 = Math.imul(43200, b1$3);
      var lo$9 = ((a0b0$3 + (a0b1$3 << 16)) | 0);
      var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
      var hi$8 = ((Math.imul(43200, amountToAdd_$_hi) + ((c1part$3 >>> 16) | 0)) | 0);
      if (((amountToAdd_$_lo | amountToAdd_$_hi) !== 0)) {
        var $x_7 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo$9, hi$8, amountToAdd_$_lo, amountToAdd_$_hi);
        var x$12_$_lo = $x_7.l;
        var x$12_$_hi = $x_7.h;
        var $x_6 = (((43200 ^ x$12_$_lo) | x$12_$_hi) !== 0);
      } else {
        var $x_6 = false;
      }
      if ($x_6) {
        this$35.au();
      }
      return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, lo$9, hi$8, 0, 0);
    }
    var x$15 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
    if (((x$15 === null) ? (unit === null) : (x$15 === unit))) {
      var this$40 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
      var b0$4 = (65535 & amountToAdd_$_lo);
      var b1$4 = ((amountToAdd_$_lo >>> 16) | 0);
      var a0b0$4 = Math.imul(20864, b0$4);
      var a0b1$4 = Math.imul(20864, b1$4);
      var lo$10 = ((a0b0$4 + (((b0$4 + a0b1$4) | 0) << 16)) | 0);
      var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
      var hi$9 = ((((((Math.imul(86400, amountToAdd_$_hi) + b1$4) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + b0$4) | 0) >>> 16) | 0)) | 0);
      if (((amountToAdd_$_lo | amountToAdd_$_hi) !== 0)) {
        var $x_9 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo$10, hi$9, amountToAdd_$_lo, amountToAdd_$_hi);
        var x$14_$_lo = $x_9.l;
        var x$14_$_hi = $x_9.h;
        var $x_8 = (((86400 ^ x$14_$_lo) | x$14_$_hi) !== 0);
      } else {
        var $x_8 = false;
      }
      if ($x_8) {
        this$40.au();
      }
      return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, lo$10, hi$9, 0, 0);
    }
    throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit));
  }
  return this.un(amountToAdd_$_lo, amountToAdd_$_hi, unit);
});
$p.WE = (function(millisToAdd_$_lo, millisToAdd_$_hi) {
  var sign = (millisToAdd_$_hi >> 31);
  var xlo = (millisToAdd_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((millisToAdd_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var quotHi = (((rhi >>> 0) / 1000) | 0);
  var k = ((rhi - Math.imul(1000, quotHi)) | 0);
  var quotLo = ((0.0010000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
  if ((millisToAdd_$_hi < 0)) {
    var lo = ((-quotLo) | 0);
    var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
    var $x_1_$_lo = lo;
    var $x_1_$_hi = hi;
  } else {
    var $x_1_$_lo = quotLo;
    var $x_1_$_hi = quotHi;
  }
  var sign$1 = (millisToAdd_$_hi >> 31);
  var xlo$1 = (millisToAdd_$_lo ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((millisToAdd_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  var k$2 = (((rhi$1 >>> 0) % 1000) | 0);
  var quotLo$2 = ((0.0010000000000000005 * ((4.294967296E9 * k$2) + (rlo$1 >>> 0.0))) | 0.0);
  var remLo = ((rlo$1 - Math.imul(1000, quotLo$2)) | 0);
  if ((millisToAdd_$_hi < 0)) {
    var lo$1 = ((-remLo) | 0);
    var hi$1 = ((-((lo$1 !== 0) | 0)) | 0);
    var x$2_$_lo = lo$1;
    var x$2_$_hi = hi$1;
  } else {
    var x$2_$_lo = remLo;
    var x$2_$_hi = 0;
  }
  var b0 = (65535 & x$2_$_lo);
  var b1 = ((x$2_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(16960, b0);
  var a1b0 = Math.imul(15, b0);
  var a0b1 = Math.imul(16960, b1);
  var lo$2 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$2 = ((((((Math.imul(1000000, x$2_$_hi) + Math.imul(15, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  return $p_Ljava_time_Instant__plus__J__J__Ljava_time_Instant(this, $x_1_$_lo, $x_1_$_hi, lo$2, hi$2);
});
$p.W1 = (function(amountToSubtract_$_lo, amountToSubtract_$_hi, unit) {
  if (((amountToSubtract_$_lo | ((-2147483648) ^ amountToSubtract_$_hi)) === 0)) {
    return this.un((-1), 2147483647, unit).un(1, 0, unit);
  } else {
    var lo = ((-amountToSubtract_$_lo) | 0);
    var hi = ((((-amountToSubtract_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
    return this.un(lo, hi, unit);
  }
});
$p.cg = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().gH()) ? $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit() : (((((((query === $m_Ljava_time_temporal_TemporalQueries$().fl()) || (query === $m_Ljava_time_temporal_TemporalQueries$().ik())) || (query === $m_Ljava_time_temporal_TemporalQueries$().eR())) || (query === $m_Ljava_time_temporal_TemporalQueries$().f1())) || (query === $m_Ljava_time_temporal_TemporalQueries$().hx())) || (query === $m_Ljava_time_temporal_TemporalQueries$().gF())) ? null : query.dQ(this)));
});
$p.he = (function(temporal) {
  var $x_2 = temporal.fq($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField(), this.er, this.es);
  var $x_1 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  var value = this.d0;
  var hi = (value >> 31);
  return $x_2.fq($x_1, value, hi);
});
$p.Og = (function(otherInstant) {
  var x_$_lo = this.er;
  var x_$_hi = this.es;
  var y_$_lo = otherInstant.er;
  var y_$_hi = otherInstant.es;
  var cmp = ((x_$_hi === y_$_hi) ? ((x_$_lo === y_$_lo) ? 0 : (((x_$_lo >>> 0) < (y_$_lo >>> 0)) ? (-1) : 1)) : ((x_$_hi < y_$_hi) ? (-1) : 1));
  return ((cmp !== 0) ? cmp : ((this.d0 - otherInstant.d0) | 0));
});
$p.f = (function(other) {
  if ((other instanceof $c_Ljava_time_Instant)) {
    if ((this === other)) {
      return true;
    } else {
      var x_$_lo = this.er;
      var x_$_hi = this.es;
      var $x_1 = other;
      var x$1_$_lo = $x_1.er;
      var x$1_$_hi = $x_1.es;
      if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
        return (this.d0 === other.d0);
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  var x$1_$_lo = this.er;
  var x$1_$_hi = this.es;
  var x_$_lo = this.er;
  var x_$_hi = this.es;
  return (((x$1_$_lo ^ x_$_hi) + Math.imul(51, this.d0)) | 0);
});
$p.b = (function() {
  return $m_Ljava_time_format_DateTimeFormatter$().RL().U7(this);
});
$p.fq = (function(field, newValue_$_lo, newValue_$_hi) {
  return this.QW(field, newValue_$_lo, newValue_$_hi);
});
$p.is = (function(amountToAdd_$_lo, amountToAdd_$_hi, unit) {
  return this.un(amountToAdd_$_lo, amountToAdd_$_hi, unit);
});
$p.uj = (function(amountToSubtract_$_lo, amountToSubtract_$_hi, unit) {
  return this.W1(amountToSubtract_$_lo, amountToSubtract_$_hi, unit);
});
$p.ic = (function(that) {
  return this.Og(that);
});
$p.fh = (function(that) {
  return this.Og(that);
});
function $isArrayOf_Ljava_time_Instant(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dx)));
}
export { $isArrayOf_Ljava_time_Instant as $isArrayOf_Ljava_time_Instant };
var $d_Ljava_time_Instant = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Instant, "java.time.Instant", ({
  dx: 1,
  G: 1,
  bs: 1,
  I: 1,
  j: 1,
  aK: 1,
  a: 1
}));
export { $d_Ljava_time_Instant as $d_Ljava_time_Instant };
function $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J($thiz, field) {
  var x = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
  if (((x === null) ? (field === null) : (x === field))) {
    var value = $thiz.cv;
    var hi = (value >> 31);
    return $j_java$002elang$002e$002dObject.$bL(value, hi);
  }
  var x$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
  if (((x$3 === null) ? (field === null) : (x$3 === field))) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
  }
  var x$5 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
  if (((x$5 === null) ? (field === null) : (x$5 === field))) {
    var value$1 = $thiz.cv;
    var hi$1 = (value$1 >> 31);
    var sign = (hi$1 >> 31);
    var xlo = (value$1 ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((hi$1 ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var quotHi = (((rhi >>> 0) / 1000) | 0);
    var k = ((rhi - Math.imul(1000, quotHi)) | 0);
    var quotLo = ((0.0010000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
    if ((hi$1 < 0)) {
      var lo = ((-quotLo) | 0);
      var hi$2 = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
      return $j_java$002elang$002e$002dObject.$bL(lo, hi$2);
    } else {
      return $j_java$002elang$002e$002dObject.$bL(quotLo, quotHi);
    }
  }
  var x$7 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField();
  if (((x$7 === null) ? (field === null) : (x$7 === field))) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
  }
  var x$9 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
  if (((x$9 === null) ? (field === null) : (x$9 === field))) {
    var value$2 = $thiz.cv;
    var hi$3 = (value$2 >> 31);
    var sign$1 = (hi$3 >> 31);
    var xlo$1 = (value$2 ^ sign$1);
    var rlo$1 = ((xlo$1 - sign$1) | 0);
    var rhi$1 = (((hi$3 ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
    var aHat = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
    var x$2 = (1.0000000000000016E-6 * aHat);
    var lo$1 = (x$2 | 0.0);
    var hi$4 = ((2.3283064365386963E-10 * x$2) | 0.0);
    var rHat = ((rlo$1 - Math.imul(1000000, lo$1)) | 0);
    if ((rHat < 0)) {
      var lo$2 = ((lo$1 - 1) | 0);
      var hi$5 = ((((hi$4 - 1) | 0) + ((lo$2 !== (-1)) | 0)) | 0);
      var absR_$_lo = lo$2;
      var absR_$_hi = hi$5;
    } else {
      var absR_$_lo = lo$1;
      var absR_$_hi = hi$4;
    }
    if ((hi$3 < 0)) {
      var lo$3 = ((-absR_$_lo) | 0);
      var hi$6 = ((((-absR_$_hi) | 0) - ((lo$3 !== 0) | 0)) | 0);
      return $j_java$002elang$002e$002dObject.$bL(lo$3, hi$6);
    } else {
      return $j_java$002elang$002e$002dObject.$bL(absR_$_lo, absR_$_hi);
    }
  }
  var x$11 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField();
  if (((x$11 === null) ? (field === null) : (x$11 === field))) {
    var $x_1 = $thiz.iv();
    var num_$_lo = $x_1.l;
    var num_$_hi = $x_1.h;
    var sign$2 = (num_$_hi >> 31);
    var xlo$2 = (num_$_lo ^ sign$2);
    var rlo$2 = ((xlo$2 - sign$2) | 0);
    var rhi$2 = (((num_$_hi ^ sign$2) + (((rlo$2 >>> 0) < (xlo$2 >>> 0)) | 0)) | 0);
    var aHat$1 = ((4.294967296E9 * (rhi$2 >>> 0.0)) + (rlo$2 >>> 0.0));
    var x$6 = (1.0000000000000016E-6 * aHat$1);
    var lo$4 = (x$6 | 0.0);
    var hi$7 = ((2.3283064365386963E-10 * x$6) | 0.0);
    var rHat$1 = ((rlo$2 - Math.imul(1000000, lo$4)) | 0);
    if ((rHat$1 < 0)) {
      var lo$5 = ((lo$4 - 1) | 0);
      var hi$8 = ((((hi$7 - 1) | 0) + ((lo$5 !== (-1)) | 0)) | 0);
      var absR$1_$_lo = lo$5;
      var absR$1_$_hi = hi$8;
    } else {
      var absR$1_$_lo = lo$4;
      var absR$1_$_hi = hi$7;
    }
    if ((num_$_hi < 0)) {
      var lo$6 = ((-absR$1_$_lo) | 0);
      var hi$9 = ((((-absR$1_$_hi) | 0) - ((lo$6 !== 0) | 0)) | 0);
      return $j_java$002elang$002e$002dObject.$bL(lo$6, hi$9);
    } else {
      return $j_java$002elang$002e$002dObject.$bL(absR$1_$_lo, absR$1_$_hi);
    }
  }
  var x$13 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
  if (((x$13 === null) ? (field === null) : (x$13 === field))) {
    var value$3 = $thiz.di;
    var hi$10 = (value$3 >> 31);
    return $j_java$002elang$002e$002dObject.$bL(value$3, hi$10);
  }
  var x$15 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
  if (((x$15 === null) ? (field === null) : (x$15 === field))) {
    var value$4 = $thiz.uF();
    var hi$11 = (value$4 >> 31);
    return $j_java$002elang$002e$002dObject.$bL(value$4, hi$11);
  }
  var x$17 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
  if (((x$17 === null) ? (field === null) : (x$17 === field))) {
    var value$5 = $thiz.dh;
    var hi$12 = (value$5 >> 31);
    return $j_java$002elang$002e$002dObject.$bL(value$5, hi$12);
  }
  var x$19 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField();
  if (((x$19 === null) ? (field === null) : (x$19 === field))) {
    var value$6 = $thiz.bu;
    var hi$13 = (value$6 >> 31);
    var b0 = (65535 & value$6);
    var b1 = ((value$6 >>> 16) | 0);
    var a0b0 = Math.imul(60, b0);
    var a0b1 = Math.imul(60, b1);
    var lo$7 = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$14 = ((Math.imul(60, hi$13) + ((c1part >>> 16) | 0)) | 0);
    var value$7 = $thiz.dh;
    var hi$15 = (value$7 >> 31);
    var lo$8 = ((lo$7 + value$7) | 0);
    var hi$16 = ((((hi$14 + hi$15) | 0) + (((lo$8 >>> 0) < (lo$7 >>> 0)) | 0)) | 0);
    return $j_java$002elang$002e$002dObject.$bL(lo$8, hi$16);
  }
  var x$21 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
  if (((x$21 === null) ? (field === null) : (x$21 === field))) {
    var value$8 = $thiz.bu;
    var hi$17 = (value$8 >> 31);
    var sign$3 = (hi$17 >> 31);
    var xlo$3 = (value$8 ^ sign$3);
    var rlo$3 = ((xlo$3 - sign$3) | 0);
    var rhi$3 = (((hi$17 ^ sign$3) + (((rlo$3 >>> 0) < (xlo$3 >>> 0)) | 0)) | 0);
    var k$2 = (((rhi$3 >>> 0) % 12) | 0);
    var quotLo$2 = ((0.08333333333333337 * ((4.294967296E9 * k$2) + (rlo$3 >>> 0.0))) | 0.0);
    var remLo = ((rlo$3 - Math.imul(12, quotLo$2)) | 0);
    if ((hi$17 < 0)) {
      var lo$9 = ((-remLo) | 0);
      var hi$18 = ((-((lo$9 !== 0) | 0)) | 0);
      return $j_java$002elang$002e$002dObject.$bL(lo$9, hi$18);
    } else {
      return $j_java$002elang$002e$002dObject.$bL(remLo, 0);
    }
  }
  var x$23 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
  if (((x$23 === null) ? (field === null) : (x$23 === field))) {
    var value$9 = $thiz.bu;
    var hi$19 = (value$9 >> 31);
    var sign$4 = (hi$19 >> 31);
    var xlo$4 = (value$9 ^ sign$4);
    var rlo$4 = ((xlo$4 - sign$4) | 0);
    var rhi$4 = (((hi$19 ^ sign$4) + (((rlo$4 >>> 0) < (xlo$4 >>> 0)) | 0)) | 0);
    var k$2$1 = (((rhi$4 >>> 0) % 12) | 0);
    var quotLo$2$1 = ((0.08333333333333337 * ((4.294967296E9 * k$2$1) + (rlo$4 >>> 0.0))) | 0.0);
    var remLo$1 = ((rlo$4 - Math.imul(12, quotLo$2$1)) | 0);
    if ((hi$19 < 0)) {
      var lo$10 = ((-remLo$1) | 0);
      var hi$20 = ((-((lo$10 !== 0) | 0)) | 0);
      var ham_$_lo = lo$10;
      var ham_$_hi = hi$20;
    } else {
      var ham_$_lo = remLo$1;
      var ham_$_hi = 0;
    }
    var sign$5 = (ham_$_hi >> 31);
    var xlo$5 = (ham_$_lo ^ sign$5);
    var rlo$5 = ((xlo$5 - sign$5) | 0);
    var rhi$5 = (((ham_$_hi ^ sign$5) + (((rlo$5 >>> 0) < (xlo$5 >>> 0)) | 0)) | 0);
    var k$2$2 = (((rhi$5 >>> 0) % 12) | 0);
    var quotLo$2$2 = ((0.08333333333333337 * ((4.294967296E9 * k$2$2) + (rlo$5 >>> 0.0))) | 0.0);
    var remLo$2 = ((rlo$5 - Math.imul(12, quotLo$2$2)) | 0);
    if ((ham_$_hi < 0)) {
      var lo$11 = ((-remLo$2) | 0);
      var hi$21 = ((-((lo$11 !== 0) | 0)) | 0);
      var x$16_$_lo = lo$11;
      var x$16_$_hi = hi$21;
    } else {
      var x$16_$_lo = remLo$2;
      var x$16_$_hi = 0;
    }
    if (((x$16_$_lo | x$16_$_hi) === 0)) {
      return $j_java$002elang$002e$002dObject.$bL(12, 0);
    } else {
      return $j_java$002elang$002e$002dObject.$bL(ham_$_lo, ham_$_hi);
    }
  }
  var x$25 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  if (((x$25 === null) ? (field === null) : (x$25 === field))) {
    var value$10 = $thiz.bu;
    var hi$22 = (value$10 >> 31);
    return $j_java$002elang$002e$002dObject.$bL(value$10, hi$22);
  }
  var x$27 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
  if (((x$27 === null) ? (field === null) : (x$27 === field))) {
    if (($thiz.bu === 0)) {
      return $j_java$002elang$002e$002dObject.$bL(24, 0);
    } else {
      var value$11 = $thiz.bu;
      var hi$23 = (value$11 >> 31);
      return $j_java$002elang$002e$002dObject.$bL(value$11, hi$23);
    }
  }
  var x$29 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField();
  if (((x$29 === null) ? (field === null) : (x$29 === field))) {
    var value$12 = $thiz.bu;
    var hi$24 = (value$12 >> 31);
    var sign$6 = (hi$24 >> 31);
    var xlo$6 = (value$12 ^ sign$6);
    var rlo$6 = ((xlo$6 - sign$6) | 0);
    var rhi$6 = (((hi$24 ^ sign$6) + (((rlo$6 >>> 0) < (xlo$6 >>> 0)) | 0)) | 0);
    var quotHi$1 = (((rhi$6 >>> 0) / 12) | 0);
    var k$1 = ((rhi$6 - Math.imul(12, quotHi$1)) | 0);
    var quotLo$1 = ((0.08333333333333337 * ((4.294967296E9 * k$1) + (rlo$6 >>> 0.0))) | 0.0);
    if ((hi$24 < 0)) {
      var lo$12 = ((-quotLo$1) | 0);
      var hi$25 = ((((-quotHi$1) | 0) - ((lo$12 !== 0) | 0)) | 0);
      return $j_java$002elang$002e$002dObject.$bL(lo$12, hi$25);
    } else {
      return $j_java$002elang$002e$002dObject.$bL(quotLo$1, quotHi$1);
    }
  }
  throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
}
export { $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J as $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J };
/** @constructor */
function $c_Ljava_time_LocalTime(_hour, _minute, _second, nano) {
  this.cv = 0;
  this.bu = 0;
  this.dh = 0;
  this.di = 0;
  this.cv = nano;
  this.bu = ((_hour << 24) >> 24);
  this.dh = ((_minute << 24) >> 24);
  this.di = ((_second << 24) >> 24);
}
export { $c_Ljava_time_LocalTime as $c_Ljava_time_LocalTime };
$p = $c_Ljava_time_LocalTime.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_LocalTime;
/** @constructor */
function $h_Ljava_time_LocalTime() {
}
export { $h_Ljava_time_LocalTime as $h_Ljava_time_LocalTime };
$h_Ljava_time_LocalTime.prototype = $p;
$p.ba = (function(field) {
  return ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField) ? field.r6() : ((field !== null) && this.ba(field)));
});
$p.bX = (function(field) {
  return $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this, field);
});
$p.cC = (function(field) {
  if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    var $x_1 = $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J(this, field);
    return $j_java$002elang$002e$002dObject.$s_RTLong__toInt__I__I__I($x_1.l, $x_1.h);
  } else {
    return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field);
  }
});
$p.ai = (function(field) {
  if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    if ((field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField())) {
      return this.iv();
    }
    if ((field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField())) {
      var $x_1 = this.iv();
      var num_$_lo = $x_1.l;
      var num_$_hi = $x_1.h;
      var sign = (num_$_hi >> 31);
      var xlo = (num_$_lo ^ sign);
      var rlo = ((xlo - sign) | 0);
      var rhi = (((num_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
      var quotHi = (((rhi >>> 0) / 1000) | 0);
      var k = ((rhi - Math.imul(1000, quotHi)) | 0);
      var quotLo = ((0.0010000000000000005 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
      if ((num_$_hi < 0)) {
        var lo = ((-quotLo) | 0);
        var hi = ((((-quotHi) | 0) - ((lo !== 0) | 0)) | 0);
        return $j_java$002elang$002e$002dObject.$bL(lo, hi);
      } else {
        return $j_java$002elang$002e$002dObject.$bL(quotLo, quotHi);
      }
    }
    return $p_Ljava_time_LocalTime__get0__Ljava_time_temporal_TemporalField__J(this, field);
  } else {
    return this.ai(field);
  }
});
$p.CM = (function(field, newValue_$_lo, newValue_$_hi) {
  if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    field.G.ak(newValue_$_lo, newValue_$_hi, field);
    var x = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      return this.CN(newValue_$_lo);
    }
    var x$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
    if (((x$3 === null) ? (field === null) : (x$3 === field))) {
      return $m_Ljava_time_LocalTime$().l5(newValue_$_lo, newValue_$_hi);
    }
    var x$5 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x$5 === null) ? (field === null) : (x$5 === field))) {
      return this.CN(Math.imul(1000, newValue_$_lo));
    }
    var x$7 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MICRO_OF_DAY__Ljava_time_temporal_ChronoField();
    if (((x$7 === null) ? (field === null) : (x$7 === field))) {
      var $x_1 = $m_Ljava_time_LocalTime$();
      var b0 = (65535 & newValue_$_lo);
      var b1 = ((newValue_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(1000, b0);
      var a0b1 = Math.imul(1000, b1);
      var lo = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi = ((Math.imul(1000, newValue_$_hi) + ((c1part >>> 16) | 0)) | 0);
      return $x_1.l5(lo, hi);
    }
    var x$9 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_SECOND__Ljava_time_temporal_ChronoField();
    if (((x$9 === null) ? (field === null) : (x$9 === field))) {
      return this.CN(Math.imul(1000000, newValue_$_lo));
    }
    var x$11 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MILLI_OF_DAY__Ljava_time_temporal_ChronoField();
    if (((x$11 === null) ? (field === null) : (x$11 === field))) {
      var $x_2 = $m_Ljava_time_LocalTime$();
      var b0$1 = (65535 & newValue_$_lo);
      var b1$1 = ((newValue_$_lo >>> 16) | 0);
      var a0b0$1 = Math.imul(16960, b0$1);
      var a1b0 = Math.imul(15, b0$1);
      var a0b1$1 = Math.imul(16960, b1$1);
      var lo$1 = ((a0b0$1 + (((a1b0 + a0b1$1) | 0) << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$1 = ((((((Math.imul(1000000, newValue_$_hi) + Math.imul(15, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0) | 0) >>> 16) | 0)) | 0);
      return $x_2.l5(lo$1, hi$1);
    }
    var x$13 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
    if (((x$13 === null) ? (field === null) : (x$13 === field))) {
      return this.Yz(newValue_$_lo);
    }
    var x$15 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_DAY__Ljava_time_temporal_ChronoField();
    if (((x$15 === null) ? (field === null) : (x$15 === field))) {
      var value = this.uF();
      var hi$2 = (value >> 31);
      var lo$2 = ((newValue_$_lo - value) | 0);
      var hi$3 = ((((newValue_$_hi - hi$2) | 0) - (((lo$2 >>> 0) > (newValue_$_lo >>> 0)) | 0)) | 0);
      return this.PU(lo$2, hi$3);
    }
    var x$17 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    if (((x$17 === null) ? (field === null) : (x$17 === field))) {
      return this.Yx(newValue_$_lo);
    }
    var x$19 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_DAY__Ljava_time_temporal_ChronoField();
    if (((x$19 === null) ? (field === null) : (x$19 === field))) {
      var value$1 = ((Math.imul(60, this.bu) + this.dh) | 0);
      var hi$4 = (value$1 >> 31);
      var lo$3 = ((newValue_$_lo - value$1) | 0);
      var hi$5 = ((((newValue_$_hi - hi$4) | 0) - (((lo$3 >>> 0) > (newValue_$_lo >>> 0)) | 0)) | 0);
      return this.PT(lo$3, hi$5);
    }
    var x$21 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
    if (((x$21 === null) ? (field === null) : (x$21 === field))) {
      var value$2 = ((this.bu % 12) | 0);
      var hi$6 = (value$2 >> 31);
      var lo$4 = ((newValue_$_lo - value$2) | 0);
      var hi$7 = ((((newValue_$_hi - hi$6) | 0) - (((lo$4 >>> 0) > (newValue_$_lo >>> 0)) | 0)) | 0);
      return this.uq(lo$4, hi$7);
    }
    var x$23 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_AMPM__Ljava_time_temporal_ChronoField();
    if (((x$23 === null) ? (field === null) : (x$23 === field))) {
      if ((((12 ^ newValue_$_lo) | newValue_$_hi) === 0)) {
        var x$1_$_lo = 0;
        var x$1_$_hi = 0;
      } else {
        var x$1_$_lo = newValue_$_lo;
        var x$1_$_hi = newValue_$_hi;
      }
      var value$3 = ((this.bu % 12) | 0);
      var hi$8 = (value$3 >> 31);
      var lo$5 = ((x$1_$_lo - value$3) | 0);
      var hi$9 = ((((x$1_$_hi - hi$8) | 0) - (((lo$5 >>> 0) > (x$1_$_lo >>> 0)) | 0)) | 0);
      return this.uq(lo$5, hi$9);
    }
    var x$25 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    if (((x$25 === null) ? (field === null) : (x$25 === field))) {
      return this.QZ(newValue_$_lo);
    }
    var x$27 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__CLOCK_HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    if (((x$27 === null) ? (field === null) : (x$27 === field))) {
      if ((((24 ^ newValue_$_lo) | newValue_$_hi) === 0)) {
        var $x_3_$_lo = 0;
        var $x_3_$_hi = 0;
      } else {
        var $x_3_$_lo = newValue_$_lo;
        var $x_3_$_hi = newValue_$_hi;
      }
      return this.QZ($x_3_$_lo);
    }
    var x$29 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__AMPM_OF_DAY__Ljava_time_temporal_ChronoField();
    if (((x$29 === null) ? (field === null) : (x$29 === field))) {
      var value$4 = ((this.bu / 12) | 0);
      var hi$10 = (value$4 >> 31);
      var lo$6 = ((newValue_$_lo - value$4) | 0);
      var hi$11 = ((((newValue_$_hi - hi$10) | 0) - (((lo$6 >>> 0) > (newValue_$_lo >>> 0)) | 0)) | 0);
      var b0$2 = (65535 & lo$6);
      var b1$2 = ((lo$6 >>> 16) | 0);
      var a0b0$2 = Math.imul(12, b0$2);
      var a0b1$2 = Math.imul(12, b1$2);
      var lo$7 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$12 = ((Math.imul(12, hi$11) + ((c1part$2 >>> 16) | 0)) | 0);
      return this.uq(lo$7, hi$12);
    }
    throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return this.CM(field, newValue_$_lo, newValue_$_hi);
  }
});
$p.QZ = (function(hour) {
  if ((this.bu === hour)) {
    return this;
  } else {
    var this$2 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__HOUR_OF_DAY__Ljava_time_temporal_ChronoField();
    var hi = (hour >> 31);
    this$2.G.ak(hour, hi, this$2);
    return $m_Ljava_time_LocalTime$().fT(hour, this.dh, this.di, this.cv);
  }
});
$p.Yx = (function(minute) {
  if ((this.dh === minute)) {
    return this;
  } else {
    var this$2 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MINUTE_OF_HOUR__Ljava_time_temporal_ChronoField();
    var hi = (minute >> 31);
    this$2.G.ak(minute, hi, this$2);
    return $m_Ljava_time_LocalTime$().fT(this.bu, minute, this.di, this.cv);
  }
});
$p.Yz = (function(second) {
  if ((this.di === second)) {
    return this;
  } else {
    var this$2 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__SECOND_OF_MINUTE__Ljava_time_temporal_ChronoField();
    var hi = (second >> 31);
    this$2.G.ak(second, hi, this$2);
    return $m_Ljava_time_LocalTime$().fT(this.bu, this.dh, second, this.cv);
  }
});
$p.CN = (function(nanoOfSecond) {
  if ((this.cv === nanoOfSecond)) {
    return this;
  } else {
    var this$2 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_SECOND__Ljava_time_temporal_ChronoField();
    var hi = (nanoOfSecond >> 31);
    this$2.G.ak(nanoOfSecond, hi, this$2);
    return $m_Ljava_time_LocalTime$().fT(this.bu, this.dh, this.di, nanoOfSecond);
  }
});
$p.uo = (function(amountToAdd_$_lo, amountToAdd_$_hi, unit) {
  if ((unit instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$c_Ljava_time_temporal_ChronoUnit)) {
    var x = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
    if (((x === null) ? (unit === null) : (x === unit))) {
      return this.Ci(amountToAdd_$_lo, amountToAdd_$_hi);
    }
    var x$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
    if (((x$3 === null) ? (unit === null) : (x$3 === unit))) {
      var sign = (amountToAdd_$_hi >> 31);
      var xlo = (amountToAdd_$_lo ^ sign);
      var rlo = ((xlo - sign) | 0);
      var rhi = (((amountToAdd_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
      var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
      var x$1 = (1.1574074074074087E-11 * aHat);
      var lo = (x$1 | 0.0);
      var hi = ((2.3283064365386963E-10 * x$1) | 0.0);
      var b0 = (65535 & lo);
      var b1 = ((lo >>> 16) | 0);
      var a0b0 = Math.imul(24576, b0);
      var a1b0 = Math.imul(7639, b0);
      var a0b1 = Math.imul(24576, b1);
      var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi$1 = ((((((((Math.imul(500654080, hi) + Math.imul(20, lo)) | 0) + Math.imul(7639, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
      var lo$2 = ((rlo - lo$1) | 0);
      var hi$2 = ((((rhi - hi$1) | 0) - (((lo$2 >>> 0) > (rlo >>> 0)) | 0)) | 0);
      if ((hi$2 < 0)) {
        var lo$3 = ((500654080 + lo$2) | 0);
        var hi$3 = ((((20 + hi$2) | 0) + (((lo$3 >>> 0) < 500654080) | 0)) | 0);
        var absR_$_lo = lo$3;
        var absR_$_hi = hi$3;
      } else {
        var absR_$_lo = lo$2;
        var absR_$_hi = hi$2;
      }
      if ((amountToAdd_$_hi < 0)) {
        var lo$4 = ((-absR_$_lo) | 0);
        var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
        var x$4_$_lo = lo$4;
        var x$4_$_hi = hi$4;
      } else {
        var x$4_$_lo = absR_$_lo;
        var x$4_$_hi = absR_$_hi;
      }
      var b0$1 = (65535 & x$4_$_lo);
      var b1$1 = ((x$4_$_lo >>> 16) | 0);
      var a0b0$1 = Math.imul(1000, b0$1);
      var a0b1$1 = Math.imul(1000, b1$1);
      var lo$5 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$5 = ((Math.imul(1000, x$4_$_hi) + ((c1part$1 >>> 16) | 0)) | 0);
      return this.Ci(lo$5, hi$5);
    }
    var x$5 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
    if (((x$5 === null) ? (unit === null) : (x$5 === unit))) {
      var sign$1 = (amountToAdd_$_hi >> 31);
      var xlo$1 = (amountToAdd_$_lo ^ sign$1);
      var rlo$1 = ((xlo$1 - sign$1) | 0);
      var rhi$1 = (((amountToAdd_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
      var aHat$1 = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
      var x$6 = (1.1574074074074087E-8 * aHat$1);
      var lo$6 = (x$6 | 0.0);
      ((2.3283064365386963E-10 * x$6) | 0.0);
      var rHat = ((rlo$1 - Math.imul(86400000, lo$6)) | 0);
      if ((rHat < 0)) {
        var lo$7 = ((86400000 + rHat) | 0);
        var absR$1_$_lo = lo$7;
        var absR$1_$_hi = 0;
      } else {
        var absR$1_$_lo = rHat;
        var absR$1_$_hi = 0;
      }
      if ((amountToAdd_$_hi < 0)) {
        var lo$8 = ((-absR$1_$_lo) | 0);
        var hi$7 = ((((-absR$1_$_hi) | 0) - ((lo$8 !== 0) | 0)) | 0);
        var x$8_$_lo = lo$8;
        var x$8_$_hi = hi$7;
      } else {
        var x$8_$_lo = absR$1_$_lo;
        var x$8_$_hi = absR$1_$_hi;
      }
      var b0$2 = (65535 & x$8_$_lo);
      var b1$2 = ((x$8_$_lo >>> 16) | 0);
      var a0b0$2 = Math.imul(16960, b0$2);
      var a1b0$1 = Math.imul(15, b0$2);
      var a0b1$2 = Math.imul(16960, b1$2);
      var lo$9 = ((a0b0$2 + (((a1b0$1 + a0b1$2) | 0) << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$8 = ((((((Math.imul(1000000, x$8_$_hi) + Math.imul(15, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$1) | 0) >>> 16) | 0)) | 0);
      return this.Ci(lo$9, hi$8);
    }
    var x$7$1 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
    if (((x$7$1 === null) ? (unit === null) : (x$7$1 === unit))) {
      return this.PU(amountToAdd_$_lo, amountToAdd_$_hi);
    }
    var x$9 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
    if (((x$9 === null) ? (unit === null) : (x$9 === unit))) {
      return this.PT(amountToAdd_$_lo, amountToAdd_$_hi);
    }
    var x$11 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
    if (((x$11 === null) ? (unit === null) : (x$11 === unit))) {
      return this.uq(amountToAdd_$_lo, amountToAdd_$_hi);
    }
    var x$13 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
    if (((x$13 === null) ? (unit === null) : (x$13 === unit))) {
      var lo$10 = ((amountToAdd_$_hi >>> 31) | 0);
      var lo$11 = ((amountToAdd_$_lo + lo$10) | 0);
      var lo$12 = (1 & lo$11);
      var lo$13 = ((lo$12 - lo$10) | 0);
      var hi$10 = ((-(((lo$13 >>> 0) > (lo$12 >>> 0)) | 0)) | 0);
      var b0$3 = (65535 & lo$13);
      var b1$3 = ((lo$13 >>> 16) | 0);
      var a0b0$3 = Math.imul(12, b0$3);
      var a0b1$3 = Math.imul(12, b1$3);
      var lo$14 = ((a0b0$3 + (a0b1$3 << 16)) | 0);
      var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
      var hi$11 = ((Math.imul(12, hi$10) + ((c1part$3 >>> 16) | 0)) | 0);
      return this.uq(lo$14, hi$11);
    }
    throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit));
  } else {
    return this.uo(amountToAdd_$_lo, amountToAdd_$_hi, unit);
  }
});
$p.uq = (function(hoursToAdd_$_lo, hoursToAdd_$_hi) {
  if (((hoursToAdd_$_lo | hoursToAdd_$_hi) === 0)) {
    return this;
  }
  var $x_2 = $m_Ljava_time_LocalTime$();
  var sign = (hoursToAdd_$_hi >> 31);
  var xlo = (hoursToAdd_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((hoursToAdd_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var k$2 = (((rhi >>> 0) % 24) | 0);
  var quotLo$2 = ((0.041666666666666685 * ((4.294967296E9 * k$2) + (rlo >>> 0.0))) | 0.0);
  var remLo = ((rlo - Math.imul(24, quotLo$2)) | 0);
  if ((hoursToAdd_$_hi < 0)) {
    var lo = ((-remLo) | 0);
    var hi = ((-((lo !== 0) | 0)) | 0);
    var $x_1_$_lo = lo;
    var $x_1_$_hi = hi;
  } else {
    var $x_1_$_lo = remLo;
    var $x_1_$_hi = 0;
  }
  return $x_2.fT(((((24 + (($x_1_$_lo + this.bu) | 0)) | 0) % 24) | 0), this.dh, this.di, this.cv);
});
$p.PT = (function(minutesToAdd_$_lo, minutesToAdd_$_hi) {
  if (((minutesToAdd_$_lo | minutesToAdd_$_hi) === 0)) {
    return this;
  }
  var mofd = ((Math.imul(60, this.bu) + this.dh) | 0);
  var sign = (minutesToAdd_$_hi >> 31);
  var xlo = (minutesToAdd_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((minutesToAdd_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var k$2 = (((rhi >>> 0) % 1440) | 0);
  var quotLo$2 = ((6.944444444444448E-4 * ((4.294967296E9 * k$2) + (rlo >>> 0.0))) | 0.0);
  var remLo = ((rlo - Math.imul(1440, quotLo$2)) | 0);
  if ((minutesToAdd_$_hi < 0)) {
    var lo = ((-remLo) | 0);
    var hi = ((-((lo !== 0) | 0)) | 0);
    var $x_1_$_lo = lo;
    var $x_1_$_hi = hi;
  } else {
    var $x_1_$_lo = remLo;
    var $x_1_$_hi = 0;
  }
  var newMofd = ((((1440 + (($x_1_$_lo + mofd) | 0)) | 0) % 1440) | 0);
  if ((mofd === newMofd)) {
    return this;
  }
  return $m_Ljava_time_LocalTime$().fT(((newMofd / 60) | 0), ((newMofd % 60) | 0), this.di, this.cv);
});
$p.PU = (function(secondstoAdd_$_lo, secondstoAdd_$_hi) {
  if (((secondstoAdd_$_lo | secondstoAdd_$_hi) === 0)) {
    return this;
  }
  var sofd = ((((Math.imul(3600, this.bu) + Math.imul(60, this.dh)) | 0) + this.di) | 0);
  var sign = (secondstoAdd_$_hi >> 31);
  var xlo = (secondstoAdd_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((secondstoAdd_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var k$2 = (((rhi >>> 0) % 86400) | 0);
  var quotLo$2 = ((1.1574074074074079E-5 * ((4.294967296E9 * k$2) + (rlo >>> 0.0))) | 0.0);
  var remLo = ((rlo - Math.imul(86400, quotLo$2)) | 0);
  if ((secondstoAdd_$_hi < 0)) {
    var lo = ((-remLo) | 0);
    var hi = ((-((lo !== 0) | 0)) | 0);
    var $x_1_$_lo = lo;
    var $x_1_$_hi = hi;
  } else {
    var $x_1_$_lo = remLo;
    var $x_1_$_hi = 0;
  }
  var newSofd = ((((86400 + (($x_1_$_lo + sofd) | 0)) | 0) % 86400) | 0);
  if ((sofd === newSofd)) {
    return this;
  }
  return $m_Ljava_time_LocalTime$().fT(((newSofd / 3600) | 0), ((((newSofd / 60) | 0) % 60) | 0), ((newSofd % 60) | 0), this.cv);
});
$p.Ci = (function(nanosToAdd_$_lo, nanosToAdd_$_hi) {
  if (((nanosToAdd_$_lo | nanosToAdd_$_hi) === 0)) {
    return this;
  }
  var $x_1 = this.iv();
  var nofd_$_lo = $x_1.l;
  var nofd_$_hi = $x_1.h;
  var sign = (nanosToAdd_$_hi >> 31);
  var xlo = (nanosToAdd_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((nanosToAdd_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.1574074074074086E-14 * aHat);
  var lo = (x | 0.0);
  var hi = ((2.3283064365386963E-10 * x) | 0.0);
  var b0 = (65535 & lo);
  var b1 = ((lo >>> 16) | 0);
  var a1b0 = Math.imul(37199, b0);
  var lo$1 = (a1b0 << 16);
  var hi$1 = ((((((Math.imul((-1857093632), hi) + Math.imul(20116, lo)) | 0) + Math.imul(37199, b1)) | 0) + ((a1b0 >>> 16) | 0)) | 0);
  var lo$2 = ((rlo - lo$1) | 0);
  var hi$2 = ((((rhi - hi$1) | 0) - (((lo$2 >>> 0) > (rlo >>> 0)) | 0)) | 0);
  if ((hi$2 < 0)) {
    var lo$3 = ((lo$2 - 1857093632) | 0);
    var hi$3 = ((((20116 + hi$2) | 0) + (((lo$3 >>> 0) < 2437873664) | 0)) | 0);
    var absR_$_lo = lo$3;
    var absR_$_hi = hi$3;
  } else {
    var absR_$_lo = lo$2;
    var absR_$_hi = hi$2;
  }
  if ((nanosToAdd_$_hi < 0)) {
    var lo$4 = ((-absR_$_lo) | 0);
    var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
    var x$2_$_lo = lo$4;
    var x$2_$_hi = hi$4;
  } else {
    var x$2_$_lo = absR_$_lo;
    var x$2_$_hi = absR_$_hi;
  }
  var lo$5 = ((x$2_$_lo + nofd_$_lo) | 0);
  var hi$5 = ((((x$2_$_hi + nofd_$_hi) | 0) + (((lo$5 >>> 0) < (x$2_$_lo >>> 0)) | 0)) | 0);
  var lo$6 = ((lo$5 - 1857093632) | 0);
  var hi$6 = ((((20116 + hi$5) | 0) + (((lo$6 >>> 0) < 2437873664) | 0)) | 0);
  var sign$1 = (hi$6 >> 31);
  var xlo$1 = (lo$6 ^ sign$1);
  var rlo$1 = ((xlo$1 - sign$1) | 0);
  var rhi$1 = (((hi$6 ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  var aHat$1 = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
  var x$3 = (1.1574074074074086E-14 * aHat$1);
  var lo$7 = (x$3 | 0.0);
  var hi$7 = ((2.3283064365386963E-10 * x$3) | 0.0);
  var b0$1 = (65535 & lo$7);
  var b1$1 = ((lo$7 >>> 16) | 0);
  var a1b0$1 = Math.imul(37199, b0$1);
  var lo$8 = (a1b0$1 << 16);
  var hi$8 = ((((((Math.imul((-1857093632), hi$7) + Math.imul(20116, lo$7)) | 0) + Math.imul(37199, b1$1)) | 0) + ((a1b0$1 >>> 16) | 0)) | 0);
  var lo$9 = ((rlo$1 - lo$8) | 0);
  var hi$9 = ((((rhi$1 - hi$8) | 0) - (((lo$9 >>> 0) > (rlo$1 >>> 0)) | 0)) | 0);
  if ((hi$9 < 0)) {
    var lo$10 = ((lo$9 - 1857093632) | 0);
    var hi$10 = ((((20116 + hi$9) | 0) + (((lo$10 >>> 0) < 2437873664) | 0)) | 0);
    var absR$1_$_lo = lo$10;
    var absR$1_$_hi = hi$10;
  } else {
    var absR$1_$_lo = lo$9;
    var absR$1_$_hi = hi$9;
  }
  if ((hi$6 < 0)) {
    var lo$11 = ((-absR$1_$_lo) | 0);
    var hi$11 = ((((-absR$1_$_hi) | 0) - ((lo$11 !== 0) | 0)) | 0);
    var newNofd_$_lo = lo$11;
    var newNofd_$_hi = hi$11;
  } else {
    var newNofd_$_lo = absR$1_$_lo;
    var newNofd_$_hi = absR$1_$_hi;
  }
  if ((((nofd_$_lo ^ newNofd_$_lo) | (nofd_$_hi ^ newNofd_$_hi)) === 0)) {
    return this;
  }
  var sign$2 = (newNofd_$_hi >> 31);
  var xlo$2 = (newNofd_$_lo ^ sign$2);
  var rlo$2 = ((xlo$2 - sign$2) | 0);
  var rhi$2 = (((newNofd_$_hi ^ sign$2) + (((rlo$2 >>> 0) < (xlo$2 >>> 0)) | 0)) | 0);
  var aHat$2 = ((4.294967296E9 * (rhi$2 >>> 0.0)) + (rlo$2 >>> 0.0));
  var x$5 = (2.777777777777782E-13 * aHat$2);
  var lo$12 = (x$5 | 0.0);
  var hi$12 = ((2.3283064365386963E-10 * x$5) | 0.0);
  var b0$2 = (65535 & lo$12);
  var b1$2 = ((lo$12 >>> 16) | 0);
  var a0b0 = Math.imul(40960, b0$2);
  var a1b0$2 = Math.imul(12472, b0$2);
  var a0b1 = Math.imul(40960, b1$2);
  var lo$13 = ((a0b0 + (((a1b0$2 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$13 = ((((((((Math.imul(817405952, hi$12) + Math.imul(838, lo$12)) | 0) + Math.imul(12472, b1$2)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var lo$14 = ((rlo$2 - lo$13) | 0);
  var hi$14 = ((((rhi$2 - hi$13) | 0) - (((lo$14 >>> 0) > (rlo$2 >>> 0)) | 0)) | 0);
  if ((hi$14 < 0)) {
    var lo$15 = ((lo$12 - 1) | 0);
    var hi$15 = ((((hi$12 - 1) | 0) + ((lo$15 !== (-1)) | 0)) | 0);
    var absR$2_$_lo = lo$15;
    var absR$2_$_hi = hi$15;
  } else {
    var absR$2_$_lo = lo$12;
    var absR$2_$_hi = hi$12;
  }
  if ((newNofd_$_hi < 0)) {
    var lo$16 = ((-absR$2_$_lo) | 0);
    var hi$16 = ((((-absR$2_$_hi) | 0) - ((lo$16 !== 0) | 0)) | 0);
    var x$7_$_lo = lo$16;
    var x$7_$_hi = hi$16;
  } else {
    var x$7_$_lo = absR$2_$_lo;
    var x$7_$_hi = absR$2_$_hi;
  }
  var sign$3 = (newNofd_$_hi >> 31);
  var xlo$3 = (newNofd_$_lo ^ sign$3);
  var rlo$3 = ((xlo$3 - sign$3) | 0);
  var rhi$3 = (((newNofd_$_hi ^ sign$3) + (((rlo$3 >>> 0) < (xlo$3 >>> 0)) | 0)) | 0);
  var aHat$3 = ((4.294967296E9 * (rhi$3 >>> 0.0)) + (rlo$3 >>> 0.0));
  var x$8 = (1.6666666666666693E-11 * aHat$3);
  var lo$17 = (x$8 | 0.0);
  var hi$17 = ((2.3283064365386963E-10 * x$8) | 0.0);
  var b0$3 = (65535 & lo$17);
  var b1$3 = ((lo$17 >>> 16) | 0);
  var a0b0$1 = Math.imul(22528, b0$3);
  var a1b0$3 = Math.imul(63559, b0$3);
  var a0b1$1 = Math.imul(22528, b1$3);
  var lo$18 = ((a0b0$1 + (((a1b0$3 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$18 = ((((((((Math.imul((-129542144), hi$17) + Math.imul(13, lo$17)) | 0) + Math.imul(63559, b1$3)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$19 = ((rlo$3 - lo$18) | 0);
  var hi$19 = ((((rhi$3 - hi$18) | 0) - (((lo$19 >>> 0) > (rlo$3 >>> 0)) | 0)) | 0);
  if ((hi$19 < 0)) {
    var lo$20 = ((lo$17 - 1) | 0);
    var hi$20 = ((((hi$17 - 1) | 0) + ((lo$20 !== (-1)) | 0)) | 0);
    var absR$3_$_lo = lo$20;
    var absR$3_$_hi = hi$20;
  } else {
    var absR$3_$_lo = lo$17;
    var absR$3_$_hi = hi$17;
  }
  if ((newNofd_$_hi < 0)) {
    var lo$21 = ((-absR$3_$_lo) | 0);
    var hi$21 = ((((-absR$3_$_hi) | 0) - ((lo$21 !== 0) | 0)) | 0);
    var num_$_lo = lo$21;
    var num_$_hi = hi$21;
  } else {
    var num_$_lo = absR$3_$_lo;
    var num_$_hi = absR$3_$_hi;
  }
  var sign$4 = (num_$_hi >> 31);
  var xlo$4 = (num_$_lo ^ sign$4);
  var rlo$4 = ((xlo$4 - sign$4) | 0);
  var rhi$4 = (((num_$_hi ^ sign$4) + (((rlo$4 >>> 0) < (xlo$4 >>> 0)) | 0)) | 0);
  var k$2 = (((rhi$4 >>> 0) % 60) | 0);
  var quotLo$2 = ((0.016666666666666673 * ((4.294967296E9 * k$2) + (rlo$4 >>> 0.0))) | 0.0);
  var remLo = ((rlo$4 - Math.imul(60, quotLo$2)) | 0);
  if ((num_$_hi < 0)) {
    var lo$22 = ((-remLo) | 0);
    var hi$22 = ((-((lo$22 !== 0) | 0)) | 0);
    var x$11_$_lo = lo$22;
    var x$11_$_hi = hi$22;
  } else {
    var x$11_$_lo = remLo;
    var x$11_$_hi = 0;
  }
  var sign$5 = (newNofd_$_hi >> 31);
  var xlo$5 = (newNofd_$_lo ^ sign$5);
  var rlo$5 = ((xlo$5 - sign$5) | 0);
  var rhi$5 = (((newNofd_$_hi ^ sign$5) + (((rlo$5 >>> 0) < (xlo$5 >>> 0)) | 0)) | 0);
  var aHat$4 = ((4.294967296E9 * (rhi$5 >>> 0.0)) + (rlo$5 >>> 0.0));
  var x$12 = (1.0000000000000017E-9 * aHat$4);
  var lo$23 = (x$12 | 0.0);
  var hi$23 = ((2.3283064365386963E-10 * x$12) | 0.0);
  var rHat = ((rlo$5 - Math.imul(1000000000, lo$23)) | 0);
  if ((rHat < 0)) {
    var lo$24 = ((lo$23 - 1) | 0);
    var hi$24 = ((((hi$23 - 1) | 0) + ((lo$24 !== (-1)) | 0)) | 0);
    var absR$4_$_lo = lo$24;
    var absR$4_$_hi = hi$24;
  } else {
    var absR$4_$_lo = lo$23;
    var absR$4_$_hi = hi$23;
  }
  if ((newNofd_$_hi < 0)) {
    var lo$25 = ((-absR$4_$_lo) | 0);
    var hi$25 = ((((-absR$4_$_hi) | 0) - ((lo$25 !== 0) | 0)) | 0);
    var num$1_$_lo = lo$25;
    var num$1_$_hi = hi$25;
  } else {
    var num$1_$_lo = absR$4_$_lo;
    var num$1_$_hi = absR$4_$_hi;
  }
  var sign$6 = (num$1_$_hi >> 31);
  var xlo$6 = (num$1_$_lo ^ sign$6);
  var rlo$6 = ((xlo$6 - sign$6) | 0);
  var rhi$6 = (((num$1_$_hi ^ sign$6) + (((rlo$6 >>> 0) < (xlo$6 >>> 0)) | 0)) | 0);
  var k$2$1 = (((rhi$6 >>> 0) % 60) | 0);
  var quotLo$2$1 = ((0.016666666666666673 * ((4.294967296E9 * k$2$1) + (rlo$6 >>> 0.0))) | 0.0);
  var remLo$1 = ((rlo$6 - Math.imul(60, quotLo$2$1)) | 0);
  if ((num$1_$_hi < 0)) {
    var lo$26 = ((-remLo$1) | 0);
    var hi$26 = ((-((lo$26 !== 0) | 0)) | 0);
    var x$15_$_lo = lo$26;
    var x$15_$_hi = hi$26;
  } else {
    var x$15_$_lo = remLo$1;
    var x$15_$_hi = 0;
  }
  var sign$7 = (newNofd_$_hi >> 31);
  var xlo$7 = (newNofd_$_lo ^ sign$7);
  var rlo$7 = ((xlo$7 - sign$7) | 0);
  var rhi$7 = (((newNofd_$_hi ^ sign$7) + (((rlo$7 >>> 0) < (xlo$7 >>> 0)) | 0)) | 0);
  var aHat$5 = ((4.294967296E9 * (rhi$7 >>> 0.0)) + (rlo$7 >>> 0.0));
  var x$16 = (1.0000000000000017E-9 * aHat$5);
  var lo$27 = (x$16 | 0.0);
  ((2.3283064365386963E-10 * x$16) | 0.0);
  var rHat$1 = ((rlo$7 - Math.imul(1000000000, lo$27)) | 0);
  if ((rHat$1 < 0)) {
    var lo$28 = ((1000000000 + rHat$1) | 0);
    var absR$5_$_lo = lo$28;
    var absR$5_$_hi = 0;
  } else {
    var absR$5_$_lo = rHat$1;
    var absR$5_$_hi = 0;
  }
  var $x_3 = $m_Ljava_time_LocalTime$();
  if ((newNofd_$_hi < 0)) {
    var lo$29 = ((-absR$5_$_lo) | 0);
    var hi$28 = ((((-absR$5_$_hi) | 0) - ((lo$29 !== 0) | 0)) | 0);
    var $x_2_$_lo = lo$29;
    var $x_2_$_hi = hi$28;
  } else {
    var $x_2_$_lo = absR$5_$_lo;
    var $x_2_$_hi = absR$5_$_hi;
  }
  return $x_3.fT(x$7_$_lo, x$11_$_lo, x$15_$_lo, $x_2_$_lo);
});
$p.W4 = (function(amountToSubtract_$_lo, amountToSubtract_$_hi, unit) {
  if (((amountToSubtract_$_lo | ((-2147483648) ^ amountToSubtract_$_hi)) === 0)) {
    return this.uo((-1), 2147483647, unit).uo(1, 0, unit);
  } else {
    var lo = ((-amountToSubtract_$_lo) | 0);
    var hi = ((((-amountToSubtract_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
    return this.uo(lo, hi, unit);
  }
});
$p.cg = (function(query) {
  var x = $m_Ljava_time_temporal_TemporalQueries$().gH();
  if (((x === null) ? (query === null) : (x === query))) {
    return $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
  }
  var x$3 = $m_Ljava_time_temporal_TemporalQueries$().ik();
  if (((x$3 === null) ? (query === null) : (x$3 === query))) {
    return this;
  }
  matchAlts1: {
    matchAlts2: {
      var x$5 = $m_Ljava_time_temporal_TemporalQueries$().eR();
      if (((x$5 === null) ? (query === null) : (x$5 === query))) {
        break matchAlts2;
      }
      var x$7 = $m_Ljava_time_temporal_TemporalQueries$().f1();
      if (((x$7 === null) ? (query === null) : (x$7 === query))) {
        break matchAlts2;
      }
      var x$9 = $m_Ljava_time_temporal_TemporalQueries$().hx();
      if (((x$9 === null) ? (query === null) : (x$9 === query))) {
        break matchAlts2;
      }
      var x$11 = $m_Ljava_time_temporal_TemporalQueries$().gF();
      if (((x$11 === null) ? (query === null) : (x$11 === query))) {
        break matchAlts2;
      }
      var x$13 = $m_Ljava_time_temporal_TemporalQueries$().fl();
      if (((x$13 === null) ? (query === null) : (x$13 === query))) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return null;
  }
  return query.dQ(this);
});
$p.he = (function(temporal) {
  var $x_2 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__NANO_OF_DAY__Ljava_time_temporal_ChronoField();
  var $x_1 = this.iv();
  return temporal.fq($x_2, $x_1.l, $x_1.h);
});
$p.uF = (function() {
  var total = Math.imul(3600, this.bu);
  total = ((total + Math.imul(60, this.dh)) | 0);
  total = ((total + this.di) | 0);
  return total;
});
$p.iv = (function() {
  var value = this.bu;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(40960, b0);
  var a1b0 = Math.imul(12472, b0);
  var a0b1 = Math.imul(40960, b1);
  var lo = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((((((((Math.imul(817405952, hi) + Math.imul(838, value)) | 0) + Math.imul(12472, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
  var total_$_lo = lo;
  var total_$_hi = hi$1;
  var x_$_lo = total_$_lo;
  var x_$_hi = total_$_hi;
  var value$1 = this.dh;
  var hi$2 = (value$1 >> 31);
  var b0$1 = (65535 & value$1);
  var b1$1 = ((value$1 >>> 16) | 0);
  var a0b0$1 = Math.imul(22528, b0$1);
  var a1b0$1 = Math.imul(63559, b0$1);
  var a0b1$1 = Math.imul(22528, b1$1);
  var lo$1 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$3 = ((((((((Math.imul((-129542144), hi$2) + Math.imul(13, value$1)) | 0) + Math.imul(63559, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  var lo$2 = ((x_$_lo + lo$1) | 0);
  var hi$4 = ((((x_$_hi + hi$3) | 0) + (((lo$2 >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
  total_$_lo = lo$2;
  total_$_hi = hi$4;
  var x$1_$_lo = total_$_lo;
  var x$1_$_hi = total_$_hi;
  var value$2 = this.di;
  var hi$5 = (value$2 >> 31);
  var b0$2 = (65535 & value$2);
  var b1$2 = ((value$2 >>> 16) | 0);
  var a0b0$2 = Math.imul(51712, b0$2);
  var a1b0$2 = Math.imul(15258, b0$2);
  var a0b1$2 = Math.imul(51712, b1$2);
  var lo$3 = ((a0b0$2 + (((a1b0$2 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$6 = ((((((Math.imul(1000000000, hi$5) + Math.imul(15258, b1$2)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$2) | 0) >>> 16) | 0)) | 0);
  var lo$4 = ((x$1_$_lo + lo$3) | 0);
  var hi$7 = ((((x$1_$_hi + hi$6) | 0) + (((lo$4 >>> 0) < (x$1_$_lo >>> 0)) | 0)) | 0);
  total_$_lo = lo$4;
  total_$_hi = hi$7;
  var x$2_$_lo = total_$_lo;
  var x$2_$_hi = total_$_hi;
  var value$3 = this.cv;
  var hi$8 = (value$3 >> 31);
  var lo$5 = ((x$2_$_lo + value$3) | 0);
  var hi$9 = ((((x$2_$_hi + hi$8) | 0) + (((lo$5 >>> 0) < (x$2_$_lo >>> 0)) | 0)) | 0);
  total_$_lo = lo$5;
  total_$_hi = hi$9;
  return $j_java$002elang$002e$002dObject.$bL(total_$_lo, total_$_hi);
});
$p.x9 = (function(other) {
  var x = this.bu;
  var y = other.bu;
  var cmp = ((x === y) ? 0 : ((x < y) ? (-1) : 1));
  if ((cmp === 0)) {
    var x$1 = this.dh;
    var y$1 = other.dh;
    cmp = ((x$1 === y$1) ? 0 : ((x$1 < y$1) ? (-1) : 1));
    if ((cmp === 0)) {
      var x$2 = this.di;
      var y$2 = other.di;
      cmp = ((x$2 === y$2) ? 0 : ((x$2 < y$2) ? (-1) : 1));
      if ((cmp === 0)) {
        var x$3 = this.cv;
        var y$3 = other.cv;
        cmp = ((x$3 === y$3) ? 0 : ((x$3 < y$3) ? (-1) : 1));
      }
    }
  }
  return cmp;
});
$p.f = (function(obj) {
  return ((obj instanceof $c_Ljava_time_LocalTime) && ((this === obj) || ((((this.bu === obj.bu) && (this.dh === obj.dh)) && (this.di === obj.di)) && (this.cv === obj.cv))));
});
$p.m = (function() {
  var $x_1 = this.iv();
  var nod_$_lo = $x_1.l;
  var nod_$_hi = $x_1.h;
  return (nod_$_lo ^ nod_$_hi);
});
$p.b = (function() {
  var buf = $j_java$002elang$002e$002dObject.$ct_scm_StringBuilder__I__(new $j_java$002elang$002e$002dObject.$c_scm_StringBuilder(), 18);
  var hourValue = this.bu;
  var minuteValue = this.dh;
  var secondValue = this.di;
  var nanoValue = this.cv;
  buf.eQ(((hourValue < 10) ? "0" : "")).d9(hourValue).eQ(((minuteValue < 10) ? ":0" : ":")).d9(minuteValue);
  if (((secondValue > 0) || (nanoValue > 0))) {
    buf.eQ(((secondValue < 10) ? ":0" : ":")).d9(secondValue);
    if ((nanoValue > 0)) {
      buf.ia(46);
      if ((((nanoValue % 1000000) | 0) === 0)) {
        var i = ((1000 + ((nanoValue / 1000000) | 0)) | 0);
        var this$2 = ("" + i);
        buf.eQ(this$2.substring(1));
      } else if ((((nanoValue % 1000) | 0) === 0)) {
        var i$1 = ((1000000 + ((nanoValue / 1000) | 0)) | 0);
        var this$6 = ("" + i$1);
        buf.eQ(this$6.substring(1));
      } else {
        var i$2 = ((1000000000 + nanoValue) | 0);
        var this$10 = ("" + i$2);
        buf.eQ(this$10.substring(1));
      }
    }
  }
  return buf.ax.r;
});
$p.fq = (function(field, newValue_$_lo, newValue_$_hi) {
  return this.CM(field, newValue_$_lo, newValue_$_hi);
});
$p.is = (function(amountToAdd_$_lo, amountToAdd_$_hi, unit) {
  return this.uo(amountToAdd_$_lo, amountToAdd_$_hi, unit);
});
$p.uj = (function(amountToSubtract_$_lo, amountToSubtract_$_hi, unit) {
  return this.W4(amountToSubtract_$_lo, amountToSubtract_$_hi, unit);
});
$p.ic = (function(that) {
  return this.x9(that);
});
$p.fh = (function(that) {
  return this.x9(that);
});
function $isArrayOf_Ljava_time_LocalTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dA)));
}
export { $isArrayOf_Ljava_time_LocalTime as $isArrayOf_Ljava_time_LocalTime };
var $d_Ljava_time_LocalTime = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_LocalTime, "java.time.LocalTime", ({
  dA: 1,
  G: 1,
  bs: 1,
  I: 1,
  j: 1,
  aK: 1,
  a: 1
}));
export { $d_Ljava_time_LocalTime as $d_Ljava_time_LocalTime };
/** @constructor */
function $c_Ljava_time_ZoneOffset(totalSeconds) {
  this.dj = 0;
  this.lS = null;
  this.dj = totalSeconds;
  $ct_Ljava_time_ZoneId__(this);
  this.lS = $m_Ljava_time_ZoneOffset$().VE(totalSeconds);
}
export { $c_Ljava_time_ZoneOffset as $c_Ljava_time_ZoneOffset };
$p = $c_Ljava_time_ZoneOffset.prototype = new $h_Ljava_time_ZoneId();
$p.constructor = $c_Ljava_time_ZoneOffset;
/** @constructor */
function $h_Ljava_time_ZoneOffset() {
}
export { $h_Ljava_time_ZoneOffset as $h_Ljava_time_ZoneOffset };
$h_Ljava_time_ZoneOffset.prototype = $p;
$p.ba = (function(field) {
  return ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField) ? (field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField()) : ((field !== null) && this.ba(field)));
});
$p.bX = (function(field) {
  if ((field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) {
    return field.G;
  } else if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return this.bX(field);
  }
});
$p.cC = (function(field) {
  if ((field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) {
    return this.dj;
  } else {
    if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
      throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
    }
    var $x_2 = this.bX(field);
    var $x_1 = this.ai(field);
    return $x_2.b0($x_1.l, $x_1.h, field);
  }
});
$p.ai = (function(field) {
  if ((field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) {
    var value = this.dj;
    var hi = (value >> 31);
    return $j_java$002elang$002e$002dObject.$bL(value, hi);
  } else if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ("Unsupported field: " + field));
  } else {
    return this.ai(field);
  }
});
$p.cg = (function(query) {
  return (((query === $m_Ljava_time_temporal_TemporalQueries$().gF()) || (query === $m_Ljava_time_temporal_TemporalQueries$().hx())) ? this : ((((((query === $m_Ljava_time_temporal_TemporalQueries$().fl()) || (query === $m_Ljava_time_temporal_TemporalQueries$().ik())) || (query === $m_Ljava_time_temporal_TemporalQueries$().gH())) || (query === $m_Ljava_time_temporal_TemporalQueries$().eR())) || (query === $m_Ljava_time_temporal_TemporalQueries$().f1())) ? null : query.dQ(this)));
});
$p.he = (function(temporal) {
  var $x_1 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
  var value = this.dj;
  var hi = (value >> 31);
  return temporal.fq($x_1, value, hi);
});
$p.Oh = (function(other) {
  return ((other.dj - this.dj) | 0);
});
$p.f = (function(obj) {
  return ((obj instanceof $c_Ljava_time_ZoneOffset) && ((this === obj) || (this.dj === obj.dj)));
});
$p.m = (function() {
  return this.dj;
});
$p.b = (function() {
  return this.lS;
});
$p.ic = (function(that) {
  return this.Oh(that);
});
$p.fh = (function(that) {
  return this.Oh(that);
});
function $isArrayOf_Ljava_time_ZoneOffset(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dD)));
}
export { $isArrayOf_Ljava_time_ZoneOffset as $isArrayOf_Ljava_time_ZoneOffset };
var $d_Ljava_time_ZoneOffset = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_ZoneOffset, "java.time.ZoneOffset", ({
  dD: 1,
  dC: 1,
  a: 1,
  G: 1,
  I: 1,
  j: 1,
  aK: 1
}));
export { $d_Ljava_time_ZoneOffset as $d_Ljava_time_ZoneOffset };
function $p_Ljava_time_ZonedDateTime__resolveOffset__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime($thiz, offset) {
  var x$2 = $thiz.eg;
  if (((!((offset === null) ? (x$2 === null) : offset.f(x$2))) && $m_Ljava_time_zone_ZoneRules$().xM($thiz.dA).Vz($thiz.bc, offset))) {
    return new $c_Ljava_time_ZonedDateTime($thiz.bc, offset, $thiz.dA);
  } else {
    return $thiz;
  }
}
export { $p_Ljava_time_ZonedDateTime__resolveOffset__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime as $p_Ljava_time_ZonedDateTime__resolveOffset__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime };
/** @constructor */
function $c_Ljava_time_ZonedDateTime(dateTime, offset, zone) {
  this.bc = null;
  this.eg = null;
  this.dA = null;
  this.bc = dateTime;
  this.eg = offset;
  this.dA = zone;
}
export { $c_Ljava_time_ZonedDateTime as $c_Ljava_time_ZonedDateTime };
$p = $c_Ljava_time_ZonedDateTime.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_ZonedDateTime;
/** @constructor */
function $h_Ljava_time_ZonedDateTime() {
}
export { $h_Ljava_time_ZonedDateTime as $h_Ljava_time_ZonedDateTime };
$h_Ljava_time_ZonedDateTime.prototype = $p;
$p.ba = (function(field) {
  return ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField) || ((field !== null) && this.ba(field)));
});
$p.bX = (function(field) {
  return ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField) ? (((field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField()) || (field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField())) ? field.G : this.bc.bX(field)) : this.bX(field));
});
$p.cC = (function(field) {
  if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    var x = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
    }
    var x$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
    if (((x$3 === null) ? (field === null) : (x$3 === field))) {
      return this.eg.dj;
    }
    return this.bc.cC(field);
  } else {
    return $f_Ljava_time_chrono_ChronoZonedDateTime__get__Ljava_time_temporal_TemporalField__I(this, field);
  }
});
$p.ai = (function(field) {
  if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    var x = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      return $f_Ljava_time_chrono_ChronoZonedDateTime__toEpochSecond__J(this);
    } else {
      var x$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if (((x$3 === null) ? (field === null) : (x$3 === field))) {
        var value = this.eg.dj;
        var hi = (value >> 31);
        return $j_java$002elang$002e$002dObject.$bL(value, hi);
      } else {
        return this.bc.ai(field);
      }
    }
  } else {
    return this.ai(field);
  }
});
$p.QX = (function(field, newValue_$_lo, newValue_$_hi) {
  if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    var x = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__INSTANT_SECONDS__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      return $m_Ljava_time_ZonedDateTime$().BU(newValue_$_lo, newValue_$_hi, this.bc.aO.cv, this.dA);
    } else {
      var x$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__OFFSET_SECONDS__Ljava_time_temporal_ChronoField();
      if (((x$3 === null) ? (field === null) : (x$3 === field))) {
        return $p_Ljava_time_ZonedDateTime__resolveOffset__Ljava_time_ZoneOffset__Ljava_time_ZonedDateTime(this, $m_Ljava_time_ZoneOffset$().ul(field.G.b0(newValue_$_lo, newValue_$_hi, field)));
      } else {
        return $m_Ljava_time_ZonedDateTime$().xN(this.bc.CL(field, newValue_$_lo, newValue_$_hi), this.dA, this.eg);
      }
    }
  } else {
    return this.QX(field, newValue_$_lo, newValue_$_hi);
  }
});
$p.up = (function(amountToAdd_$_lo, amountToAdd_$_hi, unit) {
  return ((unit instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$c_Ljava_time_temporal_ChronoUnit) ? (unit.hk() ? $m_Ljava_time_ZonedDateTime$().xN(this.bc.l8(amountToAdd_$_lo, amountToAdd_$_hi, unit), this.dA, this.eg) : $m_Ljava_time_ZonedDateTime$().Wp(this.bc.l8(amountToAdd_$_lo, amountToAdd_$_hi, unit), this.eg, this.dA)) : this.up(amountToAdd_$_lo, amountToAdd_$_hi, unit));
});
$p.W5 = (function(amountToSubtract_$_lo, amountToSubtract_$_hi, unit) {
  if (((amountToSubtract_$_lo | ((-2147483648) ^ amountToSubtract_$_hi)) === 0)) {
    return this.up((-1), 2147483647, unit).up(1, 0, unit);
  } else {
    var lo = ((-amountToSubtract_$_lo) | 0);
    var hi = ((((-amountToSubtract_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
    return this.up(lo, hi, unit);
  }
});
$p.cg = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().fl()) ? this.bc.aJ : $f_Ljava_time_chrono_ChronoZonedDateTime__query__Ljava_time_temporal_TemporalQuery__O(this, query));
});
$p.f = (function(obj) {
  if ((obj instanceof $c_Ljava_time_ZonedDateTime)) {
    if ((this === obj)) {
      return true;
    } else {
      var x = this.bc;
      var x$2 = obj.bc;
      if (((x === null) ? (x$2 === null) : x.f(x$2))) {
        var x$3 = this.eg;
        var x$4 = obj.eg;
        var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        var x$5 = this.dA;
        var x$6 = obj.dA;
        return ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  var $x_2 = this.bc.m();
  var $x_1 = this.eg.dj;
  var i = this.dA.m();
  return (($x_2 ^ $x_1) ^ ((i << 3) | ((i >>> 29) | 0)));
});
$p.b = (function() {
  var str = (("" + this.bc.b()) + this.eg.lS);
  if ((this.eg !== this.dA)) {
    str = ((str + ("[" + this.dA)) + "]");
  }
  return str;
});
$p.fh = (function(that) {
  return $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I(this, that);
});
$p.fq = (function(field, newValue_$_lo, newValue_$_hi) {
  return this.QX(field, newValue_$_lo, newValue_$_hi);
});
$p.is = (function(amountToAdd_$_lo, amountToAdd_$_hi, unit) {
  return this.up(amountToAdd_$_lo, amountToAdd_$_hi, unit);
});
$p.uj = (function(amountToSubtract_$_lo, amountToSubtract_$_hi, unit) {
  return this.W5(amountToSubtract_$_lo, amountToSubtract_$_hi, unit);
});
$p.ic = (function(that) {
  return $f_Ljava_time_chrono_ChronoZonedDateTime__compare__Ljava_time_chrono_ChronoZonedDateTime__I(this, that);
});
function $isArrayOf_Ljava_time_ZonedDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dE)));
}
export { $isArrayOf_Ljava_time_ZonedDateTime as $isArrayOf_Ljava_time_ZonedDateTime };
var $d_Ljava_time_ZonedDateTime = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_ZonedDateTime, "java.time.ZonedDateTime", ({
  dE: 1,
  G: 1,
  bs: 1,
  j: 1,
  aK: 1,
  cd: 1,
  a: 1
}));
export { $d_Ljava_time_ZonedDateTime as $d_Ljava_time_ZonedDateTime };
function $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J($thiz, field) {
  var x = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
  if (((x === null) ? (field === null) : (x === field))) {
    var value = $thiz.P7().gx();
    var hi = (value >> 31);
    return $j_java$002elang$002e$002dObject.$bL(value, hi);
  }
  var x$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField();
  if (((x$3 === null) ? (field === null) : (x$3 === field))) {
    var value$1 = $thiz.ee;
    var hi$1 = (value$1 >> 31);
    var lo = ((value$1 - 1) | 0);
    var hi$2 = ((((hi$1 - 1) | 0) + ((lo !== (-1)) | 0)) | 0);
    var sign = (hi$2 >> 31);
    var xlo = (lo ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((hi$2 ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var k$2 = (((rhi >>> 0) % 7) | 0);
    var quotLo$2 = ((0.14285714285714293 * ((4.294967296E9 * k$2) + (rlo >>> 0.0))) | 0.0);
    var remLo = ((rlo - Math.imul(7, quotLo$2)) | 0);
    if ((hi$2 < 0)) {
      var lo$1 = ((-remLo) | 0);
      var hi$3 = ((-((lo$1 !== 0) | 0)) | 0);
      var x$2_$_lo = lo$1;
      var x$2_$_hi = hi$3;
    } else {
      var x$2_$_lo = remLo;
      var x$2_$_hi = 0;
    }
    var lo$2 = ((1 + x$2_$_lo) | 0);
    var hi$4 = ((x$2_$_hi + ((lo$2 === 0) | 0)) | 0);
    return $j_java$002elang$002e$002dObject.$bL(lo$2, hi$4);
  }
  var x$5 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField();
  if (((x$5 === null) ? (field === null) : (x$5 === field))) {
    var value$2 = $thiz.xm();
    var hi$5 = (value$2 >> 31);
    var lo$3 = ((value$2 - 1) | 0);
    var hi$6 = ((((hi$5 - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
    var sign$1 = (hi$6 >> 31);
    var xlo$1 = (lo$3 ^ sign$1);
    var rlo$1 = ((xlo$1 - sign$1) | 0);
    var rhi$1 = (((hi$6 ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
    var k$2$1 = (((rhi$1 >>> 0) % 7) | 0);
    var quotLo$2$1 = ((0.14285714285714293 * ((4.294967296E9 * k$2$1) + (rlo$1 >>> 0.0))) | 0.0);
    var remLo$1 = ((rlo$1 - Math.imul(7, quotLo$2$1)) | 0);
    if ((hi$6 < 0)) {
      var lo$4 = ((-remLo$1) | 0);
      var hi$7 = ((-((lo$4 !== 0) | 0)) | 0);
      var x$6_$_lo = lo$4;
      var x$6_$_hi = hi$7;
    } else {
      var x$6_$_lo = remLo$1;
      var x$6_$_hi = 0;
    }
    var lo$5 = ((1 + x$6_$_lo) | 0);
    var hi$8 = ((x$6_$_hi + ((lo$5 === 0) | 0)) | 0);
    return $j_java$002elang$002e$002dObject.$bL(lo$5, hi$8);
  }
  var x$7 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
  if (((x$7 === null) ? (field === null) : (x$7 === field))) {
    var value$3 = $thiz.ee;
    var hi$9 = (value$3 >> 31);
    return $j_java$002elang$002e$002dObject.$bL(value$3, hi$9);
  }
  var x$9 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
  if (((x$9 === null) ? (field === null) : (x$9 === field))) {
    var value$4 = $thiz.xm();
    var hi$10 = (value$4 >> 31);
    return $j_java$002elang$002e$002dObject.$bL(value$4, hi$10);
  }
  var x$11 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
  if (((x$11 === null) ? (field === null) : (x$11 === field))) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
  }
  var x$13 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
  if (((x$13 === null) ? (field === null) : (x$13 === field))) {
    var value$5 = $thiz.ee;
    var hi$11 = (value$5 >> 31);
    var lo$6 = ((value$5 - 1) | 0);
    var hi$12 = ((((hi$11 - 1) | 0) + ((lo$6 !== (-1)) | 0)) | 0);
    var sign$2 = (hi$12 >> 31);
    var xlo$2 = (lo$6 ^ sign$2);
    var rlo$2 = ((xlo$2 - sign$2) | 0);
    var rhi$2 = (((hi$12 ^ sign$2) + (((rlo$2 >>> 0) < (xlo$2 >>> 0)) | 0)) | 0);
    var quotHi = (((rhi$2 >>> 0) / 7) | 0);
    var k = ((rhi$2 - Math.imul(7, quotHi)) | 0);
    var quotLo = ((0.14285714285714293 * ((4.294967296E9 * k) + (rlo$2 >>> 0.0))) | 0.0);
    if ((hi$12 < 0)) {
      var lo$7 = ((-quotLo) | 0);
      var hi$13 = ((((-quotHi) | 0) - ((lo$7 !== 0) | 0)) | 0);
      var x$10_$_lo = lo$7;
      var x$10_$_hi = hi$13;
    } else {
      var x$10_$_lo = quotLo;
      var x$10_$_hi = quotHi;
    }
    var lo$8 = ((1 + x$10_$_lo) | 0);
    var hi$14 = ((x$10_$_hi + ((lo$8 === 0) | 0)) | 0);
    return $j_java$002elang$002e$002dObject.$bL(lo$8, hi$14);
  }
  var x$15 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField();
  if (((x$15 === null) ? (field === null) : (x$15 === field))) {
    var value$6 = $thiz.xm();
    var hi$15 = (value$6 >> 31);
    var lo$9 = ((value$6 - 1) | 0);
    var hi$16 = ((((hi$15 - 1) | 0) + ((lo$9 !== (-1)) | 0)) | 0);
    var sign$3 = (hi$16 >> 31);
    var xlo$3 = (lo$9 ^ sign$3);
    var rlo$3 = ((xlo$3 - sign$3) | 0);
    var rhi$3 = (((hi$16 ^ sign$3) + (((rlo$3 >>> 0) < (xlo$3 >>> 0)) | 0)) | 0);
    var quotHi$1 = (((rhi$3 >>> 0) / 7) | 0);
    var k$1 = ((rhi$3 - Math.imul(7, quotHi$1)) | 0);
    var quotLo$1 = ((0.14285714285714293 * ((4.294967296E9 * k$1) + (rlo$3 >>> 0.0))) | 0.0);
    if ((hi$16 < 0)) {
      var lo$10 = ((-quotLo$1) | 0);
      var hi$17 = ((((-quotHi$1) | 0) - ((lo$10 !== 0) | 0)) | 0);
      var x$14_$_lo = lo$10;
      var x$14_$_hi = hi$17;
    } else {
      var x$14_$_lo = quotLo$1;
      var x$14_$_hi = quotHi$1;
    }
    var lo$11 = ((1 + x$14_$_lo) | 0);
    var hi$18 = ((x$14_$_hi + ((lo$11 === 0) | 0)) | 0);
    return $j_java$002elang$002e$002dObject.$bL(lo$11, hi$18);
  }
  var x$17 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
  if (((x$17 === null) ? (field === null) : (x$17 === field))) {
    var value$7 = $thiz.dX;
    var hi$19 = (value$7 >> 31);
    return $j_java$002elang$002e$002dObject.$bL(value$7, hi$19);
  }
  var x$19 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField();
  if (((x$19 === null) ? (field === null) : (x$19 === field))) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), ("Field too large for an int: " + field));
  }
  var x$21 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
  if (((x$21 === null) ? (field === null) : (x$21 === field))) {
    if (($thiz.bi >= 1)) {
      var value$8 = $thiz.bi;
      var hi$20 = (value$8 >> 31);
      return $j_java$002elang$002e$002dObject.$bL(value$8, hi$20);
    } else {
      var value$9 = $thiz.bi;
      var hi$21 = (value$9 >> 31);
      var lo$12 = ((1 - value$9) | 0);
      var hi$22 = ((((-hi$21) | 0) - (((lo$12 >>> 0) > 1) | 0)) | 0);
      return $j_java$002elang$002e$002dObject.$bL(lo$12, hi$22);
    }
  }
  var x$23 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
  if (((x$23 === null) ? (field === null) : (x$23 === field))) {
    var value$10 = $thiz.bi;
    var hi$23 = (value$10 >> 31);
    return $j_java$002elang$002e$002dObject.$bL(value$10, hi$23);
  }
  var x$25 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField();
  if (((x$25 === null) ? (field === null) : (x$25 === field))) {
    if (($thiz.bi >= 1)) {
      return $j_java$002elang$002e$002dObject.$bL(1, 0);
    } else {
      return $j_java$002elang$002e$002dObject.$bL(0, 0);
    }
  }
  throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
}
export { $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J as $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J };
function $p_Ljava_time_LocalDate__getProlepticMonth__J($thiz) {
  var value = $thiz.bi;
  var hi = (value >> 31);
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(12, b0);
  var a0b1 = Math.imul(12, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
  var value$1 = (($thiz.dX - 1) | 0);
  var hi$2 = (value$1 >> 31);
  var lo$1 = ((lo + value$1) | 0);
  var hi$3 = ((((hi$1 + hi$2) | 0) + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
  return $j_java$002elang$002e$002dObject.$bL(lo$1, hi$3);
}
export { $p_Ljava_time_LocalDate__getProlepticMonth__J as $p_Ljava_time_LocalDate__getProlepticMonth__J };
/** @constructor */
function $c_Ljava_time_LocalDate(year, monthOfYear, dayOfMonth) {
  this.bi = 0;
  this.dX = 0;
  this.ee = 0;
  this.bi = year;
  this.dX = ((monthOfYear << 16) >> 16);
  this.ee = ((dayOfMonth << 16) >> 16);
}
export { $c_Ljava_time_LocalDate as $c_Ljava_time_LocalDate };
$p = $c_Ljava_time_LocalDate.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ljava_time_LocalDate;
/** @constructor */
function $h_Ljava_time_LocalDate() {
}
export { $h_Ljava_time_LocalDate as $h_Ljava_time_LocalDate };
$h_Ljava_time_LocalDate.prototype = $p;
$p.ba = (function(field) {
  return $f_Ljava_time_chrono_ChronoLocalDate__isSupported__Ljava_time_temporal_TemporalField__Z(this, field);
});
$p.bX = (function(field) {
  if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    if (field.hk()) {
      var x = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
      if (((x === null) ? (field === null) : (x === field))) {
        var $x_1 = $j_java$002etime$002etemporal$002e$002dValue$002dRange$0024.$m_Ljava_time_temporal_ValueRange$();
        var value = this.VM();
        var hi = (value >> 31);
        return $x_1.b1(1, 0, value, hi);
      } else {
        var x$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
        if (((x$3 === null) ? (field === null) : (x$3 === field))) {
          var $x_2 = $j_java$002etime$002etemporal$002e$002dValue$002dRange$0024.$m_Ljava_time_temporal_ValueRange$();
          var value$1 = this.VN();
          var hi$1 = (value$1 >> 31);
          return $x_2.b1(1, 0, value$1, hi$1);
        } else {
          var x$5 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
          if (((x$5 === null) ? (field === null) : (x$5 === field))) {
            var $x_6 = $j_java$002etime$002etemporal$002e$002dValue$002dRange$0024.$m_Ljava_time_temporal_ValueRange$();
            if (($m_Ljava_time_Month$().xK(this.dX) === $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month())) {
              var $x_5 = $m_Ljava_time_chrono_IsoChronology$().bz();
              var value$2 = this.bi;
              var hi$2 = (value$2 >> 31);
              var $x_4 = (!$x_5.jp(value$2, hi$2));
            } else {
              var $x_4 = false;
            }
            if ($x_4) {
              var $x_3_$_lo = 4;
              var $x_3_$_hi = 0;
            } else {
              var $x_3_$_lo = 5;
              var $x_3_$_hi = 0;
            }
            return $x_6.b1(1, 0, $x_3_$_lo, $x_3_$_hi);
          } else {
            var x$7 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
            if (((x$7 === null) ? (field === null) : (x$7 === field))) {
              if ((this.bi <= 0)) {
                var $x_7 = $j_java$002etime$002etemporal$002e$002dValue$002dRange$0024.$m_Ljava_time_temporal_ValueRange$();
                var value$3 = $j_java$002etime$002e$002dYear$0024.$m_Ljava_time_Year$().qM();
                var hi$3 = (value$3 >> 31);
                var lo = ((1 + value$3) | 0);
                var hi$4 = ((hi$3 + ((lo === 0) | 0)) | 0);
                return $x_7.b1(1, 0, lo, hi$4);
              } else {
                var $x_8 = $j_java$002etime$002etemporal$002e$002dValue$002dRange$0024.$m_Ljava_time_temporal_ValueRange$();
                var value$4 = $j_java$002etime$002e$002dYear$0024.$m_Ljava_time_Year$().qM();
                var hi$5 = (value$4 >> 31);
                return $x_8.b1(1, 0, value$4, hi$5);
              }
            } else {
              return field.G;
            }
          }
        }
      }
    } else {
      throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
    }
  } else {
    return this.bX(field);
  }
});
$p.cC = (function(field) {
  if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    var $x_1 = $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J(this, field);
    return $j_java$002elang$002e$002dObject.$s_RTLong__toInt__I__I__I($x_1.l, $x_1.h);
  } else {
    return $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field);
  }
});
$p.ai = (function(field) {
  if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    if ((field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField())) {
      return this.fo();
    }
    if ((field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField())) {
      return $p_Ljava_time_LocalDate__getProlepticMonth__J(this);
    }
    return $p_Ljava_time_LocalDate__get0__Ljava_time_temporal_TemporalField__J(this, field);
  } else {
    return this.ai(field);
  }
});
$p.xm = (function() {
  var $x_2 = $m_Ljava_time_Month$().xK(this.dX);
  var $x_1 = $m_Ljava_time_chrono_IsoChronology$().bz();
  var value = this.bi;
  var hi = (value >> 31);
  return (((($x_2.Bs($x_1.jp(value, hi)) + this.ee) | 0) - 1) | 0);
});
$p.P7 = (function() {
  var $x_1 = this.fo();
  var x_$_lo = $x_1.l;
  var x_$_hi = $x_1.h;
  var lo = ((3 + x_$_lo) | 0);
  var hi = ((x_$_hi + (((lo >>> 0) < 3) | 0)) | 0);
  var sign = (hi >> 31);
  var xlo = (lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var k$2 = (((rhi >>> 0) % 7) | 0);
  var quotLo$2 = ((0.14285714285714293 * ((4.294967296E9 * k$2) + (rlo >>> 0.0))) | 0.0);
  var remLo = ((rlo - Math.imul(7, quotLo$2)) | 0);
  if ((hi < 0)) {
    var lo$1 = ((-remLo) | 0);
    var hi$1 = ((-((lo$1 !== 0) | 0)) | 0);
    var rem_$_lo = lo$1;
    var rem_$_hi = hi$1;
  } else {
    var rem_$_lo = remLo;
    var rem_$_hi = 0;
  }
  if (((hi >= 0) || ((rem_$_lo | rem_$_hi) === 0))) {
    var x$2_$_lo = rem_$_lo;
    var x$2_$_hi = rem_$_hi;
  } else {
    var lo$3 = ((7 + rem_$_lo) | 0);
    var hi$2 = ((rem_$_hi + (((lo$3 >>> 0) < 7) | 0)) | 0);
    var x$2_$_lo = lo$3;
    var x$2_$_hi = hi$2;
  }
  return $m_Ljava_time_DayOfWeek$().Ca(((1 + x$2_$_lo) | 0));
});
$p.VM = (function() {
  switch (this.dX) {
    case 2: {
      var $x_1 = $m_Ljava_time_chrono_IsoChronology$().bz();
      var value = this.bi;
      var hi = (value >> 31);
      if ($x_1.jp(value, hi)) {
        return 29;
      } else {
        return 28;
      }
      break;
    }
    case 4:
    case 6:
    case 9:
    case 11: {
      return 30;
      break;
    }
    default: {
      return 31;
    }
  }
});
$p.VN = (function() {
  var $x_1 = $m_Ljava_time_chrono_IsoChronology$().bz();
  var value = this.bi;
  var hi = (value >> 31);
  if ($x_1.jp(value, hi)) {
    return 366;
  } else {
    return 365;
  }
});
$p.QV = (function(adjuster) {
  return ((adjuster instanceof $c_Ljava_time_LocalDate) ? adjuster : adjuster.he(this));
});
$p.yf = (function(field, newValue_$_lo, newValue_$_hi) {
  if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    field.G.ak(newValue_$_lo, newValue_$_hi, field);
    var x = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
    if (((x === null) ? (field === null) : (x === field))) {
      var value = this.P7().gx();
      var hi = (value >> 31);
      var lo = ((newValue_$_lo - value) | 0);
      var hi$1 = ((((newValue_$_hi - hi) | 0) - (((lo >>> 0) > (newValue_$_lo >>> 0)) | 0)) | 0);
      return this.eC(lo, hi$1);
    }
    var x$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField();
    if (((x$3 === null) ? (field === null) : (x$3 === field))) {
      var $x_1 = this.ai($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_MONTH__Ljava_time_temporal_ChronoField());
      var x$1_$_lo = $x_1.l;
      var x$1_$_hi = $x_1.h;
      var lo$1 = ((newValue_$_lo - x$1_$_lo) | 0);
      var hi$2 = ((((newValue_$_hi - x$1_$_hi) | 0) - (((lo$1 >>> 0) > (newValue_$_lo >>> 0)) | 0)) | 0);
      return this.eC(lo$1, hi$2);
    }
    var x$5 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField();
    if (((x$5 === null) ? (field === null) : (x$5 === field))) {
      var $x_2 = this.ai($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_DAY_OF_WEEK_IN_YEAR__Ljava_time_temporal_ChronoField());
      var x$2_$_lo = $x_2.l;
      var x$2_$_hi = $x_2.h;
      var lo$2 = ((newValue_$_lo - x$2_$_lo) | 0);
      var hi$3 = ((((newValue_$_hi - x$2_$_hi) | 0) - (((lo$2 >>> 0) > (newValue_$_lo >>> 0)) | 0)) | 0);
      return this.eC(lo$2, hi$3);
    }
    var x$7 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_MONTH__Ljava_time_temporal_ChronoField();
    if (((x$7 === null) ? (field === null) : (x$7 === field))) {
      return this.Yv(newValue_$_lo);
    }
    var x$9 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_YEAR__Ljava_time_temporal_ChronoField();
    if (((x$9 === null) ? (field === null) : (x$9 === field))) {
      return this.Yw(newValue_$_lo);
    }
    var x$11 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
    if (((x$11 === null) ? (field === null) : (x$11 === field))) {
      return $m_Ljava_time_LocalDate$().gE(newValue_$_lo, newValue_$_hi);
    }
    var x$13 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField();
    if (((x$13 === null) ? (field === null) : (x$13 === field))) {
      var $x_3 = this.ai($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_MONTH__Ljava_time_temporal_ChronoField());
      var x$4_$_lo = $x_3.l;
      var x$4_$_hi = $x_3.h;
      var lo$3 = ((newValue_$_lo - x$4_$_lo) | 0);
      var hi$4 = ((((newValue_$_hi - x$4_$_hi) | 0) - (((lo$3 >>> 0) > (newValue_$_lo >>> 0)) | 0)) | 0);
      return this.it(lo$3, hi$4);
    }
    var x$15 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField();
    if (((x$15 === null) ? (field === null) : (x$15 === field))) {
      var $x_4 = this.ai($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ALIGNED_WEEK_OF_YEAR__Ljava_time_temporal_ChronoField());
      var x$6_$_lo = $x_4.l;
      var x$6_$_hi = $x_4.h;
      var lo$4 = ((newValue_$_lo - x$6_$_lo) | 0);
      var hi$5 = ((((newValue_$_hi - x$6_$_hi) | 0) - (((lo$4 >>> 0) > (newValue_$_lo >>> 0)) | 0)) | 0);
      return this.it(lo$4, hi$5);
    }
    var x$17 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    if (((x$17 === null) ? (field === null) : (x$17 === field))) {
      return this.Yy(newValue_$_lo);
    }
    var x$19 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField();
    if (((x$19 === null) ? (field === null) : (x$19 === field))) {
      var $x_5 = this.ai($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__PROLEPTIC_MONTH__Ljava_time_temporal_ChronoField());
      var x$8_$_lo = $x_5.l;
      var x$8_$_hi = $x_5.h;
      var lo$5 = ((newValue_$_lo - x$8_$_lo) | 0);
      var hi$6 = ((((newValue_$_hi - x$8_$_hi) | 0) - (((lo$5 >>> 0) > (newValue_$_lo >>> 0)) | 0)) | 0);
      return this.ur(lo$5, hi$6);
    }
    var x$21 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR_OF_ERA__Ljava_time_temporal_ChronoField();
    if (((x$21 === null) ? (field === null) : (x$21 === field))) {
      if ((this.bi >= 1)) {
        var $x_6_$_lo = newValue_$_lo;
        var $x_6_$_hi = newValue_$_hi;
      } else {
        var lo$6 = ((1 - newValue_$_lo) | 0);
        var hi$7 = ((((-newValue_$_hi) | 0) - (((lo$6 >>> 0) > 1) | 0)) | 0);
        var $x_6_$_lo = lo$6;
        var $x_6_$_hi = hi$7;
      }
      return this.CO($x_6_$_lo);
    }
    var x$23 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    if (((x$23 === null) ? (field === null) : (x$23 === field))) {
      return this.CO(newValue_$_lo);
    }
    var x$25 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField();
    if (((x$25 === null) ? (field === null) : (x$25 === field))) {
      var $x_7 = this.ai($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField());
      var x$12_$_lo = $x_7.l;
      var x$12_$_hi = $x_7.h;
      if ((((x$12_$_lo ^ newValue_$_lo) | (x$12_$_hi ^ newValue_$_hi)) === 0)) {
        return this;
      } else {
        return this.CO(((1 - this.bi) | 0));
      }
    }
    throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return this.yf(field, newValue_$_lo, newValue_$_hi);
  }
});
$p.CO = (function(year) {
  if ((this.bi === year)) {
    return this;
  } else {
    var this$2 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    var hi = (year >> 31);
    this$2.G.ak(year, hi, this$2);
    return $m_Ljava_time_LocalDate$().xx(year, this.dX, this.ee);
  }
});
$p.Yy = (function(month) {
  if ((this.dX === month)) {
    return this;
  } else {
    var this$2 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    var hi = (month >> 31);
    this$2.G.ak(month, hi, this$2);
    return $m_Ljava_time_LocalDate$().xx(this.bi, month, this.ee);
  }
});
$p.Yv = (function(dayOfMonth) {
  return ((this.ee === dayOfMonth) ? this : $m_Ljava_time_LocalDate$().eA(this.bi, this.dX, dayOfMonth));
});
$p.Yw = (function(dayOfYear) {
  return ((this.xm() === dayOfYear) ? this : $m_Ljava_time_LocalDate$().Cf(this.bi, dayOfYear));
});
$p.re = (function(amountToAdd_$_lo, amountToAdd_$_hi, unit) {
  if ((unit instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$c_Ljava_time_temporal_ChronoUnit)) {
    var x = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit();
    if (((x === null) ? (unit === null) : (x === unit))) {
      return this.eC(amountToAdd_$_lo, amountToAdd_$_hi);
    }
    var x$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__WEEKS__Ljava_time_temporal_ChronoUnit();
    if (((x$3 === null) ? (unit === null) : (x$3 === unit))) {
      return this.it(amountToAdd_$_lo, amountToAdd_$_hi);
    }
    var x$5 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit();
    if (((x$5 === null) ? (unit === null) : (x$5 === unit))) {
      return this.ur(amountToAdd_$_lo, amountToAdd_$_hi);
    }
    var x$7 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__YEARS__Ljava_time_temporal_ChronoUnit();
    if (((x$7 === null) ? (unit === null) : (x$7 === unit))) {
      return this.xU(amountToAdd_$_lo, amountToAdd_$_hi);
    }
    var x$9 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__DECADES__Ljava_time_temporal_ChronoUnit();
    if (((x$9 === null) ? (unit === null) : (x$9 === unit))) {
      var this$1 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
      var b0 = (65535 & amountToAdd_$_lo);
      var b1 = ((amountToAdd_$_lo >>> 16) | 0);
      var a0b0 = Math.imul(10, b0);
      var a0b1 = Math.imul(10, b1);
      var lo = ((a0b0 + (a0b1 << 16)) | 0);
      var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
      var hi = ((Math.imul(10, amountToAdd_$_hi) + ((c1part >>> 16) | 0)) | 0);
      if (((amountToAdd_$_lo | amountToAdd_$_hi) !== 0)) {
        var $x_2 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo, hi, amountToAdd_$_lo, amountToAdd_$_hi);
        var x$1_$_lo = $x_2.l;
        var x$1_$_hi = $x_2.h;
        var $x_1 = (((10 ^ x$1_$_lo) | x$1_$_hi) !== 0);
      } else {
        var $x_1 = false;
      }
      if ($x_1) {
        this$1.au();
      }
      return this.xU(lo, hi);
    }
    var x$11 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__CENTURIES__Ljava_time_temporal_ChronoUnit();
    if (((x$11 === null) ? (unit === null) : (x$11 === unit))) {
      var this$6 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
      var b0$1 = (65535 & amountToAdd_$_lo);
      var b1$1 = ((amountToAdd_$_lo >>> 16) | 0);
      var a0b0$1 = Math.imul(100, b0$1);
      var a0b1$1 = Math.imul(100, b1$1);
      var lo$1 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var hi$1 = ((Math.imul(100, amountToAdd_$_hi) + ((c1part$1 >>> 16) | 0)) | 0);
      if (((amountToAdd_$_lo | amountToAdd_$_hi) !== 0)) {
        var $x_4 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo$1, hi$1, amountToAdd_$_lo, amountToAdd_$_hi);
        var x$2_$_lo = $x_4.l;
        var x$2_$_hi = $x_4.h;
        var $x_3 = (((100 ^ x$2_$_lo) | x$2_$_hi) !== 0);
      } else {
        var $x_3 = false;
      }
      if ($x_3) {
        this$6.au();
      }
      return this.xU(lo$1, hi$1);
    }
    var x$13 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__MILLENNIA__Ljava_time_temporal_ChronoUnit();
    if (((x$13 === null) ? (unit === null) : (x$13 === unit))) {
      var this$11 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
      var b0$2 = (65535 & amountToAdd_$_lo);
      var b1$2 = ((amountToAdd_$_lo >>> 16) | 0);
      var a0b0$2 = Math.imul(1000, b0$2);
      var a0b1$2 = Math.imul(1000, b1$2);
      var lo$2 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
      var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
      var hi$2 = ((Math.imul(1000, amountToAdd_$_hi) + ((c1part$2 >>> 16) | 0)) | 0);
      if (((amountToAdd_$_lo | amountToAdd_$_hi) !== 0)) {
        var $x_6 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo$2, hi$2, amountToAdd_$_lo, amountToAdd_$_hi);
        var x$4_$_lo = $x_6.l;
        var x$4_$_hi = $x_6.h;
        var $x_5 = (((1000 ^ x$4_$_lo) | x$4_$_hi) !== 0);
      } else {
        var $x_5 = false;
      }
      if ($x_5) {
        this$11.au();
      }
      return this.xU(lo$2, hi$2);
    }
    var x$15 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__ERAS__Ljava_time_temporal_ChronoUnit();
    if (((x$15 === null) ? (unit === null) : (x$15 === unit))) {
      var $x_8 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField();
      var $x_7 = this.ai($j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__ERA__Ljava_time_temporal_ChronoField());
      var a_$_lo = $x_7.l;
      var a_$_hi = $x_7.h;
      var this$16 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
      var lo$3 = ((a_$_lo + amountToAdd_$_lo) | 0);
      var hi$3 = ((((a_$_hi + amountToAdd_$_hi) | 0) + (((lo$3 >>> 0) < (a_$_lo >>> 0)) | 0)) | 0);
      if ((((hi$3 ^ a_$_hi) & (hi$3 ^ amountToAdd_$_hi)) < 0)) {
        this$16.au();
      }
      return this.yf($x_8, lo$3, hi$3);
    }
    throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported unit: " + unit));
  } else {
    return this.re(amountToAdd_$_lo, amountToAdd_$_hi, unit);
  }
});
$p.xU = (function(yearsToAdd_$_lo, yearsToAdd_$_hi) {
  if (((yearsToAdd_$_lo | yearsToAdd_$_hi) === 0)) {
    return this;
  } else {
    var this$4 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    var value = this.bi;
    var hi = (value >> 31);
    var lo = ((value + yearsToAdd_$_lo) | 0);
    var hi$1 = ((((hi + yearsToAdd_$_hi) | 0) + (((lo >>> 0) < (value >>> 0)) | 0)) | 0);
    var newYear = this$4.G.b0(lo, hi$1, this$4);
    return $m_Ljava_time_LocalDate$().xx(newYear, this.dX, this.ee);
  }
});
$p.ur = (function(monthsToAdd_$_lo, monthsToAdd_$_hi) {
  if (((monthsToAdd_$_lo | monthsToAdd_$_hi) === 0)) {
    return this;
  } else {
    var value = this.bi;
    var hi = (value >> 31);
    var b0 = (65535 & value);
    var b1 = ((value >>> 16) | 0);
    var a0b0 = Math.imul(12, b0);
    var a0b1 = Math.imul(12, b1);
    var lo = ((a0b0 + (a0b1 << 16)) | 0);
    var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
    var hi$1 = ((Math.imul(12, hi) + ((c1part >>> 16) | 0)) | 0);
    var value$1 = ((this.dX - 1) | 0);
    var hi$2 = (value$1 >> 31);
    var lo$1 = ((lo + value$1) | 0);
    var hi$3 = ((((hi$1 + hi$2) | 0) + (((lo$1 >>> 0) < (lo >>> 0)) | 0)) | 0);
    var lo$2 = ((lo$1 + monthsToAdd_$_lo) | 0);
    var hi$4 = ((((hi$3 + monthsToAdd_$_hi) | 0) + (((lo$2 >>> 0) < (lo$1 >>> 0)) | 0)) | 0);
    var this$23 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__YEAR__Ljava_time_temporal_ChronoField();
    var sign = (hi$4 >> 31);
    var xlo = (lo$2 ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((hi$4 ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var quotHi = (((rhi >>> 0) / 12) | 0);
    var k = ((rhi - Math.imul(12, quotHi)) | 0);
    var quotLo = ((0.08333333333333337 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
    if ((hi$4 < 0)) {
      var lo$3 = ((-quotLo) | 0);
      var hi$5 = ((((-quotHi) | 0) - ((lo$3 !== 0) | 0)) | 0);
      var quot_$_lo = lo$3;
      var quot_$_hi = hi$5;
    } else {
      var quot_$_lo = quotLo;
      var quot_$_hi = quotHi;
    }
    if ((hi$4 >= 0)) {
      var $x_1 = true;
    } else {
      var b0$1 = (65535 & quot_$_lo);
      var b1$1 = ((quot_$_lo >>> 16) | 0);
      var a0b0$1 = Math.imul(12, b0$1);
      var a0b1$1 = Math.imul(12, b1$1);
      var lo$5 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
      var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
      var $x_1 = (((lo$5 ^ lo$2) | (((Math.imul(12, quot_$_hi) + ((c1part$1 >>> 16) | 0)) | 0) ^ hi$4)) === 0);
    }
    if ($x_1) {
      var value$2_$_lo = quot_$_lo;
      var value$2_$_hi = quot_$_hi;
    } else {
      var lo$6 = ((quot_$_lo - 1) | 0);
      var hi$7 = ((((quot_$_hi - 1) | 0) + ((lo$6 !== (-1)) | 0)) | 0);
      var value$2_$_lo = lo$6;
      var value$2_$_hi = hi$7;
    }
    var newYear = this$23.G.b0(value$2_$_lo, value$2_$_hi, this$23);
    var sign$1 = (hi$4 >> 31);
    var xlo$1 = (lo$2 ^ sign$1);
    var rlo$1 = ((xlo$1 - sign$1) | 0);
    var rhi$1 = (((hi$4 ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
    var k$2 = (((rhi$1 >>> 0) % 12) | 0);
    var quotLo$2 = ((0.08333333333333337 * ((4.294967296E9 * k$2) + (rlo$1 >>> 0.0))) | 0.0);
    var remLo = ((rlo$1 - Math.imul(12, quotLo$2)) | 0);
    if ((hi$4 < 0)) {
      var lo$7 = ((-remLo) | 0);
      var hi$8 = ((-((lo$7 !== 0) | 0)) | 0);
      var rem_$_lo = lo$7;
      var rem_$_hi = hi$8;
    } else {
      var rem_$_lo = remLo;
      var rem_$_hi = 0;
    }
    if (((hi$4 >= 0) || ((rem_$_lo | rem_$_hi) === 0))) {
      var $x_2_$_lo = rem_$_lo;
      var $x_2_$_hi = rem_$_hi;
    } else {
      var lo$9 = ((12 + rem_$_lo) | 0);
      var hi$9 = ((rem_$_hi + (((lo$9 >>> 0) < 12) | 0)) | 0);
      var $x_2_$_lo = lo$9;
      var $x_2_$_hi = hi$9;
    }
    var newMonth = ((1 + $x_2_$_lo) | 0);
    return $m_Ljava_time_LocalDate$().xx(newYear, newMonth, this.ee);
  }
});
$p.it = (function(weeksToAdd_$_lo, weeksToAdd_$_hi) {
  var this$1 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
  var b0 = (65535 & weeksToAdd_$_lo);
  var b1 = ((weeksToAdd_$_lo >>> 16) | 0);
  var a0b0 = Math.imul(7, b0);
  var a0b1 = Math.imul(7, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi = ((Math.imul(7, weeksToAdd_$_hi) + ((c1part >>> 16) | 0)) | 0);
  if (((weeksToAdd_$_lo | weeksToAdd_$_hi) !== 0)) {
    var $x_2 = $j_java$002elang$002e$002dObject.$m_RTLong$().cT(lo, hi, weeksToAdd_$_lo, weeksToAdd_$_hi);
    var x_$_lo = $x_2.l;
    var x_$_hi = $x_2.h;
    var $x_1 = (((7 ^ x_$_lo) | x_$_hi) !== 0);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    this$1.au();
  }
  return this.eC(lo, hi);
});
$p.eC = (function(daysToAdd_$_lo, daysToAdd_$_hi) {
  if (((daysToAdd_$_lo | daysToAdd_$_hi) === 0)) {
    return this;
  } else {
    var $x_1 = this.fo();
    var a_$_lo = $x_1.l;
    var a_$_hi = $x_1.h;
    var this$2 = $j_java$002elang$002e$002dObject.$m_jl_Math$();
    var lo = ((a_$_lo + daysToAdd_$_lo) | 0);
    var hi = ((((a_$_hi + daysToAdd_$_hi) | 0) + (((lo >>> 0) < (a_$_lo >>> 0)) | 0)) | 0);
    if ((((hi ^ a_$_hi) & (hi ^ daysToAdd_$_hi)) < 0)) {
      this$2.au();
    }
    return $m_Ljava_time_LocalDate$().gE(lo, hi);
  }
});
$p.W2 = (function(amountToSubtract_$_lo, amountToSubtract_$_hi, unit) {
  if (((amountToSubtract_$_lo | ((-2147483648) ^ amountToSubtract_$_hi)) === 0)) {
    return this.re((-1), 2147483647, unit).re(1, 0, unit);
  } else {
    var lo = ((-amountToSubtract_$_lo) | 0);
    var hi = ((((-amountToSubtract_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
    return this.re(lo, hi, unit);
  }
});
$p.cg = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().fl()) ? this : $f_Ljava_time_chrono_ChronoLocalDate__query__Ljava_time_temporal_TemporalQuery__O(this, query));
});
$p.he = (function(temporal) {
  var $x_2 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__EPOCH_DAY__Ljava_time_temporal_ChronoField();
  var $x_1 = this.fo();
  return temporal.fq($x_2, $x_1.l, $x_1.h);
});
$p.fo = (function() {
  var value = this.bi;
  var hi = (value >> 31);
  var value$1 = this.dX;
  var hi$1 = (value$1 >> 31);
  var total_$_lo = 0;
  var total_$_hi = 0;
  var x_$_lo = total_$_lo;
  var x_$_hi = total_$_hi;
  var b0 = (65535 & value);
  var b1 = ((value >>> 16) | 0);
  var a0b0 = Math.imul(365, b0);
  var a0b1 = Math.imul(365, b1);
  var lo = ((a0b0 + (a0b1 << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$2 = ((Math.imul(365, hi) + ((c1part >>> 16) | 0)) | 0);
  var lo$1 = ((x_$_lo + lo) | 0);
  var hi$3 = ((((x_$_hi + hi$2) | 0) + (((lo$1 >>> 0) < (x_$_lo >>> 0)) | 0)) | 0);
  total_$_lo = lo$1;
  total_$_hi = hi$3;
  if ((hi >= 0)) {
    var x$5_$_lo = total_$_lo;
    var x$5_$_hi = total_$_hi;
    var lo$2 = ((3 + value) | 0);
    var hi$4 = ((hi + (((lo$2 >>> 0) < 3) | 0)) | 0);
    var hi$5 = (hi$4 >> 1);
    var lo$4 = ((hi$5 >>> 30) | 0);
    var lo$5 = ((lo$2 + lo$4) | 0);
    var hi$6 = ((hi$4 + (((lo$5 >>> 0) < (lo$2 >>> 0)) | 0)) | 0);
    var lo$6 = (((lo$5 >>> 2) | 0) | (hi$6 << 30));
    var hi$7 = (hi$6 >> 2);
    var lo$7 = ((99 + value) | 0);
    var hi$8 = ((hi + (((lo$7 >>> 0) < 99) | 0)) | 0);
    var sign = (hi$8 >> 31);
    var xlo = (lo$7 ^ sign);
    var rlo = ((xlo - sign) | 0);
    var rhi = (((hi$8 ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
    var quotHi = (((rhi >>> 0) / 100) | 0);
    var k = ((rhi - Math.imul(100, quotHi)) | 0);
    var quotLo = ((0.010000000000000004 * ((4.294967296E9 * k) + (rlo >>> 0.0))) | 0.0);
    if ((hi$8 < 0)) {
      var lo$8 = ((-quotLo) | 0);
      var hi$9 = ((((-quotHi) | 0) - ((lo$8 !== 0) | 0)) | 0);
      var x$2_$_lo = lo$8;
      var x$2_$_hi = hi$9;
    } else {
      var x$2_$_lo = quotLo;
      var x$2_$_hi = quotHi;
    }
    var lo$9 = ((lo$6 - x$2_$_lo) | 0);
    var hi$10 = ((((hi$7 - x$2_$_hi) | 0) - (((lo$9 >>> 0) > (lo$6 >>> 0)) | 0)) | 0);
    var lo$10 = ((399 + value) | 0);
    var hi$11 = ((hi + (((lo$10 >>> 0) < 399) | 0)) | 0);
    var sign$1 = (hi$11 >> 31);
    var xlo$1 = (lo$10 ^ sign$1);
    var rlo$1 = ((xlo$1 - sign$1) | 0);
    var rhi$1 = (((hi$11 ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
    var quotHi$1 = (((rhi$1 >>> 0) / 400) | 0);
    var k$1 = ((rhi$1 - Math.imul(400, quotHi$1)) | 0);
    var quotLo$1 = ((0.002500000000000001 * ((4.294967296E9 * k$1) + (rlo$1 >>> 0.0))) | 0.0);
    if ((hi$11 < 0)) {
      var lo$11 = ((-quotLo$1) | 0);
      var hi$12 = ((((-quotHi$1) | 0) - ((lo$11 !== 0) | 0)) | 0);
      var x$4_$_lo = lo$11;
      var x$4_$_hi = hi$12;
    } else {
      var x$4_$_lo = quotLo$1;
      var x$4_$_hi = quotHi$1;
    }
    var lo$12 = ((lo$9 + x$4_$_lo) | 0);
    var hi$13 = ((((hi$10 + x$4_$_hi) | 0) + (((lo$12 >>> 0) < (lo$9 >>> 0)) | 0)) | 0);
    var lo$13 = ((x$5_$_lo + lo$12) | 0);
    var hi$14 = ((((x$5_$_hi + hi$13) | 0) + (((lo$13 >>> 0) < (x$5_$_lo >>> 0)) | 0)) | 0);
    total_$_lo = lo$13;
    total_$_hi = hi$14;
  } else {
    var x$10_$_lo = total_$_lo;
    var x$10_$_hi = total_$_hi;
    var hi$15 = (hi >> 1);
    var lo$15 = ((hi$15 >>> 30) | 0);
    var lo$16 = ((value + lo$15) | 0);
    var hi$16 = ((hi + (((lo$16 >>> 0) < (value >>> 0)) | 0)) | 0);
    var lo$17 = (((lo$16 >>> 2) | 0) | (hi$16 << 30));
    var hi$17 = (hi$16 >> 2);
    var lo$18 = ((-lo$17) | 0);
    var hi$18 = ((((-hi$17) | 0) - ((lo$18 !== 0) | 0)) | 0);
    var sign$2 = (hi >> 31);
    var xlo$2 = (value ^ sign$2);
    var rlo$2 = ((xlo$2 - sign$2) | 0);
    var rhi$2 = (((hi ^ sign$2) + (((rlo$2 >>> 0) < (xlo$2 >>> 0)) | 0)) | 0);
    var quotHi$2 = (((rhi$2 >>> 0) / 100) | 0);
    var k$2 = ((rhi$2 - Math.imul(100, quotHi$2)) | 0);
    var quotLo$2 = ((0.010000000000000004 * ((4.294967296E9 * k$2) + (rlo$2 >>> 0.0))) | 0.0);
    if ((hi < 0)) {
      var x$7_$_lo = quotLo$2;
      var x$7_$_hi = quotHi$2;
    } else {
      var lo$19 = ((-quotLo$2) | 0);
      var hi$19 = ((((-quotHi$2) | 0) - ((lo$19 !== 0) | 0)) | 0);
      var x$7_$_lo = lo$19;
      var x$7_$_hi = hi$19;
    }
    var lo$20 = ((lo$18 - x$7_$_lo) | 0);
    var hi$20 = ((((hi$18 - x$7_$_hi) | 0) - (((lo$20 >>> 0) > (lo$18 >>> 0)) | 0)) | 0);
    var sign$3 = (hi >> 31);
    var xlo$3 = (value ^ sign$3);
    var rlo$3 = ((xlo$3 - sign$3) | 0);
    var rhi$3 = (((hi ^ sign$3) + (((rlo$3 >>> 0) < (xlo$3 >>> 0)) | 0)) | 0);
    var quotHi$3 = (((rhi$3 >>> 0) / 400) | 0);
    var k$3 = ((rhi$3 - Math.imul(400, quotHi$3)) | 0);
    var quotLo$3 = ((0.002500000000000001 * ((4.294967296E9 * k$3) + (rlo$3 >>> 0.0))) | 0.0);
    if ((hi < 0)) {
      var x$9_$_lo = quotLo$3;
      var x$9_$_hi = quotHi$3;
    } else {
      var lo$21 = ((-quotLo$3) | 0);
      var hi$21 = ((((-quotHi$3) | 0) - ((lo$21 !== 0) | 0)) | 0);
      var x$9_$_lo = lo$21;
      var x$9_$_hi = hi$21;
    }
    var lo$22 = ((lo$20 + x$9_$_lo) | 0);
    var hi$22 = ((((hi$20 + x$9_$_hi) | 0) + (((lo$22 >>> 0) < (lo$20 >>> 0)) | 0)) | 0);
    var lo$23 = ((x$10_$_lo - lo$22) | 0);
    var hi$23 = ((((x$10_$_hi - hi$22) | 0) - (((lo$23 >>> 0) > (x$10_$_lo >>> 0)) | 0)) | 0);
    total_$_lo = lo$23;
    total_$_hi = hi$23;
  }
  var x$12_$_lo = total_$_lo;
  var x$12_$_hi = total_$_hi;
  var b0$1 = (65535 & value$1);
  var b1$1 = ((value$1 >>> 16) | 0);
  var a0b0$1 = Math.imul(367, b0$1);
  var a0b1$1 = Math.imul(367, b1$1);
  var lo$24 = ((a0b0$1 + (a0b1$1 << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$24 = ((Math.imul(367, hi$1) + ((c1part$1 >>> 16) | 0)) | 0);
  var lo$25 = ((lo$24 - 362) | 0);
  var hi$25 = ((((hi$24 - 1) | 0) + (((lo$25 >>> 0) < 4294966934) | 0)) | 0);
  var sign$4 = (hi$25 >> 31);
  var xlo$4 = (lo$25 ^ sign$4);
  var rlo$4 = ((xlo$4 - sign$4) | 0);
  var rhi$4 = (((hi$25 ^ sign$4) + (((rlo$4 >>> 0) < (xlo$4 >>> 0)) | 0)) | 0);
  var quotHi$4 = (((rhi$4 >>> 0) / 12) | 0);
  var k$4 = ((rhi$4 - Math.imul(12, quotHi$4)) | 0);
  var quotLo$4 = ((0.08333333333333337 * ((4.294967296E9 * k$4) + (rlo$4 >>> 0.0))) | 0.0);
  if ((hi$25 < 0)) {
    var lo$26 = ((-quotLo$4) | 0);
    var hi$26 = ((((-quotHi$4) | 0) - ((lo$26 !== 0) | 0)) | 0);
    var x$13_$_lo = lo$26;
    var x$13_$_hi = hi$26;
  } else {
    var x$13_$_lo = quotLo$4;
    var x$13_$_hi = quotHi$4;
  }
  var lo$27 = ((x$12_$_lo + x$13_$_lo) | 0);
  var hi$27 = ((((x$12_$_hi + x$13_$_hi) | 0) + (((lo$27 >>> 0) < (x$12_$_lo >>> 0)) | 0)) | 0);
  total_$_lo = lo$27;
  total_$_hi = hi$27;
  var x$14_$_lo = total_$_lo;
  var x$14_$_hi = total_$_hi;
  var value$2 = ((this.ee - 1) | 0);
  var hi$28 = (value$2 >> 31);
  var lo$28 = ((x$14_$_lo + value$2) | 0);
  var hi$29 = ((((x$14_$_hi + hi$28) | 0) + (((lo$28 >>> 0) < (x$14_$_lo >>> 0)) | 0)) | 0);
  total_$_lo = lo$28;
  total_$_hi = hi$29;
  if (((hi$1 === 0) ? ((value$1 >>> 0) > 2) : (hi$1 > 0))) {
    var x$15_$_lo = total_$_lo;
    var x$15_$_hi = total_$_hi;
    var lo$29 = ((x$15_$_lo - 1) | 0);
    var hi$30 = ((((x$15_$_hi - 1) | 0) + ((lo$29 !== (-1)) | 0)) | 0);
    total_$_lo = lo$29;
    total_$_hi = hi$30;
    var $x_1 = $m_Ljava_time_chrono_IsoChronology$().bz();
    var value$3 = this.bi;
    var hi$31 = (value$3 >> 31);
    if ((!$x_1.jp(value$3, hi$31))) {
      var x$16_$_lo = total_$_lo;
      var x$16_$_hi = total_$_hi;
      var lo$30 = ((x$16_$_lo - 1) | 0);
      var hi$32 = ((((x$16_$_hi - 1) | 0) + ((lo$30 !== (-1)) | 0)) | 0);
      total_$_lo = lo$30;
      total_$_hi = hi$32;
    }
  }
  var x$17_$_lo = total_$_lo;
  var x$17_$_hi = total_$_hi;
  var $x_2 = $m_Ljava_time_LocalDate$();
  var x$18_$_lo = $x_2.AW;
  var x$18_$_hi = $x_2.AX;
  var lo$31 = ((x$17_$_lo - x$18_$_lo) | 0);
  var hi$33 = ((((x$17_$_hi - x$18_$_hi) | 0) - (((lo$31 >>> 0) > (x$17_$_lo >>> 0)) | 0)) | 0);
  return $j_java$002elang$002e$002dObject.$bL(lo$31, hi$33);
});
$p.Om = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDate) ? this.Bi(other) : $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I(this, other));
});
$p.Bi = (function(otherDate) {
  var cmp = ((this.bi - otherDate.bi) | 0);
  if ((cmp === 0)) {
    cmp = ((this.dX - otherDate.dX) | 0);
    if ((cmp === 0)) {
      cmp = ((this.ee - otherDate.ee) | 0);
    }
  }
  return cmp;
});
$p.f = (function(obj) {
  return ((obj instanceof $c_Ljava_time_LocalDate) && ((this === obj) || (this.Bi(obj) === 0)));
});
$p.m = (function() {
  var yearValue = this.bi;
  return (((-2048) & yearValue) ^ (((((yearValue << 11) + (this.dX << 6)) | 0) + this.ee) | 0));
});
$p.b = (function() {
  var yearValue = this.bi;
  var monthValue = this.dX;
  var dayValue = this.ee;
  var sign = (yearValue >> 31);
  var absYear = (((yearValue ^ sign) - sign) | 0);
  var buf = $j_java$002elang$002e$002dObject.$ct_scm_StringBuilder__I__(new $j_java$002elang$002e$002dObject.$c_scm_StringBuilder(), 10);
  if ((absYear < 1000)) {
    if ((yearValue < 0)) {
      buf.d9(((yearValue - 10000) | 0)).OH(1);
    } else {
      buf.d9(((10000 + yearValue) | 0)).OH(0);
    }
  } else {
    if ((yearValue > 9999)) {
      buf.ia(43);
    }
    buf.d9(yearValue);
  }
  return buf.eQ(((monthValue < 10) ? "-0" : "-")).d9(monthValue).eQ(((dayValue < 10) ? "-0" : "-")).d9(dayValue).ax.r;
});
$p.fq = (function(field, newValue_$_lo, newValue_$_hi) {
  return this.yf(field, newValue_$_lo, newValue_$_hi);
});
$p.is = (function(amountToAdd_$_lo, amountToAdd_$_hi, unit) {
  return this.re(amountToAdd_$_lo, amountToAdd_$_hi, unit);
});
$p.uj = (function(amountToSubtract_$_lo, amountToSubtract_$_hi, unit) {
  return this.W2(amountToSubtract_$_lo, amountToSubtract_$_hi, unit);
});
$p.fh = (function(that) {
  return this.Om(that);
});
$p.ic = (function(that) {
  return $f_Ljava_time_chrono_ChronoLocalDate__compare__Ljava_time_chrono_ChronoLocalDate__I(this, that);
});
function $isArrayOf_Ljava_time_LocalDate(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dy)));
}
export { $isArrayOf_Ljava_time_LocalDate as $isArrayOf_Ljava_time_LocalDate };
var $d_Ljava_time_LocalDate = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_LocalDate, "java.time.LocalDate", ({
  dy: 1,
  G: 1,
  bs: 1,
  I: 1,
  j: 1,
  aK: 1,
  cc: 1,
  a: 1
}));
export { $d_Ljava_time_LocalDate as $d_Ljava_time_LocalDate };
function $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime($thiz, newDate, newTime) {
  return ((($thiz.aJ === newDate) && ($thiz.aO === newTime)) ? $thiz : new $c_Ljava_time_LocalDateTime(newDate, newTime));
}
export { $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime as $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime };
function $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime($thiz, newDate, hours_$_lo, hours_$_hi, minutes_$_lo, minutes_$_hi, seconds_$_lo, seconds_$_hi, nanos_$_lo, nanos_$_hi, sign) {
  if ((((((hours_$_lo | minutes_$_lo) | seconds_$_lo) | nanos_$_lo) | (((hours_$_hi | minutes_$_hi) | seconds_$_hi) | nanos_$_hi)) === 0)) {
    return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime($thiz, newDate, $thiz.aO);
  }
  var sign$1 = (nanos_$_hi >> 31);
  var xlo = (nanos_$_lo ^ sign$1);
  var rlo = ((xlo - sign$1) | 0);
  var rhi = (((nanos_$_hi ^ sign$1) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
  var x = (1.1574074074074086E-14 * aHat);
  var lo$3 = (x | 0.0);
  var hi$3 = ((2.3283064365386963E-10 * x) | 0.0);
  var b0 = (65535 & lo$3);
  var b1 = ((lo$3 >>> 16) | 0);
  var a1b0 = Math.imul(37199, b0);
  var lo$4 = (a1b0 << 16);
  var hi$4 = ((((((Math.imul((-1857093632), hi$3) + Math.imul(20116, lo$3)) | 0) + Math.imul(37199, b1)) | 0) + ((a1b0 >>> 16) | 0)) | 0);
  var lo$5 = ((rlo - lo$4) | 0);
  var hi$5 = ((((rhi - hi$4) | 0) - (((lo$5 >>> 0) > (rlo >>> 0)) | 0)) | 0);
  if ((hi$5 < 0)) {
    var lo$6 = ((lo$3 - 1) | 0);
    var hi$6 = ((((hi$3 - 1) | 0) + ((lo$6 !== (-1)) | 0)) | 0);
    var absR_$_lo = lo$6;
    var absR_$_hi = hi$6;
  } else {
    var absR_$_lo = lo$3;
    var absR_$_hi = hi$3;
  }
  if ((nanos_$_hi < 0)) {
    var lo$7 = ((-absR_$_lo) | 0);
    var hi$7 = ((((-absR_$_hi) | 0) - ((lo$7 !== 0) | 0)) | 0);
    var x$3_$_lo = lo$7;
    var x$3_$_hi = hi$7;
  } else {
    var x$3_$_lo = absR_$_lo;
    var x$3_$_hi = absR_$_hi;
  }
  var sign$2 = (seconds_$_hi >> 31);
  var xlo$1 = (seconds_$_lo ^ sign$2);
  var rlo$1 = ((xlo$1 - sign$2) | 0);
  var rhi$1 = (((seconds_$_hi ^ sign$2) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
  var quotHi = (((rhi$1 >>> 0) / 86400) | 0);
  var k = ((rhi$1 - Math.imul(86400, quotHi)) | 0);
  var quotLo = ((1.1574074074074079E-5 * ((4.294967296E9 * k) + (rlo$1 >>> 0.0))) | 0.0);
  if ((seconds_$_hi < 0)) {
    var lo$8 = ((-quotLo) | 0);
    var hi$8 = ((((-quotHi) | 0) - ((lo$8 !== 0) | 0)) | 0);
    var x$4_$_lo = lo$8;
    var x$4_$_hi = hi$8;
  } else {
    var x$4_$_lo = quotLo;
    var x$4_$_hi = quotHi;
  }
  var lo$9 = ((x$3_$_lo + x$4_$_lo) | 0);
  var hi$9 = ((((x$3_$_hi + x$4_$_hi) | 0) + (((lo$9 >>> 0) < (x$3_$_lo >>> 0)) | 0)) | 0);
  var sign$3 = (minutes_$_hi >> 31);
  var xlo$2 = (minutes_$_lo ^ sign$3);
  var rlo$2 = ((xlo$2 - sign$3) | 0);
  var rhi$2 = (((minutes_$_hi ^ sign$3) + (((rlo$2 >>> 0) < (xlo$2 >>> 0)) | 0)) | 0);
  var quotHi$1 = (((rhi$2 >>> 0) / 1440) | 0);
  var k$1 = ((rhi$2 - Math.imul(1440, quotHi$1)) | 0);
  var quotLo$1 = ((6.944444444444448E-4 * ((4.294967296E9 * k$1) + (rlo$2 >>> 0.0))) | 0.0);
  if ((minutes_$_hi < 0)) {
    var lo$10 = ((-quotLo$1) | 0);
    var hi$10 = ((((-quotHi$1) | 0) - ((lo$10 !== 0) | 0)) | 0);
    var x$6_$_lo = lo$10;
    var x$6_$_hi = hi$10;
  } else {
    var x$6_$_lo = quotLo$1;
    var x$6_$_hi = quotHi$1;
  }
  var lo$11 = ((lo$9 + x$6_$_lo) | 0);
  var hi$11 = ((((hi$9 + x$6_$_hi) | 0) + (((lo$11 >>> 0) < (lo$9 >>> 0)) | 0)) | 0);
  var sign$4 = (hours_$_hi >> 31);
  var xlo$3 = (hours_$_lo ^ sign$4);
  var rlo$3 = ((xlo$3 - sign$4) | 0);
  var rhi$3 = (((hours_$_hi ^ sign$4) + (((rlo$3 >>> 0) < (xlo$3 >>> 0)) | 0)) | 0);
  var quotHi$2 = (((rhi$3 >>> 0) / 24) | 0);
  var k$2 = ((rhi$3 - Math.imul(24, quotHi$2)) | 0);
  var quotLo$2 = ((0.041666666666666685 * ((4.294967296E9 * k$2) + (rlo$3 >>> 0.0))) | 0.0);
  if ((hours_$_hi < 0)) {
    var lo$12 = ((-quotLo$2) | 0);
    var hi$12 = ((((-quotHi$2) | 0) - ((lo$12 !== 0) | 0)) | 0);
    var x$8_$_lo = lo$12;
    var x$8_$_hi = hi$12;
  } else {
    var x$8_$_lo = quotLo$2;
    var x$8_$_hi = quotHi$2;
  }
  var lo$13 = ((lo$11 + x$8_$_lo) | 0);
  var hi$13 = ((((hi$11 + x$8_$_hi) | 0) + (((lo$13 >>> 0) < (lo$11 >>> 0)) | 0)) | 0);
  var totDays_$_lo = lo$13;
  var totDays_$_hi = hi$13;
  var x$9_$_lo = totDays_$_lo;
  var x$9_$_hi = totDays_$_hi;
  var hi$14 = (sign >> 31);
  var a0 = (65535 & x$9_$_lo);
  var a1 = ((x$9_$_lo >>> 16) | 0);
  var b0$1 = (65535 & sign);
  var b1$1 = ((sign >>> 16) | 0);
  var a0b0 = Math.imul(a0, b0$1);
  var a1b0$1 = Math.imul(a1, b0$1);
  var a0b1 = Math.imul(a0, b1$1);
  var lo$14 = ((a0b0 + (((a1b0$1 + a0b1) | 0) << 16)) | 0);
  var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
  var hi$15 = ((((((((Math.imul(x$9_$_lo, hi$14) + Math.imul(x$9_$_hi, sign)) | 0) + Math.imul(a1, b1$1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0$1) | 0) >>> 16) | 0)) | 0);
  totDays_$_lo = lo$14;
  totDays_$_hi = hi$15;
  var sign$5 = (nanos_$_hi >> 31);
  var xlo$4 = (nanos_$_lo ^ sign$5);
  var rlo$4 = ((xlo$4 - sign$5) | 0);
  var rhi$4 = (((nanos_$_hi ^ sign$5) + (((rlo$4 >>> 0) < (xlo$4 >>> 0)) | 0)) | 0);
  var aHat$1 = ((4.294967296E9 * (rhi$4 >>> 0.0)) + (rlo$4 >>> 0.0));
  var x$10 = (1.1574074074074086E-14 * aHat$1);
  var lo$15 = (x$10 | 0.0);
  var hi$16 = ((2.3283064365386963E-10 * x$10) | 0.0);
  var b0$2 = (65535 & lo$15);
  var b1$2 = ((lo$15 >>> 16) | 0);
  var a1b0$2 = Math.imul(37199, b0$2);
  var lo$16 = (a1b0$2 << 16);
  var hi$17 = ((((((Math.imul((-1857093632), hi$16) + Math.imul(20116, lo$15)) | 0) + Math.imul(37199, b1$2)) | 0) + ((a1b0$2 >>> 16) | 0)) | 0);
  var lo$17 = ((rlo$4 - lo$16) | 0);
  var hi$18 = ((((rhi$4 - hi$17) | 0) - (((lo$17 >>> 0) > (rlo$4 >>> 0)) | 0)) | 0);
  if ((hi$18 < 0)) {
    var lo$18 = ((lo$17 - 1857093632) | 0);
    var hi$19 = ((((20116 + hi$18) | 0) + (((lo$18 >>> 0) < 2437873664) | 0)) | 0);
    var absR$1_$_lo = lo$18;
    var absR$1_$_hi = hi$19;
  } else {
    var absR$1_$_lo = lo$17;
    var absR$1_$_hi = hi$18;
  }
  if ((nanos_$_hi < 0)) {
    var lo$19 = ((-absR$1_$_lo) | 0);
    var hi$20 = ((((-absR$1_$_hi) | 0) - ((lo$19 !== 0) | 0)) | 0);
    var x$14_$_lo = lo$19;
    var x$14_$_hi = hi$20;
  } else {
    var x$14_$_lo = absR$1_$_lo;
    var x$14_$_hi = absR$1_$_hi;
  }
  var sign$6 = (seconds_$_hi >> 31);
  var xlo$5 = (seconds_$_lo ^ sign$6);
  var rlo$5 = ((xlo$5 - sign$6) | 0);
  var rhi$5 = (((seconds_$_hi ^ sign$6) + (((rlo$5 >>> 0) < (xlo$5 >>> 0)) | 0)) | 0);
  var k$2$1 = (((rhi$5 >>> 0) % 86400) | 0);
  var quotLo$2$1 = ((1.1574074074074079E-5 * ((4.294967296E9 * k$2$1) + (rlo$5 >>> 0.0))) | 0.0);
  var remLo = ((rlo$5 - Math.imul(86400, quotLo$2$1)) | 0);
  if ((seconds_$_hi < 0)) {
    var lo$20 = ((-remLo) | 0);
    var hi$21 = ((-((lo$20 !== 0) | 0)) | 0);
    var x$13_$_lo = lo$20;
    var x$13_$_hi = hi$21;
  } else {
    var x$13_$_lo = remLo;
    var x$13_$_hi = 0;
  }
  var b0$3 = (65535 & x$13_$_lo);
  var b1$3 = ((x$13_$_lo >>> 16) | 0);
  var a0b0$1 = Math.imul(51712, b0$3);
  var a1b0$3 = Math.imul(15258, b0$3);
  var a0b1$1 = Math.imul(51712, b1$3);
  var lo$21 = ((a0b0$1 + (((a1b0$3 + a0b1$1) | 0) << 16)) | 0);
  var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
  var hi$22 = ((((((Math.imul(1000000000, x$13_$_hi) + Math.imul(15258, b1$3)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$3) | 0) >>> 16) | 0)) | 0);
  var lo$22 = ((x$14_$_lo + lo$21) | 0);
  var hi$23 = ((((x$14_$_hi + hi$22) | 0) + (((lo$22 >>> 0) < (x$14_$_lo >>> 0)) | 0)) | 0);
  var sign$7 = (minutes_$_hi >> 31);
  var xlo$6 = (minutes_$_lo ^ sign$7);
  var rlo$6 = ((xlo$6 - sign$7) | 0);
  var rhi$6 = (((minutes_$_hi ^ sign$7) + (((rlo$6 >>> 0) < (xlo$6 >>> 0)) | 0)) | 0);
  var k$2$2 = (((rhi$6 >>> 0) % 1440) | 0);
  var quotLo$2$2 = ((6.944444444444448E-4 * ((4.294967296E9 * k$2$2) + (rlo$6 >>> 0.0))) | 0.0);
  var remLo$1 = ((rlo$6 - Math.imul(1440, quotLo$2$2)) | 0);
  if ((minutes_$_hi < 0)) {
    var lo$23 = ((-remLo$1) | 0);
    var hi$24 = ((-((lo$23 !== 0) | 0)) | 0);
    var x$16_$_lo = lo$23;
    var x$16_$_hi = hi$24;
  } else {
    var x$16_$_lo = remLo$1;
    var x$16_$_hi = 0;
  }
  var b0$4 = (65535 & x$16_$_lo);
  var b1$4 = ((x$16_$_lo >>> 16) | 0);
  var a0b0$2 = Math.imul(22528, b0$4);
  var a1b0$4 = Math.imul(63559, b0$4);
  var a0b1$2 = Math.imul(22528, b1$4);
  var lo$24 = ((a0b0$2 + (((a1b0$4 + a0b1$2) | 0) << 16)) | 0);
  var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
  var hi$25 = ((((((((Math.imul((-129542144), x$16_$_hi) + Math.imul(13, x$16_$_lo)) | 0) + Math.imul(63559, b1$4)) | 0) + ((c1part$2 >>> 16) | 0)) | 0) + (((((65535 & c1part$2) + a1b0$4) | 0) >>> 16) | 0)) | 0);
  var lo$25 = ((lo$22 + lo$24) | 0);
  var hi$26 = ((((hi$23 + hi$25) | 0) + (((lo$25 >>> 0) < (lo$22 >>> 0)) | 0)) | 0);
  var sign$8 = (hours_$_hi >> 31);
  var xlo$7 = (hours_$_lo ^ sign$8);
  var rlo$7 = ((xlo$7 - sign$8) | 0);
  var rhi$7 = (((hours_$_hi ^ sign$8) + (((rlo$7 >>> 0) < (xlo$7 >>> 0)) | 0)) | 0);
  var k$2$3 = (((rhi$7 >>> 0) % 24) | 0);
  var quotLo$2$3 = ((0.041666666666666685 * ((4.294967296E9 * k$2$3) + (rlo$7 >>> 0.0))) | 0.0);
  var remLo$2 = ((rlo$7 - Math.imul(24, quotLo$2$3)) | 0);
  if ((hours_$_hi < 0)) {
    var lo$26 = ((-remLo$2) | 0);
    var hi$27 = ((-((lo$26 !== 0) | 0)) | 0);
    var x$18_$_lo = lo$26;
    var x$18_$_hi = hi$27;
  } else {
    var x$18_$_lo = remLo$2;
    var x$18_$_hi = 0;
  }
  var b0$5 = (65535 & x$18_$_lo);
  var b1$5 = ((x$18_$_lo >>> 16) | 0);
  var a0b0$3 = Math.imul(40960, b0$5);
  var a1b0$5 = Math.imul(12472, b0$5);
  var a0b1$3 = Math.imul(40960, b1$5);
  var lo$27 = ((a0b0$3 + (((a1b0$5 + a0b1$3) | 0) << 16)) | 0);
  var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
  var hi$28 = ((((((((Math.imul(817405952, x$18_$_hi) + Math.imul(838, x$18_$_lo)) | 0) + Math.imul(12472, b1$5)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$5) | 0) >>> 16) | 0)) | 0);
  var lo$28 = ((lo$25 + lo$27) | 0);
  var hi$29 = ((((hi$26 + hi$28) | 0) + (((lo$28 >>> 0) < (lo$25 >>> 0)) | 0)) | 0);
  var totNanos_$_lo = lo$28;
  var totNanos_$_hi = hi$29;
  var $x_1 = $thiz.aO.iv();
  var curNoD_$_lo = $x_1.l;
  var curNoD_$_hi = $x_1.h;
  var x$19_$_lo = totNanos_$_lo;
  var x$19_$_hi = totNanos_$_hi;
  var hi$30 = (sign >> 31);
  var a0$1 = (65535 & x$19_$_lo);
  var a1$1 = ((x$19_$_lo >>> 16) | 0);
  var b0$6 = (65535 & sign);
  var b1$6 = ((sign >>> 16) | 0);
  var a0b0$4 = Math.imul(a0$1, b0$6);
  var a1b0$6 = Math.imul(a1$1, b0$6);
  var a0b1$4 = Math.imul(a0$1, b1$6);
  var lo$29 = ((a0b0$4 + (((a1b0$6 + a0b1$4) | 0) << 16)) | 0);
  var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
  var hi$31 = ((((((((Math.imul(x$19_$_lo, hi$30) + Math.imul(x$19_$_hi, sign)) | 0) + Math.imul(a1$1, b1$6)) | 0) + ((c1part$4 >>> 16) | 0)) | 0) + (((((65535 & c1part$4) + a1b0$6) | 0) >>> 16) | 0)) | 0);
  var lo$30 = ((lo$29 + curNoD_$_lo) | 0);
  var hi$32 = ((((hi$31 + curNoD_$_hi) | 0) + (((lo$30 >>> 0) < (lo$29 >>> 0)) | 0)) | 0);
  totNanos_$_lo = lo$30;
  totNanos_$_hi = hi$32;
  var x$22_$_lo = totDays_$_lo;
  var x$22_$_hi = totDays_$_hi;
  var a_$_lo = totNanos_$_lo;
  var a_$_hi = totNanos_$_hi;
  var sign$9 = (a_$_hi >> 31);
  var xlo$8 = (a_$_lo ^ sign$9);
  var rlo$8 = ((xlo$8 - sign$9) | 0);
  var rhi$8 = (((a_$_hi ^ sign$9) + (((rlo$8 >>> 0) < (xlo$8 >>> 0)) | 0)) | 0);
  var aHat$2 = ((4.294967296E9 * (rhi$8 >>> 0.0)) + (rlo$8 >>> 0.0));
  var x$20 = (1.1574074074074086E-14 * aHat$2);
  var lo$31 = (x$20 | 0.0);
  var hi$33 = ((2.3283064365386963E-10 * x$20) | 0.0);
  var b0$7 = (65535 & lo$31);
  var b1$7 = ((lo$31 >>> 16) | 0);
  var a1b0$7 = Math.imul(37199, b0$7);
  var lo$32 = (a1b0$7 << 16);
  var hi$34 = ((((((Math.imul((-1857093632), hi$33) + Math.imul(20116, lo$31)) | 0) + Math.imul(37199, b1$7)) | 0) + ((a1b0$7 >>> 16) | 0)) | 0);
  var lo$33 = ((rlo$8 - lo$32) | 0);
  var hi$35 = ((((rhi$8 - hi$34) | 0) - (((lo$33 >>> 0) > (rlo$8 >>> 0)) | 0)) | 0);
  if ((hi$35 < 0)) {
    var lo$34 = ((lo$31 - 1) | 0);
    var hi$36 = ((((hi$33 - 1) | 0) + ((lo$34 !== (-1)) | 0)) | 0);
    var absR$2_$_lo = lo$34;
    var absR$2_$_hi = hi$36;
  } else {
    var absR$2_$_lo = lo$31;
    var absR$2_$_hi = hi$33;
  }
  if ((a_$_hi < 0)) {
    var lo$35 = ((-absR$2_$_lo) | 0);
    var hi$37 = ((((-absR$2_$_hi) | 0) - ((lo$35 !== 0) | 0)) | 0);
    var quot_$_lo = lo$35;
    var quot_$_hi = hi$37;
  } else {
    var quot_$_lo = absR$2_$_lo;
    var quot_$_hi = absR$2_$_hi;
  }
  if (((20116 ^ a_$_hi) >= 0)) {
    var $x_2 = true;
  } else {
    var b0$8 = (65535 & quot_$_lo);
    var b1$8 = ((quot_$_lo >>> 16) | 0);
    var a1b0$8 = Math.imul(37199, b0$8);
    var $x_2 = ((((a1b0$8 << 16) ^ a_$_lo) | (((((((Math.imul((-1857093632), quot_$_hi) + Math.imul(20116, quot_$_lo)) | 0) + Math.imul(37199, b1$8)) | 0) + ((a1b0$8 >>> 16) | 0)) | 0) ^ a_$_hi)) === 0);
  }
  if ($x_2) {
    var x$23_$_lo = quot_$_lo;
    var x$23_$_hi = quot_$_hi;
  } else {
    var lo$38 = ((quot_$_lo - 1) | 0);
    var hi$40 = ((((quot_$_hi - 1) | 0) + ((lo$38 !== (-1)) | 0)) | 0);
    var x$23_$_lo = lo$38;
    var x$23_$_hi = hi$40;
  }
  var lo$39 = ((x$22_$_lo + x$23_$_lo) | 0);
  var hi$41 = ((((x$22_$_hi + x$23_$_hi) | 0) + (((lo$39 >>> 0) < (x$22_$_lo >>> 0)) | 0)) | 0);
  totDays_$_lo = lo$39;
  totDays_$_hi = hi$41;
  var a$1_$_lo = totNanos_$_lo;
  var a$1_$_hi = totNanos_$_hi;
  var sign$10 = (a$1_$_hi >> 31);
  var xlo$9 = (a$1_$_lo ^ sign$10);
  var rlo$9 = ((xlo$9 - sign$10) | 0);
  var rhi$9 = (((a$1_$_hi ^ sign$10) + (((rlo$9 >>> 0) < (xlo$9 >>> 0)) | 0)) | 0);
  var aHat$3 = ((4.294967296E9 * (rhi$9 >>> 0.0)) + (rlo$9 >>> 0.0));
  var x$24 = (1.1574074074074086E-14 * aHat$3);
  var lo$40 = (x$24 | 0.0);
  var hi$42 = ((2.3283064365386963E-10 * x$24) | 0.0);
  var b0$9 = (65535 & lo$40);
  var b1$9 = ((lo$40 >>> 16) | 0);
  var a1b0$9 = Math.imul(37199, b0$9);
  var lo$41 = (a1b0$9 << 16);
  var hi$43 = ((((((Math.imul((-1857093632), hi$42) + Math.imul(20116, lo$40)) | 0) + Math.imul(37199, b1$9)) | 0) + ((a1b0$9 >>> 16) | 0)) | 0);
  var lo$42 = ((rlo$9 - lo$41) | 0);
  var hi$44 = ((((rhi$9 - hi$43) | 0) - (((lo$42 >>> 0) > (rlo$9 >>> 0)) | 0)) | 0);
  if ((hi$44 < 0)) {
    var lo$43 = ((lo$42 - 1857093632) | 0);
    var hi$45 = ((((20116 + hi$44) | 0) + (((lo$43 >>> 0) < 2437873664) | 0)) | 0);
    var absR$3_$_lo = lo$43;
    var absR$3_$_hi = hi$45;
  } else {
    var absR$3_$_lo = lo$42;
    var absR$3_$_hi = hi$44;
  }
  if ((a$1_$_hi < 0)) {
    var lo$44 = ((-absR$3_$_lo) | 0);
    var hi$46 = ((((-absR$3_$_hi) | 0) - ((lo$44 !== 0) | 0)) | 0);
    var rem_$_lo = lo$44;
    var rem_$_hi = hi$46;
  } else {
    var rem_$_lo = absR$3_$_lo;
    var rem_$_hi = absR$3_$_hi;
  }
  if ((((20116 ^ a$1_$_hi) >= 0) || ((rem_$_lo | rem_$_hi) === 0))) {
    var newNoD_$_lo = rem_$_lo;
    var newNoD_$_hi = rem_$_hi;
  } else {
    var lo$46 = ((rem_$_lo - 1857093632) | 0);
    var hi$48 = ((((20116 + rem_$_hi) | 0) + (((lo$46 >>> 0) < 2437873664) | 0)) | 0);
    var newNoD_$_lo = lo$46;
    var newNoD_$_hi = hi$48;
  }
  var newTime = ((((newNoD_$_lo ^ curNoD_$_lo) | (newNoD_$_hi ^ curNoD_$_hi)) === 0) ? $thiz.aO : $m_Ljava_time_LocalTime$().l5(newNoD_$_lo, newNoD_$_hi));
  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime($thiz, newDate.eC(totDays_$_lo, totDays_$_hi), newTime);
}
export { $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime as $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime };
function $p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I($thiz, other) {
  var cmp = $thiz.aJ.Bi(other.aJ);
  if ((cmp === 0)) {
    cmp = $thiz.aO.x9(other.aO);
  }
  return cmp;
}
export { $p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I as $p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I };
/** @constructor */
function $c_Ljava_time_LocalDateTime(date, time) {
  this.aJ = null;
  this.aO = null;
  this.aJ = date;
  this.aO = time;
}
export { $c_Ljava_time_LocalDateTime as $c_Ljava_time_LocalDateTime };
$p = $c_Ljava_time_LocalDateTime.prototype = new $h_Ljava_time_chrono_ChronoLocalDateTime();
$p.constructor = $c_Ljava_time_LocalDateTime;
/** @constructor */
function $h_Ljava_time_LocalDateTime() {
}
export { $h_Ljava_time_LocalDateTime as $h_Ljava_time_LocalDateTime };
$h_Ljava_time_LocalDateTime.prototype = $p;
$p.ba = (function(field) {
  return ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField) ? (field.hk() || field.r6()) : ((field !== null) && this.ba(field)));
});
$p.bX = (function(field) {
  return ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField) ? (field.r6() ? $f_Ljava_time_temporal_TemporalAccessor__range__Ljava_time_temporal_TemporalField__Ljava_time_temporal_ValueRange(this.aO, field) : this.aJ.bX(field)) : this.bX(field));
});
$p.cC = (function(field) {
  return ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField) ? (field.r6() ? this.aO.cC(field) : this.aJ.cC(field)) : $f_Ljava_time_temporal_TemporalAccessor__get__Ljava_time_temporal_TemporalField__I(this, field));
});
$p.ai = (function(field) {
  if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    if (field.r6()) {
      return this.aO.ai(field);
    } else {
      return this.aJ.ai(field);
    }
  } else {
    return this.ai(field);
  }
});
$p.CL = (function(field, newValue_$_lo, newValue_$_hi) {
  return ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField) ? (field.r6() ? $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, this.aJ, this.aO.CM(field, newValue_$_lo, newValue_$_hi)) : $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, this.aJ.yf(field, newValue_$_lo, newValue_$_hi), this.aO)) : this.CL(field, newValue_$_lo, newValue_$_hi));
});
$p.l8 = (function(amountToAdd_$_lo, amountToAdd_$_hi, unit) {
  if ((unit instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$c_Ljava_time_temporal_ChronoUnit)) {
    var x = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__NANOS__Ljava_time_temporal_ChronoUnit();
    if (((x === null) ? (unit === null) : (x === unit))) {
      return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this, this.aJ, 0, 0, 0, 0, 0, 0, amountToAdd_$_lo, amountToAdd_$_hi, 1);
    } else {
      var x$3 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__MICROS__Ljava_time_temporal_ChronoUnit();
      if (((x$3 === null) ? (unit === null) : (x$3 === unit))) {
        var sign = (amountToAdd_$_hi >> 31);
        var xlo = (amountToAdd_$_lo ^ sign);
        var rlo = ((xlo - sign) | 0);
        var rhi = (((amountToAdd_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
        var aHat = ((4.294967296E9 * (rhi >>> 0.0)) + (rlo >>> 0.0));
        var x$1 = (1.1574074074074087E-11 * aHat);
        var lo = (x$1 | 0.0);
        var hi = ((2.3283064365386963E-10 * x$1) | 0.0);
        var b0 = (65535 & lo);
        var b1 = ((lo >>> 16) | 0);
        var a0b0 = Math.imul(24576, b0);
        var a1b0 = Math.imul(7639, b0);
        var a0b1 = Math.imul(24576, b1);
        var lo$1 = ((a0b0 + (((a1b0 + a0b1) | 0) << 16)) | 0);
        var c1part = ((((a0b0 >>> 16) | 0) + a0b1) | 0);
        var hi$1 = ((((((((Math.imul(500654080, hi) + Math.imul(20, lo)) | 0) + Math.imul(7639, b1)) | 0) + ((c1part >>> 16) | 0)) | 0) + (((((65535 & c1part) + a1b0) | 0) >>> 16) | 0)) | 0);
        var lo$2 = ((rlo - lo$1) | 0);
        var hi$2 = ((((rhi - hi$1) | 0) - (((lo$2 >>> 0) > (rlo >>> 0)) | 0)) | 0);
        if ((hi$2 < 0)) {
          var lo$3 = ((lo - 1) | 0);
          var hi$3 = ((((hi - 1) | 0) + ((lo$3 !== (-1)) | 0)) | 0);
          var absR_$_lo = lo$3;
          var absR_$_hi = hi$3;
        } else {
          var absR_$_lo = lo;
          var absR_$_hi = hi;
        }
        if ((amountToAdd_$_hi < 0)) {
          var lo$4 = ((-absR_$_lo) | 0);
          var hi$4 = ((((-absR_$_hi) | 0) - ((lo$4 !== 0) | 0)) | 0);
          var $x_1_$_lo = lo$4;
          var $x_1_$_hi = hi$4;
        } else {
          var $x_1_$_lo = absR_$_lo;
          var $x_1_$_hi = absR_$_hi;
        }
        var this$28 = this.xT($x_1_$_lo, $x_1_$_hi);
        var sign$1 = (amountToAdd_$_hi >> 31);
        var xlo$1 = (amountToAdd_$_lo ^ sign$1);
        var rlo$1 = ((xlo$1 - sign$1) | 0);
        var rhi$1 = (((amountToAdd_$_hi ^ sign$1) + (((rlo$1 >>> 0) < (xlo$1 >>> 0)) | 0)) | 0);
        var aHat$1 = ((4.294967296E9 * (rhi$1 >>> 0.0)) + (rlo$1 >>> 0.0));
        var x$4 = (1.1574074074074087E-11 * aHat$1);
        var lo$5 = (x$4 | 0.0);
        var hi$5 = ((2.3283064365386963E-10 * x$4) | 0.0);
        var b0$1 = (65535 & lo$5);
        var b1$1 = ((lo$5 >>> 16) | 0);
        var a0b0$1 = Math.imul(24576, b0$1);
        var a1b0$1 = Math.imul(7639, b0$1);
        var a0b1$1 = Math.imul(24576, b1$1);
        var lo$6 = ((a0b0$1 + (((a1b0$1 + a0b1$1) | 0) << 16)) | 0);
        var c1part$1 = ((((a0b0$1 >>> 16) | 0) + a0b1$1) | 0);
        var hi$6 = ((((((((Math.imul(500654080, hi$5) + Math.imul(20, lo$5)) | 0) + Math.imul(7639, b1$1)) | 0) + ((c1part$1 >>> 16) | 0)) | 0) + (((((65535 & c1part$1) + a1b0$1) | 0) >>> 16) | 0)) | 0);
        var lo$7 = ((rlo$1 - lo$6) | 0);
        var hi$7 = ((((rhi$1 - hi$6) | 0) - (((lo$7 >>> 0) > (rlo$1 >>> 0)) | 0)) | 0);
        if ((hi$7 < 0)) {
          var lo$8 = ((500654080 + lo$7) | 0);
          var hi$8 = ((((20 + hi$7) | 0) + (((lo$8 >>> 0) < 500654080) | 0)) | 0);
          var absR$1_$_lo = lo$8;
          var absR$1_$_hi = hi$8;
        } else {
          var absR$1_$_lo = lo$7;
          var absR$1_$_hi = hi$7;
        }
        if ((amountToAdd_$_hi < 0)) {
          var lo$9 = ((-absR$1_$_lo) | 0);
          var hi$9 = ((((-absR$1_$_hi) | 0) - ((lo$9 !== 0) | 0)) | 0);
          var x$6_$_lo = lo$9;
          var x$6_$_hi = hi$9;
        } else {
          var x$6_$_lo = absR$1_$_lo;
          var x$6_$_hi = absR$1_$_hi;
        }
        var b0$2 = (65535 & x$6_$_lo);
        var b1$2 = ((x$6_$_lo >>> 16) | 0);
        var a0b0$2 = Math.imul(1000, b0$2);
        var a0b1$2 = Math.imul(1000, b1$2);
        var lo$10 = ((a0b0$2 + (a0b1$2 << 16)) | 0);
        var c1part$2 = ((((a0b0$2 >>> 16) | 0) + a0b1$2) | 0);
        var hi$10 = ((Math.imul(1000, x$6_$_hi) + ((c1part$2 >>> 16) | 0)) | 0);
        return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$28, this$28.aJ, 0, 0, 0, 0, 0, 0, lo$10, hi$10, 1);
      } else {
        var x$5$1 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__MILLIS__Ljava_time_temporal_ChronoUnit();
        if (((x$5$1 === null) ? (unit === null) : (x$5$1 === unit))) {
          var sign$2 = (amountToAdd_$_hi >> 31);
          var xlo$2 = (amountToAdd_$_lo ^ sign$2);
          var rlo$2 = ((xlo$2 - sign$2) | 0);
          var rhi$2 = (((amountToAdd_$_hi ^ sign$2) + (((rlo$2 >>> 0) < (xlo$2 >>> 0)) | 0)) | 0);
          var aHat$2 = ((4.294967296E9 * (rhi$2 >>> 0.0)) + (rlo$2 >>> 0.0));
          var x$7 = (1.1574074074074087E-8 * aHat$2);
          var lo$11 = (x$7 | 0.0);
          var hi$11 = ((2.3283064365386963E-10 * x$7) | 0.0);
          var rHat = ((rlo$2 - Math.imul(86400000, lo$11)) | 0);
          if ((rHat < 0)) {
            var lo$12 = ((lo$11 - 1) | 0);
            var hi$12 = ((((hi$11 - 1) | 0) + ((lo$12 !== (-1)) | 0)) | 0);
            var absR$2_$_lo = lo$12;
            var absR$2_$_hi = hi$12;
          } else {
            var absR$2_$_lo = lo$11;
            var absR$2_$_hi = hi$11;
          }
          if ((amountToAdd_$_hi < 0)) {
            var lo$13 = ((-absR$2_$_lo) | 0);
            var hi$13 = ((((-absR$2_$_hi) | 0) - ((lo$13 !== 0) | 0)) | 0);
            var $x_2_$_lo = lo$13;
            var $x_2_$_hi = hi$13;
          } else {
            var $x_2_$_lo = absR$2_$_lo;
            var $x_2_$_hi = absR$2_$_hi;
          }
          var this$53 = this.xT($x_2_$_lo, $x_2_$_hi);
          var sign$3 = (amountToAdd_$_hi >> 31);
          var xlo$3 = (amountToAdd_$_lo ^ sign$3);
          var rlo$3 = ((xlo$3 - sign$3) | 0);
          var rhi$3 = (((amountToAdd_$_hi ^ sign$3) + (((rlo$3 >>> 0) < (xlo$3 >>> 0)) | 0)) | 0);
          var aHat$3 = ((4.294967296E9 * (rhi$3 >>> 0.0)) + (rlo$3 >>> 0.0));
          var x$9 = (1.1574074074074087E-8 * aHat$3);
          var lo$14 = (x$9 | 0.0);
          ((2.3283064365386963E-10 * x$9) | 0.0);
          var rHat$1 = ((rlo$3 - Math.imul(86400000, lo$14)) | 0);
          if ((rHat$1 < 0)) {
            var lo$15 = ((86400000 + rHat$1) | 0);
            var absR$3_$_lo = lo$15;
            var absR$3_$_hi = 0;
          } else {
            var absR$3_$_lo = rHat$1;
            var absR$3_$_hi = 0;
          }
          if ((amountToAdd_$_hi < 0)) {
            var lo$16 = ((-absR$3_$_lo) | 0);
            var hi$15 = ((((-absR$3_$_hi) | 0) - ((lo$16 !== 0) | 0)) | 0);
            var x$11_$_lo = lo$16;
            var x$11_$_hi = hi$15;
          } else {
            var x$11_$_lo = absR$3_$_lo;
            var x$11_$_hi = absR$3_$_hi;
          }
          var b0$3 = (65535 & x$11_$_lo);
          var b1$3 = ((x$11_$_lo >>> 16) | 0);
          var a0b0$3 = Math.imul(16960, b0$3);
          var a1b0$2 = Math.imul(15, b0$3);
          var a0b1$3 = Math.imul(16960, b1$3);
          var lo$17 = ((a0b0$3 + (((a1b0$2 + a0b1$3) | 0) << 16)) | 0);
          var c1part$3 = ((((a0b0$3 >>> 16) | 0) + a0b1$3) | 0);
          var hi$16 = ((((((Math.imul(1000000, x$11_$_hi) + Math.imul(15, b1$3)) | 0) + ((c1part$3 >>> 16) | 0)) | 0) + (((((65535 & c1part$3) + a1b0$2) | 0) >>> 16) | 0)) | 0);
          return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$53, this$53.aJ, 0, 0, 0, 0, 0, 0, lo$17, hi$16, 1);
        } else {
          var x$7$1 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__SECONDS__Ljava_time_temporal_ChronoUnit();
          if (((x$7$1 === null) ? (unit === null) : (x$7$1 === unit))) {
            return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this, this.aJ, 0, 0, 0, 0, amountToAdd_$_lo, amountToAdd_$_hi, 0, 0, 1);
          } else {
            var x$9$1 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__MINUTES__Ljava_time_temporal_ChronoUnit();
            if (((x$9$1 === null) ? (unit === null) : (x$9$1 === unit))) {
              return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this, this.aJ, 0, 0, amountToAdd_$_lo, amountToAdd_$_hi, 0, 0, 0, 0, 1);
            } else {
              var x$11$1 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__HOURS__Ljava_time_temporal_ChronoUnit();
              if (((x$11$1 === null) ? (unit === null) : (x$11$1 === unit))) {
                return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this, this.aJ, amountToAdd_$_lo, amountToAdd_$_hi, 0, 0, 0, 0, 0, 0, 1);
              } else {
                var x$13 = $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__HALF_DAYS__Ljava_time_temporal_ChronoUnit();
                if (((x$13 === null) ? (unit === null) : (x$13 === unit))) {
                  var hi$17 = (amountToAdd_$_hi >> 7);
                  var lo$19 = ((hi$17 >>> 24) | 0);
                  var lo$20 = ((amountToAdd_$_lo + lo$19) | 0);
                  var hi$18 = ((amountToAdd_$_hi + (((lo$20 >>> 0) < (amountToAdd_$_lo >>> 0)) | 0)) | 0);
                  var lo$21 = (((lo$20 >>> 8) | 0) | (hi$18 << 24));
                  var hi$19 = (hi$18 >> 8);
                  var this$64 = this.xT(lo$21, hi$19);
                  var hi$20 = (amountToAdd_$_hi >> 7);
                  var lo$23 = ((hi$20 >>> 24) | 0);
                  var lo$24 = ((amountToAdd_$_lo + lo$23) | 0);
                  var lo$25 = (255 & lo$24);
                  var lo$26 = ((lo$25 - lo$23) | 0);
                  var hi$22 = ((-(((lo$26 >>> 0) > (lo$25 >>> 0)) | 0)) | 0);
                  var b0$4 = (65535 & lo$26);
                  var b1$4 = ((lo$26 >>> 16) | 0);
                  var a0b0$4 = Math.imul(12, b0$4);
                  var a0b1$4 = Math.imul(12, b1$4);
                  var lo$27 = ((a0b0$4 + (a0b1$4 << 16)) | 0);
                  var c1part$4 = ((((a0b0$4 >>> 16) | 0) + a0b1$4) | 0);
                  var hi$23 = ((Math.imul(12, hi$22) + ((c1part$4 >>> 16) | 0)) | 0);
                  return $p_Ljava_time_LocalDateTime__plusWithOverflow__Ljava_time_LocalDate__J__J__J__J__I__Ljava_time_LocalDateTime(this$64, this$64.aJ, lo$27, hi$23, 0, 0, 0, 0, 0, 0, 1);
                } else {
                  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, this.aJ.re(amountToAdd_$_lo, amountToAdd_$_hi, unit), this.aO);
                }
              }
            }
          }
        }
      }
    }
  } else {
    return this.l8(amountToAdd_$_lo, amountToAdd_$_hi, unit);
  }
});
$p.xT = (function(days_$_lo, days_$_hi) {
  return $p_Ljava_time_LocalDateTime__with__Ljava_time_LocalDate__Ljava_time_LocalTime__Ljava_time_LocalDateTime(this, this.aJ.eC(days_$_lo, days_$_hi), this.aO);
});
$p.W3 = (function(amountToSubtract_$_lo, amountToSubtract_$_hi, unit) {
  if (((amountToSubtract_$_lo | ((-2147483648) ^ amountToSubtract_$_hi)) === 0)) {
    return this.l8((-1), 2147483647, unit).l8(1, 0, unit);
  } else {
    var lo = ((-amountToSubtract_$_lo) | 0);
    var hi = ((((-amountToSubtract_$_hi) | 0) - ((lo !== 0) | 0)) | 0);
    return this.l8(lo, hi, unit);
  }
});
$p.cg = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().fl()) ? this.aJ : $c_Ljava_time_chrono_ChronoLocalDateTime.prototype.cg.call(this, query));
});
$p.he = (function(temporal) {
  return $c_Ljava_time_chrono_ChronoLocalDateTime.prototype.he.call(this, temporal);
});
$p.On = (function(other) {
  return ((other instanceof $c_Ljava_time_LocalDateTime) ? $p_Ljava_time_LocalDateTime__compareTo0__Ljava_time_LocalDateTime__I(this, other) : this.Oi(other));
});
$p.f = (function(obj) {
  if ((obj instanceof $c_Ljava_time_LocalDateTime)) {
    if ((this === obj)) {
      return true;
    } else {
      var x = this.aJ;
      var x$2 = obj.aJ;
      if (((x === null) ? (x$2 === null) : x.f(x$2))) {
        var x$3 = this.aO;
        var x$4 = obj.aO;
        return ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
      } else {
        return false;
      }
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return (this.aJ.m() ^ this.aO.m());
});
$p.b = (function() {
  return ((this.aJ.b() + "T") + this.aO.b());
});
$p.fq = (function(field, newValue_$_lo, newValue_$_hi) {
  return this.CL(field, newValue_$_lo, newValue_$_hi);
});
$p.is = (function(amountToAdd_$_lo, amountToAdd_$_hi, unit) {
  return this.l8(amountToAdd_$_lo, amountToAdd_$_hi, unit);
});
$p.uj = (function(amountToSubtract_$_lo, amountToSubtract_$_hi, unit) {
  return this.W3(amountToSubtract_$_lo, amountToSubtract_$_hi, unit);
});
$p.fh = (function(that) {
  return this.On(that);
});
function $isArrayOf_Ljava_time_LocalDateTime(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.dz)));
}
export { $isArrayOf_Ljava_time_LocalDateTime as $isArrayOf_Ljava_time_LocalDateTime };
var $d_Ljava_time_LocalDateTime = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_LocalDateTime, "java.time.LocalDateTime", ({
  dz: 1,
  dF: 1,
  G: 1,
  bs: 1,
  I: 1,
  j: 1,
  aK: 1,
  a: 1
}));
export { $d_Ljava_time_LocalDateTime as $d_Ljava_time_LocalDateTime };
function $ct_Ljava_time_DayOfWeek__T__I__T__I__($thiz, name, ordinal, _$name, _$ordinal) {
  $thiz.hE = ordinal;
  $j_java$002elang$002e$002dEnum.$ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
export { $ct_Ljava_time_DayOfWeek__T__I__T__I__ as $ct_Ljava_time_DayOfWeek__T__I__T__I__ };
/** @constructor */
function $c_Ljava_time_DayOfWeek() {
  this.q = null;
  this.M = 0;
  this.hE = 0;
}
export { $c_Ljava_time_DayOfWeek as $c_Ljava_time_DayOfWeek };
$p = $c_Ljava_time_DayOfWeek.prototype = new $j_java$002elang$002e$002dEnum.$h_jl_Enum();
$p.constructor = $c_Ljava_time_DayOfWeek;
/** @constructor */
function $h_Ljava_time_DayOfWeek() {
}
export { $h_Ljava_time_DayOfWeek as $h_Ljava_time_DayOfWeek };
$h_Ljava_time_DayOfWeek.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.gx = (function() {
  return ((1 + this.hE) | 0);
});
$p.ba = (function(field) {
  return ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField) ? (field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField()) : ((field !== null) && this.ba(field)));
});
$p.bX = (function(field) {
  if ((field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
    return field.G;
  } else if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return this.bX(field);
  }
});
$p.cC = (function(field) {
  if ((field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
    return this.gx();
  } else {
    var $x_2 = this.bX(field);
    var $x_1 = this.ai(field);
    return $x_2.b0($x_1.l, $x_1.h, field);
  }
});
$p.ai = (function(field) {
  if ((field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField())) {
    var value = this.gx();
    var hi = (value >> 31);
    return $j_java$002elang$002e$002dObject.$bL(value, hi);
  } else if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return this.ai(field);
  }
});
$p.cg = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().gH()) ? $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__DAYS__Ljava_time_temporal_ChronoUnit() : (((((((query === $m_Ljava_time_temporal_TemporalQueries$().fl()) || (query === $m_Ljava_time_temporal_TemporalQueries$().ik())) || (query === $m_Ljava_time_temporal_TemporalQueries$().eR())) || (query === $m_Ljava_time_temporal_TemporalQueries$().hx())) || (query === $m_Ljava_time_temporal_TemporalQueries$().f1())) || (query === $m_Ljava_time_temporal_TemporalQueries$().gF())) ? null : query.dQ(this)));
});
$p.he = (function(temporal) {
  var $x_1 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__DAY_OF_WEEK__Ljava_time_temporal_ChronoField();
  var value = this.gx();
  var hi = (value >> 31);
  return temporal.fq($x_1, value, hi);
});
var $d_Ljava_time_DayOfWeek = new $j_java$002elang$002e$002dObject.$TypeData().i(0, "java.time.DayOfWeek", ({
  aS: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1
}));
export { $d_Ljava_time_DayOfWeek as $d_Ljava_time_DayOfWeek };
function $ct_Ljava_time_Month__T__I__T__I__($thiz, name, ordinal, _$name, _$ordinal) {
  $thiz.ef = ordinal;
  $j_java$002elang$002e$002dEnum.$ct_jl_Enum__T__I__($thiz, _$name, _$ordinal);
  return $thiz;
}
export { $ct_Ljava_time_Month__T__I__T__I__ as $ct_Ljava_time_Month__T__I__T__I__ };
/** @constructor */
function $c_Ljava_time_Month() {
  this.q = null;
  this.M = 0;
  this.ef = 0;
}
export { $c_Ljava_time_Month as $c_Ljava_time_Month };
$p = $c_Ljava_time_Month.prototype = new $j_java$002elang$002e$002dEnum.$h_jl_Enum();
$p.constructor = $c_Ljava_time_Month;
/** @constructor */
function $h_Ljava_time_Month() {
}
export { $h_Ljava_time_Month as $h_Ljava_time_Month };
$h_Ljava_time_Month.prototype = $p;
$p.I = (function() {
  return new $j_java$002elang$002e$002dObject.$c_s_Product$$anon$1(this);
});
$p.gx = (function() {
  return ((1 + this.ef) | 0);
});
$p.ba = (function(field) {
  return ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField) ? (field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField()) : ((field !== null) && this.ba(field)));
});
$p.bX = (function(field) {
  if ((field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
    return field.G;
  } else if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return this.bX(field);
  }
});
$p.cC = (function(field) {
  if ((field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
    return this.gx();
  } else {
    var $x_2 = this.bX(field);
    var $x_1 = this.ai(field);
    return $x_2.b0($x_1.l, $x_1.h, field);
  }
});
$p.ai = (function(field) {
  if ((field === $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField())) {
    var value = this.gx();
    var hi = (value >> 31);
    return $j_java$002elang$002e$002dObject.$bL(value, hi);
  } else if ((field instanceof $j_java$002etime$002etemporal$002e$002dChrono$002dField.$c_Ljava_time_temporal_ChronoField)) {
    throw new $j_java$002etime$002etemporal$002e$002dUnsupported$002dTemporal$002dType$002dException.$c_Ljava_time_temporal_UnsupportedTemporalTypeException(("Unsupported field: " + field));
  } else {
    return this.ai(field);
  }
});
$p.WD = (function(months_$_lo, months_$_hi) {
  var sign = (months_$_hi >> 31);
  var xlo = (months_$_lo ^ sign);
  var rlo = ((xlo - sign) | 0);
  var rhi = (((months_$_hi ^ sign) + (((rlo >>> 0) < (xlo >>> 0)) | 0)) | 0);
  var k$2 = (((rhi >>> 0) % 12) | 0);
  var quotLo$2 = ((0.08333333333333337 * ((4.294967296E9 * k$2) + (rlo >>> 0.0))) | 0.0);
  var remLo = ((rlo - Math.imul(12, quotLo$2)) | 0);
  if ((months_$_hi < 0)) {
    var lo = ((-remLo) | 0);
    var hi = ((-((lo !== 0) | 0)) | 0);
    var x$1_$_lo = lo;
    var x$1_$_hi = hi;
  } else {
    var x$1_$_lo = remLo;
    var x$1_$_hi = 0;
  }
  return $m_Ljava_time_Month$().Pt().a[((((this.ef + ((12 + x$1_$_lo) | 0)) | 0) % 12) | 0)];
});
$p.BZ = (function(leapYear) {
  var x = $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month();
  if (((x !== null) && (x === this))) {
    return (leapYear ? 29 : 28);
  }
  matchAlts1: {
    matchAlts2: {
      var x$3 = $s_Ljava_time_Month$__APRIL__Ljava_time_Month();
      if (((x$3 !== null) && (x$3 === this))) {
        break matchAlts2;
      }
      var x$5 = $s_Ljava_time_Month$__JUNE__Ljava_time_Month();
      if (((x$5 !== null) && (x$5 === this))) {
        break matchAlts2;
      }
      var x$7 = $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month();
      if (((x$7 !== null) && (x$7 === this))) {
        break matchAlts2;
      }
      var x$9 = $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month();
      if (((x$9 !== null) && (x$9 === this))) {
        break matchAlts2;
      }
      break matchAlts1;
    }
    return 30;
  }
  return 31;
});
$p.Bs = (function(leapYear) {
  var leap = (leapYear | 0);
  var x = $s_Ljava_time_Month$__JANUARY__Ljava_time_Month();
  if (((x !== null) && (x === this))) {
    return 1;
  }
  var x$3 = $s_Ljava_time_Month$__FEBRUARY__Ljava_time_Month();
  if (((x$3 !== null) && (x$3 === this))) {
    return 32;
  }
  var x$5 = $s_Ljava_time_Month$__MARCH__Ljava_time_Month();
  if (((x$5 !== null) && (x$5 === this))) {
    return ((60 + leap) | 0);
  }
  var x$7 = $s_Ljava_time_Month$__APRIL__Ljava_time_Month();
  if (((x$7 !== null) && (x$7 === this))) {
    return ((91 + leap) | 0);
  }
  var x$9 = $s_Ljava_time_Month$__MAY__Ljava_time_Month();
  if (((x$9 !== null) && (x$9 === this))) {
    return ((121 + leap) | 0);
  }
  var x$11 = $s_Ljava_time_Month$__JUNE__Ljava_time_Month();
  if (((x$11 !== null) && (x$11 === this))) {
    return ((152 + leap) | 0);
  }
  var x$13 = $s_Ljava_time_Month$__JULY__Ljava_time_Month();
  if (((x$13 !== null) && (x$13 === this))) {
    return ((182 + leap) | 0);
  }
  var x$15 = $s_Ljava_time_Month$__AUGUST__Ljava_time_Month();
  if (((x$15 !== null) && (x$15 === this))) {
    return ((213 + leap) | 0);
  }
  var x$17 = $s_Ljava_time_Month$__SEPTEMBER__Ljava_time_Month();
  if (((x$17 !== null) && (x$17 === this))) {
    return ((244 + leap) | 0);
  }
  var x$19 = $s_Ljava_time_Month$__OCTOBER__Ljava_time_Month();
  if (((x$19 !== null) && (x$19 === this))) {
    return ((274 + leap) | 0);
  }
  var x$21 = $s_Ljava_time_Month$__NOVEMBER__Ljava_time_Month();
  if (((x$21 !== null) && (x$21 === this))) {
    return ((305 + leap) | 0);
  }
  var x$23 = $s_Ljava_time_Month$__DECEMBER__Ljava_time_Month();
  if (((x$23 !== null) && (x$23 === this))) {
    return ((335 + leap) | 0);
  }
  throw new $j_java$002elang$002e$002dObject.$c_s_MatchError(this);
});
$p.cg = (function(query) {
  return ((query === $m_Ljava_time_temporal_TemporalQueries$().eR()) ? $m_Ljava_time_chrono_IsoChronology$().bz() : ((query === $m_Ljava_time_temporal_TemporalQueries$().gH()) ? $j_java$002etime$002etemporal$002e$002dChrono$002dUnit.$s_Ljava_time_temporal_ChronoUnit$__MONTHS__Ljava_time_temporal_ChronoUnit() : ((((((query === $m_Ljava_time_temporal_TemporalQueries$().fl()) || (query === $m_Ljava_time_temporal_TemporalQueries$().ik())) || (query === $m_Ljava_time_temporal_TemporalQueries$().hx())) || (query === $m_Ljava_time_temporal_TemporalQueries$().f1())) || (query === $m_Ljava_time_temporal_TemporalQueries$().gF())) ? null : query.dQ(this))));
});
$p.he = (function(temporal) {
  var x = $m_Ljava_time_chrono_Chronology$().Ua(temporal);
  var x$2 = $m_Ljava_time_chrono_IsoChronology$().bz();
  if ((!((x === null) ? (x$2 === null) : $j_java$002etime$002echrono$002e$002dChronology.$f_Ljava_time_chrono_Chronology__equals__O__Z(x, x$2)))) {
    throw $j_java$002etime$002e$002dDate$002dTime$002dException.$ct_Ljava_time_DateTimeException__T__(new $j_java$002etime$002e$002dDate$002dTime$002dException.$c_Ljava_time_DateTimeException(), "Adjustment only supported on ISO date-time");
  } else {
    var $x_1 = $j_java$002etime$002etemporal$002e$002dChrono$002dField.$s_Ljava_time_temporal_ChronoField$__MONTH_OF_YEAR__Ljava_time_temporal_ChronoField();
    var value = this.gx();
    var hi = (value >> 31);
    return temporal.fq($x_1, value, hi);
  }
});
var $d_Ljava_time_Month = new $j_java$002elang$002e$002dObject.$TypeData().i(0, "java.time.Month", ({
  al: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1
}));
export { $d_Ljava_time_Month as $d_Ljava_time_Month };
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$1() {
  this.q = null;
  this.M = 0;
  this.hE = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "MONDAY", 0, "MONDAY", 0);
}
export { $c_Ljava_time_DayOfWeek$$anon$1 as $c_Ljava_time_DayOfWeek$$anon$1 };
$p = $c_Ljava_time_DayOfWeek$$anon$1.prototype = new $h_Ljava_time_DayOfWeek();
$p.constructor = $c_Ljava_time_DayOfWeek$$anon$1;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$1() {
}
export { $h_Ljava_time_DayOfWeek$$anon$1 as $h_Ljava_time_DayOfWeek$$anon$1 };
$h_Ljava_time_DayOfWeek$$anon$1.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_DayOfWeek$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_DayOfWeek$$anon$1, "java.time.DayOfWeek$$anon$1", ({
  kI: 1,
  aS: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_DayOfWeek$$anon$1 as $d_Ljava_time_DayOfWeek$$anon$1 };
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$2() {
  this.q = null;
  this.M = 0;
  this.hE = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "TUESDAY", 1, "TUESDAY", 1);
}
export { $c_Ljava_time_DayOfWeek$$anon$2 as $c_Ljava_time_DayOfWeek$$anon$2 };
$p = $c_Ljava_time_DayOfWeek$$anon$2.prototype = new $h_Ljava_time_DayOfWeek();
$p.constructor = $c_Ljava_time_DayOfWeek$$anon$2;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$2() {
}
export { $h_Ljava_time_DayOfWeek$$anon$2 as $h_Ljava_time_DayOfWeek$$anon$2 };
$h_Ljava_time_DayOfWeek$$anon$2.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_DayOfWeek$$anon$2 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_DayOfWeek$$anon$2, "java.time.DayOfWeek$$anon$2", ({
  kJ: 1,
  aS: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_DayOfWeek$$anon$2 as $d_Ljava_time_DayOfWeek$$anon$2 };
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$3() {
  this.q = null;
  this.M = 0;
  this.hE = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "WEDNESDAY", 2, "WEDNESDAY", 2);
}
export { $c_Ljava_time_DayOfWeek$$anon$3 as $c_Ljava_time_DayOfWeek$$anon$3 };
$p = $c_Ljava_time_DayOfWeek$$anon$3.prototype = new $h_Ljava_time_DayOfWeek();
$p.constructor = $c_Ljava_time_DayOfWeek$$anon$3;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$3() {
}
export { $h_Ljava_time_DayOfWeek$$anon$3 as $h_Ljava_time_DayOfWeek$$anon$3 };
$h_Ljava_time_DayOfWeek$$anon$3.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_DayOfWeek$$anon$3 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_DayOfWeek$$anon$3, "java.time.DayOfWeek$$anon$3", ({
  kK: 1,
  aS: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_DayOfWeek$$anon$3 as $d_Ljava_time_DayOfWeek$$anon$3 };
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$4() {
  this.q = null;
  this.M = 0;
  this.hE = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "THURSDAY", 3, "THURSDAY", 3);
}
export { $c_Ljava_time_DayOfWeek$$anon$4 as $c_Ljava_time_DayOfWeek$$anon$4 };
$p = $c_Ljava_time_DayOfWeek$$anon$4.prototype = new $h_Ljava_time_DayOfWeek();
$p.constructor = $c_Ljava_time_DayOfWeek$$anon$4;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$4() {
}
export { $h_Ljava_time_DayOfWeek$$anon$4 as $h_Ljava_time_DayOfWeek$$anon$4 };
$h_Ljava_time_DayOfWeek$$anon$4.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_DayOfWeek$$anon$4 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_DayOfWeek$$anon$4, "java.time.DayOfWeek$$anon$4", ({
  kL: 1,
  aS: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_DayOfWeek$$anon$4 as $d_Ljava_time_DayOfWeek$$anon$4 };
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$5() {
  this.q = null;
  this.M = 0;
  this.hE = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "FRIDAY", 4, "FRIDAY", 4);
}
export { $c_Ljava_time_DayOfWeek$$anon$5 as $c_Ljava_time_DayOfWeek$$anon$5 };
$p = $c_Ljava_time_DayOfWeek$$anon$5.prototype = new $h_Ljava_time_DayOfWeek();
$p.constructor = $c_Ljava_time_DayOfWeek$$anon$5;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$5() {
}
export { $h_Ljava_time_DayOfWeek$$anon$5 as $h_Ljava_time_DayOfWeek$$anon$5 };
$h_Ljava_time_DayOfWeek$$anon$5.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_DayOfWeek$$anon$5 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_DayOfWeek$$anon$5, "java.time.DayOfWeek$$anon$5", ({
  kM: 1,
  aS: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_DayOfWeek$$anon$5 as $d_Ljava_time_DayOfWeek$$anon$5 };
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$6() {
  this.q = null;
  this.M = 0;
  this.hE = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "SATURDAY", 5, "SATURDAY", 5);
}
export { $c_Ljava_time_DayOfWeek$$anon$6 as $c_Ljava_time_DayOfWeek$$anon$6 };
$p = $c_Ljava_time_DayOfWeek$$anon$6.prototype = new $h_Ljava_time_DayOfWeek();
$p.constructor = $c_Ljava_time_DayOfWeek$$anon$6;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$6() {
}
export { $h_Ljava_time_DayOfWeek$$anon$6 as $h_Ljava_time_DayOfWeek$$anon$6 };
$h_Ljava_time_DayOfWeek$$anon$6.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_DayOfWeek$$anon$6 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_DayOfWeek$$anon$6, "java.time.DayOfWeek$$anon$6", ({
  kN: 1,
  aS: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_DayOfWeek$$anon$6 as $d_Ljava_time_DayOfWeek$$anon$6 };
/** @constructor */
function $c_Ljava_time_DayOfWeek$$anon$7() {
  this.q = null;
  this.M = 0;
  this.hE = 0;
  $ct_Ljava_time_DayOfWeek__T__I__T__I__(this, "SUNDAY", 6, "SUNDAY", 6);
}
export { $c_Ljava_time_DayOfWeek$$anon$7 as $c_Ljava_time_DayOfWeek$$anon$7 };
$p = $c_Ljava_time_DayOfWeek$$anon$7.prototype = new $h_Ljava_time_DayOfWeek();
$p.constructor = $c_Ljava_time_DayOfWeek$$anon$7;
/** @constructor */
function $h_Ljava_time_DayOfWeek$$anon$7() {
}
export { $h_Ljava_time_DayOfWeek$$anon$7 as $h_Ljava_time_DayOfWeek$$anon$7 };
$h_Ljava_time_DayOfWeek$$anon$7.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_DayOfWeek$$anon$7 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_DayOfWeek$$anon$7, "java.time.DayOfWeek$$anon$7", ({
  kO: 1,
  aS: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_DayOfWeek$$anon$7 as $d_Ljava_time_DayOfWeek$$anon$7 };
/** @constructor */
function $c_Ljava_time_Month$$anon$1() {
  this.q = null;
  this.M = 0;
  this.ef = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "JANUARY", 0, "JANUARY", 0);
}
export { $c_Ljava_time_Month$$anon$1 as $c_Ljava_time_Month$$anon$1 };
$p = $c_Ljava_time_Month$$anon$1.prototype = new $h_Ljava_time_Month();
$p.constructor = $c_Ljava_time_Month$$anon$1;
/** @constructor */
function $h_Ljava_time_Month$$anon$1() {
}
export { $h_Ljava_time_Month$$anon$1 as $h_Ljava_time_Month$$anon$1 };
$h_Ljava_time_Month$$anon$1.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$1 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Month$$anon$1, "java.time.Month$$anon$1", ({
  kW: 1,
  al: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_Month$$anon$1 as $d_Ljava_time_Month$$anon$1 };
/** @constructor */
function $c_Ljava_time_Month$$anon$10() {
  this.q = null;
  this.M = 0;
  this.ef = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "OCTOBER", 9, "OCTOBER", 9);
}
export { $c_Ljava_time_Month$$anon$10 as $c_Ljava_time_Month$$anon$10 };
$p = $c_Ljava_time_Month$$anon$10.prototype = new $h_Ljava_time_Month();
$p.constructor = $c_Ljava_time_Month$$anon$10;
/** @constructor */
function $h_Ljava_time_Month$$anon$10() {
}
export { $h_Ljava_time_Month$$anon$10 as $h_Ljava_time_Month$$anon$10 };
$h_Ljava_time_Month$$anon$10.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$10 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Month$$anon$10, "java.time.Month$$anon$10", ({
  kX: 1,
  al: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_Month$$anon$10 as $d_Ljava_time_Month$$anon$10 };
/** @constructor */
function $c_Ljava_time_Month$$anon$11() {
  this.q = null;
  this.M = 0;
  this.ef = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "NOVEMBER", 10, "NOVEMBER", 10);
}
export { $c_Ljava_time_Month$$anon$11 as $c_Ljava_time_Month$$anon$11 };
$p = $c_Ljava_time_Month$$anon$11.prototype = new $h_Ljava_time_Month();
$p.constructor = $c_Ljava_time_Month$$anon$11;
/** @constructor */
function $h_Ljava_time_Month$$anon$11() {
}
export { $h_Ljava_time_Month$$anon$11 as $h_Ljava_time_Month$$anon$11 };
$h_Ljava_time_Month$$anon$11.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$11 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Month$$anon$11, "java.time.Month$$anon$11", ({
  kY: 1,
  al: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_Month$$anon$11 as $d_Ljava_time_Month$$anon$11 };
/** @constructor */
function $c_Ljava_time_Month$$anon$12() {
  this.q = null;
  this.M = 0;
  this.ef = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "DECEMBER", 11, "DECEMBER", 11);
}
export { $c_Ljava_time_Month$$anon$12 as $c_Ljava_time_Month$$anon$12 };
$p = $c_Ljava_time_Month$$anon$12.prototype = new $h_Ljava_time_Month();
$p.constructor = $c_Ljava_time_Month$$anon$12;
/** @constructor */
function $h_Ljava_time_Month$$anon$12() {
}
export { $h_Ljava_time_Month$$anon$12 as $h_Ljava_time_Month$$anon$12 };
$h_Ljava_time_Month$$anon$12.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$12 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Month$$anon$12, "java.time.Month$$anon$12", ({
  kZ: 1,
  al: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_Month$$anon$12 as $d_Ljava_time_Month$$anon$12 };
/** @constructor */
function $c_Ljava_time_Month$$anon$2() {
  this.q = null;
  this.M = 0;
  this.ef = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "FEBRUARY", 1, "FEBRUARY", 1);
}
export { $c_Ljava_time_Month$$anon$2 as $c_Ljava_time_Month$$anon$2 };
$p = $c_Ljava_time_Month$$anon$2.prototype = new $h_Ljava_time_Month();
$p.constructor = $c_Ljava_time_Month$$anon$2;
/** @constructor */
function $h_Ljava_time_Month$$anon$2() {
}
export { $h_Ljava_time_Month$$anon$2 as $h_Ljava_time_Month$$anon$2 };
$h_Ljava_time_Month$$anon$2.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$2 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Month$$anon$2, "java.time.Month$$anon$2", ({
  l0: 1,
  al: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_Month$$anon$2 as $d_Ljava_time_Month$$anon$2 };
/** @constructor */
function $c_Ljava_time_Month$$anon$3() {
  this.q = null;
  this.M = 0;
  this.ef = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "MARCH", 2, "MARCH", 2);
}
export { $c_Ljava_time_Month$$anon$3 as $c_Ljava_time_Month$$anon$3 };
$p = $c_Ljava_time_Month$$anon$3.prototype = new $h_Ljava_time_Month();
$p.constructor = $c_Ljava_time_Month$$anon$3;
/** @constructor */
function $h_Ljava_time_Month$$anon$3() {
}
export { $h_Ljava_time_Month$$anon$3 as $h_Ljava_time_Month$$anon$3 };
$h_Ljava_time_Month$$anon$3.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$3 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Month$$anon$3, "java.time.Month$$anon$3", ({
  l1: 1,
  al: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_Month$$anon$3 as $d_Ljava_time_Month$$anon$3 };
/** @constructor */
function $c_Ljava_time_Month$$anon$4() {
  this.q = null;
  this.M = 0;
  this.ef = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "APRIL", 3, "APRIL", 3);
}
export { $c_Ljava_time_Month$$anon$4 as $c_Ljava_time_Month$$anon$4 };
$p = $c_Ljava_time_Month$$anon$4.prototype = new $h_Ljava_time_Month();
$p.constructor = $c_Ljava_time_Month$$anon$4;
/** @constructor */
function $h_Ljava_time_Month$$anon$4() {
}
export { $h_Ljava_time_Month$$anon$4 as $h_Ljava_time_Month$$anon$4 };
$h_Ljava_time_Month$$anon$4.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$4 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Month$$anon$4, "java.time.Month$$anon$4", ({
  l2: 1,
  al: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_Month$$anon$4 as $d_Ljava_time_Month$$anon$4 };
/** @constructor */
function $c_Ljava_time_Month$$anon$5() {
  this.q = null;
  this.M = 0;
  this.ef = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "MAY", 4, "MAY", 4);
}
export { $c_Ljava_time_Month$$anon$5 as $c_Ljava_time_Month$$anon$5 };
$p = $c_Ljava_time_Month$$anon$5.prototype = new $h_Ljava_time_Month();
$p.constructor = $c_Ljava_time_Month$$anon$5;
/** @constructor */
function $h_Ljava_time_Month$$anon$5() {
}
export { $h_Ljava_time_Month$$anon$5 as $h_Ljava_time_Month$$anon$5 };
$h_Ljava_time_Month$$anon$5.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$5 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Month$$anon$5, "java.time.Month$$anon$5", ({
  l3: 1,
  al: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_Month$$anon$5 as $d_Ljava_time_Month$$anon$5 };
/** @constructor */
function $c_Ljava_time_Month$$anon$6() {
  this.q = null;
  this.M = 0;
  this.ef = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "JUNE", 5, "JUNE", 5);
}
export { $c_Ljava_time_Month$$anon$6 as $c_Ljava_time_Month$$anon$6 };
$p = $c_Ljava_time_Month$$anon$6.prototype = new $h_Ljava_time_Month();
$p.constructor = $c_Ljava_time_Month$$anon$6;
/** @constructor */
function $h_Ljava_time_Month$$anon$6() {
}
export { $h_Ljava_time_Month$$anon$6 as $h_Ljava_time_Month$$anon$6 };
$h_Ljava_time_Month$$anon$6.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$6 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Month$$anon$6, "java.time.Month$$anon$6", ({
  l4: 1,
  al: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_Month$$anon$6 as $d_Ljava_time_Month$$anon$6 };
/** @constructor */
function $c_Ljava_time_Month$$anon$7() {
  this.q = null;
  this.M = 0;
  this.ef = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "JULY", 6, "JULY", 6);
}
export { $c_Ljava_time_Month$$anon$7 as $c_Ljava_time_Month$$anon$7 };
$p = $c_Ljava_time_Month$$anon$7.prototype = new $h_Ljava_time_Month();
$p.constructor = $c_Ljava_time_Month$$anon$7;
/** @constructor */
function $h_Ljava_time_Month$$anon$7() {
}
export { $h_Ljava_time_Month$$anon$7 as $h_Ljava_time_Month$$anon$7 };
$h_Ljava_time_Month$$anon$7.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$7 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Month$$anon$7, "java.time.Month$$anon$7", ({
  l5: 1,
  al: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_Month$$anon$7 as $d_Ljava_time_Month$$anon$7 };
/** @constructor */
function $c_Ljava_time_Month$$anon$8() {
  this.q = null;
  this.M = 0;
  this.ef = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "AUGUST", 7, "AUGUST", 7);
}
export { $c_Ljava_time_Month$$anon$8 as $c_Ljava_time_Month$$anon$8 };
$p = $c_Ljava_time_Month$$anon$8.prototype = new $h_Ljava_time_Month();
$p.constructor = $c_Ljava_time_Month$$anon$8;
/** @constructor */
function $h_Ljava_time_Month$$anon$8() {
}
export { $h_Ljava_time_Month$$anon$8 as $h_Ljava_time_Month$$anon$8 };
$h_Ljava_time_Month$$anon$8.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$8 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Month$$anon$8, "java.time.Month$$anon$8", ({
  l6: 1,
  al: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_Month$$anon$8 as $d_Ljava_time_Month$$anon$8 };
/** @constructor */
function $c_Ljava_time_Month$$anon$9() {
  this.q = null;
  this.M = 0;
  this.ef = 0;
  $ct_Ljava_time_Month__T__I__T__I__(this, "SEPTEMBER", 8, "SEPTEMBER", 8);
}
export { $c_Ljava_time_Month$$anon$9 as $c_Ljava_time_Month$$anon$9 };
$p = $c_Ljava_time_Month$$anon$9.prototype = new $h_Ljava_time_Month();
$p.constructor = $c_Ljava_time_Month$$anon$9;
/** @constructor */
function $h_Ljava_time_Month$$anon$9() {
}
export { $h_Ljava_time_Month$$anon$9 as $h_Ljava_time_Month$$anon$9 };
$h_Ljava_time_Month$$anon$9.prototype = $p;
$p.n = (function() {
  return 0;
});
$p.g = (function(n) {
  return $j_scala$002eruntime$002e$002dEnum$002dValue.$f_sr_EnumValue__productElement__I__O(this, n);
});
$p.o = (function() {
  return this.q;
});
$p.y = (function(p) {
  return this;
});
var $d_Ljava_time_Month$$anon$9 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ljava_time_Month$$anon$9, "java.time.Month$$anon$9", ({
  l7: 1,
  al: 1,
  n: 1,
  j: 1,
  a: 1,
  G: 1,
  I: 1,
  b: 1,
  c: 1,
  l: 1,
  m: 1,
  e: 1,
  g: 1,
  k: 1
}));
export { $d_Ljava_time_Month$$anon$9 as $d_Ljava_time_Month$$anon$9 };
var $t_Ljava_time_DayOfWeek$__MONDAY = null;
function $u_Ljava_time_DayOfWeek$__MONDAY(x) {
  $t_Ljava_time_DayOfWeek$__MONDAY = x;
}
export { $t_Ljava_time_DayOfWeek$__MONDAY as $t_Ljava_time_DayOfWeek$__MONDAY, $u_Ljava_time_DayOfWeek$__MONDAY as $u_Ljava_time_DayOfWeek$__MONDAY };
var $t_Ljava_time_DayOfWeek$__TUESDAY = null;
function $u_Ljava_time_DayOfWeek$__TUESDAY(x) {
  $t_Ljava_time_DayOfWeek$__TUESDAY = x;
}
export { $t_Ljava_time_DayOfWeek$__TUESDAY as $t_Ljava_time_DayOfWeek$__TUESDAY, $u_Ljava_time_DayOfWeek$__TUESDAY as $u_Ljava_time_DayOfWeek$__TUESDAY };
var $t_Ljava_time_DayOfWeek$__WEDNESDAY = null;
function $u_Ljava_time_DayOfWeek$__WEDNESDAY(x) {
  $t_Ljava_time_DayOfWeek$__WEDNESDAY = x;
}
export { $t_Ljava_time_DayOfWeek$__WEDNESDAY as $t_Ljava_time_DayOfWeek$__WEDNESDAY, $u_Ljava_time_DayOfWeek$__WEDNESDAY as $u_Ljava_time_DayOfWeek$__WEDNESDAY };
var $t_Ljava_time_DayOfWeek$__THURSDAY = null;
function $u_Ljava_time_DayOfWeek$__THURSDAY(x) {
  $t_Ljava_time_DayOfWeek$__THURSDAY = x;
}
export { $t_Ljava_time_DayOfWeek$__THURSDAY as $t_Ljava_time_DayOfWeek$__THURSDAY, $u_Ljava_time_DayOfWeek$__THURSDAY as $u_Ljava_time_DayOfWeek$__THURSDAY };
var $t_Ljava_time_DayOfWeek$__FRIDAY = null;
function $u_Ljava_time_DayOfWeek$__FRIDAY(x) {
  $t_Ljava_time_DayOfWeek$__FRIDAY = x;
}
export { $t_Ljava_time_DayOfWeek$__FRIDAY as $t_Ljava_time_DayOfWeek$__FRIDAY, $u_Ljava_time_DayOfWeek$__FRIDAY as $u_Ljava_time_DayOfWeek$__FRIDAY };
var $t_Ljava_time_DayOfWeek$__SATURDAY = null;
function $u_Ljava_time_DayOfWeek$__SATURDAY(x) {
  $t_Ljava_time_DayOfWeek$__SATURDAY = x;
}
export { $t_Ljava_time_DayOfWeek$__SATURDAY as $t_Ljava_time_DayOfWeek$__SATURDAY, $u_Ljava_time_DayOfWeek$__SATURDAY as $u_Ljava_time_DayOfWeek$__SATURDAY };
var $t_Ljava_time_DayOfWeek$__SUNDAY = null;
function $u_Ljava_time_DayOfWeek$__SUNDAY(x) {
  $t_Ljava_time_DayOfWeek$__SUNDAY = x;
}
export { $t_Ljava_time_DayOfWeek$__SUNDAY as $t_Ljava_time_DayOfWeek$__SUNDAY, $u_Ljava_time_DayOfWeek$__SUNDAY as $u_Ljava_time_DayOfWeek$__SUNDAY };
var $t_Ljava_time_Month$__JANUARY = null;
function $u_Ljava_time_Month$__JANUARY(x) {
  $t_Ljava_time_Month$__JANUARY = x;
}
export { $t_Ljava_time_Month$__JANUARY as $t_Ljava_time_Month$__JANUARY, $u_Ljava_time_Month$__JANUARY as $u_Ljava_time_Month$__JANUARY };
var $t_Ljava_time_Month$__FEBRUARY = null;
function $u_Ljava_time_Month$__FEBRUARY(x) {
  $t_Ljava_time_Month$__FEBRUARY = x;
}
export { $t_Ljava_time_Month$__FEBRUARY as $t_Ljava_time_Month$__FEBRUARY, $u_Ljava_time_Month$__FEBRUARY as $u_Ljava_time_Month$__FEBRUARY };
var $t_Ljava_time_Month$__MARCH = null;
function $u_Ljava_time_Month$__MARCH(x) {
  $t_Ljava_time_Month$__MARCH = x;
}
export { $t_Ljava_time_Month$__MARCH as $t_Ljava_time_Month$__MARCH, $u_Ljava_time_Month$__MARCH as $u_Ljava_time_Month$__MARCH };
var $t_Ljava_time_Month$__APRIL = null;
function $u_Ljava_time_Month$__APRIL(x) {
  $t_Ljava_time_Month$__APRIL = x;
}
export { $t_Ljava_time_Month$__APRIL as $t_Ljava_time_Month$__APRIL, $u_Ljava_time_Month$__APRIL as $u_Ljava_time_Month$__APRIL };
var $t_Ljava_time_Month$__MAY = null;
function $u_Ljava_time_Month$__MAY(x) {
  $t_Ljava_time_Month$__MAY = x;
}
export { $t_Ljava_time_Month$__MAY as $t_Ljava_time_Month$__MAY, $u_Ljava_time_Month$__MAY as $u_Ljava_time_Month$__MAY };
var $t_Ljava_time_Month$__JUNE = null;
function $u_Ljava_time_Month$__JUNE(x) {
  $t_Ljava_time_Month$__JUNE = x;
}
export { $t_Ljava_time_Month$__JUNE as $t_Ljava_time_Month$__JUNE, $u_Ljava_time_Month$__JUNE as $u_Ljava_time_Month$__JUNE };
var $t_Ljava_time_Month$__JULY = null;
function $u_Ljava_time_Month$__JULY(x) {
  $t_Ljava_time_Month$__JULY = x;
}
export { $t_Ljava_time_Month$__JULY as $t_Ljava_time_Month$__JULY, $u_Ljava_time_Month$__JULY as $u_Ljava_time_Month$__JULY };
var $t_Ljava_time_Month$__AUGUST = null;
function $u_Ljava_time_Month$__AUGUST(x) {
  $t_Ljava_time_Month$__AUGUST = x;
}
export { $t_Ljava_time_Month$__AUGUST as $t_Ljava_time_Month$__AUGUST, $u_Ljava_time_Month$__AUGUST as $u_Ljava_time_Month$__AUGUST };
var $t_Ljava_time_Month$__SEPTEMBER = null;
function $u_Ljava_time_Month$__SEPTEMBER(x) {
  $t_Ljava_time_Month$__SEPTEMBER = x;
}
export { $t_Ljava_time_Month$__SEPTEMBER as $t_Ljava_time_Month$__SEPTEMBER, $u_Ljava_time_Month$__SEPTEMBER as $u_Ljava_time_Month$__SEPTEMBER };
var $t_Ljava_time_Month$__OCTOBER = null;
function $u_Ljava_time_Month$__OCTOBER(x) {
  $t_Ljava_time_Month$__OCTOBER = x;
}
export { $t_Ljava_time_Month$__OCTOBER as $t_Ljava_time_Month$__OCTOBER, $u_Ljava_time_Month$__OCTOBER as $u_Ljava_time_Month$__OCTOBER };
var $t_Ljava_time_Month$__NOVEMBER = null;
function $u_Ljava_time_Month$__NOVEMBER(x) {
  $t_Ljava_time_Month$__NOVEMBER = x;
}
export { $t_Ljava_time_Month$__NOVEMBER as $t_Ljava_time_Month$__NOVEMBER, $u_Ljava_time_Month$__NOVEMBER as $u_Ljava_time_Month$__NOVEMBER };
var $t_Ljava_time_Month$__DECEMBER = null;
function $u_Ljava_time_Month$__DECEMBER(x) {
  $t_Ljava_time_Month$__DECEMBER = x;
}
export { $t_Ljava_time_Month$__DECEMBER as $t_Ljava_time_Month$__DECEMBER, $u_Ljava_time_Month$__DECEMBER as $u_Ljava_time_Month$__DECEMBER };
